export default {
  en: {
    "setup.label.Enter_product_Description": "Enter product Description",
    "setup.label.FeedbackStatus": "Feedback Status",
    "setup.label.EnterCountryName": "Enter Country Name",
    "setup.label.city": "City",
    "setup.label.groupName": "Group Name",
    "setup.label.groupDescription": "Group Description",
    "setup.label.selectCity": "Select City",
    "setup.label.AvailableTickets": "Available Tickets",
    "setup.label.SelectedTickets": "Selected Tickets",
    "setup.label.edit_group_ticket": "Edit Group Ticket",
    "setup.label.view_group_ticket": "View Group Ticket",
    "setup.label.location": "Location",
    "setup.label.selectLocation": "Select Location",
    "setup.label.create_group_ticket": "Create Group Ticket",
    "setup.label.jobTitle": "Job Title",
    "setup.label.creditScore": "Credit Score",
    "setup.label.automation": "Automation",
    "setup.label.automation_master": "Automation Master",
    "setup.label.create_automation": "Create Automation",
    "setup.label.edit_automation": "Edit Automation",
    "setup.label.automation_detail": "Automation Detail",
    "setup.label.automation_steps": "Automation Steps",
    "setup.label.add_automation_step": "Add Automation Step",
    "setup.label.AutomationId": "Automation Id",
    "setup.label.EntityName": "Entity Name",
    "setup.label.EntityType": "Entity Type",
    "setup.label.WorkflowName": "Workflow Name",
    "setup.label.CreateAutomationScenario": "Create Automation Scenario",
    "setup.label.EditAutomationStep": "Edit Automation Step",
    "setup.label.ActionType": "Action Type",
    "setup.label.ActionDetails": "Action Details",
    "setup.label.StepOrder": "Step Order",
    "setup.label.default": "Default",
    "setup.label.customerFeedback": "Customer Feedback",
    "setup.label.questionAnswerSet": "Q & A Set",
    "setup.label.addQuestionSet": "Add Question Set",
    "setup.label.EditQuestionSet": "Edit Question Set",
    "setup.label.CategoryName": "Category Name",
    "setup.label.SubCategoryName": "Sub Category Name",
    "setup.label.TotalQuestions": "Total Questions",
    "setup.label.QuestionType": "Question Type",
    "setup.label.QuestionText": "Question Text",
    "setup.label.CustomerFeedback": "Customer Feedback",
    "setup.label.TicketId": "Ticket Id",
    "setup.label.LinkedAt": "Linked At",
    "setup.label.Remarks": "Remarks",
    "setup.label.AddFeedback": "Add Feedback",
    "setup.label.PendingForApproval": "Pending For Approval",
    "setup.label.user_availability": "User Availability",
    "setup.label.all_users_availability": "All User Availability",
    "setup.label.create_user_availability": "Create User Availability",
    "setup.label.LeaveManagement": "Leave Management",
    "setup.label.CreateLeave": "Create Leave",
    "setup.label.EditLeave": "Edit Leave",
    "setup.label.ViewLeave": "View Leave",
    "setup.label.AllUserLeaves": "All User Leaves",
    "setup.label.MyLeaves": "My Leaves",
    "setup.label.ConfigId": "Config Id",
    "setup.label.edit_user_availability": "Edit User Availability",
    "setup.label.view_user_availability": "View User Availability",
    "setup.label.unavailability_date": "Unavailability Date",
    "setup.label.start_time": "Start Time",
    "setup.label.end_time": "End Time",
    "setup.label.my_availability": "My Availability",
    "setup.label.user": "User",
    "setup.label.EditShift": "Edit Shift",
    "setup.label.UserWorkingShift": "User Working Shift",
    "setup.label.CreateUserWorkingShift": "Create User Working Shift",
    "setup.label.EditUserWorkingShift": "Edit User Working Shift",
    "setup.label.ViewUserWorkingShift": "View User Working Shift",
    "setup.label.TeamName": "Team Name",
    "setup.label.Shift": "Shift",
    "setup.label.ShiftManagement": "Shift Management",
    "setup.label.CreateShift": "Create Shift",
    "setup.label.ShiftName": "Shift Name",
    "setup.label.Session": "Session",
    "setup.label.SessionType": "Session Type",
    "setup.label.LeaveDetails": "Leave Details",
    "setup.label.SessionStartTime": "Session Start Time",
    "setup.label.SessionEndTime": "Session End Time",
    "setup.label.LeaveType": "Leave Type",
    "setup.label.AddAnotherDate": "Add Another Date",
    "setup.label.Apn_Zone": "Apn Zone",
    "setup.label.FeeMaster": "Fee Master",
    "setup.label.Number_Zone": "Number Zone",
    "setup.label.DeleteRUM": "Delete RUM",
    "setup.label.Edit_TimeModel": "Edit Time Model",
    "setup.label.Edit_Year": "Edit Year",
    "setup.label.scenario_name": "Scenario Name",
    "setup.label.event_name": "Event Name",
    "setup.label.Edit_Month": "Edit Month",
    "setup.label.Edit_Day": "Edit Day",
    "setup.label.Edit_Time": "Edit Time",
    "setup.label.Delete_TimeModel": "Delete Time Model",
    "setup.label.Delete_Year": "Delete Year",
    "setup.label.Delete_Month": "Delete Month",
    "setup.label.Delete_Day": "Delete Day",
    "setup.label.Delete_Time": "Delete Time",
    "setup.label.Are_you_sure_?": "Are you sure?",
    "setup.label.Save": "Save",
    "setup.label.TemplateDefinition": "Template Definition",
    "setup.label.EditQuantityTier": "Edit Quantity Tier",
    "setup.label.Usage_Rate_Balance": "Usage Rate Balance",
    "setup.label.Template_Name": "Template Name",
    "setup.label.Delimiter": "Delimiter",
    "setup.label.Number_Of_Fields": "Number Of Fields",
    "setup.label.Header_Recorder_Type": "Header Recorder Type",
    "setup.label.Event_Record_Type": "Event Record Type",
    "setup.label.CreateUOM": "Create UOM",
    "setup.label.TimePeriod": "Time Period",
    "setup.label.Usage_Rate_Plan": "Usage Rate Plan",
    "setup.label.TemplateDefinition": "Template Definition",
    "setup.label.CreateRUM": "Create RUM",
    "setup.label.CreateTimePeriod": "Create Time Period",
    "setup.label.TimemodelName": "Timemodel Name",
    "setup.label.TimePeriodName": "Time Period Name",
    "setup.label.StartYear": "Start Year",
    "setup.label.EndYear": "End Year",
    "setup.label.UsageRatePlan": "Usage Rate Plan",
    "setup.label.Create_Usage_Rate_Plan": "Create Usage Rate Plan",
    "setup.label.Id": "ID",
    "setup.label.PlanName": "Plan Name",
    "setup.label.ProductName": "Product Name",
    "setup.label.ChargeCode": "Charge Code",
    "setup.label.TimeModelName": "Time Model Name",
    "setup.label.RatingType": "Rating Type",
    "setup.label.RumName": "RUM Name",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "Are you sure you want to delete?",
    "setup.label.UOM": "UOM",
    "setup.label.RUM": "RUM",
    "setup.label.ImpactCategory": "Impact Category",
    "setup.label.Resource": "Resource",
    "setup.label.GLID": "GLID",
    "setup.label.Unit": "Unit",
    "setup.label.Rate": "Rate",
    "setup.label.Action": "Actions",
    "setup.label.options_selected": "options selected",
    "setup.label.UsageRateBalance": "Usage Rate Balance",
    "setup.label.EndYear": "End Year",
    "setup.label.StartMonth": "Start Month",
    "setup.label.EndMonth": "End Month",
    "setup.label.StartDay": "Start Day",
    "setup.label.EndDay": "End Day",
    "setup.label.StartTime": "Start Time",
    "setup.label.Time_Model_Name": "Time Model Name",
    "setup.label.model_includes_which_all_Bands_?":
      "Model includes which all Bands?",
    "setup.label.YearRestriction": "Year Restriction",
    "setup.label.MonthRestriction": "Month Restriction",
    "setup.label.DayRestriction": "Day Restriction",
    "setup.label.TimeRestriction": "Time Restriction",
    "setup.label.Code": "Code",
    "setup.label.Name": "Name",
    "setup.label.PriorityMapping": "Priority Mapping",
    "setup.label.AddJurisdiction": "Add Jurisdiction",
    "setup.label.Are_you_sure_?": "Are you sure?",
    "setup.label.Country": "Country",
    "setup.label.State": "State",
    "setup.label.District": "District",
    "setup.label.RateType": "Rate Type",
    "setup.label.Remove": "Remove",
    "setup.label.TaxMaster": "Tax Master",
    "setup.label.Team": "Team",
    "setup.label.Add": "Add",
    "setup.label.FeeMaster": "Fee Master",
    "setup.label.DeleteChargeCode": "Delete Charge Code",
    "setup.label.SelectSearch": "Select Search",
    "setup.label.Select_Content_Tag_Value": "Select Content Tag Value",
    "setup.label.Plan_Content": "Plan Content",
    "setup.label.Plan": "Plan",
    "setup.label.ProductPrice": "Product Price",
    "setup.label.SelectedPromotions": "Selected Promotions",
    "setup.label.AvailablePromotions": "Available Promotions",
    "setup.label.SelectType": "Select Type",
    "setup.label.Type": "Type",
    "setup.label.No_versions_available": "No versions available",
    "setup.label.Version": "Version",
    "setup.label.ListPrice": "List Price",
    "setup.label.SellingPrice": "Selling Price",
    "setup.label.EnterPlanDescription": "Enter Plan Description",
    "setup.label.AddPrice": "Add Price",
    "setup.label.Save": "Save",
    "setup.label.AddDiscount": "Add Discount",
    "setup.label.AvailablePlans": "Available Plans",
    "setup.label.SelectedPlans": "Selected Plans",
    "setup.label.PlanType": "Plan Type",
    "setup.label.Plan_Start_Date": "Plan Start Date",
    "setup.label.Plan_End_Date": "Plan End Date",
    "setup.label.Bill_Type": "Bill Type",
    "setup.label.AttributeTypes": "Attribute Types",
    "setup.label.Add": "Add",
    "setup.label.Select_Content_Tag": "Select Content Tag",
    "setup.label.PlanName": "Plan Name",
    "setup.label.AvailableDiscounts": "Available Discounts",
    "setup.label.Search": "Search...",
    "setup.label.MoveRight": "Move Right",
    "setup.label.MoveLeft": "Move Left",
    "setup.label.SelectedDiscounts": "Selected Discounts",
    "setup.label.SelectType": "Select Type",
    "setup.label.SelectLanguage": "Select Language",
    "setup.label.SelectContentTag": "Select Content Tag",
    "setup.label.SelectContentTagValue": "Select Content Tag Value",
    "setup.label.DigitalContent": "Digital Content",
    "setup.label.Enter_Plan_Description": "Enter Plan Description",
    "setup.label.DC_Rule": "DC Rule",
    "setup.label.PlanAttribute": "Plan Attribute",
    "setup.label.AdvanceView": "Advance View",
    "setup.label.Update": "Update",
    "setup.label.ProductMapping": "Product Mapping",
    "setup.label.Service": "Service",
    "setup.label.SubProducts": "Sub Products",
    "setup.label.Type": "Type",
    "setup.label.EnterValue": "Enter Value",
    "setup.label.PriceRegion": "Price Region",
    "setup.label.Enter_service_Description": "Enter service Description",
    "setup.label.ParamName": "Param Name",
    "setup.label.Category": "Category",
    "setup.label.Type": "Type",
    "setup.label.EnterValue": "Enter Value",
    "setup.label.SalesCatalogue": "Sales Catalogue",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "Are you sure you want to delete?",
    "setup.label.Channel": "Channel",
    "setup.label.Broadcaster": "Broadcaster",
    "setup.label.AddPrice": "Add Price",
    "setup.label.DeleteMediaEvent": "Delete Media Event",
    "setup.label.AdvMedia": "Adv Media",
    "setup.label.EditMedia": "Edit Media",
    "setup.label.AddEvent": "Add Event",
    "setup.label.AddAttributes": "Add Attributes",
    "setup.label.AddLocation": "Add Location",
    "setup.label.DeleteEvent": "Delete Event",
    "setup.label.Are_you_sure_?": "Are you sure?",
    "setup.label.Add": "Add",
    "setup.label.ViewEvent": "View Event",
    "setup.label.Event": "Event",
    "setup.label.RUM": "RUM",
    "setup.label.OptType": "Opt Type",
    "setup.label.Currency": "Currency",
    "setup.label.Amount": "Amount",
    "setup.label.Add": "Add",
    "setup.label.Save": "Save",
    "setup.label.AddDiscount": "Add Discount",
    "setup.label.EnterEventCode": "Enter Event Code",
    "setup.label.EnterEventDescription": "Enter Event Description",
    "setup.label.EventDescription": "Event Description",
    "setup.label.EventCategory": "Event Category",
    "setup.label.ChargeCode": "Charge Code",
    "setup.label.SelectEventValidity": "Select Event Validity",
    "setup.label.EditEvent": "Edit Event",
    "setup.label.UnitCode": "Unit Code",
    "setup.label.MediaTitle": "Media Title",
    "setup.label.ContentProvider": "Content Provider",
    "setup.label.MediaType": "Media Type",
    "setup.label.Rated": "Rated",
    "setup.label.MediaCategory": "Media Category",
    "setup.label.Rating": "Rating",
    "setup.label.Poster": "Poster",
    "setup.label.Status": "Status",
    "setup.label.MovieDuration": "Movie Duration",
    "setup.label.ReleaseDate": "Release Date",
    "setup.label.Genre": "Genre",
    "setup.label.Subject": "Subject",
    "setup.label.Overview": "Overview",
    "setup.label.Share(%)": "Share (%)",
    "setup.label.Cast": "Cast",
    "setup.label.AttributeType": "Attribute Type",
    "setup.label.CaptionValue": "Caption Value",
    "setup.label.NickName": "Nickname",
    "setup.label.Image": "Image",
    "setup.label.Language": "Language",
    "setup.label.Format": "Format",
    "setup.label.Location": "Location",
    "setup.label.CustomerType": "Customer Type",
    "setup.label.FormatType": "Format Type",
    "setup.label.DiscountCode": "Discount Code",
    "setup.label.ReProcess": "ReProcess",
    "setup.label.Code": "Code",
    "setup.label.Description": "Description",
    "setup.label.PropertyCodeType": "Property Code Type",
    "setup.label.ReferenceValue": "Reference Value",
    "setup.label.EditProperty": "Edit Property",
    "setup.label.EditPropertyMaster": "Edit Property Master",
    "setup.label.Cancel": "Cancel",
    "setup.label.View": "View",
    "setup.label.Edit": "Edit",
    "setup.label.Browse_file_to_Upload": "Browse file to Upload",
    "setup.label.CreatePropertyMaster": "Create Property Master",
    "setup.label.Property": "Property",
    "setup.label.PropertyMaster": "Property Master",
    "setup.label.ViewProperty": "View Property",
    "setup.label.ViewPropertyMaster": "View Property Master",
    "setup.label.Are_you_sure_?": "Are you sure?",
    "setup.label.Edit": "Edit",
    "setup.label.Code": "Code",
    "setup.label.Name": "Name",
    "setup.label.AddState": "Add State",
    "setup.label.AddDistrict": "Add District",
    "setup.label.AddCity": "Add City",
    "setup.label.EditCountry": "Edit Country",
    "setup.label.EditState": "Edit State",
    "setup.label.EditDistrict": "Edit District",
    "setup.label.EditCity": "Edit City",
    "setup.label.DeleteCountry": "Delete Country",
    "setup.label.DeleteState": "Delete State",
    "setup.label.DeleteDistrict": "Delete District",
    "setup.label.DeleteCity": "Delete City",
    "setup.label.ServiceAvailablity": "Service Availability",
    "setup.label.EnterCountryCode": "Enter Country Code",
    "setup.label.EnterCode": "Enter Code",
    "setup.label.EnterName": "Enter Name",
    "setup.label.Service_Availablity_for_the": "Service Availability for the",
    "setup.label.SelectServices": "Select Services",
    "setup.label.Select_One_or_More": "Select One or More",
    "setup.label.options_selected": "options selected",
    "setup.label.PromotionName": "Promotion Name",
    "setup.label.PromotionCode": "Promotion Code",
    "setup.label.BussinesType": "Business Type",
    "setup.label.OrderType": "Order Type",
    "setup.label.PaymentType": "Payment Type",
    "setup.label.SelectCategory": "Select Category",
    "setup.label.PromotionTrigger": "Promotion Trigger",
    "setup.label.PromotionRule": "Promotion Rule",
    "setup.label.PromotionTriggerCondition": "Promotion Trigger Condition",
    "setup.label.DiscountTriggerCondition": "Discount Trigger Condition",
    "setup.label.DiscountRule": "Discount Rule",
    "setup.label.DiscountTrigger": "Discount Trigger",
    "setup.label.EditTriggerCondition": "Edit Trigger Condition",
    "setup.label.Rate": "Rate",
    "setup.label.EditRule": "Edit Rule",
    "setup.label.AddRate": "Add Rate",
    "setup.label.Download": "Download",
    "setup.label.Process": "Process",
    "setup.label.ViewVendor": "View Vendor",
    "setup.label.VendorCode": "Vendor Code",
    "setup.label.VendorName": "Vendor Name",
    "setup.label.select_Currency": "Select Currency",
    "setup.label.select_Country": "Select Country",
    "setup.label.Filter_List": "Filter List",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "Are you sure you want to delete?",
    "setup.label.DeleteVoucher": "Delete Voucher",
    "setup.label.UpdatePin": "Update Pin",
    "setup.label.UpdateVoucher": "Update Voucher",
    "setup.label.select_from_dropdown": "Select from dropdown",
    "setup.label.ItemModel": "Item Model",
    "setup.label.price": "Price",
    "setup.label.Edit": "Edit",
    "setup.label.Delete": "Delete",
    "setup.label.Item": "Item",
    "setup.label.EnterSupplierAddress": "Enter Supplier Address",
    "setup.label.Title": "Title",
    "setup.label.AddPromotionTriggerCondition":
      "Add Promotion Trigger Condition",
    "setup.label.EditPromotionTriggerCondition":
      "Edit Promotion Trigger Condition",
    "setup.label.AssignTo": "Assign To",
    "setup.label.Version": "Version",
    "setup.label.IsOverride": "Is Override",
    "setup.label.PlanAttribute": "Plan Attribute",
    "setup.label.ValidationRule": "Validation Rule",
    "setup.label.SaveAndContinue": "Save & Continue",
    "setup.label.PlanManagement": "Plan Management",
    "setup.label.Plan": "Plan",
    "setup.label.DiscountTriggerCondition": "Discount Trigger Condition",
    "setup.label.AddDiscountTriggerCondition": "Add Discount Trigger Condition",
    "setup.label.SalesChannel": "Sales Channel",
    "setup.label.PaymentType": "Payment Type",
    "setup.label.OrderType": "Order Type",
    "setup.label.BusinessType": "Business Type",
    "setup.label.ViewDigitalContent": "View Digital Content",
    "setup.label.EditDigitalContent": "Edit Digital Content",
    "setup.label.AddDigitalContent": "Add Digital Content",
    "setup.label.PromotionRuleName": "Promotion Rule Name",
    "setup.label.PromotionTriggerCondition": "Promotion Trigger Condition",
    "setup.label.AddPromotionTriggerCondition":
      "Add Promotion Trigger Condition",
    "setup.label.requestApproval": "Request Approval",
    "setup.label.validity_uom": "Validity UOM",
    "setup.label.validity_value": "Validity Value",
    "setup.label.ViewItemModel": "View Item Model",
    "setup.label.ItemType": "Item Type",
    "setup.label.ViewSupplier": "View Supplier",
    "setup.label.SupplierCode": "Supplier Code",
    "setup.label.SupplierDescription": "Supplier Description",
    "setup.label.SupplierAddress": "Supplier Address",
    "setup.label.DeleteSupplier": "Delete Supplier",
    "setup.label.CreateContract": "Create Contract",
    "setup.label.CreateRule": "Create Rule",
    "setup.label.Entity": "Entity",
    "setup.label.EntityField": "Entity Field",
    "setup.label.RuleCondition": "Rule Condition",
    "setup.label.CreateRuleCondition": "Create Rule Condition",
    "setup.label.CreateDiscountRule": "Create Discount Rule",
    "setup.label.RangeType": "Range Type",
    "setup.label.RateTierName": "Rate Tier Name",
    "setup.label.contentTag": "Content Tag",
    "setup.label.contentTagValue": "Content Tag Value",
    "setup.label.ExecutionType": "Execution Type",
    "setup.label.OperationMode": "Operation Mode",
    "setup.label.AggregationType": "Aggregation Type",
    "setup.label.DurationInDays": "Duration In Days",
    "setup.label.CreateTicketTeamUser": "Create Ticket Team User",
    "setup.label.updateTermsConditions": "Update Terms & Conditions",
    "setup.label.updateDigitalContent": "Update Digital Content",
    "setup.label.createDigitalContent": "Create Digital Content",
    "setup.label.createTermsConditions": "Create Terms & Conditions",
    "setup.label.termsConditions": "Terms & Conditions",
    "setup.label.digitalContent": "Digital Content",
    "setup.label.validation_rule": "Validation Rule",
    "setup.label.Version": "Version",
    "setup.label.SaveAndContinue": "Save & Continue",
    "setup.label.IsOverride": "Is Override",
    "setup.label.planContent": "Plan Content",
    "setup.label.selectPlanContent": "Select Plan Content",
    "setup.label.FilterType": "Filter Type",
    "setup.label.FilterValue": "Filter Value",
    "setup.label.ContractPeriod": "Contract Period",
    "setup.label.AddContract": "Add Contract",
    "setup.label.EditContract": "Edit Contract",
    "setup.label.ViewContract": "View Contract",
    "setup.label.ViewValidationRule": "View Validation Rule",
    "setup.label.ValidationRule": "Validation Rule",
    "setup.label.ContractType": "Contract Type",
    "setup.label.ContractUnit": "Contract Unit",
    "setup.label.updateNetMask": "Update Net Mask",
    "setup.label.Update": "Update",
    "setup.label.BillType": "Bill Type",
    "setup.label.BillFrequency": "Bill Frequency",
    "setup.label.PlanEndDate": "Plan End Date",
    "setup.label.AddContent": "Add Content",
    "setup.label.CreatePlanContent": "Create Plan Content",
    "setup.label.SelectLanguage": "Select Language",
    "setup.label.UploadDigitalImage": "Upload Digital Image",
    "setup.label.ViewPlanContent": "View Plan Content",
    "setup.label.ExternalPlanName": "External Plan Name",
    "setup.label.ExternalProductName": "External Product Name",
    "setup.label.ViewPrice": "View Price",
    "setup.label.SelectedPlanDiscounts": "Plan Discounts",
    "setup.label.ProductDiscount": "Product Discount",
    "setup.label.createIpPool": "Create IP Pool",
    "setup.label.editIpPool": "Edit Ip Pool",
    "setup.label.UsageRateBalance": "Usage Rate Balance",
    "setup.label.Validity": "Validity",
    "setup.label.ListOfRateTires": "List Of Rate Tires",
    "setup.label.ValidityType": "Validity Type",
    "setup.label.CreatePlanName": "Create Plan Name",
    "setup.label.EditPlanContent": "Edit Plan Content",
    "setup.label.CreatePlanDescription": "Create Plan Description",
    "setup.label.ContentType": "Content Type",
    "setup.label.CreateFeatureList": "Create Feature List",
    "setup.label.Area": "Area",
    "setup.label.TaxPercentage": "Tax Percentage",
    "setup.label.Add": "Add",
    "setup.label.Remove": "Remove",
    "setup.label.planPrice": "Plan Price",
    "setup.label.listview": "List View",
    "setup.label.AddOrEditDiscount": "Add/Edit Discount",
    "setup.label.Next": "Next",
    "setup.label.MainCategory": "Main Category",
    "setup.label.SubCategory": "Sub Category",
    "setup.label.select_date": "Select Date",
    "setup.label.AddDiscountTrigger": "Add Discount Trigger",
    "setup.label.AddPromotionTrigger": "Add Promotion Trigger",
    "setup.label.edit_promotion_trigger": "Edit Promotion Trigger",
    "setup.label.DiscountTrigger": "Discount Trigger",
    "setup.label.TriggerName": "Trigger Name",
    "setup.label.When": "When",
    "setup.label.CustomerType": "Customer Type",
    "setup.label.Criteria": "Criteria",
    "setup.label.Values": "Values",
    "setup.label.ApplicableTo": "Applicable To",
    "setup.label.ApplicableValues": "Applicable Values",
    "setup.label.DiscountRulesAndRates": "Discount Rules And Rates",
    "setup.label.RuleName": "Rule Name",
    "setup.label.MaxDiscount": "Max Discount",
    "setup.label.ResourceId": "Resource Id",
    "setup.label.DiscountRateType": "Discount Rate Type",
    "setup.label.Unit": "Unit",
    "setup.label.PlanValidationRules": "Plan Validation Rules",
    "setup.label.CreateValidationRule": "Create Validation Rule",
    "setup.label.EditValidationRule": "Edit Validation Rule",
    "setup.label.InputPlanId": "Input Plan Id",
    "setup.label.CheckinPlanId": "Checkin Plan Id",
    "setup.label.RuleAppliesTo": "Rule Applies To",
    "setup.label.Rule": "Rule",
    "setup.label.DiscountId": "Discount Id",
    "setup.label.DiscountName": "Discount Name",
    "setup.label.Priority": "Priority",
    "setup.label.Items": "Items",
    "setup.label.ItemCode": "Item Code",
    "setup.label.ItemDescription": "Item Description",
    "setup.label.Units": "Units",
    "setup.label.Total": "Total",
    "setup.label.Warranty": "Warranty",
    "setup.label.UsedItems": "Used Items",
    "setup.label.Balanced": "Balanced",
    "setup.label.IsProvisioning": "Is Provisioning",
    "setup.label.CreateItem": "Create Item",
    "setup.label.ItemClass": "Item Class",
    "setup.label.ReorderLevel": "Reorder Level",
    "setup.label.WarrantyPeriod": "Warranty Period",
    "setup.label.Currency": "Currency",
    "setup.label.DefaultPrice": "Default Price",
    "setup.label.IsSelector": "Is Selector",
    "setup.label.SelectorMenu": "Selector Menu",
    "setup.label.Selector": "Selector",
    "setup.label.VariablePrice": "Variable Price",
    "setup.label.ItemModel": "Item Model",
    "setup.label.Price": "Price",
    "setup.label.Action": "Action",
    "setup.label.Cancel": "CANCEL",
    "setup.label.Submit": "SUBMIT",
    "setup.label.EditItem": "Edit Item",
    "setup.label.Id": "Id",
    "setup.label.ItemMasterId": "Item Master Id",
    "setup.label.RegionId": "Region Id",
    "setup.label.Edit": "Edit",
    "setup.label.ViewItem": "View Item",
    "setup.label.UnitPrice": "Unit Price",
    "setup.label.ItemModels": "Item Models",
    "setup.label.NetworkElement": "Network Element",
    "setup.label.Model": "Model",
    "setup.label.Make": "Make",
    "setup.label.ListofTimePeriods": "List of Time Periods",
    "setup.label.CreateItemModel": "Create Item Model",
    "setup.label.Reset": "Reset",
    "setup.label.EditItemModel": "Edit Item Model",
    "setup.label.ServiceCode": "Service Code",
    "setup.label.ServiceDescription": "Service Description",
    "setup.label.ServiceType": "Service Type",
    "setup.label.Isoptional": "Is Optional",
    "setup.label.Isautoprovision": "Is Auto Provision",
    "setup.label.CreateService": "Create Service",
    "setup.label.Code": "Code",
    "setup.label.Description": "Description",
    "setup.label.Type": "Type",
    "setup.label.EditService": "Edit Service",
    "setup.label.ServiceParameter": "Service Parameter",
    "setup.label.ParamName": "Param Name",
    "setup.label.ParamType": "Param Type",
    "setup.label.ParamCategory": "Param Category",
    "setup.label.ParamValue": "Param Value",
    "setup.label.BB": "BB",
    "setup.label.Delete": "Delete",
    "setup.label.ServiceCategory": "Service Category",
    "setup.label.DeleteServices": "Delete Services",
    "setup.label.Confirm": "Confirm",
    "setup.label.Service": "Service",
    "setup.label.Status": "Status",
    "setup.label.Bouquet": "Bouquet",
    "setup.label.Actions": "Actions",
    "setup.label.CreateProduct": "Create Product",
    "setup.label.ProductParameter": "Product Parameter",
    "setup.label.EditProduct": "Edit Product",
    "setup.label.ProductDescription": "Product Description",
    "setup.label.ProductCategory": "Product Category",
    "setup.label.BroadcasterCode": "Broadcaster Code",
    "setup.label.BroadcasterName": "Broadcaster Name",
    "setup.label.GstRegNumber": "GST Reg Number",
    "setup.label.ContactPerson": "Contact Person",
    "setup.label.ContactMobile": "Contact Mobile",
    "setup.label.Email": "Email",
    "setup.label.CreateBroadcaster": "Create Broadcaster",
    "setup.label.Address": "Address",
    "setup.label.MobileNo": "Mobile No",
    "setup.label.LandlineNo": "Landline No",
    "setup.label.EditBroadcaster": "Edit Broadcaster",
    "setup.label.ChannelName": "Channel Name",
    "setup.label.ChannelType": "Channel Type",
    "setup.label.DeleteBroadcaster": "Delete Broadcaster",
    "setup.label.ChannelCategory": "Channel Category",
    "setup.label.ChannelSequence": "Channel Sequence",
    "setup.label.IsHdChannel": "Is HD Channel",
    "setup.label.CreateChannel": "Create Channel",
    "setup.label.Language": "Language",
    "setup.label.IsLocalChannel": "Is Local Channel",
    "setup.label.Genre": "Genre",
    "setup.label.BroadcasterId": "Broadcaster Id",
    "setup.label.EditChannel": "Edit Channel",
    "setup.label.DeleteChannel": "Delete Channel",
    "setup.label.ProductMapping": "Product Mapping",
    "setup.label.CreateProductChannelMapping": "Create Product Channel Mapping",
    "setup.label.ProductId": "Product Id",
    "setup.label.AvailableChannels": "Available Channels",
    "setup.label.SelectedChannels": "Selected Channels",
    "setup.label.EditChannelMapping": "Edit Channel Mapping",
    "setup.label.PlanPricing": "Plan & Pricing",
    "setup.label.CreatePlan": "Create Plan",
    "setup.label.PlanCode": "Plan Code",
    "setup.label.PlanDescription": "Plan Description",
    "setup.label.PlanStatus": "Plan Status",
    "setup.label.PlanProvisionSystem": "Plan Provision System",
    "setup.label.PlanStartDate": "Plan Start Date",
    "setup.label.IsPrepaid": "Is Prepaid",
    "setup.label.Duration": "Duration",
    "setup.label.PlanType": "Plan Type",
    "setup.label.BillingRule": "Billing Rule",
    "setup.label.EndDate": "End Date",
    "setup.label.IsProvision": "Is Provision",
    "setup.label.EditPlan": "Edit Plan",
    "setup.label.SelectProduct": "Select Product",
    "setup.label.ViewPlan": "View Plan",
    "setup.label.ProvisioningSystem": "Provisioning System",
    "setup.label.DeletePlan": "Delete Plan",
    "setup.label.Prices": "Prices",
    "setup.label.ChargeOwner": "Charge Owner",
    "setup.label.DiscountCode": "Discount Code",
    "setup.label.PriceRegion": "Price Region",
    "setup.label.Resource": "Resource",
    "setup.label.SalesChannel": "Sales Channel",
    "setup.label.OrderType": "Order Type",
    "setup.label.BusinessType": "Business Type",
    "setup.label.RoundingType": "Rounding Type",
    "setup.label.GLID": "GL ID",
    "setup.label.Value": "Value",
    "setup.label.TemplateDefinition": "Template Definition",
    "setup.label.CreateTemplateDefinition": "Create Template Definition",
    "setup.label.TemplateName": "Template Name",
    "setup.label.Delimiter": "Delimiter",
    "setup.label.NumberOfFields": "Number Of Fields",
    "setup.label.HeaderRecorderType": "Header Recorder Type",
    "setup.label.EventRecordType": "Event Record Type",
    "setup.label.ProductCode": "Product Code",
    "setup.label.IsHeader": "Is Header",
    "setup.label.FieldType": "Field Type",
    "setup.label.FieldName": "Field Name",
    "setup.label.IdentifierType": "Identifier Type",
    "setup.label.Length": "Length",
    "setup.label.ExistsTemplateDefinition": "Exists Template Definition",
    "setup.label.UOM(Unit Of measurement)": "UOM (Unit Of Measurement)",
    "setup.label.CreateUOM": "Create UOM",
    "setup.label.Name": "Name",
    "setup.label.EditTemplateDefinition": "Edit Template Definition",
    "setup.label.EditUOM": "Edit UOM",
    "setup.label.Save": "Save",
    "setup.label.DeleteUOM": "Delete UOM",
    "setup.label.CreateICZone": "Create IC Zone",
    "setup.label.Ok": "Ok",
    "setup.label.ViewUOM": "View UOM",
    "setup.label.RUM(RatableUsageMetric)": "RUM (Ratable Usage Metric)",
    "setup.label.CreateRUM": "Create RUM",
    "setup.label.ChargeName": "Charge Name",
    "setup.label.Template Name": "Template Name",
    "setup.label.RumName": "Rum Name",
    "setup.label.RumExpression": "Rum Expression",
    "setup.label.Expression": "Expression",
    "setup.label.Operators": "Operators",
    "setup.label.EditRUM": "Edit RUM",
    "setup.label.ViewRUM": "View RUM",
    "setup.label.TimePeriod": "Time Period",
    "setup.label.CreateTimePeriod": "Create Time Period",
    "setup.label.TimeModelName": "Time Model Name",
    "setup.label.StartYear": "Start Year",
    "setup.label.EndYear": "End Year",
    "setup.label.StartMonth": "Start Month",
    "setup.label.EndMonth": "End Month",
    "setup.label.StartDay": "Start Day",
    "setup.label.EndDay": "End Day",
    "setup.label.StartTime": "Start Time",
    "setup.label.EndTime": "End Time",
    "setup.label.CreateTimeModel": "Create Time Model",
    "setup.label.ExpandAll / CollapseAll": "Expand All / Collapse All",
    "setup.label.AddTimemodel": "Add Time Model",
    "setup.label.UsageRatePlan": "Usage Rate Plan",
    "setup.label.CreateUsageRatePlan": "Create Usage Rate Plan",
    "setup.label.PlanName": "Plan Name",
    "setup.label.ProductName": "Product Name",
    "setup.label.TimemodelName": "Time Model Name",
    "setup.label.ViewUsageRatePlan": "View Usage Rate Plan",
    "setup.label.RUM": "RUM",
    "setup.label.RatingType": "Rating Type",
    "setup.label.TimeModel": "Time Model",
    "setup.label.ZoneModel": "Zone Model",
    "setup.label.ViewQuantityTier": "View Quantity Tier",
    "setup.label.QuantityTier": "Quantity Tier",
    "setup.label.TierName": "Tier Name",
    "setup.label.CumulativeResource": "Cumulative Resource",
    "setup.label.TierRange": "Tier Range",
    "setup.label.StepName": "Step Name",
    "setup.label.StartRange": "Start Range",
    "setup.label.EndRange": "End Range",
    "setup.label.AddQuantityTier": "Add Quantity Tier",
    "setup.label.NumberZone": "Number Zone",
    "setup.label.CreateNumberZone": "Create Number Zone",
    "setup.label.SourceNumberPrefix": "Source Number Prefix",
    "setup.label.DestinationNumberPrefix": "Destination Number Prefix",
    "setup.label.ImpactCategory": "Impact Category",
    "setup.label.Rank": "Rank",
    "setup.label.APNZone": "APN Zone",
    "setup.label.APN": "APN",
    "setup.label.CreateAPNZone": "Create APN Zone",
    "setup.label.OperatorZone": "Operator Zone",
    "setup.label.CreateOperatorZone": "Create Operator Zone",
    "setup.label.SourceOperatorCode": "Source Operator Code",
    "setup.label.DestinationOperatorCode": "Destination Operator Code",
    "setup.label.ICZone": "IC Zone",
    "setup.label.IncomingTrunkid": "Incoming Trunkid",
    "setup.label.OutcomingTrunkid": "Outcoming Trunkid",
    "setup.label.CreateChargeCode": "Create Charge Code",
    "setup.label.ChargeDescription": "Charge Description",
    "setup.label.ChargeType": "Charge Type",
    "setup.label.ChargeDuration": "Charge Duration",
    "setup.label.DurationType": "Duration Type",
    "setup.label.TaxInclusive": "Tax Inclusive",
    "setup.label.BillFrequencyCode": "Bill Frequency Code",
    "setup.label.TaxCode": "Tax Code",
    "setup.label.IsAggregate": "Is Aggregate",
    "setup.label.EditChargeCode": "Edit Charge Code",
    "setup.label.TaxMaster": "Tax Master",
    "setup.label.CreateTaxMaster": "Create Tax Master",
    "setup.label.GroupType": "Group Type",
    "setup.label.GroupCode": "Group Tax Code",
    "setup.label.StartDate": "Start Date",
    "setup.label.Rate": "Rate",
    "setup.label.BaseTaxCode": "Base Tax Code",
    "setup.label.Jurisdiction": "Jurisdiction",
    "setup.label.RateType": "Rate Type",
    "setup.label.TaxType": "Tax Type",
    "setup.label.Location": "Location",
    "setup.label.DeleteTax": "Delete Tax",
    "setup.label.CreateDiscount": "Create Discount",
    "setup.label.DiscountDescription": "Discount Description",
    "setup.label.DiscountType": "Discount Type",
    "setup.label.DiscountRate": "Discount Rate",
    "setup.label.DiscountDetails": "Discount Details",
    "setup.label.ClientCategory": "Client Category",
    "setup.label.CustomerCategory": "Customer Category",
    "setup.label.EditDiscount": "Edit Discount",
    "setup.label.DeleteDiscount": "Delete Discount",
    "setup.label.CreatePromotion": "Create Promotion",
    "setup.label.PromotionCode": "Promotion Code",
    "setup.label.PromotionName": "Promotion Name",
    "setup.label.PromotionId": "Promotion Id",
    "setup.label.PromotionDescription": "Promotion Description",
    "setup.label.EditPromotionCode": "Edit Promotion Code",
    "setup.label.ListOfDiscounts": "List of Discounts",
    "setup.label.CreatePriceRegion": "Create Price Region",
    "setup.label.RegionCode": "Region Code",
    "setup.label.RegionName": "Region Name",
    "setup.label.Country": "Country",
    "setup.label.States": "States",
    "setup.label.EditPriceRegion": "Edit Price Region",
    "setup.label.DeletePriceRegion": "Delete Price Region",
    "setup.label.CreateSalesCatalogue": "Create Sales Catalogue",
    "setup.label.SalesCatalogueName": "Sales Catalogue Name",
    "setup.label.AssignUsers": "Assign Users",
    "setup.label.SalesPlanCategory": "Sales Plan Category",
    "setup.label.Plans": "Plans",
    "setup.label.EditSalesCatalogue": "Edit Sales Catalogue",
    "setup.label.DeleteSalesCatalogue": "Delete Sales Catalogue",
    "setup.label.UserId": "User ID",
    "setup.label.UserName": "User Name",
    "setup.label.CreateUsersCatalogue": "Create Users Catalogue",
    "setup.label.Catalogue": "Catalogue",
    "setup.label.EditUserCatalogue": "Edit User Catalogue",
    "setup.label.VoucherPins": "Voucher Pins",
    "setup.label.CreateVoucherPins": "Create Voucher Pins",
    "setup.label.Voucher": "Voucher",
    "setup.label.Coupon": "Coupon",
    "setup.label.LCO": "LCO",
    "setup.label.LengthOfPins": "Length Of Pins",
    "setup.label.SerialNoLength": "Serial No Length",
    "setup.label.NumberValue ": "Number Value",
    "setup.label.PinValue ": "Pin Value",
    "setup.label.BatchName": "Batch Name",
    "setup.label.PinCategory": "Pin Category",
    "setup.label.BeginWith": "Begin With",
    "setup.label.Quantity": "Quantity",
    "setup.label.PinType": "Pin Type",
    "setup.label.SIMNumbers": "SIM Numbers",
    "setup.label.CreateSIMNumber": "Create SIM Number",
    "setup.label.NumberCategory": "Number Category",
    "setup.label.ExpiryDate": "Expiry Date",
    "setup.label.Partner": "Partner",
    "setup.label.LengthofNumber": "Length of Number",
    "setup.label.LengthofSerialNumber": "Length of Serial Number",
    "setup.label.NumberType": "Number Type",
    "setup.label.Product": "Product",
    "setup.label.Supplier": "Supplier",
    "setup.label.CreateSupplier": "Create Supplier",
    "setup.label.EditSupplier": "Edit Supplier",
    "setup.label.AddressMaster": "Address Master",
    "setup.label.CountryName": "Country Name",
    "setup.label.StateName": "State Name",
    "setup.label.DistrictName": "District Name",
    "setup.label.CityName": "City Name",
    "setup.label.TreeView": "Tree View",
    "setup.label.AddCountry": "Add Country",
    "setup.label.CountryCode": "Country Code",
    "setup.label.TeamHead": "Team Head",
    "setup.label.CreateTicketTeam": "Create Ticket Team",
    "setup.label.TeamCode": "Team Code",
    "setup.label.TeamDescription": "Team Description",
    "setup.label.TeamCategory": "Team Category",
    "setup.label.CreateTicketTeamUsers": "Create Ticket Team Users",
    "setup.label.TeamEmail": "Team Email",
    "setup.label.AvailableUsers": "Available Users",
    "setup.label.SelectedUsers": "Selected Users",
    "setup.label.TeamId": "Team Id",
    "setup.label.ViewTeam": "View Team",
    "setup.label.DeleteTeam": "Delete Team",
    "setup.label.EditTicketTeam": "Edit Ticket Team",
    "setup.label.TeamUser": "Team User",
    "setup.label.EditTicketUsers": "Edit Ticket Users",
    "setup.label.DeleteTeamUser": "Delete Team User",
    "setup.label.VendorManagement": "Vendor Management",
    "setup.label.CreateVendor": "Create Vendor",
    "setup.label.ContactName": "Contact Name",
    "setup.label.Mobile": "Mobile",
    "setup.label.Landline": "Landline",
    "setup.label.CreateNewVendor": "Create New Vendor",
    "setup.label.EditVendor": "Edit Vendor",
    "setup.label.FeeMaster": "Fee Master",
    "setup.label.CreateFeeMaster": "Create Fee Master",
    "setup.label.FeeMasterCode": "FeeMaster Code",
    "setup.label.FeeMasterDescription": "FeeMaster Description",
    "setup.label.FeeMasterTransactionType": "FeeMaster TransactionType",
    "setup.label.ChargeCode": "Charge Code",
    "setup.label.VariablePricing": "Variable Pricing",
    "setup.label.Regions": "Regions",
    "setup.label.Amount": "Amount",
    "setup.label.EditFeeMaster": "Edit Fee Master",
    "setup.label.ManageMessage": "Manage Message",
    "setup.label.AddMessage": "Add Message",
    "setup.label.TemplateDescription": "Template Description",
    "setup.label.Subject": "Subject",
    "setup.label.MessageType": "Message Type",
    "setup.label.Header": "Header",
    "setup.label.Body": "Body",
    "setup.label.Footer": "Footer",
    "setup.label.CreateMessageTemplate": "Create Message Template",
    "setup.label.MessageParams": "Message Params",
    "setup.label.Parameter": "Parameter",
    "setup.label.Params": "Params",
    "setup.label.DeleteMessage": "Delete Message",
    "setup.label.EditMessage": "Edit Message",
    "setup.label.GroupsDetails": "Groups Details",
    "setup.label.GroupName": "Group Name",
    "setup.label.GroupAddress": "Group Address",
    "setup.label.CountNo's": "Count No's",
    "setup.label.AddGroup": "Add Group",
    "setup.label.AdditionalInformation": "Additional Information",
    "setup.label.GroupCIR": "Group CIR",
    "setup.label.DIR": "DIR",
    "setup.label.MemberCIR": "Member CIR",
    "setup.label.IpPoolManagement": "IP Pool Management",
    "setup.label.UpdateNetMask": "Update Net Mask",
    "setup.label.IpAddress": "Ip Address",
    "setup.label.NetMark": "Net Mark",
    "setup.label.IpType": "Ip Type",
    "setup.label.CoustomerId": "Customer Id",
    "setup.label.CustomerName": "Customer Name",
    "setup.label.Notes": "Notes",
    "setup.label.Subnet": "Subnet",
    "setup.label.DetailsOfMedia": "Details Of Media",
    "setup.label.Media": "Media",
    "setup.label.AddMedia": "Add Media",
    "setup.label.MediaTitle": "Media Title",
    "setup.label.MediaCatagory": "Media Category",
    "setup.label.ContentProvider": "Content Provider",
    "setup.label.Share": "Share(%)",
    "setup.label.AddMediaDetails": "Add Media Details",
    "setup.label.MediaLocation": "Media Location",
    "setup.label.SelectMediaCategory": "Select Media Category",
    "setup.label.Movies": "Movies",
    "setup.label.ViewMedia": "View Media",
    "setup.label.EditMedia": "Edit Media",
    "setup.label.MediaAttributes": "Media Attributes",
    "setup.label.Cast": "Cast",
    "setup.label.AttributeType": "Attribute Type",
    "setup.label.CaptionValue": "Caption Value",
    "setup.label.NickName": "Nick Name",
    "setup.label.Image": "Image",
    "setup.label.AddMediaLocations": "Add Media Locations",
    "setup.label.LanguageData": "Language Data",
    "setup.label.FormatData": "Format Data",
    "setup.label.MediaLocations": "Media Locations",
    "setup.label.DetailsOfEvent": "Details Of Event",
    "setup.label.EventName": "Event Name",
    "setup.label.EventCode": "Event Code",
    "setup.label.SelectedMediaService": "Selected Media Service",
    "setup.label.AvailableMedia": "Available Media",
    "setup.label.EventDescription": "Event Description",
    "setup.label.EventCategory": "Event Category",
    "setup.label.CreateEvent": "Create Event",
    "setup.label.DetailsOfProperty": "Details Of Property",
    "setup.label.PropertyCode": "Property Code",
    "setup.label.PropertyType": "Property Type",
    "setup.label.Parcel": "Parcel",
    "setup.label.BuildingCode": "Building Code",
    "setup.label.Precinct": "Precinct",
    "setup.label.Allocated": "Allocated",
    "setup.label.UploadPropertyData": "Upload Property Data",
    "setup.label.Clear": "Clear",
    "setup.label.CreateProperty": "Create Property",
    "setup.label.PropertyDataUpload": "Property Data Upload",
    "setup.label.Street": "Street",
    "setup.label.PaymentType": "Payment Type",
    "setup.label.PoBox": "PoBox",
    "setup.label.State": "State",
    "setup.label.District": "District",
    "setup.label.Floor": "Floor",
    "setup.label.UnitCode": "Unit Code",
    "setup.label.PropertyMaster": "Property Master",
    "setup.label.CodeDescription": "Code Description",
    "setup.label.ReferenceValue": "Reference Value",
    "setup.label.Services": "Services",
    "setup.label.IsBouquet": "IsBouquet",
    "setup.label.Broadcaster": "Broadcaster",
    "setup.label.Channel": "Channel",
    "setup.label.ContactNumber": "Contact Number",
    "setup.label.UOM": "UOM",
    "setup.label.DeleteTemplateDefinition": "Delete Template Definition",
    "setup.label.Discount": "Discount",
    "setup.label.SalseCatalogue": "Sales Catalogue",
    "setup.label.UserCatalogue": "User Catalogue",
    "setup.label.Team": "Team",
    "setup.label.MediaDetails": "Media Details",
    "setup.label.Event": "Event",
    "setup.label.Properties": "Properties",
    "setup.label.ExternalPlanId": "External Plan Id",
    "setup.label.ExternalProductId": "External Product Id",
    "setup.label.ServicesProducts": "Services & Products",
    "setup.label.BroadcasterChannelMapping": "Broadcaster, Channel & Mapping",
    "setup.label.UsageRating": "Usage Rating",
    "setup.label.ZoneSetup": "Zone Setup",
    "setup.label.Promotion": "Promotion",
    "setup.label.PromotionTrigger": "Promotion Trigger",
    "setup.label.PromotionRulesAndRates": "Promotion Rules And Rates",
    "setup.label.CatalogeMapping": "Catalogue Mapping",
    "setup.label.VoucherPin": "Voucher Pin",
    "setup.label.SIMNumber": "SIM Number",
    "setup.label.TeamTeamUser": "Team & Team User",
    "setup.label.MessageTemplate": "Message Template",
    "setup.label.ClosedUserGroup": "Closed User Group",
    "setup.label.IpManagement": "IP Management",
    "setup.label.PropertyDefinition": "Property Definition",
    "setup.label.PriorityMapping": "Priority Mapping",
    "setup.label.AddProducts": "Add Products",
    "setup.label.AddDiscount": "Add Discount",
    "setup.label.Products": "Products",
    "setup.label.ChargeCodeData": "Charge Code Data",
    "setup.label.TaxMapping": "Tax Mapping",
    "setup.label.TaxRegion": "Tax Region",
    "setup.label.CreateUserCatalogue": "Create User Catalogue",
    "setup.label.IcZone": "Ic Zone",
    "setup.label.ViewIcZone": "View Ic Zone",
    "setup.label.ViewNumberZone": "View Number Zone",
    "setup.label.EditNumberZone": "Edit Number Zone",
    "setup.label.DeleteNumberZone": "Delete Number Zone",
    "setup.label.AreYouSure": "Are you sure?",
    "setup.label.ViewAPNZone": "View APN Zone",
    "setup.label.EditAPNZone": "Edit APN Zone",
    "setup.label.DeleteAPNZone": "Delete APN Zone",
    "setup.label.ViewOperatorZone": "View Operator Zone",
    "setup.label.EditOperatorZone": "Edit Operator Zone",
    "setup.label.EditICZone": "Edit IC Zone",
    "setup.label.DeleteOperatorZone": "Delete Operator Zone",
    "setup.label.DeleteIcZone": "Delete IC Zone",
    "setup.label.MobileNumber": "Mobile Number",
    "setup.label.LandlineNumber": "Landline Number (Optional)",
    "setup.label.RatePlanName": "Rate Plan Name",
    "setup.label.CreateVoucherPin": "Create Voucher Pin",
    "setup.label.EditSubCategory": "Edit Sub Category",
    "setup.label.CreateSubCategory": "Create Sub Category",
    "setup.label.ViewSubCategory": "View Sub Category",
    "setup.label.TimeTaken": "Time Taken",
    "setup.label.TeamMapping": "Team Mapping",
    "setup.label.CreateTeamMapping": "Create Team Mapping",
    "setup.label.Category": "Category",
    "setup.label.external_promotional_code": "External Promotional Code",
    "setup.label.Subcategory": "Subcategory",
    "setup.label.DeleteItemMapping": "Delete Item Mapping",
    "setup.label.EditTeamMapping": "Edit Team Mapping",
    "setup.label.ViewTeamMapping": "View Team Mapping",
    "setup.label.DeletePriorityMapping": "Delete Priority Mapping",
    "setup.label.discount_rule": "Discount Rule",
    "setup.label.promotion_rule": "Promotion Rule",
    "setup.label.discount_rate": "Discount Rate",
    "setup.label.create_discount_rule": "Create Discount Rule",
    "setup.label.edit_promotion_rule": "Edit Promotion Rule",
    "setup.label.create_promotion_rule": "Create Promotion Rule",
    "setup.label.create_discount_rate": "Create Discount Rate",
    "setup.label.add_discount_rate": "Add Discount Rate",
    "setup.label.add_promotion_rate": "Add Promotion Rate",
    "setup.label.edit_discount": "Edit Discount",
    "setup.label.edit_promotion": "Edit Promotion",
    "setup.label.edit_discount_trigger": "Edit Discount Trigger",
    "setup.label.edit_discount_rule": "Edit Discount Rule",
    "setup.label.collection_process": "Collection Process",
    "setup.label.create_collection_profile": "Create Collection Profile",
    "setup.label.collection_profile": "Collection Profile",
    "setup.label.collection_profile_id": "Collection ProfileId",
    "setup.label.region": "Region",
    "setup.label.collection": "Collection",
    "setup.label.collection_trigger": "Collection Trigger",
    "setup.label.collection_scenario": "Collection Scenario",
    "setup.label.add_collection_trigger": "Add Collection Trigger",
    "setup.label.add_collection_scenario": "Add Collection Scenario",
    "setup.label.trigger_id": "Trigger Id",
    "setup.label.criteria_type": "Criteria Type",
    "setup.label.due_balance": "Due Balance",
    "setup.label.ageing_days": "Ageing Days",
    "setup.label.scenario_id": "Scenario Id",
    "setup.label.action_name": "Action Name",
    "setup.label.age": "Age",
    "setup.label.create_collection_trigger": "Create Collection Trigger",
    "setup.label.create_collection_scenario": "Create Collection Scenario",
    "setup.label.edit_collection_profile": "Edit Collection Profile",
    "setup.label.edit_collection_trigger": "Edit Collection Trigger",
    "setup.label.edit_collection_scenario": "Edit Collection Scenario",
    "setup.label.SlaInHours": "SLA in Hours",
    "setup.label.contractduration": "Contract Duration",
    "setup.label.chargesperiodicity": "Charges Periodicity",
  },

  fr: {
    "setup.label.Enter_product_Description": "Entrez la description du produit",
    "setup.label.FeedbackStatus": "Statut du retour",
    "setup.label.EnterCountryName": "Entrez le nom du pays",
    "setup.label.location": "Emplacement",
    "setup.label.selectLocation": "Sélectionner l'emplacement",
    "setup.label.create_group_ticket": "Créer un ticket de groupe",
    "setup.label.default": "Défaut",
    "setup.label.customerFeedback": "Retour client",
    "setup.label.automation": "Automatisation",
    "setup.label.automation_master": "Maître d'automatisation",
    "setup.label.create_automation": "Créer une automatisation",
    "setup.label.edit_automation": "Modifier l'automatisation",
    "setup.label.automation_detail": "Détail de l'automatisation",
    "setup.label.automation_steps": "Étapes d'automatisation",
    "setup.label.add_automation_step": "Ajouter une étape d'automatisation",
    "setup.label.AutomationId": "ID d'automatisation",
    "setup.label.EntityName": "Nom de l'entité",
    "setup.label.EntityType": "Type d'entité",
    "setup.label.WorkflowName": "Nom du flux de travail",
    "setup.label.CreateAutomationScenario": "Créer un scénario d'automatisation",
    "setup.label.EditAutomationStep": "Modifier l'étape d'automatisation",
    "setup.label.ActionType": "Type d'action",
    "setup.label.ActionDetails": "Détails de l'action",
    "setup.label.StepOrder": "Ordre des étapes",
    "setup.label.questionAnswerSet": "Ensemble de questions et réponses",
    "setup.label.addQuestionSet": "Ajouter un ensemble de questions",
    "setup.label.EditQuestionSet": "Modifier l'ensemble de questions",
    "setup.label.CategoryName": "Nom de la catégorie",
    "setup.label.SubCategoryName": "Nom de la sous-catégorie",
    "setup.label.TotalQuestions": "Total des questions",
    "setup.label.QuestionType": "Type de question",
    "setup.label.QuestionText": "Texte de la question",
    "setup.label.CustomerFeedback": "Retour client",
    "setup.label.TicketId": "ID du ticket",
    "setup.label.LinkedAt": "Lié le",
    "setup.label.Remarks": "Remarques",
    "setup.label.AddFeedback": "Ajouter un retour",
    "setup.label.PendingForApproval": "En attente d'approbation",
    "setup.label.user_availability": "User Availability",
    "setup.label.all_users_availability": "All User Availability",
    "setup.label.create_user_availability": "Create User Availability",
    "setup.label.LeaveManagement": "Gestion des congés",
    "setup.label.CreateLeave": "Créer un congé",
    "setup.label.EditLeave": "Modifier le congé",
    "setup.label.ViewLeave": "Voir le congé",
    "setup.label.AllUserLeaves": "Tous les congés des utilisateurs",
    "setup.label.MyLeaves": "Mes congés",
    "setup.label.ConfigId": "ID de configuration",
    "setup.label.edit_user_availability": "Edit User Availability",
    "setup.label.view_user_availability": "View User Availability",
    "setup.label.unavailability_date": "Date d'indisponibilité",
    "setup.label.start_time": "Start Time",
    "setup.label.end_time": "End Time",
    "setup.label.my_availability": "My Availability",
    "setup.label.user": "User",
    "setup.label.EditShift": "Modifier le quart",
    "setup.label.UserWorkingShift": "Quart de travail de l'utilisateur",
    "setup.label.CreateUserWorkingShift":
      "Créer un quart de travail de l'utilisateur",
    "setup.label.EditUserWorkingShift":
      "Modifier le quart de travail de l'utilisateur",
    "setup.label.ViewUserWorkingShift":
      "Voir le quart de travail de l'utilisateur",
    "setup.label.TeamName": "Nom de l'équipe",
    "setup.label.Shift": "Quart",
    "setup.label.ShiftManagement": "Gestion des quarts",
    "setup.label.CreateShift": "Créer un quart",
    "setup.label.ShiftName": "Nom du quart",
    "setup.label.Session": "Session",
    "setup.label.SessionType": "Type de session",
    "setup.label.LeaveDetails": "Détails du congé",
    "setup.label.SessionStartTime": "Heure de début de session",
    "setup.label.SessionEndTime": "Heure de fin de session",
    "setup.label.LeaveType": "Type de congé",
    "setup.label.AddAnotherDate": "Ajouter une autre date",
    "setup.label.Apn_Zone": "Zone Apn",
    "setup.label.FeeMaster": "Maître des frais",
    "setup.label.Number_Zone": "Zone Numérique",
    "setup.label.DeleteRUM": "Supprimer RUM",
    "setup.label.Edit_TimeModel": "Modifier le modèle de temps",
    "setup.label.Edit_Year": "Modifier l’année",
    "setup.label.scenario_name": "Nom du scénario",
    "setup.label.event_name": "Nom de l’événement",
    "setup.label.Edit_Month": "Modifier le mois",
    "setup.label.Edit_Day": "Modifier le jour",
    "setup.label.Edit_Time": "Modifier l’heure",
    "setup.label.Delete_TimeModel": "Supprimer le modèle de temps",
    "setup.label.Delete_Year": "Supprimer l’année",
    "setup.label.Delete_Month": "Supprimer le mois",
    "setup.label.Delete_Day": "Supprimer le jour",
    "setup.label.Delete_Time": "Supprimer l’heure",
    "setup.label.Are_you_sure_?": "Êtes-vous sûr ?",
    "setup.label.Save": "Enregistrer",
    "setup.label.TemplateDefinition": "Définition du modèle",
    "setup.label.EditQuantityTier": "Modifier le niveau de quantité",
    "setup.label.Usage_Rate_Balance": "Solde du taux d'utilisation",
    "setup.label.Template_Name": "Nom du modèle",
    "setup.label.Delimiter": "Délimiteur",
    "setup.label.Number_Of_Fields": "Nombre de champs",
    "setup.label.Header_Recorder_Type": "Type d'enregistrement d'en-tête",
    "setup.label.Event_Record_Type": "Type d'enregistrement d'événement",
    "setup.label.CreateUOM": "Créer une unité de mesure",
    "setup.label.TimePeriod": "Période de temps",
    "setup.label.Usage_Rate_Plan": "Plan de taux d'utilisation",
    "setup.label.TemplateDefinition": "Définition du modèle",
    "setup.label.CreateRUM": "Créer un RUM",
    "setup.label.CreateTimePeriod": "Créer une période de temps",
    "setup.label.TimemodelName": "Nom du modèle temporel",
    "setup.label.TimePeriodName": "Nom de la période",
    "setup.label.StartYear": "Année de début",
    "setup.label.EndYear": "Année de fin",
    "setup.label.UsageRatePlan": "Plan de taux d'utilisation",
    "setup.label.Create_Usage_Rate_Plan": "Créer un plan de taux d'utilisation",
    "setup.label.Id": "ID",
    "setup.label.PlanName": "Nom du plan",
    "setup.label.ProductName": "Nom du produit",
    "setup.label.ChargeCode": "Code de facturation",
    "setup.label.TimeModelName": "Nom du modèle temporel",
    "setup.label.RatingType": "Type de tarification",
    "setup.label.RumName": "Nom du RUM",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "Êtes-vous sûr de vouloir supprimer ?",
    "setup.label.UOM": "Unité de mesure",
    "setup.label.RUM": "RUM",
    "setup.label.ImpactCategory": "Catégorie d’impact",
    "setup.label.Resource": "Ressource",
    "setup.label.GLID": "GLID",
    "setup.label.Unit": "Unité",
    "setup.label.Rate": "Taux",
    "setup.label.Action": "Action",
    "setup.label.options_selected": "options sélectionnées",
    "setup.label.UsageRateBalance": "Solde du taux d’utilisation",
    "setup.label.EndYear": "Année de fin",
    "setup.label.StartMonth": "Mois de début",
    "setup.label.EndMonth": "Mois de fin",
    "setup.label.StartDay": "Jour de début",
    "setup.label.EndDay": "Jour de fin",
    "setup.label.StartTime": "Heure de début",
    "setup.label.Time_Model_Name": "Nom du modèle temporel",
    "setup.label.model_includes_which_all_Bands_?":
      "Le modèle comprend quels groupes ?",
    "setup.label.YearRestriction": "Restriction par année",
    "setup.label.MonthRestriction": "Restriction par mois",
    "setup.label.DayRestriction": "Restriction par jour",
    "setup.label.TimeRestriction": "Restriction temporelle",
    "setup.label.Code": "Code",
    "setup.label.Name": "Nom",
    "setup.label.PriorityMapping": "Mappage des priorités",
    "setup.label.AddJurisdiction": "Ajouter une juridiction",
    "setup.label.Are_you_sure_?": "Êtes-vous sûr ?",
    "setup.label.Country": "Pays",
    "setup.label.State": "État",
    "setup.label.District": "District",
    "setup.label.RateType": "Type de taux",
    "setup.label.Remove": "Supprimer",
    "setup.label.TaxMaster": "Maître des taxes",
    "setup.label.Team": "Équipe",
    "setup.label.Add": "Ajouter",
    "setup.label.FeeMaster": "Maître des frais",
    "setup.label.DeleteChargeCode": "Supprimer le code de facturation",
    "setup.label.SelectSearch": "Sélectionner une recherche",
    "setup.label.Select_Content_Tag_Value":
      "Sélectionner la valeur du tag de contenu",
    "setup.label.Plan_Content": "Contenu du forfait",
    "setup.label.Plan": "Forfait",
    "setup.label.ProductPrice": "Prix du produit",
    "setup.label.SelectedPromotions": "Promotions sélectionnées",
    "setup.label.AvailablePromotions": "Promotions disponibles",
    "setup.label.SelectType": "Sélectionner le type",
    "setup.label.Type": "Type",
    "setup.label.No_versions_available": "Aucune version disponible",
    "setup.label.Version": "Version",
    "setup.label.ListPrice": "Prix catalogue",
    "setup.label.SellingPrice": "Prix de vente",
    "setup.label.EnterPlanDescription": "Entrer la description du plan",
    "setup.label.AddPrice": "Ajouter un prix",
    "setup.label.Save": "Enregistrer",
    "setup.label.AddDiscount": "Ajouter une remise",
    "setup.label.AvailablePlans": "Plans disponibles",
    "setup.label.SelectedPlans": "Plans sélectionnés",
    "setup.label.PlanType": "Type de plan",
    "setup.label.Plan_Start_Date": "Date de début du plan",
    "setup.label.Plan_End_Date": "Date de fin du plan",
    "setup.label.Bill_Type": "Type de facture",
    "setup.label.AttributeTypes": "Types d'attributs",
    "setup.label.Add": "Ajouter",
    "setup.label.Select_Content_Tag": "Sélectionner le tag de contenu",
    "setup.label.PlanName": "Nom du plan",
    "setup.label.AvailableDiscounts": "Réductions disponibles",
    "setup.label.Search": "Rechercher...",
    "setup.label.MoveRight": "Déplacer vers la droite",
    "setup.label.MoveLeft": "Déplacer vers la gauche",
    "setup.label.SelectedDiscounts": "Réductions sélectionnées",
    "setup.label.SelectType": "Sélectionner le type",
    "setup.label.SelectLanguage": "Sélectionner la langue",
    "setup.label.SelectContentTag": "Sélectionner le tag de contenu",
    "setup.label.SelectContentTagValue": "Sélectionner la valeur du tag",
    "setup.label.DigitalContent": "Contenu numérique",
    "setup.label.Enter_Plan_Description": "Entrez la description du plan",
    "setup.label.DC_Rule": "Règle DC",
    "setup.label.PlanAttribute": "Attribut du plan",
    "setup.label.AdvanceView": "Vue avancée",
    "setup.label.Update": "Mettre à jour",
    "setup.label.ProductMapping": "Correspondance de produit",
    "setup.label.Service": "Service",
    "setup.label.SubProducts": "Sous-produits",
    "setup.label.Type": "Type",
    "setup.label.EnterValue": "Entrer la valeur",
    "setup.label.PriceRegion": "Région tarifaire",
    "setup.label.Enter_service_Description": "Entrez la description du service",
    "setup.label.ParamName": "Nom du paramètre",
    "setup.label.Category": "Catégorie",
    "setup.label.Type": "Type",
    "setup.label.EnterValue": "Entrer la valeur",
    "setup.label.SalesCatalogue": "Catalogue de ventes",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "Êtes-vous sûr de vouloir supprimer ?",
    "setup.label.Channel": "Chaîne",
    "setup.label.Broadcaster": "Diffuseur",
    "setup.label.AddPrice": "Ajouter un prix",
    "setup.label.DeleteMediaEvent": "Supprimer l’événement média",
    "setup.label.AdvMedia": "Média publicitaire",
    "setup.label.EditMedia": "Modifier le média",
    "setup.label.AddEvent": "Ajouter un événement",
    "setup.label.AddAttributes": "Ajouter des attributs",
    "setup.label.AddLocation": "Ajouter un emplacement",
    "setup.label.DeleteEvent": "Supprimer l’événement",
    "setup.label.Are_you_sure_?": "Êtes-vous sûr ?",
    "setup.label.Add": "Ajouter",
    "setup.label.ViewEvent": "Voir l’événement",
    "setup.label.Event": "Événement",
    "setup.label.RUM": "RUM",
    "setup.label.OptType": "Type d'option",
    "setup.label.Currency": "Devise",
    "setup.label.Amount": "Montant",
    "setup.label.Add": "Ajouter",
    "setup.label.Save": "Enregistrer",
    "setup.label.AddDiscount": "Ajouter une remise",
    "setup.label.EnterEventCode": "Entrez le code de l'événement",
    "setup.label.EnterEventDescription": "Entrez la description de l'événement",
    "setup.label.EventDescription": "Description de l'événement",
    "setup.label.EventCategory": "Catégorie d'événement",
    "setup.label.ChargeCode": "Code de facturation",
    "setup.label.SelectEventValidity":
      "Sélectionner la validité de l'événement",
    "setup.label.EditEvent": "Modifier l'événement",
    "setup.label.UnitCode": "Code d’unité",
    "setup.label.MediaTitle": "Titre du média",
    "setup.label.ContentProvider": "Fournisseur de contenu",
    "setup.label.MediaType": "Type de média",
    "setup.label.Rated": "Évalué",
    "setup.label.MediaCategory": "Catégorie de média",
    "setup.label.Rating": "Classement",
    "setup.label.Poster": "Affiche",
    "setup.label.Status": "Statut",
    "setup.label.MovieDuration": "Durée du film",
    "setup.label.ReleaseDate": "Date de sortie",
    "setup.label.Genre": "Genre",
    "setup.label.Subject": "Sujet",
    "setup.label.Overview": "Aperçu",
    "setup.label.Share(%)": "Part (%)",
    "setup.label.Cast": "Distribution",
    "setup.label.AttributeType": "Type d’attribut",
    "setup.label.CaptionValue": "Valeur de la légende",
    "setup.label.NickName": "Surnom",
    "setup.label.Image": "Image",
    "setup.label.Language": "Langue",
    "setup.label.Format": "Format",
    "setup.label.Location": "Emplacement",
    "setup.label.CustomerType": "Type de client",
    "setup.label.FormatType": "Type de format",
    "setup.label.DiscountCode": "Code de réduction",
    "setup.label.ReProcess": "ReTraiter",
    "setup.label.Code": "Code",
    "setup.label.Description": "Description",
    "setup.label.PropertyCodeType": "Type de code de propriété",
    "setup.label.ReferenceValue": "Valeur de référence",
    "setup.label.EditProperty": "Modifier la propriété",
    "setup.label.EditPropertyMaster": "Modifier le maître de propriété",
    "setup.label.Cancel": "Annuler",
    "setup.label.View": "Voir",
    "setup.label.Edit": "Modifier",
    "setup.label.Browse_file_to_Upload": "Parcourir le fichier à télécharger",
    "setup.label.CreatePropertyMaster": "Créer un maître de propriété",
    "setup.label.Property": "Propriété",
    "setup.label.PropertyMaster": "Maître de propriété",
    "setup.label.ViewProperty": "Voir la propriété",
    "setup.label.ViewPropertyMaster": "Voir le maître de propriété",
    "setup.label.Are_you_sure_?": "Êtes-vous sûr ?",
    "setup.label.Edit": "Modifier",
    "setup.label.Code": "Code",
    "setup.label.Name": "Nom",
    "setup.label.AddState": "Ajouter un État",
    "setup.label.AddDistrict": "Ajouter un district",
    "setup.label.AddCity": "Ajouter une ville",
    "setup.label.EditCountry": "Modifier le pays",
    "setup.label.EditState": "Modifier l’État",
    "setup.label.EditDistrict": "Modifier le district",
    "setup.label.EditCity": "Modifier la ville",
    "setup.label.DeleteCountry": "Supprimer le pays",
    "setup.label.DeleteState": "Supprimer l’État",
    "setup.label.DeleteDistrict": "Supprimer le district",
    "setup.label.DeleteCity": "Supprimer la ville",
    "setup.label.ServiceAvailablity": "Disponibilité du service",
    "setup.label.EnterCountryCode": "Entrez le code du pays",
    "setup.label.EnterCode": "Entrez le code",
    "setup.label.EnterName": "Entrez le nom",
    "setup.label.Service_Availablity_for_the":
      "Disponibilité du service pour le",
    "setup.label.SelectServices": "Sélectionner des services",
    "setup.label.Select_One_or_More": "Sélectionner un ou plusieurs",
    "setup.label.options_selected": "options sélectionnées",
    "setup.label.PromotionName": "Nom de la promotion",
    "setup.label.PromotionCode": "Code promotionnel",
    "setup.label.BussinesType": "Type d'entreprise",
    "setup.label.OrderType": "Type de commande",
    "setup.label.PaymentType": "Type de paiement",
    "setup.label.SelectCategory": "Sélectionner une catégorie",
    "setup.label.PromotionTrigger": "Déclencheur de promotion",
    "setup.label.PromotionRule": "Règle de promotion",
    "setup.label.PromotionTriggerCondition":
      "Condition de déclenchement de la promotion",
    "setup.label.DiscountTriggerCondition":
      "Condition de déclenchement de remise",
    "setup.label.DiscountRule": "Règle de remise",
    "setup.label.DiscountTrigger": "Déclencheur de remise",
    "setup.label.EditTriggerCondition":
      "Modifier la condition de déclenchement",
    "setup.label.Rate": "Taux",
    "setup.label.EditRule": "Modifier la règle",
    "setup.label.AddRate": "Ajouter un taux",
    "setup.label.Download": "Télécharger",
    "setup.label.Process": "Traiter",
    "setup.label.ViewVendor": "Voir le fournisseur",
    "setup.label.VendorCode": "Code fournisseur",
    "setup.label.VendorName": "Nom du fournisseur",
    "setup.label.select_Currency": "Sélectionnez la devise",
    "setup.label.select_Country": "Sélectionnez le pays",
    "setup.label.Filter_List": "Filtrer la liste",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "Êtes-vous sûr de vouloir supprimer ?",
    "setup.label.DeleteVoucher": "Supprimer le bon",
    "setup.label.UpdatePin": "Mettre à jour le code PIN",
    "setup.label.UpdateVoucher": "Mettre à jour le bon",
    "setup.label.select_from_dropdown": "Sélectionnez dans la liste déroulante",
    "setup.label.ItemModel": "Modèle d'article",
    "setup.label.price": "Prix",
    "setup.label.Edit": "Modifier",
    "setup.label.Delete": "Supprimer",
    "setup.label.Item": "Article",
    "setup.label.EnterSupplierAddress": "Entrez l'adresse du fournisseur",
    "setup.label.Title": "Titre",
    "setup.label.AddPromotionTriggerCondition":
      "Ajouter une condition de déclenchement de promotion",
    "setup.label.EditPromotionTriggerCondition":
      "Modifier une condition de déclenchement de promotion",
    "setup.label.AssignTo": "Attribuer à",
    "setup.label.Version": "Version",
    "setup.label.IsOverride": "Est-ce un remplacement",
    "setup.label.PlanAttribute": "Attribut du plan",
    "setup.label.ValidationRule": "Règle de validation",
    "setup.label.SaveAndContinue": "Enregistrer et continuer",
    "setup.label.PlanManagement": "Gestion des plans",
    "setup.label.Plan": "Plan",
    "setup.label.DiscountTriggerCondition":
      "Condition de déclenchement de remise",
    "setup.label.AddDiscountTriggerCondition":
      "Ajouter une condition de déclenchement de remise",
    "setup.label.SalesChannel": "Canal de vente",
    "setup.label.PaymentType": "Type de paiement",
    "setup.label.OrderType": "Type de commande",
    "setup.label.BusinessType": "Type d'entreprise",
    "setup.label.ViewDigitalContent": "Afficher le contenu numérique",
    "setup.label.EditDigitalContent": "Modifier le contenu numérique",
    "setup.label.AddDigitalContent": "Ajouter du contenu numérique",
    "setup.label.PromotionRuleName": "Nom de la règle de promotion",
    "setup.label.PromotionTriggerCondition":
      "Condition de déclenchement de promotion",
    "setup.label.AddPromotionTriggerCondition":
      "Ajouter une condition de déclenchement de promotion",
    "setup.label.BussinesType": "Type d'entreprise",
    "setup.label.requestApproval": "Demander une approbation",
    "setup.label.validity_uom": "Unité de Validité",
    "setup.label.validity_value": "Valeur de Validité",
    "setup.label.ViewItemModel": "Voir le modèle d'article",
    "setup.label.ItemType": "Type d'article",
    "setup.label.ViewSupplier": "Voir le fournisseur",
    "setup.label.SupplierCode": "Code fournisseur",
    "setup.label.SupplierDescription": "Description du fournisseur",
    "setup.label.SupplierAddress": "Adresse du fournisseur",
    "setup.label.DeleteSupplier": "Supprimer le fournisseur",
    "setup.label.CreateContract": "Créer un contrat",
    "setup.label.RateTierName": "Nom du niveau tarifaire",
    "setup.label.RangeType": "Type de plage",
    "setup.label.CreateDiscountRule": "Créer une règle de remise",
    "setup.label.RuleCondition": "Condition de règle",
    "setup.label.CreateRuleCondition": "Créer une condition de règle",
    "setup.label.CreateRule": "Créer une règle",
    "setup.label.Entity": "Entité",
    "setup.label.EntityField": "Champ d'entité",
    "setup.label.contentTag": "Étiquette de contenu",
    "setup.label.contentTagValue": "Valeur de l'étiquette de contenu",
    "setup.label.ExecutionType": "Type d'exécution",
    "setup.label.OperationMode": "Mode de fonctionnement",
    "setup.label.AggregationType": "Type d'agrégation",
    "setup.label.DurationInDays": "Durée en jours",
    "setup.label.CreateTicketTeamUser":
      "Créer un utilisateur de l'équipe des tickets",
    "setup.label.termsConditions": "Conditions générales",
    "setup.label.updateTermsConditions":
      "Mettre à jour les conditions générales",
    "setup.label.updateDigitalContent": "Mettre à jour le contenu numérique",
    "setup.label.createDigitalContent": "Créer du contenu numérique",
    "setup.label.createTermsConditions": "Créer des termes et conditions",
    "setup.label.digitalContent": "Contenu numérique",
    "setup.label.planContent": "Contenu du forfait",
    "setup.label.selectPlanContent": "Sélectionnez le contenu du forfait",
    "setup.label.FilterType": "Type de filtre",
    "setup.label.FilterValue": "Valeur du filtre",
    "setup.label.ContractPeriod": "Période de contrat",
    "setup.label.AddContract": "Ajouter un contrat",
    "setup.label.EditContract": "Modifier le contrat",
    "setup.label.ExternalPlanId": "ID du plan externe",
    "setup.label.ExternalProductId": "ID du produit externe",
    "setup.label.ViewContract": "Voir le contrat",
    "setup.label.ContractType": "Type de contrat",
    "setup.label.ContractUnit": "Unité contractuelle",
    "setup.label.updateNetMask": "Mettre à jour le masque de réseau",
    "setup.label.Update": "Mettre à jour",
    "setup.label.BillType": "Type de facture",
    "setup.label.BillFrequency": "Fréquence de facturation",
    "setup.label.PlanEndDate": "Date de fin du plan",
    "setup.label.AddContent": "Ajouter du contenu",
    "setup.label.CreatePlanContent": "Créer le contenu du plan",
    "setup.label.SelectLanguage": "Sélectionner la langue",
    "setup.label.UploadDigitalImage": "Télécharger une image numérique",
    "setup.label.ViewPlanContent": "Voir le contenu du plan",
    "setup.label.ExternalPlanName": "Nom du plan externe",
    "setup.label.ExternalProductName": "Nom du produit externe",
    "setup.label.ViewPrice": "Voir le prix",
    "setup.label.SelectedPlanDiscounts": "Réductions sur le plan sélectionné,",
    "setup.label.ProductDiscount": "Réductions sur le produit,",
    "setup.label.createIpPool": "Créer un pool d'IP",
    "setup.label.editIpPool": "Modifier le pool d'IP",
    "setup.label.AddOrEditDiscount": "Ajouter/Modifier une remise",
    "setup.label.Next": "Suivant",
    "setup.label.PlanValidationRules": "Règles de validation du plan",
    "setup.label.CreateValidationRule": "Créer une règle de validation",
    "setup.label.EditValidationRule": "Modifier la règle de validation",
    "setup.label.InputPlanId": "Saisir l'ID du plan",
    "setup.label.CheckinPlanId": "ID du plan de validation",
    "setup.label.RuleAppliesTo": "Unité",
    "setup.label.Rule": "Règle",
    "setup.label.ViewValidationRule": "Règle de validation de la vue",
    "setup.label.ValidationRule": "Règle de validation",

    "setup.label.select_date": "Sélectionner la Date",
    "setup.label.MainCategory": "catégorie principale",
    "setup.label.SubCategory": "Sous-catégorie",
    "setup.label.AddDiscountTrigger": "Ajouter un Déclencheur de Réduction",
    "setup.label.AddPromotionTrigger": "Ajouter un déclencheur de promotion",
    "setup.label.edit_promotion_trigger":
      "Modifier le déclencheur de promotion",
    "setup.label.DiscountTrigger": "Déclencheur de Réduction",
    "setup.label.TriggerName": "Nom du Déclencheur",
    "setup.label.When": "Quand",
    "setup.label.CustomerType": "Type de Client",
    "setup.label.Criteria": "Critères",
    "setup.label.Values": "Valeurs",
    "setup.label.ApplicableTo": "Applicable à",
    "setup.label.ApplicableValues": "Valeurs Applicables",
    "setup.label.DiscountRulesAndRates": "Règles et Taux de Réduction",
    "setup.label.RuleName": "Nom de la Règle",
    "setup.label.MaxDiscount": "Réduction Maximale",
    "setup.label.ResourceId": "Identifiant de Ressource",
    "setup.label.DiscountRateType": "Type de Taux de Réduction",
    "setup.label.Unit": "Unité",
    "setup.label.DiscountId": "Identifiant de Réduction",
    "setup.label.DiscountName": "Nom de la Réduction",
    "setup.label.Priority": "Priorité",
    "setup.label.Items": "Articles",
    "setup.label.ItemCode": "Code d'article",
    "setup.label.ItemDescription": "Description de l'article",
    "setup.label.Units": "Unités",
    "setup.label.Total": "Total",
    "setup.label.Warranty": "Garantie",
    "setup.label.UsedItems": "Articles utilisés",
    "setup.label.Balanced": "Équilibré",
    "setup.label.IsProvisioning": "Est la provision",
    "setup.label.CreateItem": "Créer un article",
    "setup.label.ItemClass": "Classe d'article",
    "setup.label.ReorderLevel": "Niveau de réapprovisionnement",
    "setup.label.WarrantyPeriod": "Période de garantie",
    "setup.label.Currency": "Devise",
    "setup.label.DefaultPrice": "Prix par défaut",
    "setup.label.IsSelector": "Est sélecteur",
    "setup.label.SelectorMenu": "Menu sélecteur",
    "setup.label.Selector": "Sélecteur",
    "setup.label.VariablePrice": "Prix variable",
    "setup.label.ItemModel": "Modèle d'article",
    "setup.label.Price": "Prix",
    "setup.label.Action": "Action",
    "setup.label.Cancel": "Annuler",
    "setup.label.planPrice": "Prix du Plan",
    "setup.label.listview": "Affichage en Liste",
    "setup.label.Submit": "Soumettre",
    "setup.label.EditItem": "Modifier l'élément",
    "setup.label.Id": "Id",
    "setup.label.ItemMasterId": "Identifiant de l'élément maître",
    "setup.label.RegionId": "Identifiant de région",
    "setup.label.Edit": "Modifier",
    "setup.label.ViewItem": "Voir l'élément",
    "setup.label.UnitPrice": "Prix unitaire",
    "setup.label.ItemModels": "Modèles d'élément",
    "setup.label.NetworkElement": "Élément de réseau",
    "setup.label.Model": "Modèle",
    "setup.label.Make": "Fabriquer",
    "setup.label.CreateItemModel": "Créer un modèle d'élément",
    "setup.label.Reset": "Réinitialiser",
    "setup.label.EditItemModel": "Modifier le modèle d'élément",
    "setup.label.ServiceCode": "Code de service",
    "setup.label.ServiceDescription": "Description du service",
    "setup.label.ServiceType": "Type de service",
    "setup.label.Isoptional": "Est optionnel",
    "setup.label.Isautoprovision": "Est autoprovision",
    "setup.label.CreateService": "Créer un service",
    "setup.label.Code": "Code",
    "setup.label.Description": "Description",
    "setup.label.Type": "Type",
    "setup.label.EditService": "Modifier le service",
    "setup.label.ServiceParameter": "Paramètre de service",
    "setup.label.ParamName": "Nom du paramètre",
    "setup.label.ParamType": "Type de paramètre",
    "setup.label.ParamCategory": "Catégorie de paramètre",
    "setup.label.ParamValue": "Valeur du paramètre",
    "setup.label.Delete": "Supprimer",
    "setup.label.ServiceCategory": "Catégorie de service",
    "setup.label.DeleteServices": "Supprimer les services",
    "setup.label.Confirm": "Confirmer",
    "setup.label.Service": "Service",
    "setup.label.Status": "Statut",
    "setup.label.Bouquet": "Bouquet",
    "setup.label.Actions": "Actions",
    "setup.label.CreateProduct": "Créer un produit",
    "setup.label.ProductParameter": "Paramètre du produit",
    "setup.label.EditProduct": "Modifier le produit",
    "setup.label.ProductDescription": "Description du produit",
    "setup.label.ProductCategory": "Catégorie de produit",
    "setup.label.BroadcasterCode": "Code de Diffuseur",
    "setup.label.BroadcasterName": "Nom du Diffuseur",
    "setup.label.GstRegNumber": "Numéro de Registre GST",
    "setup.label.ContactPerson": "Personne de Contact",
    "setup.label.ContactMobile": "Mobile de Contact",
    "setup.label.Email": "Email",
    "setup.label.CreateBroadcaster": "Créer un Diffuseur",
    "setup.label.Address": "Adresse",
    "setup.label.MobileNo": "Numéro de Mobile",
    "setup.label.LandlineNo": "Numéro de Téléphone Fixe",
    "setup.label.EditBroadcaster": "Modifier le Diffuseur",
    "setup.label.ChannelName": "Nom de la Chaîne",
    "setup.label.ChannelType": "Type de Chaîne",
    "setup.label.DeleteBroadcaster": "Supprimer le Diffuseur",
    "setup.label.ChannelCategory": "Catégorie de Chaîne",
    "setup.label.ChannelSequence": "Séquence de Chaîne",
    "setup.label.IsHdChannel": "Est une Chaîne HD",
    "setup.label.CreateChannel": "Créer une Chaîne",
    "setup.label.Language": "Langue",
    "setup.label.IsLocalChannel": "Est une Chaîne Locale",
    "setup.label.Genre": "Genre",
    "setup.label.BroadcasterId": "ID du Diffuseur",
    "setup.label.EditChannel": "Modifier la Chaîne",
    "setup.label.DeleteChannel": "Supprimer la Chaîne",
    "setup.label.ProductMapping": "Cartographie des Produits",
    "setup.label.CreateProductChannelMapping":
      "Créer une Cartographie de Chaînes",
    "setup.label.ProductId": "ID Produit",
    "setup.label.AvailableChannels": "Chaînes Disponibles",
    "setup.label.SelectedChannels": "Chaînes Sélectionnées",
    "setup.label.EditChannelMapping": "Modifier la Cartographie des Chaînes",
    "setup.label.PlanPricing": "Plan & Tarification",
    "setup.label.CreatePlan": "Créer un Plan",
    "setup.label.PlanCode": "Code du Plan",
    "setup.label.PlanDescription": "Description du Plan",
    "setup.label.PlanStatus": "Statut du Plan",
    "setup.label.PlanProvisionSystem": "Système de Provision du Plan",
    "setup.label.PlanStartDate": "Date de Début du Plan",
    "setup.label.IsPrepaid": "Est Prépayé",
    "setup.label.Duration": "Durée",
    "setup.label.PlanType": "Type de Plan",
    "setup.label.BillingRule": "Règle de Facturation",
    "setup.label.EndDate": "Date de Fin",
    "setup.label.IsProvision": "Est Provisionné",
    "setup.label.EditPlan": "Modifier le Plan",
    "setup.label.SelectProduct": "Sélectionner un Produit",
    "setup.label.ViewPlan": "Voir le Plan",
    "setup.label.ProvisioningSystem": "Système de Provision",
    "setup.label.DeletePlan": "Supprimer le Plan",
    "setup.label.Prices": "Prix",
    "setup.label.ChargeOwner": "Propriétaire de la charge",
    "setup.label.DiscountCode": "Code de réduction",
    "setup.label.PriceRegion": "Région de prix",
    "setup.label.Resource": "Ressource",
    "setup.label.SalesChannel": "Canal de vente",
    "setup.label.OrderType": "Type de commande",
    "setup.label.BusinessType": "Type d'entreprise",
    "setup.label.RoundingType": "Type d'arrondi",
    "setup.label.GLID": "ID GL",
    "setup.label.Value": "Valeur",
    "setup.label.TemplateDefinition": "Définition du Modèle",
    "setup.label.CreateTemplateDefinition": "Créer la Définition du Modèle",
    "setup.label.TemplateName": "Nom du Modèle",
    "setup.label.Delimiter": "Délimiteur",
    "setup.label.NumberOfFields": "Nombre de Champs",
    "setup.label.HeaderRecorderType": "Type d'Enregistreur d'En-tête",
    "setup.label.EventRecordType": "Type d'Enregistrement d'Événement",
    "setup.label.ProductCode": "Code du Produit",
    "setup.label.IsHeader": "Est un En-tête",
    "setup.label.FieldType": "Type de Champ",
    "setup.label.FieldName": "Nom du Champ",
    "setup.label.IdentifierType": "Type d'Identifiant",
    "setup.label.Length": "Longueur",
    "setup.label.ExistsTemplateDefinition": "Définition du Modèle Existant",
    "setup.label.UOM(Unit Of measurement)": "UOM (Unité de mesure)",
    "setup.label.CreateUOM": "Créer une UOM",
    "setup.label.Name": "Nom",
    "setup.label.EditTemplateDefinition": "Modifier la définition du modèle",
    "setup.label.EditUOM": "Modifier l'UOM",
    "setup.label.Save": "Enregistrer",
    "setup.label.DeleteUOM": "Supprimer l'UOM",
    "setup.label.Ok": "Ok",
    "setup.label.ViewUOM": "Voir l'UOM",
    "setup.label.RUM(RatableUsageMetric)":
      "RUM (Métrique d'Utilisation Tarifiable)",
    "setup.label.CreateRUM": "Créer un RUM",
    "setup.label.ChargeName": "Nom de la Charge",
    "setup.label.Template Name": "Nom du Modèle",
    "setup.label.RumName": "Nom du Rum",
    "setup.label.RumExpression": "Expression du Rum",
    "setup.label.Operators": "Opérateurs",
    "setup.label.EditRUM": "Modifier le RUM",
    "setup.label.ViewRUM": "Voir le RUM",
    "setup.label.TimePeriod": "Période",
    "setup.label.CreateTimePeriod": "Créer une période",
    "setup.label.TimeModelName": "Nom du modèle temporel",
    "setup.label.StartYear": "Année de début",
    "setup.label.EndYear": "Année de fin",
    "setup.label.StartMonth": "Mois de début",
    "setup.label.EndMonth": "Mois de fin",
    "setup.label.StartDay": "Jour de début",
    "setup.label.EndDay": "Jour de fin",
    "setup.label.StartTime": "Heure de début",
    "setup.label.EndTime": "Heure de fin",
    "setup.label.CreateTimeModel": "Créer un modèle temporel",
    "setup.label.ExpandAll / CollapseAll": "Tout déplier / Tout replier",
    "setup.label.AddTimemodel": "Ajouter un modèle temporel",
    "setup.label.UsageRatePlan": "Plan de tarification d'usage",
    "setup.label.CreateUsageRatePlan": "Créer un plan de tarification d'usage",
    "setup.label.PlanName": "Nom du plan",
    "setup.label.ProductName": "Nom du produit",
    "setup.label.TimemodelName": "Nom du modèle temporel",
    "setup.label.ViewUsageRatePlan": "Voir le plan de tarification d'usage",
    "setup.label.RUM": "RUM",
    "setup.label.RatingType": "Type de tarification",
    "setup.label.TimeModel": "Modèle temporel",
    "setup.label.ZoneModel": "Modèle de zone",
    "setup.label.ViewQuantityTier": "Voir le niveau de quantité",
    "setup.label.QuantityTier": "Niveau de quantité",
    "setup.label.TierName": "Nom du niveau",
    "setup.label.CumulativeResource": "Ressource cumulative",
    "setup.label.TierRange": "Plage de niveau",
    "setup.label.StepName": "Nom de l'étape",
    "setup.label.StartRange": "Plage de début",
    "setup.label.EndRange": "Plage de fin",
    "setup.label.AddQuantityTier": "Ajouter un niveau de quantité",
    "setup.label.NumberZone": "Zone de numéro",
    "setup.label.CreateNumberZone": "Créer une zone de numéro",
    "setup.label.SourceNumberPrefix": "Préfixe de numéro source",
    "setup.label.DestinationNumberPrefix": "Préfixe de numéro de destination",
    "setup.label.ImpactCategory": "Catégorie d'impact",
    "setup.label.Rank": "Rang",
    "setup.label.APNZone": "Zone APN",
    "setup.label.APN": "APN",
    "setup.label.CreateAPNZone": "Créer une zone APN",
    "setup.label.OperatorZone": "Zone d'opérateur",
    "setup.label.CreateOperatorZone": "Créer une zone d'opérateur",
    "setup.label.SourceOperatorCode": "Code de l'opérateur source",
    "setup.label.DestinationOperatorCode": "Code de l'opérateur de destination",
    "setup.label.ICZone": "Zone IC",
    "setup.label.IncomingTrunkid": "Trunkid entrant",
    "setup.label.OutcomingTrunkid": "Trunkid sortant",
    "setup.label.ChargeCode": "Code de frais",
    "setup.label.CreateChargeCode": "Créer un code de frais",
    "setup.label.ChargeDescription": "Description des frais",
    "setup.label.ChargeType": "Type de frais",
    "setup.label.ChargeDuration": "Durée des frais",
    "setup.label.DurationType": "Type de durée",
    "setup.label.TaxInclusive": "Taxe incluse",
    "setup.label.BillFrequencyCode": "Code de fréquence de facturation",
    "setup.label.TaxCode": "Code fiscal",
    "setup.label.IsAggregate": "Est agrégé",
    "setup.label.EditChargeCode": "Modifier le code de frais",
    "setup.label.TaxMaster": "Maître des taxes",
    "setup.label.CreateTaxMaster": "Créer un maître des taxes",
    "setup.label.GroupType": "Type de groupe",
    "setup.label.GroupCode": "Code de groupe",
    "setup.label.StartDate": "Date de début",
    "setup.label.Rate": "Taux",
    "setup.label.BaseTaxCode": "Code fiscal de base",
    "setup.label.Jurisdiction": "Juridiction",
    "setup.label.RateType": "Type de taux",
    "setup.label.Location": "Emplacement",
    "setup.label.DeleteTax": "Supprimer la taxe",
    "setup.label.CreateDiscount": "Créer une remise",
    "setup.label.DiscountDescription": "Description de la remise",
    "setup.label.DiscountType": "Type de remise",
    "setup.label.DiscountRate": "Taux de remise",
    "setup.label.DiscountDetails": "Détails de la remise",
    "setup.label.ClientCategory": "Catégorie de client",
    "setup.label.CustomerCategory": "Catégorie de client",
    "setup.label.EditDiscount": "Modifier la remise",
    "setup.label.DeleteDiscount": "Supprimer la remise",
    "setup.label.CreatePromotion": "Créer une promotion",
    "setup.label.PromotionCode": "Code de promotion",
    "setup.label.PromotionName": "Nom de la promotion",
    "setup.label.PromotionId": "Numéro de promotion",
    "setup.label.PromotionDescription": "Description de la promotion",
    "setup.label.EditPromotionCode": "Modifier le code de promotion",
    "setup.label.ListOfDiscounts": "Liste des remises",
    "setup.label.ListofTimePeriods": "Liste des périodes de temps",
    "setup.label.CreatePriceRegion": "Créer une région de prix",
    "setup.label.RegionCode": "Code de région",
    "setup.label.RegionName": "Nom de la région",
    "setup.label.Country": "Pays",
    "setup.label.States": "États",
    "setup.label.EditPriceRegion": "Modifier la région de prix",
    "setup.label.DeletePriceRegion": "Supprimer la région de prix",
    "setup.label.CreateSalesCatalogue": "Créer un catalogue de ventes",
    "setup.label.SalesCatalogueName": "Nom du catalogue de ventes",
    "setup.label.AssignUsers": "Attribuer des utilisateurs",
    "setup.label.SalesPlanCategory": "Catégorie du plan de vente",
    "setup.label.Plans": "Plans",
    "setup.label.EditSalesCatalogue": "Modifier le catalogue de ventes",
    "setup.label.DeleteSalesCatalogue": "Supprimer le catalogue de ventes",
    "setup.label.UserId": "ID utilisateur",
    "setup.label.UserName": "Nom d'utilisateur",
    "setup.label.CreateUsersCatalogue": "Créer un catalogue d'utilisateurs",
    "setup.label.Catalogue": "Catalogue",
    "setup.label.EditUserCatalogue": "Modifier le catalogue d'utilisateurs",
    "setup.label.VoucherPins": "Codes de bons",
    "setup.label.CreateVoucherPins": "Créer des codes de bons",
    "setup.label.Voucher": "Bon",
    "setup.label.Coupon": "Coupon",
    "setup.label.LCO": "LCO",
    "setup.label.LengthOfPins": "Longueur des pins",
    "setup.label.SerialNoLength": "Longueur du numéro de série",
    "setup.label.NumberValue ": "Valeur Numérique",
    "setup.label.PinValue ": "Valeur du Code PIN",
    "setup.label.BatchName": "Nom du lot",
    "setup.label.PinCategory": "Catégorie de code",
    "setup.label.BeginWith": "Commencer avec",
    "setup.label.Quantity": "Quantité",
    "setup.label.PinType": "Type de code",
    "setup.label.SIMNumbers": "Numéros SIM",
    "setup.label.CreateSIMNumber": "Créer un numéro SIM",
    "setup.label.NumberCategory": "Catégorie de numéro",
    "setup.label.ExpiryDate": "Date d'expiration",
    "setup.label.Partner": "Partenaire",
    "setup.label.LengthofNumber": "Longueur du numéro",
    "setup.label.LengthofSerialNumber": "Longueur du numéro de série",
    "setup.label.NumberType": "Type de numéro",
    "setup.label.Product": "Produit",
    "setup.label.Supplier": "Fournisseur",
    "setup.label.CreateSupplier": "Créer un fournisseur",
    "setup.label.EditSupplier": "Modifier le fournisseur",
    "setup.label.AddressMaster": "Adresse principale",
    "setup.label.CountryName": "Nom du pays",
    "setup.label.StateName": "Nom de l'état",
    "setup.label.DistrictName": "Nom du district",
    "setup.label.CityName": "Nom de la ville",
    "setup.label.TreeView": "Vue en arbre",
    "setup.label.AddCountry": "Ajouter un pays",
    "setup.label.CountryCode": "Code du pays",
    "setup.label.TeamHead": "Chef d'équipe",
    "setup.label.CreateTicketTeam": "Créer une équipe de tickets",
    "setup.label.TeamCode": "Code de l'équipe",
    "setup.label.TeamDescription": "Description de l'équipe",
    "setup.label.TeamCategory": "Catégorie d'équipe",
    "setup.label.CreateTicketTeamUsers":
      "Créer des utilisateurs d'équipe de tickets",
    "setup.label.TeamEmail": "Email de l'équipe",
    "setup.label.AvailableUsers": "Utilisateurs disponibles",
    "setup.label.SelectedUsers": "Utilisateurs sélectionnés",
    "setup.label.TeamId": "ID de l'équipe",
    "setup.label.ViewTeam": "Voir l'équipe",
    "setup.label.DeleteTeam": "Supprimer l'équipe",
    "setup.label.EditTicketTeam": "Modifier l'équipe de tickets",
    "setup.label.TeamUser": "Utilisateur de l'équipe",
    "setup.label.EditTicketUsers": "Modifier les utilisateurs de tickets",
    "setup.label.DeleteTeamUser": "Supprimer l'utilisateur de l'équipe",
    "setup.label.VendorManagement": "Gestion des fournisseurs",
    "setup.label.CreateVendor": "Créer un fournisseur",
    "setup.label.ContactName": "Nom du contact",
    "setup.label.Mobile": "Mobile",
    "setup.label.Landline": "Ligne fixe",
    "setup.label.CreateNewVendor": "Créer un nouveau fournisseur",
    "setup.label.EditVendor": "Modifier le fournisseur",
    "setup.label.FeeMaster": "Maître des frais",
    "setup.label.CreateFeeMaster": "Créer maître des frais",
    "setup.label.FeeMasterCode": "Code maître des frais",
    "setup.label.FeeMasterDescription": "Description maître des frais",
    "setup.label.FeeMasterTransactionType":
      "Type de transaction maître des frais",
    "setup.label.VariablePricing": "Tarification variable",
    "setup.label.Regions": "Régions",
    "setup.label.Amount": "Montant",
    "setup.label.EditFeeMaster": "Modifier maître des frais",
    "setup.label.ManageMessage": "Gérer le message",
    "setup.label.AddMessage": "Ajouter un message",
    "setup.label.TemplateDescription": "Description du modèle",
    "setup.label.Subject": "Sujet",
    "setup.label.MessageType": "Type de message",
    "setup.label.Header": "En-tête",
    "setup.label.Body": "Corps",
    "setup.label.Footer": "Pied de page",
    "setup.label.CreateMessageTemplate": "Créer un modèle de message",
    "setup.label.MessageParams": "Paramètres du message",
    "setup.label.Parameter": "Paramètre",
    "setup.label.Params": "Paramètres",
    "setup.label.DeleteMessage": "Supprimer le message",
    "setup.label.EditMessage": "Modifier le message",
    "setup.label.GroupsDetails": "Détails des groupes",
    "setup.label.GroupName": "Nom du groupe",
    "setup.label.GroupAddress": "Adresse du groupe",
    "setup.label.CountNo's": "Compter les numéros",
    "setup.label.AddGroup": "Ajouter un groupe",
    "setup.label.AdditionalInformation": "Informations supplémentaires",
    "setup.label.GroupCIR": "CIR du groupe",
    "setup.label.DIR": "DIR",
    "setup.label.MemberCIR": "CIR du membre",
    "setup.label.IpPoolManagement": "Gestion du pool IP",
    "setup.label.UpdateNetMask": "Mettre à jour le masque de réseau",
    "setup.label.IpAddress": "Adresse IP",
    "setup.label.NetMark": "Marque de réseau",
    "setup.label.IpType": "Type d'IP",
    "setup.label.CoustomerId": "Identifiant client",
    "setup.label.CustomerName": "Nom du client",
    "setup.label.Notes": "Notes",
    "setup.label.Subnet": "Sous-réseau",
    "setup.label.DetailsOfMedia": "Détails du média",
    "setup.label.Media": "Média",
    "setup.label.AddMedia": "Ajouter un média",
    "setup.label.MediaTitle": "Titre du média",
    "setup.label.MediaCatagory": "Catégorie de média",
    "setup.label.ContentProvider": "Fournisseur de contenu",
    "setup.label.Share": "Partage(%)",
    "setup.label.AddMediaDetails": "Ajouter des détails de média",
    "setup.label.MediaLocation": "Emplacement du média",
    "setup.label.SelectMediaCategory": "Sélectionner une catégorie de média",
    "setup.label.Movies": "Films",
    "setup.label.ViewMedia": "Voir le média",
    "setup.label.EditMedia": "Modifier le média",
    "setup.label.MediaAttributes": "Attributs du média",
    "setup.label.Cast": "Distribution",
    "setup.label.AttributeType": "Type d'attribut",
    "setup.label.CaptionValue": "Valeur de la légende",
    "setup.label.NickName": "Surnom",
    "setup.label.Image": "Image",
    "setup.label.AddMediaLocations": "Ajouter des emplacements de média",
    "setup.label.LanguageData": "Données linguistiques",
    "setup.label.FormatData": "Données de format",
    "setup.label.MediaLocations": "Emplacements de média",
    "setup.label.DetailsOfEvent": "Détails de l'Événement",
    "setup.label.EventName": "Nom de l'Événement",
    "setup.label.EventCode": "Code de l'Événement",
    "setup.label.SelectedMediaService": "Service Média Sélectionné",
    "setup.label.AvailableMedia": "Médias Disponibles",
    "setup.label.EventDescription": "Description de l'Événement",
    "setup.label.EventCategory": "Catégorie de l'Événement",
    "setup.label.CreateEvent": "Créer un Événement",
    "setup.label.DetailsOfProperty": "Détails de la Propriété",
    "setup.label.PropertyCode": "Code de Propriété",
    "setup.label.PropertyType": "Type de Propriété",
    "setup.label.Parcel": "Parcelle",
    "setup.label.BuildingCode": "Code du Bâtiment",
    "setup.label.Precinct": "Quartier",
    "setup.label.Allocated": "Attribué",
    "setup.label.UploadPropertyData": "Télécharger les Données de la Propriété",
    "setup.label.Clear": "Effacer",
    "setup.label.CreateProperty": "Créer une Propriété",
    "setup.label.PropertyDataUpload": "Télécharger les Données de la Propriété",
    "setup.label.Street": "Rue",
    "setup.label.PaymentType": "Type de Paiement",
    "setup.label.PoBox": "Boîte Postale",
    "setup.label.State": "État",
    "setup.label.District": "District",
    "setup.label.Floor": "Étage",
    "setup.label.LimitCode": "Code Limite",
    "setup.label.PropertyMaster": "Maître de Propriété",
    "setup.label.CodeDescription": "Description du Code",
    "setup.label.ReferenceValue": "Valeur de Référence",
    "setup.label.Services": "Services",
    "setup.label.IsBouquet": "Est un Bouquet",
    "setup.label.Broadcaster": "Diffuseur",
    "setup.label.Channel": "Chaîne",
    "setup.label.UOM": "UOM",
    "setup.label.DeleteTemplateDefinition": "Supprimer la Définition du Modèle",
    "setup.label.Discount": "Remise",
    "setup.label.SalseCatalogue": "Catalogue de Vente",
    "setup.label.UserCatalogue": "Catalogue d'Utilisateurs",
    "setup.label.Team": "Équipe",
    "setup.label.MediaDetails": "Détails des Médias",
    "setup.label.Event": "Événement",
    "setup.label.Properties": "Propriétés",
    "setup.label.ServicesProducts": "Services & Produits",
    "setup.label.BroadcasterChannelMapping": "Diffuseur, Chaîne & Cartographie",
    "setup.label.UsageRating": "Évaluation de l'Utilisation",
    "setup.label.ZoneSetup": "Configuration de Zone",
    "setup.label.Promotion": "Promotion",
    "setup.label.PromotionTrigger": "Déclencheur de promotion",
    "setup.label.PromotionRulesAndRates": "Règles et tarifs de la promotion",
    "setup.label.CatalogeMapping": "Cartographie de Catalogue",
    "setup.label.VoucherPin": "Code de Bon",
    "setup.label.SIMNumber": "Numéro SIM",
    "setup.label.TeamTeamUser": "Équipe & Utilisateur de l'Équipe",
    "setup.label.MessageTemplate": "Modèle de Message",
    "setup.label.ClosedUserGroup": "Groupe d'Utilisateurs Fermé",
    "setup.label.IpManagement": "Gestion IP",
    "setup.label.PropertyDefinition": "Définition de Propriété",
    "setup.label.PriorityMapping": "Cartographie des priorités",
    "setup.label.AddProducts": "Ajouter des Produits",
    "setup.label.AddDiscount": "Ajouter une Remise",
    "setup.label.Products": "Produits",
    "setup.label.ChargeCodeData": "Données du Code de Facturation",
    "setup.label.TaxMapping": "Cartographie Fiscale",
    "setup.label.TaxRegion": "Région Fiscale",
    "setup.label.CreateUserCatalogue": "Créer le Catalogue Utilisateur",
    "setup.label.IcZone": "Zone Ic",
    "setup.label.ViewIcZone": "Voir la Zone Ic",
    "setup.label.ViewNumberZone": "Voir la Zone Numéro",
    "setup.label.EditNumberZone": "Modifier la Zone Numéro",
    "setup.label.DeleteNumberZone": "Supprimer la Zone Numéro",
    "setup.label.AreYouSure": "Êtes-vous sûr?",
    "setup.label.ViewAPNZone": "Voir la Zone APN",
    "setup.label.EditAPNZone": "Modifier la Zone APN",
    "setup.label.DeleteAPNZone": "Supprimer la Zone APN",
    "setup.label.ViewOperatorZone": "Voir la Zone Opérateur",
    "setup.label.EditOperatorZone": "Modifier la Zone Opérateur",
    "setup.label.CreateICZone": "Créer la Zone IC",
    "setup.label.EditICZone": "Modifier la Zone IC",
    "setup.label.DeleteOperatorZone": "Supprimer la Zone Opérateur",
    "setup.label.DeleteIcZone": "Supprimer la Zone IC",
    "setup.label.MobileNumber": "Numéro de Mobile",
    "setup.label.LandlineNumber": "Numéro de téléphone fixe (facultatif)",
    "setup.label.RatePlanName": "Nom du Plan Tarifaire",
    "setup.label.UsageRateBalance": "Solde du taux d'utilisation",
    "setup.label.ValidityType": "Type de validité",
    "setup.label.Validity": "Validité",
    "setup.label.ListOfRateTires": "Liste des pneus tarifaires",
    "setup.label.CreatePlanName": "Créer le nom du plan",
    "setup.label.EditPlanContent": "Modifier le contenu du plan",
    "setup.label.CreatePlanDescription": "Créer la description du plan",
    "setup.label.ContentType": "Type de contenu",
    "setup.label.CreateFeatureList": "Créer la liste des fonctionnalités",
    "setup.label.Area": "Zone",
    "setup.label.TaxPercentage": "Pourcentage d'impôt",
    "setup.label.Add": "Ajouter",
    "setup.label.Remove": "Retirer",
    "setup.label.CreateVoucherPin": "Créer un Code de Bon",
    "setup.label.EditSubCategory": "Modifier la sous-catégorie",
    "setup.label.CreateSubCategory": "Créer une sous-catégorie",
    "setup.label.ViewSubCategory": "Voir la sous-catégorie",
    "setup.label.TimeTaken": "Temps pris",
    "setup.label.TeamMapping": "Mapping d'Équipe",
    "setup.label.CreateTeamMapping": "Créer un Mapping d'Équipe",
    "setup.label.Category": "Catégorie",
    "setup.label.external_promotional_code": "Code promotionnel externe",
    "setup.label.Subcategory": "Sous-catégorie",
    "setup.label.DeleteItemMapping": "Supprimer le Mapping d'Élément",
    "setup.label.EditTeamMapping": "Modifier le Mapping d'Équipe",
    "setup.label.ViewTeamMapping": "Voir le Mapping d'Équipe",
    "setup.label.DeletePriorityMapping": "Supprimer le Mapping Prioritaire",
    "setup.label.discount_rule": "Règle de réduction",
    "setup.label.promotion_rule": "Règle de promotion",
    "setup.label.discount_rate": "Taux de réduction",
    "setup.label.create_discount_rule": "Créer une règle de remise",
    "setup.label.edit_promotion_rule": "Modifier la règle de promotion",
    "setup.label.create_promotion_rule": "Créer une règle de promotion",
    "setup.label.add_discount_rate": "Ajouter un taux de réduction",
    "setup.label.add_promotion_rate": "Ajouter un taux de promotion",
    "setup.label.create_discount_rate": "Créer un taux de remise",
    "setup.label.edit_discount": "Modifier la réduction",
    "setup.label.edit_promotion": "Modifier la promotion",
    "setup.label.edit_discount_trigger": "Modifier le déclencheur de réduction",
    "setup.label.edit_discount_rule": "Modifier la règle de réduction",
    "setup.label.collection_process": "Processus de recouvrement",
    "setup.label.create_collection_profile": "Créer un profil de recouvrement",
    "setup.label.collection_profile": "Profil de recouvrement",
    "setup.label.collection_profile_id":
      "Identifiant du profil de recouvrement",
    "setup.label.region": "Région",
    "setup.label.collection": "Recouvrement",
    "setup.label.collection_trigger": "Déclencheur de recouvrement",
    "setup.label.collection_scenario": "Scénario de recouvrement",
    "setup.label.add_collection_trigger":
      "Ajouter un déclencheur de recouvrement",
    "setup.label.add_collection_scenario":
      "Ajouter un scénario de recouvrement",
    "setup.label.trigger_id": "ID du déclencheur",
    "setup.label.criteria_type": "Type de critère",
    "setup.label.due_balance": "Solde dû",
    "setup.label.ageing_days": "Jours de vieillissement",
    "setup.label.scenario_id": "ID de scénario",
    "setup.label.action_name": "Nom de l'action",
    "setup.label.age": "Âge",
    "setup.label.create_collection_trigger":
      "Créer un déclencheur de recouvrement",
    "setup.label.create_collection_scenario":
      "Créer un scénario de recouvrement",
    "setup.label.edit_collection_profile": "Modifier le profil de recouvrement",
    "setup.label.edit_collection_trigger":
      "Modifier le déclencheur de recouvrement",
    "setup.label.edit_collection_scenario":
      "Modifier le scénario de recouvrement",
    "setup.label.SlaInHours": "SLA en heures",
    "setup.label.contractduration": "Durée du Contrat",
    "setup.label.chargesperiodicity": "Périodicité des Charges",
  },

  es: {
    "setup.label.Enter_product_Description": "Ingrese la descripción del producto",
    "setup.label.FeedbackStatus": "Estado de comentarios",
    "setup.label.EnterCountryName": "Ingrese el nombre del país",
    "setup.label.location": "Ubicación",
    "setup.label.selectLocation": "Seleccionar ubicación",
    "setup.label.create_group_ticket": "Crear grupo de tickets",
    "setup.label.default": "Configuración",
    "setup.label.customerFeedback": "Comentarios del cliente",
    "setup.label.automation": "Automatización",
    "setup.label.automation_master": "Maestro de automatización",
    "setup.label.create_automation": "Crear automatización",
    "setup.label.edit_automation": "Editar automatización",
    "setup.label.automation_detail": "Detalle de automatización",
    "setup.label.automation_steps": "Pasos de automatización",
    "setup.label.add_automation_step": "Agregar paso de automatización",
    "setup.label.AutomationId": "ID de automatización",
    "setup.label.EntityName": "Nombre de entidad",
    "setup.label.EntityType": "Tipo de entidad",
    "setup.label.WorkflowName": "Nombre del flujo de trabajo",
    "setup.label.CreateAutomationScenario": "Crear escenario de automatización",
    "setup.label.EditAutomationStep": "Editar paso de automatización",
    "setup.label.ActionType": "Tipo de acción",
    "setup.label.ActionDetails": "Detalles de la acción",
    "setup.label.StepOrder": "Orden de los pasos",
    "setup.label.questionAnswerSet": "Conjunto de preguntas y respuestas",
    "setup.label.addQuestionSet": "Agregar conjunto de preguntas",
    "setup.label.EditQuestionSet": "Editar conjunto de preguntas",
    "setup.label.CategoryName": "Nombre de la categoría",
    "setup.label.SubCategoryName": "Nombre de la subcategoría",
    "setup.label.TotalQuestions": "Total de preguntas",
    "setup.label.QuestionType": "Tipo de pregunta",
    "setup.label.QuestionText": "Texto de la pregunta",
    "setup.label.CustomerFeedback": "Comentarios del cliente",
    "setup.label.TicketId": "ID del ticket",
    "setup.label.LinkedAt": "Vinculado en",
    "setup.label.Remarks": "Observaciones",
    "setup.label.AddFeedback": "Agregar comentario",
    "setup.label.PendingForApproval": "Pendiente de aprobación",
    "setup.label.Apn_Zone": "Zona Apn",
    "setup.label.user_availability": "Disponibilidad del usuario",
    "setup.label.all_users_availability":
      "Disponibilidad de todos los usuarios",
    "setup.label.create_user_availability": "Crear disponibilidad del usuario",
    "setup.label.LeaveManagement": "Gestión de licencias",
    "setup.label.CreateLeave": "Crear licencia",
    "setup.label.EditLeave": "Editar licencia",
    "setup.label.ViewLeave": "Ver licencia",
    "setup.label.AllUserLeaves": "Todas las licencias de usuarios",
    "setup.label.MyLeaves": "Mis licencias",
    "setup.label.ConfigId": "ID de configuración",
    "setup.label.edit_user_availability": "Editar disponibilidad del usuario",
    "setup.label.view_user_availability": "Ver disponibilidad del usuario",
    "setup.label.unavailability_date": "Fecha de indisponibilidad",
    "setup.label.start_time": "Hora de inicio",
    "setup.label.end_time": "Hora de finalización",
    "setup.label.my_availability": "Mi disponibilidad",
    "setup.label.user": "Usuario",
    "setup.label.EditShift": "Editar turno",
    "setup.label.UserWorkingShift": "Turno de trabajo del usuario",
    "setup.label.CreateUserWorkingShift": "Crear turno de trabajo del usuario",
    "setup.label.EditUserWorkingShift": "Editar turno de trabajo del usuario",
    "setup.label.ViewUserWorkingShift": "Ver turno de trabajo del usuario",
    "setup.label.TeamName": "Nombre del equipo",
    "setup.label.Shift": "Turno",
    "setup.label.ShiftManagement": "Gestión de turnos",
    "setup.label.CreateShift": "Crear turno",
    "setup.label.ShiftName": "Nombre del turno",
    "setup.label.Session": "Sesión",
    "setup.label.SessionType": "Tipo de sesión",
    "setup.label.LeaveDetails": "Detalles de la licencia",
    "setup.label.SessionStartTime": "Hora de inicio de la sesión",
    "setup.label.SessionEndTime": "Hora de fin de la sesión",
    "setup.label.LeaveType": "Tipo de permiso",
    "setup.label.AddAnotherDate": "Agregar otra fecha",
    "setup.label.FeeMaster": "Maestro de Tarifas",
    "setup.label.Number_Zone": "Zona Numérica",
    "setup.label.DeleteRUM": "Eliminar RUM",
    "setup.label.Edit_TimeModel": "Editar modelo de tiempo",
    "setup.label.Edit_Year": "Editar año",
    "setup.label.scenario_name": "Nombre del escenario",
    "setup.label.event_name": "Nombre del evento",
    "setup.label.Edit_Month": "Editar mes",
    "setup.label.Edit_Day": "Editar día",
    "setup.label.Edit_Time": "Editar hora",
    "setup.label.Delete_TimeModel": "Eliminar modelo de tiempo",
    "setup.label.Delete_Year": "Eliminar año",
    "setup.label.Delete_Month": "Eliminar mes",
    "setup.label.Delete_Day": "Eliminar día",
    "setup.label.Delete_Time": "Eliminar hora",
    "setup.label.Are_you_sure_?": "¿Estás seguro?",
    "setup.label.Save": "Guardar",
    "setup.label.TemplateDefinition": "Definición de plantilla",
    "setup.label.EditQuantityTier": "Editar nivel de cantidad",
    "setup.label.Usage_Rate_Balance": "Saldo de tarifa de uso",
    "setup.label.Template_Name": "Nombre de la plantilla",
    "setup.label.Delimiter": "Delimitador",
    "setup.label.Number_Of_Fields": "Número de campos",
    "setup.label.Header_Recorder_Type": "Tipo de grabador de encabezado",
    "setup.label.Event_Record_Type": "Tipo de registro de evento",
    "setup.label.CreateUOM": "Crear unidad de medida",
    "setup.label.TimePeriod": "Período de tiempo",
    "setup.label.Usage_Rate_Plan": "Plan de tarifa de uso",
    "setup.label.TemplateDefinition": "Definición de plantilla",
    "setup.label.CreateRUM": "Crear RUM",
    "setup.label.CreateTimePeriod": "Crear período de tiempo",
    "setup.label.TimemodelName": "Nombre del modelo de tiempo",
    "setup.label.TimePeriodName": "Nombre del período",
    "setup.label.StartYear": "Año de inicio",
    "setup.label.EndYear": "Año de finalización",
    "setup.label.UsageRatePlan": "Plan de tarifa de uso",
    "setup.label.Create_Usage_Rate_Plan": "Crear plan de tarifa de uso",
    "setup.label.Id": "ID",
    "setup.label.PlanName": "Nombre del plan",
    "setup.label.ProductName": "Nombre del producto",
    "setup.label.ChargeCode": "Código de cargo",
    "setup.label.TimeModelName": "Nombre del modelo de tiempo",
    "setup.label.RatingType": "Tipo de calificación",
    "setup.label.RumName": "Nombre del RUM",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "¿Está seguro de que desea eliminar?",
    "setup.label.UOM": "Unidad de medida",
    "setup.label.RUM": "RUM",
    "setup.label.ImpactCategory": "Categoría de impacto",
    "setup.label.Resource": "Recurso",
    "setup.label.GLID": "GLID",
    "setup.label.Unit": "Unidad",
    "setup.label.Rate": "Tarifa",
    "setup.label.Action": "Acción",
    "setup.label.options_selected": "opciones seleccionadas",
    "setup.label.UsageRateBalance": "Saldo de tasa de uso",
    "setup.label.EndYear": "Año de fin",
    "setup.label.StartMonth": "Mes de inicio",
    "setup.label.EndMonth": "Mes de fin",
    "setup.label.StartDay": "Día de inicio",
    "setup.label.EndDay": "Día de fin",
    "setup.label.StartTime": "Hora de inicio",
    "setup.label.Time_Model_Name": "Nombre del modelo de tiempo",
    "setup.label.model_includes_which_all_Bands_?":
      "¿Qué bandas incluye el modelo?",
    "setup.label.YearRestriction": "Restricción por año",
    "setup.label.MonthRestriction": "Restricción por mes",
    "setup.label.DayRestriction": "Restricción por día",
    "setup.label.TimeRestriction": "Restricción de tiempo",
    "setup.label.Code": "Código",
    "setup.label.Name": "Nombre",
    "setup.label.PriorityMapping": "Mapeo de prioridades",
    "setup.label.AddJurisdiction": "Agregar jurisdicción",
    "setup.label.Are_you_sure_?": "¿Estás seguro?",
    "setup.label.Country": "País",
    "setup.label.State": "Estado",
    "setup.label.District": "Distrito",
    "setup.label.RateType": "Tipo de tasa",
    "setup.label.Remove": "Eliminar",
    "setup.label.TaxMaster": "Maestro de impuestos",
    "setup.label.Team": "Equipo",
    "setup.label.Add": "Agregar",
    "setup.label.FeeMaster": "Maestro de tarifas",
    "setup.label.DeleteChargeCode": "Eliminar código de cargo",
    "setup.label.SelectSearch": "Seleccionar búsqueda",
    "setup.label.Select_Content_Tag_Value":
      "Seleccionar valor de etiqueta de contenido",
    "setup.label.Plan_Content": "Contenido del plan",
    "setup.label.Plan": "Plan",
    "setup.label.ProductPrice": "Precio del producto",
    "setup.label.SelectedPromotions": "Promociones seleccionadas",
    "setup.label.AvailablePromotions": "Promociones disponibles",
    "setup.label.SelectType": "Seleccionar tipo",
    "setup.label.Type": "Tipo",
    "setup.label.No_versions_available": "No hay versiones disponibles",
    "setup.label.Version": "Versión",
    "setup.label.ListPrice": "Precio de lista",
    "setup.label.SellingPrice": "Precio de venta",
    "setup.label.EnterPlanDescription": "Ingrese la descripción del plan",
    "setup.label.AddPrice": "Agregar precio",
    "setup.label.Save": "Guardar",
    "setup.label.AddDiscount": "Agregar descuento",
    "setup.label.AvailablePlans": "Planes disponibles",
    "setup.label.SelectedPlans": "Planes seleccionados",
    "setup.label.PlanType": "Tipo de plan",
    "setup.label.Plan_Start_Date": "Fecha de inicio del plan",
    "setup.label.Plan_End_Date": "Fecha de fin del plan",
    "setup.label.Bill_Type": "Tipo de factura",
    "setup.label.AttributeTypes": "Tipos de atributos",
    "setup.label.Add": "Agregar",
    "setup.label.Select_Content_Tag": "Seleccionar etiqueta de contenido",
    "setup.label.PlanName": "Nombre del plan",
    "setup.label.AvailableDiscounts": "Descuentos disponibles",
    "setup.label.Search": "Buscar...",
    "setup.label.MoveRight": "Mover a la derecha",
    "setup.label.MoveLeft": "Mover a la izquierda",
    "setup.label.SelectedDiscounts": "Descuentos seleccionados",
    "setup.label.SelectType": "Seleccionar tipo",
    "setup.label.SelectLanguage": "Seleccionar idioma",
    "setup.label.SelectContentTag": "Seleccionar etiqueta de contenido",
    "setup.label.SelectContentTagValue": "Seleccionar valor de la etiqueta",
    "setup.label.DigitalContent": "Contenido digital",
    "setup.label.Enter_Plan_Description": "Ingrese la descripción del plan",
    "setup.label.DC_Rule": "Regla DC",
    "setup.label.PlanAttribute": "Atributo del plan",
    "setup.label.AdvanceView": "Vista avanzada",
    "setup.label.Update": "Actualizar",
    "setup.label.ProductMapping": "Mapeo de producto",
    "setup.label.Service": "Servicio",
    "setup.label.SubProducts": "Subproductos",
    "setup.label.Type": "Tipo",
    "setup.label.EnterValue": "Ingresar valor",
    "setup.label.PriceRegion": "Región de precio",
    "setup.label.Enter_service_Description":
      "Ingrese la descripción del servicio",
    "setup.label.ParamName": "Nombre del parámetro",
    "setup.label.Category": "Categoría",
    "setup.label.Type": "Tipo",
    "setup.label.EnterValue": "Ingrese el valor",
    "setup.label.SalesCatalogue": "Catálogo de ventas",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "¿Estás seguro de que deseas eliminar?",
    "setup.label.Channel": "Canal",
    "setup.label.Broadcaster": "Radiodifusor",
    "setup.label.AddPrice": "Agregar precio",
    "setup.label.DeleteMediaEvent": "Eliminar evento multimedia",
    "setup.label.AdvMedia": "Medios publicitarios",
    "setup.label.EditMedia": "Editar medios",
    "setup.label.AddEvent": "Agregar evento",
    "setup.label.AddAttributes": "Agregar atributos",
    "setup.label.AddLocation": "Agregar ubicación",
    "setup.label.DeleteEvent": "Eliminar evento",
    "setup.label.Are_you_sure_?": "¿Estás seguro?",
    "setup.label.Add": "Agregar",
    "setup.label.ViewEvent": "Ver evento",
    "setup.label.Event": "Evento",
    "setup.label.RUM": "RUM",
    "setup.label.OptType": "Tipo de opción",
    "setup.label.Currency": "Moneda",
    "setup.label.Amount": "Cantidad",
    "setup.label.Add": "Agregar",
    "setup.label.Save": "Guardar",
    "setup.label.AddDiscount": "Agregar descuento",
    "setup.label.EnterEventCode": "Ingrese el código del evento",
    "setup.label.EnterEventDescription": "Ingrese la descripción del evento",
    "setup.label.EventDescription": "Descripción del evento",
    "setup.label.EventCategory": "Categoría del evento",
    "setup.label.ChargeCode": "Código de cargo",
    "setup.label.SelectEventValidity": "Seleccionar validez del evento",
    "setup.label.EditEvent": "Editar evento",
    "setup.label.UnitCode": "Código de unidad",
    "setup.label.MediaTitle": "Título del medio",
    "setup.label.ContentProvider": "Proveedor de contenido",
    "setup.label.MediaType": "Tipo de medio",
    "setup.label.Rated": "Clasificado",
    "setup.label.MediaCategory": "Categoría de medio",
    "setup.label.Rating": "Calificación",
    "setup.label.Poster": "Póster",
    "setup.label.Status": "Estado",
    "setup.label.MovieDuration": "Duración de la película",
    "setup.label.ReleaseDate": "Fecha de estreno",
    "setup.label.Genre": "Género",
    "setup.label.Subject": "Tema",
    "setup.label.Overview": "Resumen",
    "setup.label.Share(%)": "Participación (%)",
    "setup.label.Cast": "Reparto",
    "setup.label.AttributeType": "Tipo de atributo",
    "setup.label.CaptionValue": "Valor de subtítulo",
    "setup.label.NickName": "Apodo",
    "setup.label.Image": "Imagen",
    "setup.label.Language": "Idioma",
    "setup.label.Format": "Formato",
    "setup.label.Location": "Ubicación",
    "setup.label.CustomerType": "Tipo de cliente",
    "setup.label.FormatType": "Tipo de formato",
    "setup.label.DiscountCode": "Código de descuento",
    "setup.label.ReProcess": "Reprocesar",
    "setup.label.Code": "Código",
    "setup.label.Description": "Descripción",
    "setup.label.PropertyCodeType": "Tipo de código de propiedad",
    "setup.label.ReferenceValue": "Valor de referencia",
    "setup.label.EditProperty": "Editar propiedad",
    "setup.label.EditPropertyMaster": "Editar maestro de propiedad",
    "setup.label.Cancel": "Cancelar",
    "setup.label.View": "Ver",
    "setup.label.Edit": "Editar",
    "setup.label.Browse_file_to_Upload": "Buscar archivo para subir",
    "setup.label.CreatePropertyMaster": "Crear maestro de propiedad",
    "setup.label.Property": "Propiedad",
    "setup.label.PropertyMaster": "Maestro de propiedad",
    "setup.label.ViewProperty": "Ver propiedad",
    "setup.label.ViewPropertyMaster": "Ver maestro de propiedad",
    "setup.label.Are_you_sure_?": "¿Estás seguro?",
    "setup.label.Edit": "Editar",
    "setup.label.Code": "Código",
    "setup.label.Name": "Nombre",
    "setup.label.AddState": "Agregar estado",
    "setup.label.AddDistrict": "Agregar distrito",
    "setup.label.AddCity": "Agregar ciudad",
    "setup.label.EditCountry": "Editar país",
    "setup.label.EditState": "Editar estado",
    "setup.label.EditDistrict": "Editar distrito",
    "setup.label.EditCity": "Editar ciudad",
    "setup.label.DeleteCountry": "Eliminar país",
    "setup.label.DeleteState": "Eliminar estado",
    "setup.label.DeleteDistrict": "Eliminar distrito",
    "setup.label.DeleteCity": "Eliminar ciudad",
    "setup.label.ServiceAvailablity": "Disponibilidad del servicio",
    "setup.label.EnterCountryCode": "Ingrese el código del país",
    "setup.label.EnterCode": "Ingrese el código",
    "setup.label.EnterName": "Ingrese el nombre",
    "setup.label.Service_Availablity_for_the":
      "Disponibilidad del servicio para",
    "setup.label.SelectServices": "Seleccionar servicios",
    "setup.label.Select_One_or_More": "Seleccionar uno o más",
    "setup.label.options_selected": "opciones seleccionadas",
    "setup.label.PromotionName": "Nombre de promoción",
    "setup.label.PromotionCode": "Código de promoción",
    "setup.label.BussinesType": "Tipo de negocio",
    "setup.label.OrderType": "Tipo de orden",
    "setup.label.PaymentType": "Tipo de pago",
    "setup.label.SelectCategory": "Seleccionar categoría",
    "setup.label.PromotionTrigger": "Disparador de promoción",
    "setup.label.PromotionRule": "Regla de promoción",
    "setup.label.PromotionTriggerCondition":
      "Condición del disparador de promoción",
    "setup.label.DiscountTriggerCondition":
      "Condición de activación de descuento",
    "setup.label.DiscountRule": "Regla de descuento",
    "setup.label.DiscountTrigger": "Activador de descuento",
    "setup.label.EditTriggerCondition": "Editar condición de activación",
    "setup.label.Rate": "Tasa",
    "setup.label.EditRule": "Editar regla",
    "setup.label.AddRate": "Agregar tasa",
    "setup.label.Download": "Descargar",
    "setup.label.Process": "Procesar",
    "setup.label.ViewVendor": "Ver proveedor",
    "setup.label.VendorCode": "Código del proveedor",
    "setup.label.VendorName": "Nombre del proveedor",
    "setup.label.select_Currency": "Seleccionar moneda",
    "setup.label.select_Country": "Seleccionar país",
    "setup.label.Filter_List": "Filtrar lista",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "¿Estás seguro de que deseas eliminar?",
    "setup.label.DeleteVoucher": "Eliminar vale",
    "setup.label.UpdatePin": "Actualizar PIN",
    "setup.label.UpdateVoucher": "Actualizar vale",
    "setup.label.select_from_dropdown": "Seleccionar del menú desplegable",
    "setup.label.ItemModel": "Modelo del artículo",
    "setup.label.price": "Precio",
    "setup.label.Edit": "Editar",
    "setup.label.Delete": "Eliminar",
    "setup.label.Item": "Artículo",
    "setup.label.EnterSupplierAddress": "Ingresar dirección del proveedor",
    "setup.label.Title": "Título",
    "setup.label.AddPromotionTriggerCondition":
      "Agregar condición de activación de promoción",
    "setup.label.EditPromotionTriggerCondition":
      "Editar condición de activación de promoción",
    "setup.label.AssignTo": "Asignar a",
    "setup.label.Version": "Versión",
    "setup.label.IsOverride": "Es sobrescritura",
    "setup.label.PlanAttribute": "Atributo del plan",
    "setup.label.ValidationRule": "Regla de validación",
    "setup.label.SaveAndContinue": "Guardar y continuar",
    "setup.label.PlanManagement": "Gestión de planes",
    "setup.label.Plan": "Plan",
    "setup.label.DiscountTriggerCondition":
      "Condición de activación de descuento",
    "setup.label.AddDiscountTriggerCondition":
      "Agregar condición de activación de descuento",
    "setup.label.SalesChannel": "Canal de ventas",
    "setup.label.PaymentType": "Tipo de pago",
    "setup.label.OrderType": "Tipo de pedido",
    "setup.label.BusinessType": "Tipo de negocio",
    "setup.label.ViewDigitalContent": "Ver contenido digital",
    "setup.label.EditDigitalContent": "Editar contenido digital",
    "setup.label.AddDigitalContent": "Agregar contenido digital",
    "setup.label.PromotionRuleName": "Nombre de la regla de promoción",
    "setup.label.PromotionTriggerCondition":
      "Condición de activación de promoción",
    "setup.label.AddPromotionTriggerCondition":
      "Agregar condición de activación de promoción",
    "setup.label.BussinesType": "Tipo de negocio",
    "setup.label.requestApproval": "Solicitar aprobación",
    "setup.label.validity_uom": "UOM de Validez",
    "setup.label.validity_value": "Valor de Validez",
    "setup.label.ViewItemModel": "Ver modelo de artículo",
    "setup.label.ItemType": "Tipo de artículo",
    "setup.label.ViewSupplier": "Ver proveedor",
    "setup.label.SupplierCode": "Código de proveedor",
    "setup.label.SupplierDescription": "Descripción del proveedor",
    "setup.label.SupplierAddress": "Dirección del proveedor",
    "setup.label.DeleteSupplier": "Eliminar proveedor",
    "setup.label.CreateContract": "Crear contrato",
    "setup.label.RateTierName": "Nombre del nivel de tarifa",
    "setup.label.RangeType": "Tipo de rango",
    "setup.label.CreateDiscountRule": "Crear regla de descuento",
    "setup.label.RuleCondition": "Condición de regla",
    "setup.label.CreateRuleCondition": "Crear condición de regla",
    "setup.label.CreateRule": "Crear regla",
    "setup.label.Entity": "Entidad",
    "setup.label.EntityField": "Campo de entidad",
    "setup.label.contentTag": "Etiqueta de contenido",
    "setup.label.contentTagValue": "Valor de la etiqueta de contenido",
    "setup.label.ExecutionType": "Tipo de Ejecución",
    "setup.label.OperationMode": "Modo de Operación",
    "setup.label.AggregationType": "Tipo de Agregación",
    "setup.label.DurationInDays": "Duración en Días",
    "setup.label.CreateTicketTeamUser": "Crear usuario del equipo de tickets",
    "setup.label.termsConditions": "Términos y condiciones",
    "setup.label.updateTermsConditions": "Actualizar términos y condiciones",
    "setup.label.updateDigitalContent": "Actualizar contenido digital",
    "setup.label.createDigitalContent": "Crear contenido digital",
    "setup.label.createTermsConditions": "Crear términos y condiciones",
    "setup.label.digitalContent": "Contenido Digital",
    "setup.label.planContent": "Contenido del plan",
    "setup.label.selectPlanContent": "Seleccionar contenido del plan",
    "setup.label.FilterType": "Tipo de filtro",
    "setup.label.FilterValue": "Valor del filtro",
    "setup.label.ContractPeriod": "Período de contrato",
    "setup.label.AddContract": "Agregar contrato",
    "setup.label.EditContract": "Editar contrato",
    "setup.label.ViewContract": "Ver contrato",
    "setup.label.ContractType": "tipo de contrato",
    "setup.label.ExternalPlanId": "ID del plan externo",
    "setup.label.ExternalProductId": "ID del producto externo",
    "setup.label.ContractUnit": "Unidad de contrato",
    "setup.label.updateNetMask": "Actualizar máscara de red",
    "setup.label.Update": "Actualizar",
    "setup.label.BillType": "Tipo de factura",
    "setup.label.BillFrequency": "Frecuencia de facturación",
    "setup.label.PlanEndDate": "Fecha de finalización del plan",
    "setup.label.AddContent": "Agregar contenido",
    "setup.label.CreatePlanContent": "Crear contenido del plan",
    "setup.label.SelectLanguage": "Seleccionar idioma",
    "setup.label.UploadDigitalImage": "Subir imagen digital",
    "setup.label.ViewPlanContent": "Ver contenido del plan",
    "setup.label.ExternalPlanName": "Nombre del plan externo",
    "setup.label.ExternalProductName": "Nombre del producto externo",
    "setup.label.ViewPrice": "Ver precio",
    "setup.label.SelectedPlanDiscounts": "Descuentos del plan seleccionado,",
    "setup.label.ProductDiscount": "Descuentos del producto,",
    "setup.label.PlanValidationRules": "Reglas de validación del plan",
    "setup.label.CreateValidationRule": "Crear regla de validación",
    "setup.label.EditValidationRule": "Editar regla de validación",
    "setup.label.InputPlanId": "Ingresar ID del plan",
    "setup.label.CheckinPlanId": "ID del plan de validación",
    "setup.label.RuleAppliesTo": "Unidad",
    "setup.label.Rule": "Regla",
    "setup.label.ViewValidationRule": "Regla de validación de vista",
    "setup.label.ValidationRule": "Regla de validación",
    "setup.label.createIpPool": "Crear grupo de IP",
    "setup.label.editIpPool": "Editar grupo de IP",
    "setup.label.AddOrEditDiscount": "Agregar/Editar descuento",
    "setup.label.Next": "Siguiente",
    "setup.label.MainCategory": "categoria principal",
    "setup.label.SubCategory": "Subcategoría",
    "setup.label.select_date": "Seleccionar Fecha",
    "setup.label.AddDiscountTrigger": "Agregar Disparador de Descuento",
    "setup.label.AddPromotionTrigger": "Agregar activador de promoción",
    "setup.label.edit_promotion_trigger": "Editar activador de promoción",
    "setup.label.DiscountTrigger": "Disparador de Descuento",
    "setup.label.TriggerName": "Nombre del Disparador",
    "setup.label.When": "Cuándo",
    "setup.label.CustomerType": "Tipo de Cliente",
    "setup.label.Criteria": "Criterios",
    "setup.label.Values": "Valores",
    "setup.label.ApplicableTo": "Aplicable a",
    "setup.label.ApplicableValues": "Valores Aplicables",
    "setup.label.DiscountRulesAndRates": "Reglas y Tasas de Descuento",
    "setup.label.RuleName": "Nombre de la Regla",
    "setup.label.MaxDiscount": "Descuento Máximo",
    "setup.label.ResourceId": "ID de Recurso",
    "setup.label.DiscountRateType": "Tipo de Tasa de Descuento",
    "setup.label.Unit": "Unidad",
    "setup.label.DiscountId": "ID de Descuento",
    "setup.label.DiscountName": "Nombre del Descuento",
    "setup.label.Priority": "Prioridad",
    "setup.label.Items": "Artículos",
    "setup.label.ItemCode": "Código de artículo",
    "setup.label.ItemDescription": "Descripción del artículo",
    "setup.label.Units": "Unidades",
    "setup.label.Total": "Total",
    "setup.label.Warranty": "Garantía",
    "setup.label.UsedItems": "Artículos usados",
    "setup.label.Balanced": "Equilibrado",
    "setup.label.IsProvisioning": "Es provisión",
    "setup.label.CreateItem": "Crear artículo",
    "setup.label.ItemClass": "Clase de artículo",
    "setup.label.ReorderLevel": "Nivel de reorden",
    "setup.label.WarrantyPeriod": "Período de garantía",
    "setup.label.Currency": "Moneda",
    "setup.label.DefaultPrice": "Precio predeterminado",
    "setup.label.IsSelector": "Es selector",
    "setup.label.SelectorMenu": "Menú selector",
    "setup.label.Selector": "Selector",
    "setup.label.VariablePrice": "Precio variable",
    "setup.label.ItemModel": "Modelo de artículo",
    "setup.label.Price": "Precio",
    "setup.label.Action": "Acción",
    "setup.label.Cancel": "Cancelar",
    "setup.label.planPrice": "Precio del Plan",
    "setup.label.listview": "Vista de Lista",
    "setup.label.Submit": "Enviar",
    "setup.label.EditItem": "Editar ítem",
    "setup.label.Id": "Id",
    "setup.label.ItemMasterId": "Id del Maestro de Ítem",
    "setup.label.RegionId": "Id de Región",
    "setup.label.Edit": "Editar",
    "setup.label.ViewItem": "Ver elemento",
    "setup.label.UnitPrice": "Precio unitario",
    "setup.label.ItemModels": "Modelos de elemento",
    "setup.label.NetworkElement": "Elemento de red",
    "setup.label.Model": "Modelo",
    "setup.label.Make": "Hacer",
    "setup.label.CreateItemModel": "Crear modelo de elemento",
    "setup.label.Reset": "Reiniciar",
    "setup.label.EditItemModel": "Editar modelo de elemento",
    "setup.label.ServiceCode": "Código de servicio",
    "setup.label.ServiceDescription": "Descripción del servicio",
    "setup.label.ServiceType": "Tipo de servicio",
    "setup.label.Isoptional": "Es opcional",
    "setup.label.Isautoprovision": "Es autoprovisión",
    "setup.label.CreateService": "Crear servicio",
    "setup.label.Code": "Código",
    "setup.label.Description": "Descripción",
    "setup.label.Type": "Tipo",
    "setup.label.EditService": "Editar servicio",
    "setup.label.ServiceParameter": "Parámetro de servicio",
    "setup.label.ParamName": "Nombre del parámetro",
    "setup.label.ParamType": "Tipo de parámetro",
    "setup.label.ParamCategory": "Categoría del parámetro",
    "setup.label.ParamValue": "Valor del parámetro",
    "setup.label.BB": "BB",
    "setup.label.Delete": "Eliminar",
    "setup.label.ServiceCategory": "Categoría de servicio",
    "setup.label.DeleteServices": "Eliminar servicios",
    "setup.label.Confirm": "Confirmar",
    "setup.label.Service": "Servicio",
    "setup.label.Status": "Estado",
    "setup.label.Bouquet": "Ramo",
    "setup.label.Actions": "Acciones",
    "setup.label.CreateProduct": "Crear producto",
    "setup.label.ProductParameter": "Parámetro del producto",
    "setup.label.EditProduct": "Editar producto",
    "setup.label.ProductDescription": "Descripción del producto",
    "setup.label.ProductCategory": "Categoría de producto",
    "setup.label.BroadcasterCode": "Código del Emisor",
    "setup.label.BroadcasterName": "Nombre del Emisor",
    "setup.label.GstRegNumber": "Número de Registro GST",
    "setup.label.ContactPerson": "Persona de Contacto",
    "setup.label.ContactMobile": "Móvil de Contacto",
    "setup.label.Email": "Correo Electrónico",
    "setup.label.CreateBroadcaster": "Crear Emisor",
    "setup.label.Address": "Dirección",
    "setup.label.MobileNo": "Número de Móvil",
    "setup.label.LandlineNo": "Número de Teléfono Fijo",
    "setup.label.EditBroadcaster": "Editar Emisor",
    "setup.label.ChannelName": "Nombre del Canal",
    "setup.label.ChannelType": "Tipo de Canal",
    "setup.label.DeleteBroadcaster": "Eliminar Emisor",
    "setup.label.ChannelCategory": "Categoría del Canal",
    "setup.label.ChannelSequence": "Secuencia del Canal",
    "setup.label.IsHdChannel": "Es Canal HD",
    "setup.label.CreateChannel": "Crear Canal",
    "setup.label.Language": "Idioma",
    "setup.label.IsLocalChannel": "Es Canal Local",
    "setup.label.Genre": "Género",
    "setup.label.BroadcasterId": "ID del Emisor",
    "setup.label.EditChannel": "Editar Canal",
    "setup.label.DeleteChannel": "Eliminar Canal",
    "setup.label.ProductMapping": "Mapeo de Productos",
    "setup.label.CreateProductChannelMapping":
      "Crear Mapeo de Canales de Producto",
    "setup.label.ProductId": "ID de Producto",
    "setup.label.AvailableChannels": "Canales Disponibles",
    "setup.label.SelectedChannels": "Canales Seleccionados",
    "setup.label.EditChannelMapping": "Editar Mapeo de Canales",
    "setup.label.PlanPricing": "Plan y Precios",
    "setup.label.CreatePlan": "Crear Plan",
    "setup.label.PlanCode": "Código del Plan",
    "setup.label.PlanDescription": "Descripción del Plan",
    "setup.label.PlanStatus": "Estado del Plan",
    "setup.label.PlanProvisionSystem": "Sistema de Provisión del Plan",
    "setup.label.PlanStartDate": "Fecha de Inicio del Plan",
    "setup.label.IsPrepaid": "Es Prepagado",
    "setup.label.Duration": "Duración",
    "setup.label.PlanType": "Tipo de Plan",
    "setup.label.BillingRule": "Regla de Facturación",
    "setup.label.EndDate": "Fecha de Finalización",
    "setup.label.IsProvision": "Está Provisionado",
    "setup.label.EditPlan": "Editar Plan",
    "setup.label.SelectProduct": "Seleccionar Producto",
    "setup.label.ViewPlan": "Ver Plan",
    "setup.label.ProvisioningSystem": "Sistema de Provisión",
    "setup.label.DeletePlan": "Eliminar Plan",
    "setup.label.Prices": "Precios",
    "setup.label.ChargeOwner": "Propietario del cargo",
    "setup.label.DiscountCode": "Código de descuento",
    "setup.label.PriceRegion": "Región de precios",
    "setup.label.Resource": "Recurso",
    "setup.label.SalesChannel": "Canal de Ventas",
    "setup.label.OrderType": "Tipo de orden",
    "setup.label.BusinessType": "Type d'entreprise",
    "setup.label.RoundingType": "Tipo de redondeo",
    "setup.label.GLID": "ID de GL",
    "setup.label.Value": "Valor",
    "setup.label.TemplateDefinition": "Definición de Plantilla",
    "setup.label.CreateTemplateDefinition": "Crear Definición de Plantilla",
    "setup.label.TemplateName": "Nombre de Plantilla",
    "setup.label.Delimiter": "Delimitador",
    "setup.label.NumberOfFields": "Número de Campos",
    "setup.label.HeaderRecorderType": "Tipo de Grabador de Encabezado",
    "setup.label.EventRecordType": "Tipo de Registro de Evento",
    "setup.label.ProductCode": "Código de Producto",
    "setup.label.IsHeader": "Es Encabezado",
    "setup.label.FieldType": "Tipo de Campo",
    "setup.label.FieldName": "Nombre de Campo",
    "setup.label.IdentifierType": "Tipo de Identificador",
    "setup.label.Length": "Longitud",
    "setup.label.ExistsTemplateDefinition": "Definición de Plantilla Existente",
    "setup.label.UOM(Unit Of measurement)": "UOM (Unidad de Medida)",
    "setup.label.CreateUOM": "Crear UOM",
    "setup.label.Name": "Nombre",
    "setup.label.EditTemplateDefinition": "Editar Definición de Plantilla",
    "setup.label.EditUOM": "Editar UOM",
    "setup.label.Save": "Guardar",
    "setup.label.DeleteUOM": "Eliminar UOM",
    "setup.label.Ok": "Ok",
    "setup.label.ViewUOM": "Ver UOM",
    "setup.label.RUM(RatableUsageMetric)": "RUM (Métrica de Uso Tarificable)",
    "setup.label.CreateRUM": "Crear RUM",
    "setup.label.ChargeName": "Nombre del Cargo",
    "setup.label.Template Name": "Nombre de la Plantilla",
    "setup.label.RumName": "Nombre del Rum",
    "setup.label.RumExpression": "Expresión del Rum",
    "setup.label.Operators": "Operadores",
    "setup.label.EditRUM": "Editar RUM",
    "setup.label.ViewRUM": "Ver RUM",
    "setup.label.TimePeriod": "Período de tiempo",
    "setup.label.CreateTimePeriod": "Crear período de tiempo",
    "setup.label.TimeModelName": "Nombre del modelo de tiempo",
    "setup.label.StartYear": "Año de inicio",
    "setup.label.EndYear": "Año de fin",
    "setup.label.StartMonth": "Mes de inicio",
    "setup.label.EndMonth": "Mes de fin",
    "setup.label.StartDay": "Día de inicio",
    "setup.label.EndDay": "Día de fin",
    "setup.label.StartTime": "Hora de inicio",
    "setup.label.EndTime": "Hora de fin",
    "setup.label.CreateTimeModel": "Crear modelo de tiempo",
    "setup.label.ExpandAll / CollapseAll": "Expandir todo / Colapsar todo",
    "setup.label.AddTimemodel": "Agregar modelo de tiempo",
    "setup.label.UsageRatePlan": "Plan de tarifas de uso",
    "setup.label.CreateUsageRatePlan": "Crear plan de tarifas de uso",
    "setup.label.PlanName": "Nombre del plan",
    "setup.label.ProductName": "Nombre del producto",
    "setup.label.TimemodelName": "Nombre del modelo temporal",
    "setup.label.ViewUsageRatePlan": "Ver plan de tarifas de uso",
    "setup.label.RUM": "RUM",
    "setup.label.RatingType": "Tipo de calificación",
    "setup.label.TimeModel": "Modelo temporal",
    "setup.label.ZoneModel": "Modelo de zona",
    "setup.label.ViewQuantityTier": "Ver nivel de cantidad",
    "setup.label.QuantityTier": "Nivel de cantidad",
    "setup.label.TierName": "Nombre del nivel",
    "setup.label.CumulativeResource": "Recurso acumulativo",
    "setup.label.TierRange": "Rango de nivel",
    "setup.label.StepName": "Nombre del paso",
    "setup.label.StartRange": "Rango de inicio",
    "setup.label.EndRange": "Rango de fin",
    "setup.label.AddQuantityTier": "Agregar nivel de cantidad",
    "setup.label.NumberZone": "Zona de número",
    "setup.label.CreateNumberZone": "Crear zona de número",
    "setup.label.SourceNumberPrefix": "Prefijo de número de origen",
    "setup.label.DestinationNumberPrefix": "Prefijo de número de destino",
    "setup.label.ImpactCategory": "Categoría de impacto",
    "setup.label.Rank": "Rango",
    "setup.label.APNZone": "Zona APN",
    "setup.label.APN": "APN",
    "setup.label.CreateAPNZone": "Crear zona APN",
    "setup.label.OperatorZone": "Zona de operador",
    "setup.label.CreateOperatorZone": "Crear zona de operador",
    "setup.label.SourceOperatorCode": "Código del operador de origen",
    "setup.label.DestinationOperatorCode": "Código del operador de destino",
    "setup.label.ICZone": "Zona IC",
    "setup.label.IncomingTrunkid": "Trunkid entrante",
    "setup.label.OutcomingTrunkid": "Trunkid saliente",
    "setup.label.CreateChargeCode": "Crear código de cargo",
    "setup.label.ChargeDescription": "Descripción del cargo",
    "setup.label.ChargeType": "Tipo de cargo",
    "setup.label.ChargeDuration": "Duración del cargo",
    "setup.label.DurationType": "Tipo de duración",
    "setup.label.TaxInclusive": "Impuesto incluido",
    "setup.label.BillFrequencyCode": "Código de frecuencia de facturación",
    "setup.label.TaxCode": "Código fiscal",
    "setup.label.IsAggregate": "Es agregado",
    "setup.label.EditChargeCode": "Editar código de cargo",
    "setup.label.TaxMaster": "Maestro de impuestos",
    "setup.label.CreateTaxMaster": "Crear maestro de impuestos",
    "setup.label.GroupType": "Tipo de grupo",
    "setup.label.GroupCode": "Código de grupo",
    "setup.label.StartDate": "Fecha de inicio",
    "setup.label.Rate": "Tasa",
    "setup.label.BaseTaxCode": "Código Tributario Base",
    "setup.label.Jurisdiction": "Jurisdicción",
    "setup.label.RateType": "Tipo de tasa",
    "setup.label.Location": "Ubicación",
    "setup.label.DeleteTax": "Eliminar impuesto",
    "setup.label.CreateDiscount": "Crear descuento",
    "setup.label.DiscountDescription": "Descripción del descuento",
    "setup.label.DiscountType": "Tipo de descuento",
    "setup.label.DiscountRate": "Tasa de descuento",
    "setup.label.DiscountDetails": "Detalles del descuento",
    "setup.label.ClientCategory": "Categoría de cliente",
    "setup.label.CustomerCategory": "Categoría de cliente",
    "setup.label.EditDiscount": "Editar descuento",
    "setup.label.DeleteDiscount": "Eliminar descuento",
    "setup.label.CreatePromotion": "Crear promoción",
    "setup.label.PromotionCode": "Código de promoción",
    "setup.label.PromotionName": "Nombre de la promoción",
    "setup.label.PromotionId": "ID de promoción",
    "setup.label.PromotionDescription": "Descripción de la promoción",
    "setup.label.EditPromotionCode": "Editar código de promoción",
    "setup.label.ListOfDiscounts": "Lista de descuentos",
    "setup.label.ListofTimePeriods": "Lista de períodos de tiempo",
    "setup.label.CreatePriceRegion": "Crear región de precio",
    "setup.label.RegionCode": "Código de región",
    "setup.label.RegionName": "Nombre de la región",
    "setup.label.Country": "País",
    "setup.label.States": "Estados",
    "setup.label.EditPriceRegion": "Editar región de precio",
    "setup.label.DeletePriceRegion": "Eliminar región de precio",
    "setup.label.CreateSalesCatalogue": "Crear catálogo de ventas",
    "setup.label.SalesCatalogueName": "Nombre del catálogo de ventas",
    "setup.label.AssignUsers": "Asignar usuarios",
    "setup.label.SalesPlanCategory": "Categoría del plan de ventas",
    "setup.label.Plans": "Planes",
    "setup.label.EditSalesCatalogue": "Editar catálogo de ventas",
    "setup.label.DeleteSalesCatalogue": "Eliminar catálogo de ventas",
    "setup.label.UserId": "ID de usuario",
    "setup.label.UserName": "Nombre de usuario",
    "setup.label.CreateUsersCatalogue": "Crear catálogo de usuarios",
    "setup.label.Catalogue": "Catálogo",
    "setup.label.EditUserCatalogue": "Editar catálogo de usuarios",
    "setup.label.VoucherPins": "Códigos de vales",
    "setup.label.CreateVoucherPins": "Crear códigos de vales",
    "setup.label.Voucher": "Vale",
    "setup.label.Coupon": "Cupón",
    "setup.label.LCO": "LCO",
    "setup.label.LengthOfPins": "Longitud de los pines",
    "setup.label.SerialNoLength": "Longitud del número de serie",
    "setup.label.NumberValue ": "Valor Numérico",
    "setup.label.PinValue ": "Valor del PIN",
    "setup.label.BatchName": "Nombre del lote",
    "setup.label.PinCategory": "Categoría de código",
    "setup.label.BeginWith": "Comenzar con",
    "setup.label.Quantity": "Cantidad",
    "setup.label.PinType": "Tipo de código",
    "setup.label.SIMNumbers": "Números SIM",
    "setup.label.CreateSIMNumber": "Crear número SIM",
    "setup.label.NumberCategory": "Categoría de número",
    "setup.label.ExpiryDate": "Fecha de caducidad",
    "setup.label.Partner": "Socio",
    "setup.label.LengthofNumber": "Longitud del número",
    "setup.label.LengthofSerialNumber": "Longitud del número de serie",
    "setup.label.NumberType": "Tipo de número",
    "setup.label.Product": "Producto",
    "setup.label.Supplier": "Proveedor",
    "setup.label.CreateSupplier": "Crear proveedor",
    "setup.label.EditSupplier": "Editar proveedor",
    "setup.label.AddressMaster": "Dirección principal",
    "setup.label.CountryName": "Nombre del país",
    "setup.label.StateName": "Nombre del estado",
    "setup.label.DistrictName": "Nombre del distrito",
    "setup.label.CityName": "Nombre de la ciudad",
    "setup.label.TreeView": "Vista de árbol",
    "setup.label.AddCountry": "Añadir país",
    "setup.label.CountryCode": "Código del país",
    "setup.label.TeamHead": "Jefe de equipo",
    "setup.label.CreateTicketTeam": "Crear equipo de tickets",
    "setup.label.TeamCode": "Código del equipo",
    "setup.label.TeamDescription": "Descripción del equipo",
    "setup.label.TeamCategory": "Categoría del equipo",
    "setup.label.CreateTicketTeamUsers": "Crear usuarios del equipo de tickets",
    "setup.label.TeamEmail": "Correo del equipo",
    "setup.label.AvailableUsers": "Usuarios disponibles",
    "setup.label.SelectedUsers": "Usuarios seleccionados",
    "setup.label.TeamId": "ID del equipo",
    "setup.label.ViewTeam": "Ver equipo",
    "setup.label.DeleteTeam": "Eliminar equipo",
    "setup.label.EditTicketTeam": "Editar equipo de tickets",
    "setup.label.TeamUser": "Usuario del equipo",
    "setup.label.EditTicketUsers": "Editar usuarios de tickets",
    "setup.label.DeleteTeamUser": "Eliminar usuario del equipo",
    "setup.label.VendorManagement": "Gestión de proveedores",
    "setup.label.CreateVendor": "Crear proveedor",
    "setup.label.ContactName": "Nombre de contacto",
    "setup.label.Mobile": "Móvil",
    "setup.label.Landline": "Teléfono fijo",
    "setup.label.CreateNewVendor": "Crear nuevo proveedor",
    "setup.label.EditVendor": "Editar proveedor",
    "setup.label.FeeMaster": "Maestro de tarifas",
    "setup.label.CreateFeeMaster": "Crear maestro de tarifas",
    "setup.label.FeeMasterCode": "Código maestro de tarifas",
    "setup.label.FeeMasterDescription": "Descripción maestro de tarifas",
    "setup.label.FeeMasterTransactionType":
      "Tipo de transacción maestro de tarifas",
    "setup.label.ChargeCode": "Código de cargo",
    "setup.label.VariablePricing": "Precios variables",
    "setup.label.Regions": "Regiones",
    "setup.label.Amount": "Cantidad",
    "setup.label.EditFeeMaster": "Editar maestro de tarifas",
    "setup.label.ManageMessage": "Gestionar mensaje",
    "setup.label.AddMessage": "Agregar mensaje",
    "setup.label.TemplateDescription": "Descripción de la plantilla",
    "setup.label.Subject": "Asunto",
    "setup.label.MessageType": "Tipo de mensaje",
    "setup.label.Header": "Encabezado",
    "setup.label.Body": "Cuerpo",
    "setup.label.Footer": "Pie de página",
    "setup.label.CreateMessageTemplate": "Crear plantilla de mensaje",
    "setup.label.MessageParams": "Parámetros del mensaje",
    "setup.label.Parameter": "Parámetro",
    "setup.label.Params": "Parámetros",
    "setup.label.DeleteMessage": "Eliminar mensaje",
    "setup.label.EditMessage": "Editar mensaje",
    "setup.label.GroupsDetails": "Detalles de los grupos",
    "setup.label.GroupName": "Nombre del grupo",
    "setup.label.GroupAddress": "Dirección del grupo",
    "setup.label.CountNo's": "Contar números",
    "setup.label.AddGroup": "Añadir grupo",
    "setup.label.AdditionalInformation": "Información adicional",
    "setup.label.GroupCIR": "CIR del grupo",
    "setup.label.DIR": "DIR",
    "setup.label.MemberCIR": "CIR del miembro",
    "setup.label.IpPoolManagement": "Gestión del pool de IP",
    "setup.label.UpdateNetMask": "Actualizar máscara de red",
    "setup.label.IpAddress": "Dirección IP",
    "setup.label.NetMark": "Marca de red",
    "setup.label.IpType": "Tipo de IP",
    "setup.label.CoustomerId": "Id del cliente",
    "setup.label.CustomerName": "Nombre del cliente",
    "setup.label.Notes": "Notas",
    "setup.label.Subnet": "Subred",
    "setup.label.DetailsOfMedia": "Detalles del medio",
    "setup.label.Media": "Medio",
    "setup.label.AddMedia": "Agregar medio",
    "setup.label.MediaTitle": "Título del medio",
    "setup.label.MediaCatagory": "Categoría del medio",
    "setup.label.ContentProvider": "Proveedor de contenido",
    "setup.label.Share": "Compartir(%)",
    "setup.label.AddMediaDetails": "Agregar detalles del medio",
    "setup.label.MediaLocation": "Ubicación del medio",
    "setup.label.SelectMediaCategory": "Seleccionar categoría del medio",
    "setup.label.Movies": "Películas",
    "setup.label.ViewMedia": "Ver medio",
    "setup.label.EditMedia": "Editar medio",
    "setup.label.MediaAttributes": "Atributos del medio",
    "setup.label.Cast": "Reparto",
    "setup.label.AttributeType": "Tipo de atributo",
    "setup.label.CaptionValue": "Valor del subtítulo",
    "setup.label.NickName": "Apodo",
    "setup.label.Image": "Imagen",
    "setup.label.AddMediaLocations": "Agregar ubicaciones de medios",
    "setup.label.LanguageData": "Datos del idioma",
    "setup.label.FormatData": "Datos de formato",
    "setup.label.MediaLocations": "Ubicaciones de medios",
    "setup.label.DetailsOfEvent": "Detalles del Evento",
    "setup.label.EventName": "Nombre del Evento",
    "setup.label.EventCode": "Código del Evento",
    "setup.label.SelectedMediaService": "Servicio de Medios Seleccionado",
    "setup.label.AvailableMedia": "Medios Disponibles",
    "setup.label.EventDescription": "Descripción del Evento",
    "setup.label.EventCategory": "Categoría del Evento",
    "setup.label.CreateEvent": "Crear Evento",
    "setup.label.DetailsOfProperty": "Detalles de la Propiedad",
    "setup.label.PropertyCode": "Código de Propiedad",
    "setup.label.PropertyType": "Tipo de Propiedad",
    "setup.label.Parcel": "Parcela",
    "setup.label.BuildingCode": "Código del Edificio",
    "setup.label.Precinct": "Precinto",
    "setup.label.Allocated": "Asignado",
    "setup.label.UploadPropertyData": "Subir Datos de la Propiedad",
    "setup.label.Clear": "Limpiar",
    "setup.label.CreateProperty": "Crear Propiedad",
    "setup.label.PropertyDataUpload": "Subir Datos de la Propiedad",
    "setup.label.Street": "Calle",
    "setup.label.PaymentType": "Tipo de Pago",
    "setup.label.PoBox": "Apartado Postal",
    "setup.label.State": "Estado",
    "setup.label.District": "Distrito",
    "setup.label.Floor": "Piso",
    "setup.label.LimitCode": "Código Límite",
    "setup.label.PropertyMaster": "Maestro de Propiedad",
    "setup.label.CodeDescription": "Descripción del Código",
    "setup.label.ReferenceValue": "Valor de Referencia",
    "setup.label.Services": "Servicios",
    "setup.label.IsBouquet": "EsBouquet",
    "setup.label.Broadcaster": "Emisor",
    "setup.label.Channel": "Canal",
    "setup.label.ContactNumber": "Número de Contacto",
    "setup.label.UOM": "UOM",
    "setup.label.DeleteTemplateDefinition": "Eliminar Definición de Plantilla",
    "setup.label.Discount": "Descuento",
    "setup.label.SalseCatalogue": "Catálogo de Ventas",
    "setup.label.UserCatalogue": "Catálogo de Usuarios",
    "setup.label.Team": "Equipo",
    "setup.label.MediaDetails": "Detalles de los Medios",
    "setup.label.Event": "Evento",
    "setup.label.Properties": "Propiedades",
    "setup.label.ServicesProducts": "Servicios & Productos",
    "setup.label.BroadcasterChannelMapping": "Emisor, Canal & Mapeo",
    "setup.label.UsageRating": "Calificación de Uso",
    "setup.label.ZoneSetup": "Configuración de Zona",
    "setup.label.Promotion": "Promoción",
    "setup.label.PromotionTrigger": "Activador de promoción",
    "setup.label.PromotionRulesAndRates": "Reglas y tarifas de promoción",
    "setup.label.CatalogeMapping": "Mapeo de Catálogo",
    "setup.label.VoucherPin": "Código de Vale",
    "setup.label.SIMNumber": "Número SIM",
    "setup.label.TeamTeamUser": "Equipo & Usuario del Equipo",
    "setup.label.MessageTemplate": "Plantilla de Mensaje",
    "setup.label.ClosedUserGroup": "Grupo de Usuarios Cerrado",
    "setup.label.IpManagement": "Gestión IP",
    "setup.label.PropertyDefinition": "Definición de Propiedad",
    "setup.label.PriorityMapping": "Mapeo de prioridades",
    "setup.label.AddProducts": "Agregar Productos",
    "setup.label.AddDiscount": "Agregar Descuento",
    "setup.label.Products": "Productos",
    "setup.label.ChargeCodeData": "Datos del Código de Cargo",
    "setup.label.TaxMapping": "Mapeo de Impuestos",
    "setup.label.TaxRegion": "Región Fiscal",
    "setup.label.CreateUserCatalogue": "Crear Catálogo de Usuario",
    "setup.label.IcZone": "Zona Ic",
    "setup.label.ViewIcZone": "Ver Zona Ic",
    "setup.label.ViewNumberZone": "Ver Zona de Números",
    "setup.label.EditNumberZone": "Editar Zona de Números",
    "setup.label.DeleteNumberZone": "Eliminar Zona de Números",
    "setup.label.AreYouSure": "¿Estás seguro?",
    "setup.label.ViewAPNZone": "Ver Zona APN",
    "setup.label.EditAPNZone": "Editar Zona APN",
    "setup.label.DeleteAPNZone": "Eliminar Zona APN",
    "setup.label.ViewOperatorZone": "Ver Zona de Operador",
    "setup.label.EditOperatorZone": "Editar Zona de Operador",
    "setup.label.CreateICZone": "Crear Zona IC",
    "setup.label.EditICZone": "Editar Zona IC",
    "setup.label.DeleteOperatorZone": "Eliminar Zona de Operador",
    "setup.label.DeleteIcZone": "Eliminar Zona IC",
    "setup.label.MobileNumber": "Número de Móvil",
    "setup.label.LandlineNumber": "Número de teléfono fijo (opcional)",
    "setup.label.RatePlanName": "Nombre del Plan Tarifario",
    "setup.label.UsageRateBalance": "Saldo de tasa de uso",
    "setup.label.ValidityType": "Tipo de validez",
    "setup.label.ListOfRateTires": "Lista de neumáticos de tarifas",
    "setup.label.Validity": "Validez",
    "setup.label.CreatePlanName": "Crear nombre del plan",
    "setup.label.EditPlanContent": "Editar contenido del plan",
    "setup.label.CreatePlanDescription": "Crear descripción del plan",
    "setup.label.ContentType": "Tipo de contenido",
    "setup.label.CreateFeatureList": "Crear lista de características",
    "setup.label.Area": "Área",
    "setup.label.TaxPercentage": "Porcentaje de impuestos",
    "setup.label.Add": "Añadir",
    "setup.label.Remove": "Eliminar",
    "setup.label.CreateVoucherPin": "Crear Código de Vale",
    "setup.label.EditSubCategory": "Editar subcategoría",
    "setup.label.CreateSubCategory": "Crear subcategoría",
    "setup.label.ViewSubCategory": "Ver subcategoría",
    "setup.label.TimeTaken": "Tiempo tomado",
    "setup.label.TeamMapping": "Asignación de Equipo",
    "setup.label.CreateTeamMapping": "Crear Asignación de Equipo",
    "setup.label.Category": "Categoría",
    "setup.label.external_promotional_code": "Código promocional externo",
    "setup.label.Subcategory": "Subcategoría",
    "setup.label.DeleteItemMapping": "Eliminar Asignación de Elemento",
    "setup.label.EditTeamMapping": "Editar Asignación de Equipo",
    "setup.label.ViewTeamMapping": "Ver Asignación de Equipo",
    "setup.label.DeletePriorityMapping": "Eliminar Asignación de Prioridad",
    "setup.label.discount_rule": "Regla de Descuento",
    "setup.label.promotion_rule": "Regla de promoción",
    "setup.label.discount_rate": "Tasa de Descuento",
    "setup.label.create_discount_rule": "Crear regla de descuento",
    "setup.label.edit_promotion_rule": "Editar regla de promoción",
    "setup.label.create_promotion_rule": "Crear regla de promoción",
    "setup.label.create_discount_rate": "Crear tasa de descuento",
    "setup.label.add_discount_rate": "Agregar Tasa de Descuento",
    "setup.label.add_promotion_rate": "Agregar tarifa de promoción",
    "setup.label.edit_discount": "Editar Descuento",
    "setup.label.edit_promotion": "Editar promoción",
    "setup.label.edit_discount_trigger": "Editar Disparador de Descuento",
    "setup.label.edit_discount_rule": "Editar Regla de Descuento",
    "setup.label.collection_process": "Proceso de Cobro",
    "setup.label.create_collection_profile": "Crear Perfil de Cobro",
    "setup.label.collection_profile": "Perfil de Cobro",
    "setup.label.collection_profile_id": "ID del Perfil de Cobro",
    "setup.label.region": "Región",
    "setup.label.collection": "Cobro",
    "setup.label.collection_trigger": "Disparador de Cobro",
    "setup.label.collection_scenario": "Escenario de Cobro",
    "setup.label.add_collection_trigger": "Agregar Disparador de Cobro",
    "setup.label.add_collection_scenario": "Agregar Escenario de Cobro",
    "setup.label.trigger_id": "ID del Disparador",
    "setup.label.criteria_type": "Tipo de Criterio",
    "setup.label.due_balance": "Saldo Adeudado",
    "setup.label.ageing_days": "Días de Envejecimiento",
    "setup.label.scenario_id": "ID del Escenario",
    "setup.label.action_name": "Nombre de la Acción",
    "setup.label.age": "Edad",
    "setup.label.create_collection_trigger": "Crear Disparador de Cobro",
    "setup.label.create_collection_scenario": "Crear Escenario de Cobro",
    "setup.label.edit_collection_profile": "Editar Perfil de Cobro",
    "setup.label.edit_collection_trigger": "Editar Disparador de Cobro",
    "setup.label.edit_collection_scenario": "Editar Escenario de Cobro",
    "setup.label.SlaInHours": "SLA en horas",
    "setup.label.contractduration": "Duración del Contrato",
    "setup.label.chargesperiodicity": "Periodicidad de los Cargos",
  },

  pt: {
    "setup.label.Enter_product_Description": "Digite a descrição do produto",
    "setup.label.FeedbackStatus": "Status do Feedback",
    "setup.label.EnterCountryName": "Digite o nome do país",
    "setup.label.location": "Localização",
    "setup.label.selectLocation": "Selecionar Localização",
    "setup.label.create_group_ticket": "Criar Ticket de Grupo",
    "setup.label.default": "Padrão",
    "setup.label.customerFeedback": "Feedback do cliente",
    "setup.label.automation": "Automação",
    "setup.label.automation_master": "Mestre de automação",
    "setup.label.create_automation": "Criar automação",
    "setup.label.edit_automation": "Editar automação",
    "setup.label.automation_detail": "Detalhes da automação",
    "setup.label.automation_steps": "Etapas da automação",
    "setup.label.add_automation_step": "Adicionar etapa de automação",
    "setup.label.AutomationId": "ID da automação",
    "setup.label.EntityName": "Nome da entidade",
    "setup.label.EntityType": "Tipo de entidade",
    "setup.label.WorkflowName": "Nome do fluxo de trabalho",
    "setup.label.CreateAutomationScenario": "Criar cenário de automação",
    "setup.label.EditAutomationStep": "Editar etapa de automação",
    "setup.label.ActionType": "Tipo de ação",
    "setup.label.ActionDetails": "Detalhes da ação",
    "setup.label.StepOrder": "Ordem das etapas",
    "setup.label.questionAnswerSet": "Conjunto de perguntas e respostas",
    "setup.label.addQuestionSet": "Adicionar conjunto de perguntas",
    "setup.label.EditQuestionSet": "Editar conjunto de perguntas",
    "setup.label.CategoryName": "Nome da categoria",
    "setup.label.SubCategoryName": "Nome da subcategoria",
    "setup.label.TotalQuestions": "Total de perguntas",
    "setup.label.QuestionType": "Tipo de pergunta",
    "setup.label.QuestionText": "Texto da pergunta",
    "setup.label.CustomerFeedback": "Feedback do cliente",
    "setup.label.TicketId": "ID do ticket",
    "setup.label.LinkedAt": "Vinculado em",
    "setup.label.Remarks": "Observações",
    "setup.label.AddFeedback": "Adicionar feedback",
    "setup.label.PendingForApproval": "Pendente de aprovação",
    "setup.label.user_availability": "Disponibilidade do usuário",
    "setup.label.all_users_availability":
      "Disponibilidade de todos os usuários",
    "setup.label.create_user_availability": "Criar disponibilidade do usuário",
    "setup.label.LeaveManagement": "Gestão de licenças",
    "setup.label.CreateLeave": "Criar licença",
    "setup.label.EditLeave": "Editar licença",
    "setup.label.ViewLeave": "Ver licença",
    "setup.label.AllUserLeaves": "Todas as licenças dos usuários",
    "setup.label.MyLeaves": "Minhas licenças",
    "setup.label.ConfigId": "ID de configuração",
    "setup.label.edit_user_availability": "Editar disponibilidade do usuário",
    "setup.label.view_user_availability":
      "Visualizar disponibilidade do usuário",
    "setup.label.unavailability_date": "Data de indisponibilidade",
    "setup.label.start_time": "Hora de início",
    "setup.label.end_time": "Hora de término",
    "setup.label.my_availability": "Minha disponibilidade",
    "setup.label.user": "Usuário",
    "setup.label.EditShift": "Editar turno",
    "setup.label.UserWorkingShift": "Turno de trabalho do usuário",
    "setup.label.CreateUserWorkingShift": "Criar turno de trabalho do usuário",
    "setup.label.EditUserWorkingShift": "Editar turno de trabalho do usuário",
    "setup.label.ViewUserWorkingShift": "Ver turno de trabalho do usuário",
    "setup.label.TeamName": "Nome da equipe",
    "setup.label.Shift": "Turno",
    "setup.label.ShiftManagement": "Gestão de turnos",
    "setup.label.CreateShift": "Criar turno",
    "setup.label.ShiftName": "Nome do turno",
    "setup.label.Session": "Sessão",
    "setup.label.SessionType": "Tipo de sessão",
    "setup.label.LeaveDetails": "Detalhes da licença",
    "setup.label.SessionStartTime": "Hora de início da sessão",
    "setup.label.SessionEndTime": "Hora de término da sessão",
    "setup.label.LeaveType": "Tipo de licença",
    "setup.label.AddAnotherDate": "Adicionar outra data",
    "setup.label.Apn_Zone": "Zona Apn",
    "setup.label.FeeMaster": "Mestre de Taxas",
    "setup.label.Number_Zone": "Zona Numérica",
    "setup.label.DeleteRUM": "Excluir RUM",
    "setup.label.Edit_TimeModel": "Editar modelo de tempo",
    "setup.label.Edit_Year": "Editar ano",
    "setup.label.scenario_name": "Nome do cenário",
    "setup.label.event_name": "Nome do evento",
    "setup.label.Edit_Month": "Editar mês",
    "setup.label.Edit_Day": "Editar dia",
    "setup.label.Edit_Time": "Editar hora",
    "setup.label.Delete_TimeModel": "Excluir modelo de tempo",
    "setup.label.Delete_Year": "Excluir ano",
    "setup.label.Delete_Month": "Excluir mês",
    "setup.label.Delete_Day": "Excluir dia",
    "setup.label.Delete_Time": "Excluir hora",
    "setup.label.Are_you_sure_?": "Tem certeza?",
    "setup.label.Save": "Salvar",
    "setup.label.TemplateDefinition": "Definição do modelo",
    "setup.label.EditQuantityTier": "Editar nível de quantidade",
    "setup.label.Usage_Rate_Balance": "Saldo da tarifa de uso",
    "setup.label.Template_Name": "Nome do modelo",
    "setup.label.Delimiter": "Delimitador",
    "setup.label.Number_Of_Fields": "Número de campos",
    "setup.label.Header_Recorder_Type": "Tipo de gravador de cabeçalho",
    "setup.label.Event_Record_Type": "Tipo de registro de evento",
    "setup.label.CreateUOM": "Criar unidade de medida",
    "setup.label.TimePeriod": "Período de tempo",
    "setup.label.Usage_Rate_Plan": "Plano de tarifa de uso",
    "setup.label.TemplateDefinition": "Definição do modelo",
    "setup.label.CreateRUM": "Criar RUM",
    "setup.label.CreateTimePeriod": "Criar período de tempo",
    "setup.label.TimemodelName": "Nome do modelo de tempo",
    "setup.label.TimePeriodName": "Nome do período de tempo",
    "setup.label.StartYear": "Ano de início",
    "setup.label.EndYear": "Ano final",
    "setup.label.UsageRatePlan": "Plano de tarifa de uso",
    "setup.label.Create_Usage_Rate_Plan": "Criar plano de tarifa de uso",
    "setup.label.Id": "ID",
    "setup.label.PlanName": "Nome do plano",
    "setup.label.ProductName": "Nome do produto",
    "setup.label.ChargeCode": "Código de cobrança",
    "setup.label.TimeModelName": "Nome do modelo de tempo",
    "setup.label.RatingType": "Tipo de classificação",
    "setup.label.RumName": "Nome do RUM",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "Tem certeza de que deseja excluir?",
    "setup.label.UOM": "Unidade de Medida",
    "setup.label.RUM": "RUM",
    "setup.label.ImpactCategory": "Categoria de Impacto",
    "setup.label.Resource": "Recurso",
    "setup.label.GLID": "GLID",
    "setup.label.Unit": "Unidade",
    "setup.label.Rate": "Taxa",
    "setup.label.Action": "Ação",
    "setup.label.options_selected": "opções selecionadas",
    "setup.label.UsageRateBalance": "Saldo da Taxa de Uso",
    "setup.label.EndYear": "Ano Final",
    "setup.label.StartMonth": "Mês de Início",
    "setup.label.EndMonth": "Mês Final",
    "setup.label.StartDay": "Dia de Início",
    "setup.label.EndDay": "Dia Final",
    "setup.label.StartTime": "Hora de Início",
    "setup.label.Time_Model_Name": "Nome do Modelo de Tempo",
    "setup.label.model_includes_which_all_Bands_?":
      "O modelo inclui quais bandas?",
    "setup.label.YearRestriction": "Restrição por Ano",
    "setup.label.MonthRestriction": "Restrição por Mês",
    "setup.label.DayRestriction": "Restrição por Dia",
    "setup.label.TimeRestriction": "Restrição de Tempo",
    "setup.label.Code": "Código",
    "setup.label.Name": "Nome",
    "setup.label.PriorityMapping": "Mapeamento de Prioridade",
    "setup.label.AddJurisdiction": "Adicionar jurisdição",
    "setup.label.Are_you_sure_?": "Tem certeza?",
    "setup.label.Country": "País",
    "setup.label.State": "Estado",
    "setup.label.District": "Distrito",
    "setup.label.RateType": "Tipo de taxa",
    "setup.label.Remove": "Remover",
    "setup.label.TaxMaster": "Mestre de impostos",
    "setup.label.Team": "Equipe",
    "setup.label.Add": "Adicionar",
    "setup.label.FeeMaster": "Mestre de taxas",
    "setup.label.DeleteChargeCode": "Excluir código de cobrança",
    "setup.label.SelectSearch": "Selecionar pesquisa",
    "setup.label.Select_Content_Tag_Value":
      "Selecionar valor da tag de conteúdo",
    "setup.label.Plan_Content": "Conteúdo do plano",
    "setup.label.Plan": "Plano",
    "setup.label.ProductPrice": "Preço do produto",
    "setup.label.SelectedPromotions": "Promoções selecionadas",
    "setup.label.AvailablePromotions": "Promoções disponíveis",
    "setup.label.SelectType": "Selecionar tipo",
    "setup.label.Type": "Tipo",
    "setup.label.No_versions_available": "Nenhuma versão disponível",
    "setup.label.Version": "Versão",
    "setup.label.ListPrice": "Preço de tabela",
    "setup.label.SellingPrice": "Preço de venda",
    "setup.label.EnterPlanDescription": "Inserir descrição do plano",
    "setup.label.AddPrice": "Adicionar preço",
    "setup.label.Save": "Salvar",
    "setup.label.AddDiscount": "Adicionar desconto",
    "setup.label.AvailablePlans": "Planos disponíveis",
    "setup.label.SelectedPlans": "Planos selecionados",
    "setup.label.PlanType": "Tipo de plano",
    "setup.label.Plan_Start_Date": "Data de início do plano",
    "setup.label.Plan_End_Date": "Data de término do plano",
    "setup.label.Bill_Type": "Tipo de cobrança",
    "setup.label.AttributeTypes": "Tipos de atributo",
    "setup.label.Add": "Adicionar",
    "setup.label.Select_Content_Tag": "Selecionar etiqueta de conteúdo",
    "setup.label.PlanName": "Nome do plano",
    "setup.label.AvailableDiscounts": "Descontos disponíveis",
    "setup.label.Search": "Pesquisar...",
    "setup.label.MoveRight": "Mover para a direita",
    "setup.label.MoveLeft": "Mover para a esquerda",
    "setup.label.SelectedDiscounts": "Descontos selecionados",
    "setup.label.SelectType": "Selecionar tipo",
    "setup.label.SelectLanguage": "Selecionar idioma",
    "setup.label.SelectContentTag": "Selecionar tag de conteúdo",
    "setup.label.SelectContentTagValue": "Selecionar valor do tag",
    "setup.label.DigitalContent": "Conteúdo digital",
    "setup.label.Enter_Plan_Description": "Digite a descrição do plano",
    "setup.label.DC_Rule": "Regra DC",
    "setup.label.PlanAttribute": "Atributo do plano",
    "setup.label.AdvanceView": "Visualização avançada",
    "setup.label.Update": "Atualizar",
    "setup.label.ProductMapping": "Mapeamento de produto",
    "setup.label.Service": "Serviço",
    "setup.label.SubProducts": "Subprodutos",
    "setup.label.Type": "Tipo",
    "setup.label.EnterValue": "Inserir valor",
    "setup.label.PriceRegion": "Região de preço",
    "setup.label.Enter_service_Description": "Digite a descrição do serviço",
    "setup.label.ParamName": "Nome do parâmetro",
    "setup.label.Category": "Categoria",
    "setup.label.Type": "Tipo",
    "setup.label.EnterValue": "Digite o valor",
    "setup.label.SalesCatalogue": "Catálogo de vendas",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "Tem certeza de que deseja excluir?",
    "setup.label.Channel": "Canal",
    "setup.label.Broadcaster": "Emissora",
    "setup.label.AddPrice": "Adicionar preço",
    "setup.label.DeleteMediaEvent": "Excluir evento de mídia",
    "setup.label.AdvMedia": "Mídia publicitária",
    "setup.label.EditMedia": "Editar mídia",
    "setup.label.AddEvent": "Adicionar evento",
    "setup.label.AddAttributes": "Adicionar atributos",
    "setup.label.AddLocation": "Adicionar local",
    "setup.label.DeleteEvent": "Excluir evento",
    "setup.label.Are_you_sure_?": "Tem certeza?",
    "setup.label.Add": "Adicionar",
    "setup.label.ViewEvent": "Visualizar evento",
    "setup.label.Event": "Evento",
    "setup.label.RUM": "RUM",
    "setup.label.OptType": "Tipo de opção",
    "setup.label.Currency": "Moeda",
    "setup.label.Amount": "Quantia",
    "setup.label.Add": "Adicionar",
    "setup.label.Save": "Salvar",
    "setup.label.AddDiscount": "Adicionar desconto",
    "setup.label.EnterEventCode": "Inserir código do evento",
    "setup.label.EnterEventDescription": "Inserir descrição do evento",
    "setup.label.EventDescription": "Descrição do evento",
    "setup.label.EventCategory": "Categoria do evento",
    "setup.label.ChargeCode": "Código de cobrança",
    "setup.label.SelectEventValidity": "Selecionar validade do evento",
    "setup.label.EditEvent": "Editar evento",
    "setup.label.UnitCode": "Código da Unidade",
    "setup.label.MediaTitle": "Título da Mídia",
    "setup.label.ContentProvider": "Fornecedor de Conteúdo",
    "setup.label.MediaType": "Tipo de Mídia",
    "setup.label.Rated": "Classificado",
    "setup.label.MediaCategory": "Categoria de Mídia",
    "setup.label.Rating": "Classificação",
    "setup.label.Poster": "Cartaz",
    "setup.label.Status": "Status",
    "setup.label.MovieDuration": "Duração do Filme",
    "setup.label.ReleaseDate": "Data de Lançamento",
    "setup.label.Genre": "Gênero",
    "setup.label.Subject": "Assunto",
    "setup.label.Overview": "Visão Geral",
    "setup.label.Share(%)": "Participação (%)",
    "setup.label.Cast": "Elenco",
    "setup.label.AttributeType": "Tipo de Atributo",
    "setup.label.CaptionValue": "Valor da Legenda",
    "setup.label.NickName": "Apelido",
    "setup.label.Image": "Imagem",
    "setup.label.Language": "Idioma",
    "setup.label.Format": "Formato",
    "setup.label.Location": "Localização",
    "setup.label.CustomerType": "Tipo de Cliente",
    "setup.label.FormatType": "Tipo de Formato",
    "setup.label.DiscountCode": "Código de Desconto",
    "setup.label.ReProcess": "Reprocessar",
    "setup.label.Code": "Código",
    "setup.label.Description": "Descrição",
    "setup.label.PropertyCodeType": "Tipo de Código da Propriedade",
    "setup.label.ReferenceValue": "Valor de Referência",
    "setup.label.EditProperty": "Editar Propriedade",
    "setup.label.EditPropertyMaster": "Editar Mestre de Propriedade",
    "setup.label.Cancel": "Cancelar",
    "setup.label.View": "Visualizar",
    "setup.label.Edit": "Editar",
    "setup.label.Browse_file_to_Upload": "Procurar arquivo para enviar",
    "setup.label.CreatePropertyMaster": "Criar Mestre de Propriedade",
    "setup.label.Property": "Propriedade",
    "setup.label.PropertyMaster": "Mestre de Propriedade",
    "setup.label.ViewProperty": "Visualizar Propriedade",
    "setup.label.ViewPropertyMaster": "Visualizar Mestre de Propriedade",
    "setup.label.Are_you_sure_?": "Tem certeza?",
    "setup.label.Edit": "Editar",
    "setup.label.Code": "Código",
    "setup.label.Name": "Nome",
    "setup.label.AddState": "Adicionar estado",
    "setup.label.AddDistrict": "Adicionar distrito",
    "setup.label.AddCity": "Adicionar cidade",
    "setup.label.EditCountry": "Editar país",
    "setup.label.EditState": "Editar estado",
    "setup.label.EditDistrict": "Editar distrito",
    "setup.label.EditCity": "Editar cidade",
    "setup.label.DeleteCountry": "Excluir país",
    "setup.label.DeleteState": "Excluir estado",
    "setup.label.DeleteDistrict": "Excluir distrito",
    "setup.label.DeleteCity": "Excluir cidade",
    "setup.label.ServiceAvailablity": "Disponibilidade do serviço",
    "setup.label.EnterCountryCode": "Insira o código do país",
    "setup.label.EnterCode": "Insira o código",
    "setup.label.EnterName": "Insira o nome",
    "setup.label.Service_Availablity_for_the":
      "Disponibilidade do serviço para",
    "setup.label.SelectServices": "Selecionar serviços",
    "setup.label.Select_One_or_More": "Selecionar um ou mais",
    "setup.label.options_selected": "opções selecionadas",
    "setup.label.PromotionName": "Nome da promoção",
    "setup.label.PromotionCode": "Código da promoção",
    "setup.label.BussinesType": "Tipo de negócio",
    "setup.label.OrderType": "Tipo de pedido",
    "setup.label.PaymentType": "Tipo de pagamento",
    "setup.label.SelectCategory": "Selecionar categoria",
    "setup.label.PromotionTrigger": "Gatilho da promoção",
    "setup.label.PromotionRule": "Regra da promoção",
    "setup.label.PromotionTriggerCondition": "Condição do gatilho da promoção",
    "setup.label.DiscountTriggerCondition": "Condição de gatilho de desconto",
    "setup.label.DiscountRule": "Regra de desconto",
    "setup.label.DiscountTrigger": "Gatilho de desconto",
    "setup.label.EditTriggerCondition": "Editar condição de gatilho",
    "setup.label.Rate": "Taxa",
    "setup.label.EditRule": "Editar regra",
    "setup.label.AddRate": "Adicionar taxa",
    "setup.label.Download": "Baixar",
    "setup.label.Process": "Processar",
    "setup.label.ViewVendor": "Ver fornecedor",
    "setup.label.VendorCode": "Código do fornecedor",
    "setup.label.VendorName": "Nome do fornecedor",
    "setup.label.select_Currency": "Selecionar moeda",
    "setup.label.select_Country": "Selecionar país",
    "setup.label.Filter_List": "Filtrar lista",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "Tem certeza de que deseja excluir?",
    "setup.label.DeleteVoucher": "Excluir voucher",
    "setup.label.UpdatePin": "Atualizar PIN",
    "setup.label.UpdateVoucher": "Atualizar voucher",
    "setup.label.select_from_dropdown": "Selecionar no menu suspenso",
    "setup.label.ItemModel": "Modelo do item",
    "setup.label.price": "Preço",
    "setup.label.Edit": "Editar",
    "setup.label.Delete": "Excluir",
    "setup.label.Item": "Item",
    "setup.label.EnterSupplierAddress": "Inserir endereço do fornecedor",
    "setup.label.Title": "Título",
    "setup.label.AddPromotionTriggerCondition":
      "Adicionar Condição de Gatilho de Promoção",
    "setup.label.EditPromotionTriggerCondition":
      "Editar Condição de Gatilho de Promoção",
    "setup.label.AssignTo": "Atribuir a",
    "setup.label.Version": "Versão",
    "setup.label.IsOverride": "É substituição",
    "setup.label.PlanAttribute": "Atributo do plano",
    "setup.label.ValidationRule": "Regra de validação",
    "setup.label.SaveAndContinue": "Salvar e continuar",
    "setup.label.PlanManagement": "Gerenciamento de Planos",
    "setup.label.Plan": "Plano",
    "setup.label.DiscountTriggerCondition": "Condição de Gatilho de Desconto",
    "setup.label.AddDiscountTriggerCondition":
      "Adicionar Condição de Gatilho de Desconto",
    "setup.label.SalesChannel": "Canal de vendas",
    "setup.label.PaymentType": "Tipo de Pagamento",
    "setup.label.OrderType": "Tipo de Pedido",
    "setup.label.BusinessType": "Tipo de Negócio",
    "setup.label.ViewDigitalContent": "Ver Conteúdo Digital",
    "setup.label.EditDigitalContent": "Editar Conteúdo Digital",
    "setup.label.AddDigitalContent": "Adicionar Conteúdo Digital",
    "setup.label.PromotionRuleName": "Nome da Regra de Promoção",
    "setup.label.PromotionTriggerCondition": "Condição de Gatilho da Promoção",
    "setup.label.AddPromotionTriggerCondition":
      "Adicionar Condição de Gatilho da Promoção",
    "setup.label.BussinesType": "Tipo de Negócio",
    "setup.label.requestApproval": "Solicitar aprovação",
    "setup.label.validity_uom": "Unidade de Validade",
    "setup.label.validity_value": "Valor de Validade",
    "setup.label.ViewItemModel": "Visualizar modelo de item",
    "setup.label.ItemType": "Tipo de item",
    "setup.label.ViewSupplier": "Ver Fornecedor",
    "setup.label.SupplierCode": "Código do Fornecedor",
    "setup.label.SupplierDescription": "Descrição do Fornecedor",
    "setup.label.SupplierAddress": "Endereço do Fornecedor",
    "setup.label.DeleteSupplier": "Excluir Fornecedor",
    "setup.label.CreateContract": "Criar contrato",
    "setup.label.RateTierName": "Nome do nível de taxa",
    "setup.label.RangeType": "Tipo de intervalo",
    "setup.label.CreateDiscountRule": "Criar regra de desconto",
    "setup.label.RuleCondition": "Condição da regra",
    "setup.label.CreateRuleCondition": "Criar condição de regra",
    "setup.label.CreateRule": "Criar regra",
    "setup.label.Entity": "Entidade",
    "setup.label.EntityField": "Campo Entidade",
    "setup.label.contentTag": "Etiqueta de conteúdo",
    "setup.label.contentTagValue": "Valor da etiqueta de conteúdo",
    "setup.label.ExecutionType": "Tipo de Execução",
    "setup.label.OperationMode": "Modo de Operação",
    "setup.label.AggregationType": "Tipo de Agregação",
    "setup.label.DurationInDays": "Duração em Dias",
    "setup.label.CreateTicketTeamUser": "Criar usuário da equipe de tickets",
    "setup.label.termsConditions": "Termos e Condições",
    "setup.label.updateTermsConditions": "Atualizar Termos e Condições",
    "setup.label.updateDigitalContent": "Atualizar conteúdo digital",
    "setup.label.createDigitalContent": "Crie conteúdo digital",
    "setup.label.createTermsConditions": "Crie Termos e Condições",
    "setup.label.digitalContent": "Conteúdo digital",
    "setup.label.planContent": "Planejar conteúdo",
    "setup.label.selectPlanContent": "Selecione o conteúdo do plano",
    "setup.label.FilterType": "Tipo de Filtro",
    "setup.label.FilterValue": "Valor do Filtro",
    "setup.label.ContractPeriod": "Período do contrato",
    "setup.label.AddContract": "Adicionar contrato",
    "setup.label.EditContract": "Editar contrato",
    "setup.label.ViewContract": "Ver Contrato",
    "setup.label.ContractType": "tipo de contrato",
    "setup.label.ContractUnit": "Unidade de Contrato",
    "setup.label.AddOrEditDiscount": "Período do contrato",
    "setup.label.ExternalPlanId": "ID do plano externo",
    "setup.label.ExternalProductId": "ID do produto externo",
    "setup.label.updateNetMask": "Atualizar máscara de rede",
    "setup.label.Update": "Atualizar",
    "setup.label.BillType": "Tipo de fatura",
    "setup.label.BillFrequency": "Frequência de faturamento",
    "setup.label.PlanEndDate": "Data de término do plano",
    "setup.label.AddContent": "Adicionar conteúdo",
    "setup.label.CreatePlanContent": "Criar conteúdo do plano",
    "setup.label.SelectLanguage": "Selecionar idioma",
    "setup.label.UploadDigitalImage": "Carregar imagem digital",
    "setup.label.ViewPlanContent": "Visualizar conteúdo do plano",
    "setup.label.ExternalPlanName": "Nome do plano externo",
    "setup.label.ExternalProductName": "Nome do produto externo",
    "setup.label.ViewPrice": "Visualizar preço",
    "setup.label.SelectedPlanDiscounts": "Descontos do plano selecionado,",
    "setup.label.ProductDiscount": "Descontos do produto,",
    "setup.label.PlanValidationRules": "Regras de validação do plano",
    "setup.label.CreateValidationRule": "Criar regra de validação",
    "setup.label.EditValidationRule": "Editar regra de validação",
    "setup.label.InputPlanId": "Inserir ID do plano",
    "setup.label.CheckinPlanId": "ID do plano de validação",
    "setup.label.RuleAppliesTo": "Unidade",
    "setup.label.Rule": "Regra",
    "setup.label.ViewValidationRule": "Regra de validação de exibição",
    "setup.label.ValidationRule": "Regra de validação",
    "setup.label.createIpPool": "Criar pool de IP",
    "setup.label.editIpPool": "Editar pool de IP",
    "setup.label.Next": "Próximo",
    "setup.label.MainCategory": "categoria principal",
    "setup.label.SubCategory": "Subcategoria",
    "setup.label.select_date": "Selecionar Data",
    "setup.label.AddDiscountTrigger": "Adicionar Gatilho de Desconto",
    "setup.label.AddPromotionTrigger": "Adicionar gatilho de promoção",
    "setup.label.edit_promotion_trigger": "Editar gatilho de promoção",
    "setup.label.DiscountTrigger": "Gatilho de Desconto",
    "setup.label.TriggerName": "Nome do Gatilho",
    "setup.label.When": "Quando",
    "setup.label.CustomerType": "Tipo de Cliente",
    "setup.label.Criteria": "Critérios",
    "setup.label.Values": "Valores",
    "setup.label.ApplicableTo": "Aplicável a",
    "setup.label.ApplicableValues": "Valores Aplicáveis",
    "setup.label.DiscountRulesAndRates": "Regras e Taxas de Desconto",
    "setup.label.RuleName": "Nome da Regra",
    "setup.label.MaxDiscount": "Desconto Máximo",
    "setup.label.ResourceId": "ID de Recurso",
    "setup.label.DiscountRateType": "Tipo de Taxa de Desconto",
    "setup.label.Unit": "Unidade",
    "setup.label.DiscountId": "ID de Desconto",
    "setup.label.DiscountName": "Nome do Desconto",
    "setup.label.Priority": "Prioridade",
    "setup.label.Items": "Itens",
    "setup.label.ItemCode": "Código do Item",
    "setup.label.ItemDescription": "Descrição do Item",
    "setup.label.Units": "Unidades",
    "setup.label.Total": "Total",
    "setup.label.Warranty": "Garantia",
    "setup.label.UsedItems": "Itens Utilizados",
    "setup.label.Balanced": "Equilibrado",
    "setup.label.IsProvisioning": "É Provisão",
    "setup.label.CreateItem": "Criar Item",
    "setup.label.ItemClass": "Classe do Item",
    "setup.label.ReorderLevel": "Nível de Reordenação",
    "setup.label.WarrantyPeriod": "Período de Garantia",
    "setup.label.Currency": "Moeda",
    "setup.label.DefaultPrice": "Preço Padrão",
    "setup.label.IsSelector": "É Seletor",
    "setup.label.SelectorMenu": "Menu de Seleção",
    "setup.label.Selector": "Seletor",
    "setup.label.VariablePrice": "Preço Variável",
    "setup.label.ItemModel": "Modelo do Item",
    "setup.label.Price": "Preço",
    "setup.label.Action": "Ação",
    "setup.label.Cancel": "Cancelar",
    "setup.label.planPrice": "Preço do Plano",
    "setup.label.listview": "Visualização em Lista",
    "setup.label.Submit": "Enviar",
    "setup.label.EditItem": "Editar Item",
    "setup.label.Id": "Id",
    "setup.label.ItemMasterId": "Id do Item Mestre",
    "setup.label.RegionId": "Id da Região",
    "setup.label.Edit": "Editar",
    "setup.label.ViewItem": "Ver Item",
    "setup.label.UnitPrice": "Preço unitário",
    "setup.label.ItemModels": "Modelos de Item",
    "setup.label.NetworkElement": "Elemento de Rede",
    "setup.label.Model": "Modelo",
    "setup.label.Make": "Criar",
    "setup.label.CreateItemModel": "Criar Modelo de Item",
    "setup.label.Reset": "Redefinir",
    "setup.label.EditItemModel": "Editar Modelo de Item",
    "setup.label.ServiceCode": "Código de serviço",
    "setup.label.ServiceDescription": "Descrição do serviço",
    "setup.label.ServiceType": "Tipo de serviço",
    "setup.label.Isoptional": "É opcional",
    "setup.label.Isautoprovision": "É autoprovisionamento",
    "setup.label.CreateService": "Criar serviço",
    "setup.label.Code": "Código",
    "setup.label.Description": "Descrição",
    "setup.label.Type": "Tipo",
    "setup.label.EditService": "Editar serviço",
    "setup.label.ServiceParameter": "Parâmetro de serviço",
    "setup.label.ParamName": "Nome do parâmetro",
    "setup.label.ParamType": "Tipo de parâmetro",
    "setup.label.ParamCategory": "Categoria de parâmetro",
    "setup.label.ParamValue": "Valor do parâmetro",
    "setup.label.BB": "BB",
    "setup.label.Delete": "Excluir",
    "setup.label.ServiceCategory": "Categoria de serviço",
    "setup.label.DeleteServices": "Excluir serviços",
    "setup.label.Confirm": "Confirmar",
    "setup.label.Service": "Serviço",
    "setup.label.Status": "Status",
    "setup.label.Bouquet": "Bouquet",
    "setup.label.Actions": "Ações",
    "setup.label.CreateProduct": "Criar Produto",
    "setup.label.ProductParameter": "Parâmetro do produto",
    "setup.label.EditProduct": "Editar Produto",
    "setup.label.ProductDescription": "Descrição do produto",
    "setup.label.ProductCategory": "Categoria de produto",
    "setup.label.BroadcasterCode": "Código do Radiodifusor",
    "setup.label.BroadcasterName": "Nome do Radiodifusor",
    "setup.label.GstRegNumber": "Número de Registro GST",
    "setup.label.ContactPerson": "Pessoa de Contato",
    "setup.label.ContactMobile": "Móvel de Contato",
    "setup.label.Email": "Email",
    "setup.label.CreateBroadcaster": "Criar Radiodifusor",
    "setup.label.Address": "Endereço",
    "setup.label.MobileNo": "Número de Celular",
    "setup.label.LandlineNo": "Número de Telefone Fixo",
    "setup.label.EditBroadcaster": "Editar Radiodifusor",
    "setup.label.ChannelName": "Nome do Canal",
    "setup.label.ChannelType": "Tipo de Canal",
    "setup.label.DeleteBroadcaster": "Excluir Radiodifusor",
    "setup.label.ChannelCategory": "Categoria do Canal",
    "setup.label.ChannelSequence": "Sequência do Canal",
    "setup.label.IsHdChannel": "É Canal HD",
    "setup.label.CreateChannel": "Criar Canal",
    "setup.label.Language": "Idioma",
    "setup.label.IsLocalChannel": "É Canal Local",
    "setup.label.Genre": "Gênero",
    "setup.label.BroadcasterId": "ID do Radiodifusor",
    "setup.label.EditChannel": "Editar Canal",
    "setup.label.DeleteChannel": "Excluir Canal",
    "setup.label.ProductMapping": "Mapeamento de Produtos",
    "setup.label.CreateProductChannelMapping":
      "Criar Mapeamento de Canais de Produto",
    "setup.label.ProductId": "ID do Produto",
    "setup.label.AvailableChannels": "Canais Disponíveis",
    "setup.label.SelectedChannels": "Canais Selecionados",
    "setup.label.EditChannelMapping": "Editar Mapeamento de Canais",
    "setup.label.PlanPricing": "Plano e Preços",
    "setup.label.CreatePlan": "Criar Plano",
    "setup.label.PlanCode": "Código do Plano",
    "setup.label.PlanDescription": "Descrição do Plano",
    "setup.label.PlanStatus": "Status do Plano",
    "setup.label.PlanProvisionSystem": "Sistema de Provisão do Plano",
    "setup.label.PlanStartDate": "Data de Início do Plano",
    "setup.label.IsPrepaid": "É Pré-pago",
    "setup.label.Duration": "Duração",
    "setup.label.PlanType": "Tipo de Plano",
    "setup.label.BillingRule": "Regra de Cobrança",
    "setup.label.EndDate": "Data de Término",
    "setup.label.IsProvision": "Está Provisionado",
    "setup.label.EditPlan": "Editar Plano",
    "setup.label.SelectProduct": "Selecionar Produto",
    "setup.label.ViewPlan": "Ver Plano",
    "setup.label.ProvisioningSystem": "Sistema de Provisão",
    "setup.label.DeletePlan": "Excluir Plano",
    "setup.label.Prices": "Preços",
    "setup.label.ChargeOwner": "Proprietário da cobrança",
    "setup.label.DiscountCode": "Código de desconto",
    "setup.label.PriceRegion": "Região de preço",
    "setup.label.Resource": "Recurso",
    "setup.label.SalesChannel": "Canal de vendas",
    "setup.label.OrderType": "Tipo de pedido",
    "setup.label.BusinessType": "Tipo de negócio",
    "setup.label.RoundingType": "Tipo de arredondamento",
    "setup.label.GLID": "ID do GL",
    "setup.label.Value": "Valor",
    "setup.label.TemplateDefinition": "Definição de Modelo",
    "setup.label.CreateTemplateDefinition": "Criar Definição de Modelo",
    "setup.label.TemplateName": "Nome do Modelo",
    "setup.label.Delimiter": "Delimitador",
    "setup.label.NumberOfFields": "Número de Campos",
    "setup.label.HeaderRecorderType": "Tipo de Gravador de Cabeçalho",
    "setup.label.EventRecordType": "Tipo de Registro de Evento",
    "setup.label.ProductCode": "Código do Produto",
    "setup.label.IsHeader": "É Cabeçalho",
    "setup.label.FieldType": "Tipo de Campo",
    "setup.label.FieldName": "Nome do Campo",
    "setup.label.IdentifierType": "Tipo de Identificador",
    "setup.label.Length": "Comprimento",
    "setup.label.ExistsTemplateDefinition": "Definição de Modelo Existente",
    "setup.label.UOM(Unit Of measurement)": "UOM (Unidade de Medida)",
    "setup.label.CreateUOM": "Criar UOM",
    "setup.label.Name": "Nome",
    "setup.label.EditTemplateDefinition": "Editar Definição de Modelo",
    "setup.label.EditUOM": "Editar UOM",
    "setup.label.Save": "Salvar",
    "setup.label.DeleteUOM": "Excluir UOM",
    "setup.label.Ok": "Ok",
    "setup.label.ViewUOM": "Visualizar UOM",
    "setup.label.RUM(RatableUsageMetric)": "RUM (Métrica de Uso Tarifável)",
    "setup.label.CreateRUM": "Criar RUM",
    "setup.label.ChargeName": "Nome da Cobrança",
    "setup.label.Template Name": "Nome do Modelo",
    "setup.label.RumName": "Nome do Rum",
    "setup.label.RumExpression": "Expressão do Rum",
    "setup.label.Operators": "Operadores",
    "setup.label.EditRUM": "Editar RUM",
    "setup.label.ViewRUM": "Ver RUM",
    "setup.label.TimePeriod": "Período de tempo",
    "setup.label.CreateTimePeriod": "Criar período de tempo",
    "setup.label.TimeModelName": "Nome do modelo de tempo",
    "setup.label.StartYear": "Ano de início",
    "setup.label.EndYear": "Ano de fim",
    "setup.label.StartMonth": "Mês de início",
    "setup.label.EndMonth": "Mês de fim",
    "setup.label.StartDay": "Dia de início",
    "setup.label.EndDay": "Dia de fim",
    "setup.label.StartTime": "Hora de início",
    "setup.label.EndTime": "Hora de fim",
    "setup.label.CreateTimeModel": "Criar modelo de tempo",
    "setup.label.ExpandAll / CollapseAll": "Expandir tudo / Colapsar tudo",
    "setup.label.AddTimemodel": "Adicionar modelo de tempo",
    "setup.label.UsageRatePlan": "Plano de taxas de uso",
    "setup.label.CreateUsageRatePlan": "Criar plano de taxas de uso",
    "setup.label.PlanName": "Nome do plano",
    "setup.label.ProductName": "Nome do produto",
    "setup.label.TimemodelName": "Nome do modelo temporal",
    "setup.label.ViewUsageRatePlan": "Ver plano de taxas de uso",
    "setup.label.RUM": "RUM",
    "setup.label.RatingType": "Tipo de classificação",
    "setup.label.TimeModel": "Modelo temporal",
    "setup.label.ZoneModel": "Modelo de zona",
    "setup.label.ViewQuantityTier": "Ver nível de quantidade",
    "setup.label.QuantityTier": "Nível de quantidade",
    "setup.label.TierName": "Nome do nível",
    "setup.label.CumulativeResource": "Recurso cumulativo",
    "setup.label.TierRange": "Faixa de nível",
    "setup.label.StepName": "Nome do passo",
    "setup.label.StartRange": "Faixa de início",
    "setup.label.EndRange": "Faixa de fim",
    "setup.label.AddQuantityTier": "Adicionar nível de quantidade",
    "setup.label.NumberZone": "Zona de número",
    "setup.label.CreateNumberZone": "Criar zona de número",
    "setup.label.SourceNumberPrefix": "Prefixo do número de origem",
    "setup.label.DestinationNumberPrefix": "Prefixo do número de destino",
    "setup.label.ImpactCategory": "Categoria de impacto",
    "setup.label.Rank": "Classificação",
    "setup.label.APNZone": "Zona APN",
    "setup.label.APN": "APN",
    "setup.label.CreateAPNZone": "Criar zona APN",
    "setup.label.OperatorZone": "Zona do operador",
    "setup.label.CreateOperatorZone": "Criar zona do operador",
    "setup.label.SourceOperatorCode": "Código do operador de origem",
    "setup.label.DestinationOperatorCode": "Código do operador de destino",
    "setup.label.ICZone": "Zona IC",
    "setup.label.IncomingTrunkid": "Trunkid de entrada",
    "setup.label.OutcomingTrunkid": "Trunkid de saída",
    "setup.label.CreateChargeCode": "Criar código de cobrança",
    "setup.label.ChargeDescription": "Descrição da cobrança",
    "setup.label.ChargeType": "Tipo de cobrança",
    "setup.label.ChargeDuration": "Duração da cobrança",
    "setup.label.DurationType": "Tipo de duração",
    "setup.label.TaxInclusive": "Imposto incluído",
    "setup.label.BillFrequencyCode": "Código de frequência de faturamento",
    "setup.label.TaxCode": "Código fiscal",
    "setup.label.IsAggregate": "É agregado",
    "setup.label.EditChargeCode": "Editar código de cobrança",
    "setup.label.TaxMaster": "Mestre de impostos",
    "setup.label.CreateTaxMaster": "Criar mestre de impostos",
    "setup.label.GroupType": "Tipo de grupo",
    "setup.label.GroupCode": "Código de grupo",
    "setup.label.StartDate": "Data de início",
    "setup.label.Rate": "Taxa",
    "setup.label.BaseTaxCode": "Código Tributário Base",
    "setup.label.Jurisdiction": "Jurisdição",
    "setup.label.RateType": "Tipo de taxa",
    "setup.label.Location": "Localização",
    "setup.label.DeleteTax": "Excluir imposto",
    "setup.label.CreateDiscount": "Criar desconto",
    "setup.label.DiscountDescription": "Descrição do desconto",
    "setup.label.DiscountType": "Tipo de desconto",
    "setup.label.DiscountRate": "Taxa de desconto",
    "setup.label.DiscountDetails": "Detalhes do desconto",
    "setup.label.ClientCategory": "Categoria de cliente",
    "setup.label.CustomerCategory": "Categoria de cliente",
    "setup.label.EditDiscount": "Editar desconto",
    "setup.label.DeleteDiscount": "Excluir desconto",
    "setup.label.CreatePromotion": "Criar promoção",
    "setup.label.PromotionCode": "Código de promoção",
    "setup.label.PromotionName": "Nome da promoção",
    "setup.label.PromotionId": "ID da promoção",
    "setup.label.PromotionDescription": "Descrição da promoção",
    "setup.label.EditPromotionCode": "Editar código de promoção",
    "setup.label.ListOfDiscounts": "Lista de descontos",
    "setup.label.ListofTimePeriods": "Lista de períodos de tempo",
    "setup.label.CreatePriceRegion": "Criar região de preço",
    "setup.label.RegionCode": "Código da região",
    "setup.label.RegionName": "Nome da região",
    "setup.label.Country": "País",
    "setup.label.States": "Estados",
    "setup.label.EditPriceRegion": "Editar região de preço",
    "setup.label.DeletePriceRegion": "Excluir região de preço",
    "setup.label.CreateSalesCatalogue": "Criar catálogo de vendas",
    "setup.label.SalesCatalogueName": "Nome do catálogo de vendas",
    "setup.label.AssignUsers": "Atribuir usuários",
    "setup.label.SalesPlanCategory": "Categoria do plano de vendas",
    "setup.label.Plans": "Planos",
    "setup.label.EditSalesCatalogue": "Editar catálogo de vendas",
    "setup.label.DeleteSalesCatalogue": "Excluir catálogo de vendas",
    "setup.label.UserId": "ID de usuário",
    "setup.label.UserName": "Nome de usuário",
    "setup.label.CreateUsersCatalogue": "Criar catálogo de usuários",
    "setup.label.Catalogue": "Catálogo",
    "setup.label.EditUserCatalogue": "Editar catálogo de usuários",
    "setup.label.VoucherPins": "Códigos de voucher",
    "setup.label.CreateVoucherPins": "Criar códigos de voucher",
    "setup.label.Voucher": "Códigos de voucher",
    "setup.label.Coupon": "Códigos de cupom",
    "setup.label.LCO": "LCO",
    "setup.label.LengthOfPins": "Comprimento dos pins",
    "setup.label.SerialNoLength": "Comprimento do número de série",
    "setup.label.NumberValue ": "Valor Numérico",
    "setup.label.PinValue ": "Valor do PIN",
    "setup.label.BatchName": "Nome do lote",
    "setup.label.PinCategory": "Categoria de código",
    "setup.label.BeginWith": "Começar com",
    "setup.label.Quantity": "Quantidade",
    "setup.label.PinType": "Tipo de código",
    "setup.label.SIMNumbers": "Números SIM",
    "setup.label.CreateSIMNumber": "Criar número de SIM",
    "setup.label.NumberCategory": "Categoria de número",
    "setup.label.ExpiryDate": "Data de validade",
    "setup.label.Partner": "Parceiro",
    "setup.label.LengthofNumber": "Comprimento do número",
    "setup.label.LengthofSerialNumber": "Comprimento do número de série",
    "setup.label.NumberType": "Tipo de número",
    "setup.label.Product": "Produto",
    "setup.label.Supplier": "Fornecedor",
    "setup.label.CreateSupplier": "Criar fornecedor",
    "setup.label.EditSupplier": "Editar fornecedor",
    "setup.label.AddressMaster": "Endereço principal",
    "setup.label.CountryName": "Nome do país",
    "setup.label.StateName": "Nome do estado",
    "setup.label.DistrictName": "Nome do distrito",
    "setup.label.CityName": "Nome da cidade",
    "setup.label.TreeView": "Vista de árvore",
    "setup.label.AddCountry": "Adicionar país",
    "setup.label.CountryCode": "Código do país",
    "setup.label.TeamHead": "Chefe de equipe",
    "setup.label.CreateTicketTeam": "Criar equipe de tickets",
    "setup.label.TeamCode": "Código da equipe",
    "setup.label.TeamDescription": "Descrição da equipe",
    "setup.label.TeamCategory": "Categoria da equipe",
    "setup.label.CreateTicketTeamUsers": "Criar usuários da equipe de tickets",
    "setup.label.TeamEmail": "Email da equipe",
    "setup.label.AvailableUsers": "Usuários disponíveis",
    "setup.label.SelectedUsers": "Usuários selecionados",
    "setup.label.TeamId": "ID da equipe",
    "setup.label.ViewTeam": "Ver equipe",
    "setup.label.DeleteTeam": "Excluir equipe",
    "setup.label.EditTicketTeam": "Editar equipe de tickets",
    "setup.label.TeamUser": "Usuário da equipe",
    "setup.label.EditTicketUsers": "Editar usuários de tickets",
    "setup.label.DeleteTeamUser": "Excluir usuário da equipe",
    "setup.label.VendorManagement": "Gestão de fornecedores",
    "setup.label.CreateVendor": "Criar fornecedor",
    "setup.label.ContactName": "Nome do contato",
    "setup.label.Mobile": "Celular",
    "setup.label.Landline": "Telefone fixo",
    "setup.label.CreateNewVendor": "Criar novo fornecedor",
    "setup.label.EditVendor": "Editar fornecedor",
    "setup.label.FeeMaster": "Mestre de tarifas",
    "setup.label.CreateFeeMaster": "Criar mestre de tarifas",
    "setup.label.FeeMasterCode": "Código mestre de tarifas",
    "setup.label.FeeMasterDescription": "Descrição mestre de tarifas",
    "setup.label.FeeMasterTransactionType":
      "Tipo de transação mestre de tarifas",
    "setup.label.ChargeCode": "Código de cobrança",
    "setup.label.VariablePricing": "Preços variáveis",
    "setup.label.Regions": "Regiões",
    "setup.label.Amount": "Quantidade",
    "setup.label.EditFeeMaster": "Editar mestre de tarifas",
    "setup.label.ManageMessage": "Gerenciar mensagem",
    "setup.label.AddMessage": "Adicionar mensagem",
    "setup.label.TemplateDescription": "Descrição do modelo",
    "setup.label.Subject": "Assunto",
    "setup.label.MessageType": "Tipo de mensagem",
    "setup.label.Header": "Cabeçalho",
    "setup.label.Body": "Corpo",
    "setup.label.Footer": "Rodapé",
    "setup.label.CreateMessageTemplate": "Criar modelo de mensagem",
    "setup.label.MessageParams": "Parâmetros da mensagem",
    "setup.label.Parameter": "Parâmetro",
    "setup.label.Params": "Parâmetros",
    "setup.label.DeleteMessage": "Excluir mensagem",
    "setup.label.EditMessage": "Editar mensagem",
    "setup.label.GroupsDetails": "Detalhes dos grupos",
    "setup.label.GroupName": "Nome do grupo",
    "setup.label.GroupAddress": "Endereço do grupo",
    "setup.label.CountNo's": "Contar números",
    "setup.label.AddGroup": "Adicionar grupo",
    "setup.label.AdditionalInformation": "Informação adicional",
    "setup.label.GroupCIR": "CIR do grupo",
    "setup.label.DIR": "DIR",
    "setup.label.MemberCIR": "CIR do membro",
    "setup.label.IpPoolManagement": "Gestão do pool de IP",
    "setup.label.UpdateNetMask": "Atualizar máscara de rede",
    "setup.label.IpAddress": "Endereço IP",
    "setup.label.NetMark": "Marca de rede",
    "setup.label.IpType": "Tipo de IP",
    "setup.label.CoustomerId": "Id do cliente",
    "setup.label.CustomerName": "Nome do cliente",
    "setup.label.Notes": "Notas",
    "setup.label.Subnet": "Sub-rede",
    "setup.label.DetailsOfMedia": "Detalhes da mídia",
    "setup.label.Media": "Mídia",
    "setup.label.AddMedia": "Adicionar mídia",
    "setup.label.MediaTitle": "Título da mídia",
    "setup.label.MediaCatagory": "Categoria da mídia",
    "setup.label.ContentProvider": "Fornecedor de conteúdo",
    "setup.label.Share": "Compartilhar(%)",
    "setup.label.AddMediaDetails": "Adicionar detalhes da mídia",
    "setup.label.MediaLocation": "Localização da mídia",
    "setup.label.SelectMediaCategory": "Selecionar categoria da mídia",
    "setup.label.Movies": "Filmes",
    "setup.label.ViewMedia": "Ver mídia",
    "setup.label.EditMedia": "Editar mídia",
    "setup.label.MediaAttributes": "Atributos da mídia",
    "setup.label.Cast": "Elenco",
    "setup.label.AttributeType": "Tipo de atributo",
    "setup.label.CaptionValue": "Valor da legenda",
    "setup.label.NickName": "Apelido",
    "setup.label.Image": "Imagem",
    "setup.label.AddMediaLocations": "Adicionar localizações de mídia",
    "setup.label.LanguageData": "Dados de idioma",
    "setup.label.FormatData": "Dados de formato",
    "setup.label.MediaLocations": "Localizações de mídia",
    "setup.label.DetailsOfEvent": "Detalhes do Evento",
    "setup.label.EventName": "Nome do Evento",
    "setup.label.EventCode": "Código do Evento",
    "setup.label.SelectedMediaService": "Serviço de Mídia Selecionado",
    "setup.label.AvailableMedia": "Mídia Disponível",
    "setup.label.EventDescription": "Descrição do Evento",
    "setup.label.EventCategory": "Categoria do Evento",
    "setup.label.CreateEvent": "Criar Evento",
    "setup.label.DetailsOfProperty": "Detalhes da Propriedade",
    "setup.label.PropertyCode": "Código da Propriedade",
    "setup.label.PropertyType": "Tipo de Propriedade",
    "setup.label.Parcel": "Parcela",
    "setup.label.BuildingCode": "Código do Edifício",
    "setup.label.Precinct": "Distrito",
    "setup.label.Allocated": "Alocado",
    "setup.label.UploadPropertyData": "Carregar Dados da Propriedade",
    "setup.label.Clear": "Limpar",
    "setup.label.CreateProperty": "Criar Propriedade",
    "setup.label.PropertyDataUpload": "Carregar Dados da Propriedade",
    "setup.label.Street": "Rua",
    "setup.label.PaymentType": "Tipo de Pagamento",
    "setup.label.PoBox": "Caixa Postal",
    "setup.label.State": "Estado",
    "setup.label.District": "Distrito",
    "setup.label.Floor": "Andar",
    "setup.label.LimitCode": "Código Limite",
    "setup.label.PropertyMaster": "Mestre de Propriedade",
    "setup.label.CodeDescription": "Descrição do Código",
    "setup.label.ReferenceValue": "Valor de Referência",
    "setup.label.Services": "Serviços",
    "setup.label.IsBouquet": "ÉBouquet",
    "setup.label.Broadcaster": "Transmissor",
    "setup.label.Channel": "Canal",
    "setup.label.ContactNumber": "Número de Contato",
    "setup.label.UOM": "UOM",
    "setup.label.DeleteTemplateDefinition": "Excluir Definição de Modelo",
    "setup.label.Discount": "Desconto",
    "setup.label.SalseCatalogue": "Catálogo de Vendas",
    "setup.label.UserCatalogue": "Catálogo de Usuários",
    "setup.label.Team": "Equipe",
    "setup.label.MediaDetails": "Detalhes da Mídia",
    "setup.label.Event": "Evento",
    "setup.label.Properties": "Propriedades",
    "setup.label.ServicesProducts": "Serviços & Produtos",
    "setup.label.BroadcasterChannelMapping": "Emissora, Canal & Mapeamento",
    "setup.label.UsageRating": "Avaliação de Uso",
    "setup.label.ZoneSetup": "Configuração de Zona",
    "setup.label.Promotion": "Promoção",
    "setup.label.PromotionTrigger": "Gatilho de promoção",
    "setup.label.PromotionRulesAndRates": "Regras e taxas de promoção",
    "setup.label.CatalogeMapping": "Mapeamento de Catálogo",
    "setup.label.VoucherPin": "Código de Voucher",
    "setup.label.SIMNumber": "Número SIM",
    "setup.label.TeamTeamUser": "Equipe & Usuário da Equipe",
    "setup.label.MessageTemplate": "Modelo de Mensagem",
    "setup.label.ClosedUserGroup": "Grupo de Usuários Fechado",
    "setup.label.IpManagement": "Gestão de IP",
    "setup.label.PropertyDefinition": "Definição de Propriedade",
    "setup.label.PriorityMapping": "Mapeamento de prioridades",
    "setup.label.AddProducts": "Adicionar Produtos",
    "setup.label.AddDiscount": "Adicionar Desconto",
    "setup.label.Products": "Produtos",
    "setup.label.ChargeCodeData": "Dados do Código de Cobrança",
    "setup.label.TaxMapping": "Mapeamento de Impostos",
    "setup.label.TaxRegion": "Região Fiscal",
    "setup.label.CreateUserCatalogue": "Criar Catálogo de Usuário",
    "setup.label.IcZone": "Zona Ic",
    "setup.label.ViewIcZone": "Ver Zona Ic",
    "setup.label.ViewNumberZone": "Ver Zona de Número",
    "setup.label.EditNumberZone": "Editar Zona de Número",
    "setup.label.DeleteNumberZone": "Excluir Zona de Número",
    "setup.label.AreYouSure": "Você tem certeza?",
    "setup.label.ViewAPNZone": "Ver Zona APN",
    "setup.label.EditAPNZone": "Editar Zona APN",
    "setup.label.DeleteAPNZone": "Excluir Zona APN",
    "setup.label.ViewOperatorZone": "Ver Zona de Operador",
    "setup.label.EditOperatorZone": "Editar Zona de Operador",
    "setup.label.CreateICZone": "Criar Zona IC",
    "setup.label.EditICZone": "Editar Zona IC",
    "setup.label.DeleteOperatorZone": "Excluir Zona de Operador",
    "setup.label.DeleteIcZone": "Excluir Zona IC",
    "setup.label.MobileNumber": "Número de Celular",
    "setup.label.LandlineNumber": "Número de telefone fixo (opcional)",
    "setup.label.RatePlanName": "Nome do Plano de Tarifas",
    "setup.label.UsageRateBalance": "Saldo da taxa de uso",
    "setup.label.ValidityType": "Tipo de validade",
    "setup.label.ListOfRateTires": "Lista de pneus avaliados",
    "setup.label.Validity": "Validade",
    "setup.label.CreatePlanName": "Criar nome do plano",
    "setup.label.EditPlanContent": "Editar conteúdo do plano",
    "setup.label.CreatePlanDescription": "Criar descrição do plano",
    "setup.label.ContentType": "Tipo de conteúdo",
    "setup.label.CreateFeatureList": "Criar lista de funcionalidades",
    "setup.label.Area": "Área",
    "setup.label.TaxPercentage": "Porcentagem de imposto",
    "setup.label.Add": "Adicionar",
    "setup.label.Remove": "Remover",
    "setup.label.CreateVoucherPin": "Criar Código do Voucher",
    "setup.label.EditSubCategory": "Editar subcategoria",
    "setup.label.CreateSubCategory": "Criar subcategoria",
    "setup.label.ViewSubCategory": "Ver subcategoria",
    "setup.label.TimeTaken": "Tempo gasto",
    "setup.label.TeamMapping": "Mapeamento de Equipe",
    "setup.label.CreateTeamMapping": "Criar Mapeamento de Equipe",
    "setup.label.Category": "Categoria",
    "setup.label.external_promotional_code": "Código promocional externo",
    "setup.label.Subcategory": "Subcategoria",
    "setup.label.DeleteItemMapping": "Excluir Mapeamento de Item",
    "setup.label.EditTeamMapping": "Editar Mapeamento de Equipe",
    "setup.label.ViewTeamMapping": "Visualizar Mapeamento de Equipe",
    "setup.label.DeletePriorityMapping": "Excluir Mapeamento de Prioridade",
    "setup.label.discount_rule": "Regra de Desconto",
    "setup.label.promotion_rule": "Regra de promoção",
    "setup.label.discount_rate": "Taxa de Desconto",
    "setup.label.create_discount_rule": "Criar regra de desconto",
    "setup.label.edit_promotion_rule": "Editar regra de promoção",
    "setup.label.create_promotion_rule": "Criar regra de promoção",
    "setup.label.create_discount_rate": "Criar taxa de desconto",
    "setup.label.add_discount_rate": "Adicionar Taxa de Desconto",
    "setup.label.add_promotion_rate": "Adicionar taxa de promoção",
    "setup.label.edit_discount": "Editar Desconto",
    "setup.label.edit_promotion": "Editar promoção",
    "setup.label.edit_discount_trigger": "Editar Gatilho de Desconto",
    "setup.label.edit_discount_rule": "Editar Regra de Desconto",
    "setup.label.collection_process": "Processo de Cobrança",
    "setup.label.create_collection_profile": "Criar Perfil de Cobrança",
    "setup.label.collection_profile": "Perfil de Cobrança",
    "setup.label.collection_profile_id": "ID do Perfil de Cobrança",
    "setup.label.region": "Região",
    "setup.label.collection": "Cobrança",
    "setup.label.collection_trigger": "Gatilho de Cobrança",
    "setup.label.collection_scenario": "Cenário de Cobrança",
    "setup.label.add_collection_trigger": "Adicionar Gatilho de Cobrança",
    "setup.label.add_collection_scenario": "Adicionar Cenário de Cobrança",
    "setup.label.trigger_id": "ID do Gatilho",
    "setup.label.criteria_type": "Tipo de Critério",
    "setup.label.due_balance": "Saldo Devido",
    "setup.label.ageing_days": "Dias de Envelhecimento",
    "setup.label.scenario_id": "ID do Cenário",
    "setup.label.action_name": "Nome da Ação",
    "setup.label.age": "Idade",
    "setup.label.create_collection_trigger": "Criar Gatilho de Cobrança",
    "setup.label.create_collection_scenario": "Criar Cenário de Cobrança",
    "setup.label.edit_collection_profile": "Editar Perfil de Cobrança",
    "setup.label.edit_collection_trigger": "Editar Gatilho de Cobrança",
    "setup.label.edit_collection_scenario": "Editar Cenário de Cobrança",
    "setup.label.SlaInHours": "SLA em horas",
    "setup.label.contractduration": "Duração do Contrato",
    "setup.label.chargesperiodicity": "Periodicidade das Taxas",
  },

  zh_CN: {
    "setup.label.Enter_product_Description": "输入产品描述",
    "setup.label.FeedbackStatus": "反馈状态",
    "setup.label.EnterCountryName": "输入国家名称",
    "setup.label.location": "位置",
    "setup.label.selectLocation": "选择位置",
    "setup.label.create_group_ticket": "创建组工单",
    "setup.label.default": "默认",
    "setup.label.customerFeedback": "客户反馈",
    "setup.label.automation": "自动化",
    "setup.label.automation_master": "自动化主控",
    "setup.label.create_automation": "创建自动化",
    "setup.label.edit_automation": "编辑自动化",
    "setup.label.automation_detail": "自动化详情",
    "setup.label.automation_steps": "自动化步骤",
    "setup.label.add_automation_step": "添加自动化步骤",
    "setup.label.AutomationId": "自动化编号",
    "setup.label.EntityName": "实体名称",
    "setup.label.EntityType": "实体类型",
    "setup.label.WorkflowName": "工作流程名称",
    "setup.label.CreateAutomationScenario": "创建自动化方案",
    "setup.label.EditAutomationStep": "编辑自动化步骤",
    "setup.label.ActionType": "操作类型",
    "setup.label.ActionDetails": "操作详情",
    "setup.label.StepOrder": "步骤顺序",
    "setup.label.questionAnswerSet": "问答集",
    "setup.label.addQuestionSet": "添加问答集",
    "setup.label.EditQuestionSet": "编辑问答集",
    "setup.label.CategoryName": "类别名称",
    "setup.label.SubCategoryName": "子类别名称",
    "setup.label.TotalQuestions": "问题总数",
    "setup.label.QuestionType": "问题类型",
    "setup.label.QuestionText": "问题文本",
    "setup.label.CustomerFeedback": "客户反馈",
    "setup.label.TicketId": "工单编号",
    "setup.label.LinkedAt": "关联时间",
    "setup.label.Remarks": "备注",
    "setup.label.AddFeedback": "添加反馈",
    "setup.label.PendingForApproval": "等待审批",
    "setup.label.user_availability": "用户可用性",
    "setup.label.all_users_availability": "所有用户的可用性",
    "setup.label.create_user_availability": "创建用户可用性",
    "setup.label.LeaveManagement": "请假管理",
    "setup.label.CreateLeave": "创建请假",
    "setup.label.EditLeave": "编辑请假",
    "setup.label.ViewLeave": "查看请假",
    "setup.label.AllUserLeaves": "所有用户请假",
    "setup.label.MyLeaves": "我的请假",
    "setup.label.ConfigId": "配置编号",
    "setup.label.edit_user_availability": "编辑用户可用性",
    "setup.label.view_user_availability": "查看用户可用性",
    "setup.label.unavailability_date": "不可用日期",
    "setup.label.start_time": "开始时间",
    "setup.label.end_time": "结束时间",
    "setup.label.my_availability": "我的可用性",
    "setup.label.user": "用户",
    "setup.label.EditShift": "编辑班次",
    "setup.label.UserWorkingShift": "用户工作班次",
    "setup.label.CreateUserWorkingShift": "创建用户工作班次",
    "setup.label.EditUserWorkingShift": "编辑用户工作班次",
    "setup.label.ViewUserWorkingShift": "查看用户工作班次",
    "setup.label.TeamName": "团队名称",
    "setup.label.Shift": "班次",
    "setup.label.ShiftManagement": "班次管理",
    "setup.label.CreateShift": "创建班次",
    "setup.label.ShiftName": "班次名称",
    "setup.label.Session": "会话",
    "setup.label.SessionType": "会话类型",
    "setup.label.LeaveDetails": "请假详情",
    "setup.label.SessionStartTime": "会话开始时间",
    "setup.label.SessionEndTime": "会话结束时间",
    "setup.label.LeaveType": "请假类型",
    "setup.label.AddAnotherDate": "添加另一个日期",
    "setup.label.Apn_Zone": "APN 区域",
    "setup.label.FeeMaster": "费用主数据",
    "setup.label.Number_Zone": "号码区域",
    "setup.label.DeleteRUM": "删除RUM",
    "setup.label.Edit_TimeModel": "编辑时间模型",
    "setup.label.Edit_Year": "编辑年份",
    "setup.label.scenario_name": "Nome do cenário",
    "setup.label.event_name": "Nome do evento",
    "setup.label.Edit_Month": "编辑月份",
    "setup.label.Edit_Day": "编辑日期",
    "setup.label.Edit_Time": "编辑时间",
    "setup.label.Delete_TimeModel": "删除时间模型",
    "setup.label.Delete_Year": "删除年份",
    "setup.label.Delete_Month": "删除月份",
    "setup.label.Delete_Day": "删除日期",
    "setup.label.Delete_Time": "删除时间",
    "setup.label.Are_you_sure_?": "你确定吗？",
    "setup.label.Save": "保存",
    "setup.label.TemplateDefinition": "模板定义",
    "setup.label.EditQuantityTier": "编辑数量层级",
    "setup.label.Usage_Rate_Balance": "使用率余额",
    "setup.label.Template_Name": "模板名称",
    "setup.label.Delimiter": "分隔符",
    "setup.label.Number_Of_Fields": "字段数量",
    "setup.label.Header_Recorder_Type": "头记录类型",
    "setup.label.Event_Record_Type": "事件记录类型",
    "setup.label.CreateUOM": "创建计量单位",
    "setup.label.TimePeriod": "时间周期",
    "setup.label.Usage_Rate_Plan": "使用率计划",
    "setup.label.TemplateDefinition": "模板定义",
    "setup.label.CreateRUM": "创建RUM",
    "setup.label.CreateTimePeriod": "创建时间周期",
    "setup.label.TimemodelName": "时间模型名称",
    "setup.label.TimePeriodName": "时间周期名称",
    "setup.label.StartYear": "开始年份",
    "setup.label.EndYear": "结束年份",
    "setup.label.UsageRatePlan": "使用率计划",
    "setup.label.Create_Usage_Rate_Plan": "创建使用率计划",
    "setup.label.Id": "编号",
    "setup.label.PlanName": "计划名称",
    "setup.label.ProductName": "产品名称",
    "setup.label.ChargeCode": "计费代码",
    "setup.label.TimeModelName": "时间模型名称",
    "setup.label.RatingType": "计费类型",
    "setup.label.RumName": "RUM名称",
    "setup.label.Are_you_sure_you_want_to_delete_?": "您确定要删除吗？",
    "setup.label.UOM": "计量单位",
    "setup.label.RUM": "RUM",
    "setup.label.ImpactCategory": "影响类别",
    "setup.label.Resource": "资源",
    "setup.label.GLID": "GLID",
    "setup.label.Unit": "单位",
    "setup.label.Rate": "费率",
    "setup.label.Action": "操作",
    "setup.label.options_selected": "已选择的选项",
    "setup.label.UsageRateBalance": "使用费率余额",
    "setup.label.EndYear": "结束年份",
    "setup.label.StartMonth": "开始月份",
    "setup.label.EndMonth": "结束月份",
    "setup.label.StartDay": "开始日期",
    "setup.label.EndDay": "结束日期",
    "setup.label.StartTime": "开始时间",
    "setup.label.Time_Model_Name": "时间模型名称",
    "setup.label.model_includes_which_all_Bands_?": "模型包含哪些频段？",
    "setup.label.YearRestriction": "年份限制",
    "setup.label.MonthRestriction": "月份限制",
    "setup.label.DayRestriction": "日期限制",
    "setup.label.TimeRestriction": "时间限制",
    "setup.label.Code": "代码",
    "setup.label.Name": "名称",
    "setup.label.PriorityMapping": "优先级映射",
    "setup.label.AddJurisdiction": "添加司法管辖区",
    "setup.label.Are_you_sure_?": "你确定吗？",
    "setup.label.Country": "国家",
    "setup.label.State": "州/省",
    "setup.label.District": "地区",
    "setup.label.RateType": "费率类型",
    "setup.label.Remove": "移除",
    "setup.label.TaxMaster": "税务主控",
    "setup.label.Team": "团队",
    "setup.label.Add": "添加",
    "setup.label.FeeMaster": "费用主档",
    "setup.label.DeleteChargeCode": "删除费用代码",
    "setup.label.SelectSearch": "选择搜索",
    "setup.label.Select_Content_Tag_Value": "选择内容标签值",
    "setup.label.Plan_Content": "计划内容",
    "setup.label.Plan": "计划",
    "setup.label.ProductPrice": "产品价格",
    "setup.label.SelectedPromotions": "已选促销",
    "setup.label.AvailablePromotions": "可用促销",
    "setup.label.SelectType": "选择类型",
    "setup.label.Type": "类型",
    "setup.label.No_versions_available": "没有可用版本",
    "setup.label.Version": "版本",
    "setup.label.ListPrice": "目录价格",
    "setup.label.SellingPrice": "销售价格",
    "setup.label.EnterPlanDescription": "输入计划描述",
    "setup.label.AddPrice": "添加价格",
    "setup.label.Save": "保存",
    "setup.label.AddDiscount": "添加折扣",
    "setup.label.AvailablePlans": "可用计划",
    "setup.label.SelectedPlans": "已选计划",
    "setup.label.PlanType": "计划类型",
    "setup.label.Plan_Start_Date": "计划开始日期",
    "setup.label.Plan_End_Date": "计划结束日期",
    "setup.label.Bill_Type": "账单类型",
    "setup.label.AttributeTypes": "属性类型",
    "setup.label.Add": "添加",
    "setup.label.Select_Content_Tag": "选择内容标签",
    "setup.label.PlanName": "计划名称",
    "setup.label.AvailableDiscounts": "可用折扣",
    "setup.label.Search": "搜索...",
    "setup.label.MoveRight": "向右移动",
    "setup.label.MoveLeft": "向左移动",
    "setup.label.SelectedDiscounts": "已选择的折扣",
    "setup.label.SelectType": "选择类型",
    "setup.label.SelectLanguage": "选择语言",
    "setup.label.SelectContentTag": "选择内容标签",
    "setup.label.SelectContentTagValue": "选择内容标签值",
    "setup.label.DigitalContent": "数字内容",
    "setup.label.Enter_Plan_Description": "输入计划描述",
    "setup.label.DC_Rule": "DC规则",
    "setup.label.PlanAttribute": "计划属性",
    "setup.label.AdvanceView": "高级视图",
    "setup.label.Update": "更新",
    "setup.label.ProductMapping": "产品映射",
    "setup.label.Service": "服务",
    "setup.label.SubProducts": "子产品",
    "setup.label.Type": "类型",
    "setup.label.EnterValue": "输入值",
    "setup.label.PriceRegion": "价格区域",
    "setup.label.Enter_service_Description": "输入服务描述",
    "setup.label.ParamName": "参数名称",
    "setup.label.Category": "类别",
    "setup.label.Type": "类型",
    "setup.label.EnterValue": "输入值",
    "setup.label.SalesCatalogue": "销售目录",
    "setup.label.Are_you_sure_you_want_to_delete_?": "您确定要删除吗？",
    "setup.label.Channel": "频道",
    "setup.label.Broadcaster": "广播公司",
    "setup.label.AddPrice": "添加价格",
    "setup.label.DeleteMediaEvent": "删除媒体事件",
    "setup.label.AdvMedia": "广告媒体",
    "setup.label.EditMedia": "编辑媒体",
    "setup.label.AddEvent": "添加事件",
    "setup.label.AddAttributes": "添加属性",
    "setup.label.AddLocation": "添加位置",
    "setup.label.DeleteEvent": "删除事件",
    "setup.label.Are_you_sure_?": "你确定吗？",
    "setup.label.Add": "添加",
    "setup.label.ViewEvent": "查看事件",
    "setup.label.Event": "事件",
    "setup.label.RUM": "RUM",
    "setup.label.OptType": "选项类型",
    "setup.label.Currency": "货币",
    "setup.label.Amount": "金额",
    "setup.label.Add": "添加",
    "setup.label.Save": "保存",
    "setup.label.AddDiscount": "添加折扣",
    "setup.label.EnterEventCode": "输入事件代码",
    "setup.label.EnterEventDescription": "输入事件描述",
    "setup.label.EventDescription": "事件描述",
    "setup.label.EventCategory": "事件类别",
    "setup.label.ChargeCode": "收费代码",
    "setup.label.SelectEventValidity": "选择事件有效期",
    "setup.label.EditEvent": "编辑事件",
    "setup.label.UnitCode": "单位代码",
    "setup.label.MediaTitle": "媒体标题",
    "setup.label.ContentProvider": "内容提供商",
    "setup.label.MediaType": "媒体类型",
    "setup.label.Rated": "评级",
    "setup.label.MediaCategory": "媒体分类",
    "setup.label.Rating": "评分",
    "setup.label.Poster": "海报",
    "setup.label.Status": "状态",
    "setup.label.MovieDuration": "电影时长",
    "setup.label.ReleaseDate": "上映日期",
    "setup.label.Genre": "类型",
    "setup.label.Subject": "主题",
    "setup.label.Overview": "概述",
    "setup.label.Share(%)": "分成 (%)",
    "setup.label.Cast": "演员表",
    "setup.label.AttributeType": "属性类型",
    "setup.label.CaptionValue": "字幕值",
    "setup.label.NickName": "昵称",
    "setup.label.Image": "图片",
    "setup.label.Language": "语言",
    "setup.label.Format": "格式",
    "setup.label.Location": "位置",
    "setup.label.CustomerType": "客户类型",
    "setup.label.FormatType": "格式类型",
    "setup.label.DiscountCode": "折扣代码",
    "setup.label.ReProcess": "重新处理",
    "setup.label.Code": "代码",
    "setup.label.Description": "描述",
    "setup.label.PropertyCodeType": "属性代码类型",
    "setup.label.ReferenceValue": "参考值",
    "setup.label.EditProperty": "编辑属性",
    "setup.label.EditPropertyMaster": "编辑属性主数据",
    "setup.label.Cancel": "取消",
    "setup.label.View": "查看",
    "setup.label.Edit": "编辑",
    "setup.label.Browse_file_to_Upload": "浏览上传文件",
    "setup.label.CreatePropertyMaster": "创建属性主数据",
    "setup.label.Property": "属性",
    "setup.label.PropertyMaster": "属性主数据",
    "setup.label.ViewProperty": "查看属性",
    "setup.label.ViewPropertyMaster": "查看属性主数据",
    "setup.label.Are_you_sure_?": "你确定吗？",
    "setup.label.Edit": "编辑",
    "setup.label.Code": "代码",
    "setup.label.Name": "名称",
    "setup.label.AddState": "添加州",
    "setup.label.AddDistrict": "添加区",
    "setup.label.AddCity": "添加城市",
    "setup.label.EditCountry": "编辑国家",
    "setup.label.EditState": "编辑州",
    "setup.label.EditDistrict": "编辑区",
    "setup.label.EditCity": "编辑城市",
    "setup.label.DeleteCountry": "删除国家",
    "setup.label.DeleteState": "删除州",
    "setup.label.DeleteDistrict": "删除区",
    "setup.label.DeleteCity": "删除城市",
    "setup.label.ServiceAvailablity": "服务可用性",
    "setup.label.EnterCountryCode": "输入国家代码",
    "setup.label.EnterCode": "输入代码",
    "setup.label.EnterName": "输入名称",
    "setup.label.Service_Availablity_for_the": "服务可用性：",
    "setup.label.SelectServices": "选择服务",
    "setup.label.Select_One_or_More": "选择一个或多个",
    "setup.label.options_selected": "项已选择",
    "setup.label.PromotionName": "促销名称",
    "setup.label.PromotionCode": "促销代码",
    "setup.label.BussinesType": "业务类型",
    "setup.label.OrderType": "订单类型",
    "setup.label.PaymentType": "付款方式",
    "setup.label.SelectCategory": "选择类别",
    "setup.label.PromotionTrigger": "促销触发器",
    "setup.label.PromotionRule": "促销规则",
    "setup.label.PromotionTriggerCondition": "促销触发条件",
    "setup.label.DiscountTriggerCondition": "折扣触发条件",
    "setup.label.DiscountRule": "折扣规则",
    "setup.label.DiscountTrigger": "折扣触发器",
    "setup.label.EditTriggerCondition": "编辑触发条件",
    "setup.label.Rate": "费率",
    "setup.label.EditRule": "编辑规则",
    "setup.label.AddRate": "添加费率",
    "setup.label.Download": "下载",
    "setup.label.Process": "处理",
    "setup.label.ViewVendor": "查看供应商",
    "setup.label.VendorCode": "供应商代码",
    "setup.label.VendorName": "供应商名称",
    "setup.label.select_Currency": "选择货币",
    "setup.label.select_Country": "选择国家",
    "setup.label.Filter_List": "筛选列表",
    "setup.label.Are_you_sure_you_want_to_delete_?": "你确定要删除吗？",
    "setup.label.DeleteVoucher": "删除凭证",
    "setup.label.UpdatePin": "更新PIN码",
    "setup.label.UpdateVoucher": "更新凭证",
    "setup.label.select_from_dropdown": "从下拉菜单中选择",
    "setup.label.ItemModel": "商品型号",
    "setup.label.price": "价格",
    "setup.label.Edit": "编辑",
    "setup.label.Delete": "删除",
    "setup.label.Item": "项目",
    "setup.label.EnterSupplierAddress": "输入供应商地址",
    "setup.label.Title": "标题",
    "setup.label.AddPromotionTriggerCondition": "添加促销触发条件",
    "setup.label.EditPromotionTriggerCondition": "编辑促销触发条件",
    "setup.label.AssignTo": "分配给",
    "setup.label.Version": "版本",
    "setup.label.IsOverride": "是否覆盖",
    "setup.label.PlanAttribute": "计划属性",
    "setup.label.ValidationRule": "验证规则",
    "setup.label.SaveAndContinue": "保存并继续",
    "setup.label.PlanManagement": "计划管理",
    "setup.label.Plan": "计划",
    "setup.label.DiscountTriggerCondition": "折扣触发条件",
    "setup.label.AddDiscountTriggerCondition": "添加折扣触发条件",
    "setup.label.SalesChannel": "销售渠道",
    "setup.label.PaymentType": "支付类型",
    "setup.label.OrderType": "订单类型",
    "setup.label.BusinessType": "业务类型",
    "setup.label.ViewDigitalContent": "查看数字内容",
    "setup.label.EditDigitalContent": "编辑数字内容",
    "setup.label.AddDigitalContent": "添加数字内容",
    "setup.label.PromotionRuleName": "促销规则名称",
    "setup.label.PromotionTriggerCondition": "促销触发条件",
    "setup.label.AddPromotionTriggerCondition": "添加促销触发条件",
    "setup.label.BussinesType": "业务类型",
    "setup.label.requestApproval": "请求批准",
    "setup.label.validity_uom": "有效期单位",
    "setup.label.validity_value": "有效期值",
    "setup.label.ViewItemModel": "查看项目模型",
    "setup.label.ItemType": "项目类型",
    "setup.label.ViewSupplier": "查看供应商",
    "setup.label.SupplierCode": "供应商代码",
    "setup.label.SupplierDescription": "供应商描述",
    "setup.label.SupplierAddress": "供应商地址",
    "setup.label.DeleteSupplier": "删除供应商",
    "setup.label.CreateContract": "创建合同",
    "setup.label.RateTierName": "费率等级名称",
    "setup.label.RangeType": "范围类型",
    "setup.label.CreateDiscountRule": "创建折扣规则",
    "setup.label.RuleCondition": "规则条件",
    "setup.label.CreateRuleCondition": "创建规则条件",
    "setup.label.CreateRule": "创建规则",
    "setup.label.Entity": "实体",
    "setup.label.EntityField": "实体字段",
    "setup.label.contentTag": "内容标签",
    "setup.label.contentTagValue": "内容标签值",
    "setup.label.ExecutionType": "执行类型",
    "setup.label.OperationMode": "操作模式",
    "setup.label.AggregationType": "聚合类型",
    "setup.label.DurationInDays": "持续时间（天）",
    "setup.label.CreateTicketTeamUser": "创建工单团队用户",
    "setup.label.termsConditions": "条款及条件",
    "setup.label.updateTermsConditions": "更新条款和条件",
    "setup.label.updateDigitalContent": "更新数字内容",
    "setup.label.createDigitalContent": "创建数字内容",
    "setup.label.createTermsConditions": "创建条款和条件",
    "setup.label.digitalContent": "数字内容",
    "setup.label.planContent": "计划内容",
    "setup.label.selectPlanContent": "选择计划内容",
    "setup.label.FilterType": "过滤类型",
    "setup.label.FilterValue": "过滤值",
    "setup.label.ContractPeriod": "合約期間",
    "setup.label.AddContract": "添加合約",
    "setup.label.EditContract": "編輯合約",
    "setup.label.ViewContract": "查看合約",
    "setup.label.ExternalPlanId": "外部计划ID",
    "setup.label.ExternalProductId": "外部产品ID",
    "setup.label.ContractType": "合約類型",
    "setup.label.ContractUnit": "合約單位",
    "setup.label.updateNetMask": "更新网络掩码",
    "setup.label.Update": "更新",
    "setup.label.BillType": "账单类型",
    "setup.label.BillFrequency": "账单频率",
    "setup.label.PlanEndDate": "计划结束日期",
    "setup.label.AddContent": "添加内容",
    "setup.label.CreatePlanContent": "创建计划内容",
    "setup.label.SelectLanguage": "选择语言",
    "setup.label.UploadDigitalImage": "上传数字图像",
    "setup.label.ViewPlanContent": "查看计划内容",
    "setup.label.ExternalPlanName": "外部计划名称",
    "setup.label.ExternalProductName": "外部产品名称",
    "setup.label.ViewPrice": "查看价格",
    "setup.label.SelectedPlanDiscounts": "选定计划折扣,",
    "setup.label.ProductDiscount": "产品折扣,",
    "setup.label.createIpPool": "创建IP池",
    "setup.label.PlanValidationRules": "计划验证规则",
    "setup.label.CreateValidationRule": "创建验证规则",
    "setup.label.EditValidationRule": "编辑验证规则",
    "setup.label.InputPlanId": "输入计划ID",
    "setup.label.CheckinPlanId": "验证计划ID",
    "setup.label.RuleAppliesTo": "单位",
    "setup.label.Rule": "规则",
    "setup.label.ViewValidationRule": "视图验证规则",
    "setup.label.ValidationRule": "验证规则",
    "setup.label.editIpPool": "编辑IP池",
    "setup.label.AddOrEditDiscount": "新增/編輯折扣",
    "setup.label.Next": "下一步",
    "setup.label.MainCategory": "主要類別",
    "setup.label.SubCategory": "子類別",
    "setup.label.select_date": "选择日期",
    "setup.label.AddDiscountTrigger": "添加折扣触发器",
    "setup.label.AddPromotionTrigger": "添加促销触发器",
    "setup.label.edit_promotion_trigger": "编辑促销触发器",
    "setup.label.DiscountTrigger": "折扣触发器",
    "setup.label.TriggerName": "触发器名称",
    "setup.label.When": "时间",
    "setup.label.CustomerType": "客户类型",
    "setup.label.Criteria": "标准",
    "setup.label.Values": "值",
    "setup.label.ApplicableTo": "适用于",
    "setup.label.ApplicableValues": "适用值",
    "setup.label.DiscountRulesAndRates": "折扣规则和费率",
    "setup.label.RuleName": "规则名称",
    "setup.label.MaxDiscount": "最大折扣",
    "setup.label.ResourceId": "资源ID",
    "setup.label.DiscountRateType": "折扣率类型",
    "setup.label.Unit": "单位",
    "setup.label.DiscountId": "折扣编号",
    "setup.label.DiscountName": "折扣名称",
    "setup.label.Priority": "优先级",
    "setup.label.Items": "物品",
    "setup.label.ItemCode": "物品编码",
    "setup.label.ItemDescription": "物品描述",
    "setup.label.Units": "单位",
    "setup.label.Total": "总计",
    "setup.label.Warranty": "保修",
    "setup.label.UsedItems": "使用过的物品",
    "setup.label.Balanced": "平衡",
    "setup.label.IsProvisioning": "是否提供",
    "setup.label.CreateItem": "创建物品",
    "setup.label.ItemClass": "物品类别",
    "setup.label.ReorderLevel": "重新订购级别",
    "setup.label.WarrantyPeriod": "保修期限",
    "setup.label.Currency": "货币",
    "setup.label.DefaultPrice": "默认价格",
    "setup.label.IsSelector": "是否选择器",
    "setup.label.SelectorMenu": "选择菜单",
    "setup.label.Selector": "选择器",
    "setup.label.VariablePrice": "可变价格",
    "setup.label.ItemModel": "物品型号",
    "setup.label.Price": "价格",
    "setup.label.Action": "操作",
    "setup.label.IteClass": "物料分类",
    "setup.label.ChargCode": "费用代码",
    "setup.label.Cancel": "取消",
    "setup.label.planPrice": "计划价格",
    "setup.label.listview": "列表视图",
    "setup.label.Submit": "提交",
    "setup.label.EdiItem": "编辑物品",
    "setup.label.Id": "ID",
    "setup.label.IteMasteId": "物品主 ID",
    "setup.label.RegioId": "地区 ID",
    "setup.label.Edit": "编辑",
    "setup.label.ViewItem": "查看项目",
    "setup.label.UnitPrice": "单价",
    "setup.label.ItemModels": "项目模型",
    "setup.label.NetworkElement": "网络元素",
    "setup.label.Model": "模型",
    "setup.label.Make": "制作",
    "setup.label.CreateItemModel": "创建项目模型",
    "setup.label.Reset": "重置",
    "setup.label.EditItemModel": "编辑项目模型",
    "setup.label.ServiceCode": "服务代码",
    "setup.label.ServiceDescription": "服务描述",
    "setup.label.ServiceType": "服务类型",
    "setup.label.Isoptional": "可选",
    "setup.label.Isautoprovision": "自动配置",
    "setup.label.CreateService": "创建服务",
    "setup.label.Code": "代码",
    "setup.label.Description": "描述",
    "setup.label.Type": "类型",
    "setup.label.EditService": "编辑服务",
    "setup.label.ServiceParameter": "服务参数",
    "setup.label.ParamName": "参数名称",
    "setup.label.ParamType": "参数类型",
    "setup.label.ParamCategory": "参数类别",
    "setup.label.ParamValue": "参数值",
    "setup.label.BB": "BB",
    "setup.label.Delete": "删除",
    "setup.label.ServiceCategory": "服务类别",
    "setup.label.DeleteServices": "删除服务",
    "setup.label.Confirm": "确认",
    "setup.label.Service": "服务",
    "setup.label.Status": "状态",
    "setup.label.Bouquet": "花束",
    "setup.label.Actions": "操作",
    "setup.label.CreateProduct": "创建产品",
    "setup.label.ProductParameter": "产品参数",
    "setup.label.EditProduct": "编辑产品",
    "setup.label.ProductCode": "产品代码",
    "setup.label.ProductDescription": "产品描述",
    "setup.label.ProductCategory": "产品类别",
    "setup.label.BroadcasterCode": "广播公司代码",
    "setup.label.BroadcasterName": "广播公司名称",
    "setup.label.GstRegNumber": "GST 注册号",
    "setup.label.ContactPerson": "联系人",
    "setup.label.ContactMobile": "联系电话",
    "setup.label.Email": "电子邮件",
    "setup.label.CreateBroadcaster": "创建广播公司",
    "setup.label.Address": "地址",
    "setup.label.MobileNo": "手机号",
    "setup.label.LandlineNo": "固定电话",
    "setup.label.EditBroadcaster": "编辑广播公司",
    "setup.label.ChannelName": "频道名称",
    "setup.label.ChannelType": "频道类型",
    "setup.label.DeleteBroadcaster": "删除广播公司",
    "setup.label.ChannelCategory": "频道类别",
    "setup.label.ChannelSequence": "频道顺序",
    "setup.label.IsHdChannel": "是高清频道",
    "setup.label.CreateChannel": "创建频道",
    "setup.label.Language": "语言",
    "setup.label.IsLocalChannel": "是本地频道",
    "setup.label.Genre": "类型",
    "setup.label.BroadcasterId": "广播公司编号",
    "setup.label.EditChannel": "编辑频道",
    "setup.label.DeleteChannel": "删除频道",
    "setup.label.ProductMapping": "产品映射",
    "setup.label.CreateProductChannelMapping": "创建产品频道映射",
    "setup.label.ProductId": "产品 ID",
    "setup.label.AvailableChannels": "可用频道",
    "setup.label.SelectedChannels": "已选择的频道",
    "setup.label.EditChannelMapping": "编辑频道映射",
    "setup.label.PlanPricing": "计划和定价",
    "setup.label.CreatePlan": "创建计划",
    "setup.label.PlanCode": "计划代码",
    "setup.label.PlanDescription": "计划描述",
    "setup.label.PlanStatus": "计划状态",
    "setup.label.PlanProvisionSystem": "计划供应系统",
    "setup.label.PlanStartDate": "计划开始日期",
    "setup.label.IsPrepaid": "是否预付",
    "setup.label.Duration": "持续时间",
    "setup.label.PlanType": "计划类型",
    "setup.label.BillingRule": "计费规则",
    "setup.label.EndDate": "结束日期",
    "setup.label.IsProvision": "是否供应",
    "setup.label.EditPlan": "编辑计划",
    "setup.label.SelectProduct": "选择产品",
    "setup.label.ViewPlan": "查看计划",
    "setup.label.ProvisioningSystem": "供应系统",
    "setup.label.DeletePlan": "删除计划",
    "setup.label.Prices": "价格",
    "setup.label.ChargeOwner": "收费所有者",
    "setup.label.DiscountCode": "折扣代码",
    "setup.label.PriceRegion": "价格区域",
    "setup.label.Resource": "资源",
    "setup.label.SalesChannel": "销售渠道",
    "setup.label.OrderType": "订单类型",
    "setup.label.BusinessType": "业务类型",
    "setup.label.RoundingType": "舍入类型",
    "setup.label.GLID": "GL ID",
    "setup.label.Value": "价值",
    "setup.label.TemplateDefinition": "模板定义",
    "setup.label.CreateTemplateDefinition": "创建模板定义",
    "setup.label.TemplateName": "模板名称",
    "setup.label.Delimiter": "分隔符",
    "setup.label.NumberOfFields": "字段数量",
    "setup.label.HeaderRecorderType": "头部记录器类型",
    "setup.label.EventRecordType": "事件记录类型",
    "setup.label.IsHeader": "是否为头部",
    "setup.label.FieldType": "字段类型",
    "setup.label.FieldName": "字段名称",
    "setup.label.IdentifierType": "标识符类型",
    "setup.label.Length": "长度",
    "setup.label.ExistsTemplateDefinition": "已存在的模板定义",
    "setup.label.UOM(Unit Of measurement)": "UOM（计量单位）",
    "setup.label.CreateUOM": "创建 UOM",
    "setup.label.Name": "名称",
    "setup.label.EditTemplateDefinition": "编辑模板定义",
    "setup.label.EditUOM": "编辑 UOM",
    "setup.label.Save": "保存",
    "setup.label.DeleteUOM": "删除 UOM",
    "setup.label.Ok": "确定",
    "setup.label.ViewUOM": "查看 UOM",
    "setup.label.RUM(RatableUsageMetric)": "RUM（可定价使用度量）",
    "setup.label.CreateRUM": "创建 RUM",
    "setup.label.ChargeName": "费用名称",
    "setup.label.Template Name": "模板名称",
    "setup.label.RumName": "Rum 名称",
    "setup.label.RumExpression": "Rum 表达式",
    "setup.label.Operators": "运算符",
    "setup.label.EditRUM": "编辑 RUM",
    "setup.label.ViewRUM": "查看 RUM",
    "setup.label.TimePeriod": "时间段",
    "setup.label.CreateTimePeriod": "创建时间段",
    "setup.label.TimeModelName": "时间模型名称",
    "setup.label.StartYear": "开始年份",
    "setup.label.EndYear": "结束年份",
    "setup.label.StartMonth": "开始月份",
    "setup.label.EndMonth": "结束月份",
    "setup.label.StartDay": "开始日期",
    "setup.label.EndDay": "结束日期",
    "setup.label.StartTime": "开始时间",
    "setup.label.EndTime": "结束时间",
    "setup.label.CreateTimeModel": "创建时间模型",
    "setup.label.ExpandAll / CollapseAll": "展开全部 / 收起全部",
    "setup.label.AddTimemodel": "添加时间模型",
    "setup.label.UsageRatePlan": "使用率计划",
    "setup.label.CreateUsageRatePlan": "创建使用率计划",
    "setup.label.PlanName": "计划名称",
    "setup.label.ProductName": "产品名称",
    "setup.label.TimemodelName": "时间模型名称",
    "setup.label.ViewUsageRatePlan": "查看使用率计划",
    "setup.label.RUM": "RUM",
    "setup.label.RatingType": "评级类型",
    "setup.label.TimeModel": "时间模型",
    "setup.label.ZoneModel": "区域模型",
    "setup.label.ViewQuantityTier": "查看数量级别",
    "setup.label.QuantityTier": "数量级别",
    "setup.label.TierName": "级别名称",
    "setup.label.CumulativeResource": "累积资源",
    "setup.label.TierRange": "级别范围",
    "setup.label.StepName": "步骤名称",
    "setup.label.StartRange": "开始范围",
    "setup.label.EndRange": "结束范围",
    "setup.label.AddQuantityTier": "添加数量级别",
    "setup.label.NumberZone": "号码区",
    "setup.label.CreateNumberZone": "创建号码区",
    "setup.label.SourceNumberPrefix": "源号码前缀",
    "setup.label.DestinationNumberPrefix": "目的号码前缀",
    "setup.label.ImpactCategory": "影响类别",
    "setup.label.Rank": "排名",
    "setup.label.APNZone": "APN 区域",
    "setup.label.APN": "APN",
    "setup.label.CreateAPNZone": "创建 APN 区域",
    "setup.label.OperatorZone": "运营商区域",
    "setup.label.CreateOperatorZone": "创建运营商区域",
    "setup.label.SourceOperatorCode": "源运营商代码",
    "setup.label.DestinationOperatorCode": "目的运营商代码",
    "setup.label.ICZone": "IC 区域",
    "setup.label.IncomingTrunkid": "来电干线ID",
    "setup.label.OutcomingTrunkid": "去电干线ID",
    "setup.label.CreateChargeCode": "创建收费代码",
    "setup.label.ChargeDescription": "收费描述",
    "setup.label.ChargeType": "收费类型",
    "setup.label.ChargeDuration": "收费时长",
    "setup.label.DurationType": "时长类型",
    "setup.label.TaxInclusive": "含税",
    "setup.label.BillFrequencyCode": "计费频率代码",
    "setup.label.TaxCode": "税码",
    "setup.label.IsAggregate": "是否汇总",
    "setup.label.EditChargeCode": "编辑收费代码",
    "setup.label.TaxMaster": "税务管理",
    "setup.label.CreateTaxMaster": "创建税务管理",
    "setup.label.GroupType": "组类型",
    "setup.label.GroupCode": "组代码",
    "setup.label.StartDate": "开始日期",
    "setup.label.Rate": "税率",
    "setup.label.BaseTaxCode": "基本稅碼",
    "setup.label.Jurisdiction": "管辖区",
    "setup.label.RateType": "税率类型",
    "setup.label.Location": "地點",
    "setup.label.DeleteTax": "删除税",
    "setup.label.CreateDiscount": "创建折扣",
    "setup.label.DiscountDescription": "折扣描述",
    "setup.label.DiscountType": "折扣类型",
    "setup.label.DiscountRate": "折扣率",
    "setup.label.DiscountDetails": "折扣详情",
    "setup.label.ClientCategory": "客户类别",
    "setup.label.CustomerCategory": "客户类别",
    "setup.label.EditDiscount": "编辑折扣",
    "setup.label.DeleteDiscount": "删除折扣",
    "setup.label.CreatePromotion": "创建促销",
    "setup.label.PromotionCode": "促销代码",
    "setup.label.PromotionName": "促销名称",
    "setup.label.PromotionId": "促销 ID",
    "setup.label.PromotionDescription": "促销描述",
    "setup.label.EditPromotionCode": "编辑促销代码",
    "setup.label.ListOfDiscounts": "折扣列表",
    "setup.label.ListofTimePeriods": "时间段列表",
    "setup.label.CreatePriceRegion": "创建价格区域",
    "setup.label.RegionCode": "区域代码",
    "setup.label.RegionName": "区域名称",
    "setup.label.Country": "国家",
    "setup.label.States": "州",
    "setup.label.EditPriceRegion": "编辑价格区域",
    "setup.label.DeletePriceRegion": "删除价格区域",
    "setup.label.CreateSalesCatalogue": "创建销售目录",
    "setup.label.SalesCatalogueName": "销售目录名称",
    "setup.label.AssignUsers": "分配用户",
    "setup.label.SalesPlanCategory": "销售计划类别",
    "setup.label.Plans": "计划",
    "setup.label.EditSalesCatalogue": "编辑销售目录",
    "setup.label.DeleteSalesCatalogue": "删除销售目录",
    "setup.label.UserId": "用户 ID",
    "setup.label.UserName": "用户名",
    "setup.label.CreateUsersCatalogue": "创建用户目录",
    "setup.label.Catalogue": "目录",
    "setup.label.EditUserCatalogue": "编辑用户目录",
    "setup.label.VoucherPins": "代金券密码",
    "setup.label.CreateVoucherPins": "创建代金券密码",
    "setup.label.Voucher": "代金券",
    "setup.label.Coupon": "优惠券",
    "setup.label.LCO": "LCO",
    "setup.label.LengthOfPins": "密码长度",
    "setup.label.SerialNoLength": "序列号长度",
    "setup.label.NumberValue ": "数值",
    "setup.label.PinValue ": "PIN值",
    "setup.label.BatchName": "批次名称",
    "setup.label.PinCategory": "密码类别",
    "setup.label.BeginWith": "以...开头",
    "setup.label.Quantity": "数量",
    "setup.label.PinType": "密码类型",
    "setup.label.SIMNumbers": "SIM 卡号码",
    "setup.label.CreateSIMNumber": "创建 SIM 卡号码",
    "setup.label.NumberCategory": "号码类别",
    "setup.label.ExpiryDate": "到期日期",
    "setup.label.Partner": "合作伙伴",
    "setup.label.LengthofNumber": "号码长度",
    "setup.label.LengthofSerialNumber": "序列号长度",
    "setup.label.NumberType": "号码类型",
    "setup.label.Product": "产品",
    "setup.label.Supplier": "供应商",
    "setup.label.CreateSupplier": "创建供应商",
    "setup.label.EditSupplier": "编辑供应商",
    "setup.label.AddressMaster": "地址主控",
    "setup.label.CountryName": "国家名称",
    "setup.label.StateName": "州名",
    "setup.label.DistrictName": "区名",
    "setup.label.CityName": "城市名称",
    "setup.label.TreeView": "树视图",
    "setup.label.AddCountry": "添加国家",
    "setup.label.CountryCode": "国家代码",
    "setup.label.TeamHead": "团队负责人",
    "setup.label.CreateTicketTeam": "创建工单团队",
    "setup.label.TeamCode": "团队代码",
    "setup.label.TeamDescription": "团队描述",
    "setup.label.TeamCategory": "团队类别",
    "setup.label.CreateTicketTeamUsers": "创建工单团队用户",
    "setup.label.TeamEmail": "团队邮箱",
    "setup.label.AvailableUsers": "可用用户",
    "setup.label.SelectedUsers": "已选用户",
    "setup.label.TeamId": "团队ID",
    "setup.label.ViewTeam": "查看团队",
    "setup.label.DeleteTeam": "删除团队",
    "setup.label.EditTicketTeam": "编辑工单团队",
    "setup.label.TeamUser": "团队用户",
    "setup.label.EditTicketUsers": "编辑工单用户",
    "setup.label.DeleteTeamUser": "删除团队用户",
    "setup.label.VendorManagement": "供应商管理",
    "setup.label.CreateVendor": "创建供应商",
    "setup.label.ContactName": "联系人姓名",
    "setup.label.Mobile": "手机",
    "setup.label.Landline": "固定电话",
    "setup.label.CreateNewVendor": "创建新供应商",
    "setup.label.EditVendor": "编辑供应商",
    "setup.label.FeeMaster": "费用主控",
    "setup.label.CreateFeeMaster": "创建费用主控",
    "setup.label.FeeMasterCode": "费用主控代码",
    "setup.label.FeeMasterDescription": "费用主控描述",
    "setup.label.FeeMasterTransactionType": "费用主控交易类型",
    "setup.label.ChargeCode": "收费代码",
    "setup.label.VariablePricing": "可变定价",
    "setup.label.Regions": "地区",
    "setup.label.Amount": "金额",
    "setup.label.EditFeeMaster": "编辑费用主控",
    "setup.label.ManageMessage": "管理消息",
    "setup.label.AddMessage": "添加消息",
    "setup.label.TemplateDescription": "模板描述",
    "setup.label.Subject": "主题",
    "setup.label.MessageType": "消息类型",
    "setup.label.Header": "头部",
    "setup.label.Body": "主体",
    "setup.label.Footer": "页脚",
    "setup.label.CreateMessageTemplate": "创建消息模板",
    "setup.label.MessageParams": "消息参数",
    "setup.label.Parameter": "参数",
    "setup.label.Params": "参数",
    "setup.label.DeleteMessage": "删除消息",
    "setup.label.EditMessage": "编辑消息",
    "setup.label.GroupsDetails": "组详细信息",
    "setup.label.GroupName": "组名",
    "setup.label.GroupAddress": "组地址",
    "setup.label.CountNo's": "计数号码",
    "setup.label.AddGroup": "添加组",
    "setup.label.AdditionalInformation": "附加信息",
    "setup.label.GroupCIR": "组 CIR",
    "setup.label.DIR": "DIR",
    "setup.label.MemberCIR": "成员 CIR",
    "setup.label.IpPoolManagement": "IP 池管理",
    "setup.label.UpdateNetMask": "更新网络掩码",
    "setup.label.IpAddress": "IP 地址",
    "setup.label.NetMark": "网络标记",
    "setup.label.IpType": "IP 类型",
    "setup.label.CoustomerId": "客户 ID",
    "setup.label.CustomerName": "客户名称",
    "setup.label.Notes": "备注",
    "setup.label.Subnet": "子网",
    "setup.label.DetailsOfMedia": "媒体详情",
    "setup.label.Media": "媒体",
    "setup.label.AddMedia": "添加媒体",
    "setup.label.MediaTitle": "媒体标题",
    "setup.label.MediaCatagory": "媒体类别",
    "setup.label.ContentProvider": "内容提供者",
    "setup.label.Share": "分享(%)",
    "setup.label.AddMediaDetails": "添加媒体详情",
    "setup.label.MediaLocation": "媒体位置",
    "setup.label.SelectMediaCategory": "选择媒体类别",
    "setup.label.Movies": "电影",
    "setup.label.ViewMedia": "查看媒体",
    "setup.label.EditMedia": "编辑媒体",
    "setup.label.MediaAttributes": "媒体属性",
    "setup.label.Cast": "演员",
    "setup.label.AttributeType": "属性类型",
    "setup.label.CaptionValue": "字幕值",
    "setup.label.NickName": "昵称",
    "setup.label.Image": "图片",
    "setup.label.AddMediaLocations": "添加媒体位置",
    "setup.label.LanguageData": "语言数据",
    "setup.label.FormatData": "格式数据",
    "setup.label.MediaLocations": "媒体位置",
    "setup.label.DetailsOfEvent": "事件详情",
    "setup.label.EventName": "事件名称",
    "setup.label.EventCode": "事件代码",
    "setup.label.SelectedMediaService": "已选媒体服务",
    "setup.label.AvailableMedia": "可用媒体",
    "setup.label.EventDescription": "事件描述",
    "setup.label.EventCategory": "事件类别",
    "setup.label.CreateEvent": "创建事件",
    "setup.label.DetailsOfProperty": "财产详情",
    "setup.label.PropertyCode": "财产代码",
    "setup.label.PropertyType": "财产类型",
    "setup.label.Parcel": "地块",
    "setup.label.BuildingCode": "建筑代码",
    "setup.label.Precinct": "区",
    "setup.label.Allocated": "分配",
    "setup.label.UploadPropertyData": "上传财产数据",
    "setup.label.Clear": "清除",
    "setup.label.CreateProperty": "创建财产",
    "setup.label.PropertyDataUpload": "上传财产数据",
    "setup.label.Street": "街道",
    "setup.label.PaymentType": "支付类型",
    "setup.label.PoBox": "邮箱",
    "setup.label.State": "州",
    "setup.label.District": "區",
    "setup.label.Floor": "楼层",
    "setup.label.LimitCode": "限制代码",
    "setup.label.PropertyMaster": "物业管理",
    "setup.label.CodeDescription": "代码描述",
    "setup.label.ReferenceValue": "参考值",
    "setup.label.Services": "服务",
    "setup.label.IsBouquet": "是否为花束",
    "setup.label.Broadcaster": "广播公司",
    "setup.label.Channel": "频道",
    "setup.label.ContactNumber": "联系电话",
    "setup.label.UOM": "单位",
    "setup.label.DeleteTemplateDefinition": "删除模板定义",
    "setup.label.Discount": "折扣",
    "setup.label.SalseCatalogue": "销售目录",
    "setup.label.UserCatalogue": "用户目录",
    "setup.label.Team": "团队",
    "setup.label.MediaDetails": "媒体详情",
    "setup.label.Event": "事件",
    "setup.label.Properties": "属性",
    "setup.label.ServicesProducts": "服务和产品",
    "setup.label.BroadcasterChannelMapping": "广播公司、频道和映射",
    "setup.label.UsageRating": "使用评分",
    "setup.label.ZoneSetup": "区域设置",
    "setup.label.Promotion": "促销",
    "setup.label.PromotionTrigger": "促销触发",
    "setup.label.PromotionRulesAndRates": "促销规则及费率",
    "setup.label.CatalogeMapping": "目录映射",
    "setup.label.VoucherPin": "优惠券码",
    "setup.label.SIMNumber": "SIM卡号",
    "setup.label.TeamTeamUser": "团队和团队用户",
    "setup.label.MessageTemplate": "消息模板",
    "setup.label.ClosedUserGroup": "封闭用户组",
    "setup.label.IpManagement": "IP管理",
    "setup.label.PropertyDefinition": "属性定义",
    "setup.label.PriorityMapping": "優先權映射",
    "setup.label.AddProducts": "添加产品",
    "setup.label.AddDiscount": "添加折扣",
    "setup.label.Products": "产品",
    "setup.label.ChargeCodeData": "收费代码数据",
    "setup.label.TaxMapping": "税收映射",
    "setup.label.TaxRegion": "税区",
    "setup.label.CreateUserCatalogue": "创建用户目录",
    "setup.label.IcZone": "Ic 区域",
    "setup.label.ViewIcZone": "查看 Ic 区域",
    "setup.label.ViewNumberZone": "查看号码区",
    "setup.label.EditNumberZone": "编辑号码区",
    "setup.label.DeleteNumberZone": "删除号码区",
    "setup.label.AreYouSure": "你确定吗？",
    "setup.label.ViewAPNZone": "查看APN区",
    "setup.label.EditAPNZone": "编辑APN区",
    "setup.label.DeleteAPNZone": "删除APN区",
    "setup.label.ViewOperatorZone": "查看运营商区",
    "setup.label.EditOperatorZone": "编辑运营商区",
    "setup.label.CreateICZone": "创建IC区",
    "setup.label.EditICZone": "编辑IC区",
    "setup.label.DeleteOperatorZone": "删除运营商区",
    "setup.label.DeleteIcZone": "删除IC区",
    "setup.label.MobileNumber": "手机号码",
    "setup.label.LandlineNumber": "固定电话号码（可选）",
    "setup.label.RatePlanName": "资费计划名称",
    "setup.label.UsageRateBalance": "使用率余额",
    "setup.label.ValidityType": "有效性类型",
    "setup.label.ListOfRateTires": "费率轮胎列表",
    "setup.label.Validity": "有效性",
    "setup.label.CreatePlanName": "创建计划名称",
    "setup.label.EditPlanContent": "编辑计划内容",
    "setup.label.CreatePlanDescription": "创建计划描述",
    "setup.label.ContentType": "内容类型",
    "setup.label.CreateFeatureList": "创建功能列表",
    "setup.label.Area": "區域",
    "setup.label.TaxPercentage": "稅率",
    "setup.label.Add": "添加",
    "setup.label.Remove": "消除",
    "setup.label.CreateVoucherPin": "创建代金券密码",
    "setup.label.EditSubCategory": "編輯子類別",
    "setup.label.CreateSubCategory": "建立子類別",
    "setup.label.ViewSubCategory": "查看子類別",
    "setup.label.TimeTaken": "所用時間",
    "setup.label.TeamMapping": "团队映射",
    "setup.label.CreateTeamMapping": "创建团队映射",
    "setup.label.Category": "类别",
    "setup.label.external_promotional_code": "外部促销代码",
    "setup.label.Subcategory": "子类别",
    "setup.label.DeleteItemMapping": "删除项目映射",
    "setup.label.EditTeamMapping": "编辑团队映射",
    "setup.label.ViewTeamMapping": "查看团队映射",
    "setup.label.DeletePriorityMapping": "删除优先级映射",
    "setup.label.discount_rule": "折扣规则",
    "setup.label.promotion_rule": "促销规则",
    "setup.label.discount_rate": "折扣率",
    "setup.label.create_discount_rule": "创建折扣规则",
    "setup.label.edit_promotion_rule": "编辑促销规则",
    "setup.label.create_promotion_rule": "创建促销规则",
    "setup.label.create_discount_rate": "创建折扣率",
    "setup.label.add_discount_rate": "添加折扣率",
    "setup.label.add_promotion_rate": "添加促销率",
    "setup.label.edit_discount": "编辑折扣",
    "setup.label.edit_promotion": "编辑促销",
    "setup.label.edit_discount_trigger": "编辑折扣触发器",
    "setup.label.edit_discount_rule": "编辑折扣规则",
    "setup.label.collection_process": "催收过程",
    "setup.label.create_collection_profile": "创建催收档案",
    "setup.label.collection_profile": "催收档案",
    "setup.label.collection_profile_id": "催收档案ID",
    "setup.label.region": "地区",
    "setup.label.collection": "催收",
    "setup.label.collection_trigger": "催收触发器",
    "setup.label.collection_scenario": "催收情景",
    "setup.label.add_collection_trigger": "添加催收触发器",
    "setup.label.add_collection_scenario": "添加催收情景",
    "setup.label.trigger_id": "触发器 ID",
    "setup.label.criteria_type": "标准类型",
    "setup.label.due_balance": "应付余额",
    "setup.label.ageing_days": "账龄天数",
    "setup.label.scenario_id": "情景 ID",
    "setup.label.action_name": "动作名称",
    "setup.label.age": "年龄",
    "setup.label.create_collection_trigger": "创建催收触发器",
    "setup.label.create_collection_scenario": "创建催收情景",
    "setup.label.edit_collection_profile": "编辑催收配置文件",
    "setup.label.edit_collection_trigger": "编辑催收触发器",
    "setup.label.edit_collection_scenario": "编辑催收情景",
    "setup.label.SlaInHours": "SLA（以小時為單位）",
    "setup.label.contractduration": "合同期限",
    "setup.label.chargesperiodicity": "收费周期",
  },

  hi: {
    "setup.label.Enter_product_Description": "उत्पाद विवरण दर्ज करें",
    "setup.label.FeedbackStatus": "फीडबैक की स्थिति",
    "setup.label.EnterCountryName": "देश का नाम दर्ज करें",
    "setup.label.location": "स्थान",
    "setup.label.selectLocation": "स्थान चुनें",
    "setup.label.create_group_ticket": "समूह टिकट बनाएं",
    "setup.label.default": "डिफ़ॉल्ट",
    "setup.label.customerFeedback": "ग्राहक प्रतिक्रिया",
    "setup.label.automation": "स्वचालन",
    "setup.label.automation_master": "स्वचालन मास्टर",
    "setup.label.create_automation": "स्वचालन बनाएँ",
    "setup.label.edit_automation": "स्वचालन संपादित करें",
    "setup.label.automation_detail": "स्वचालन विवरण",
    "setup.label.automation_steps": "स्वचालन चरण",
    "setup.label.add_automation_step": "स्वचालन चरण जोड़ें",
    "setup.label.AutomationId": "स्वचालन आईडी",
    "setup.label.EntityName": "इकाई का नाम",
    "setup.label.EntityType": "इकाई का प्रकार",
    "setup.label.WorkflowName": "वर्कफ़्लो नाम",
    "setup.label.CreateAutomationScenario": "स्वचालन परिदृश्य बनाएँ",
    "setup.label.EditAutomationStep": "स्वचालन चरण संपादित करें",
    "setup.label.ActionType": "क्रिया का प्रकार",
    "setup.label.ActionDetails": "क्रिया विवरण",
    "setup.label.StepOrder": "चरण क्रम",
    "setup.label.questionAnswerSet": "प्रश्न और उत्तर सेट",
    "setup.label.addQuestionSet": "प्रश्न सेट जोड़ें",
    "setup.label.EditQuestionSet": "प्रश्न सेट संपादित करें",
    "setup.label.CategoryName": "श्रेणी का नाम",
    "setup.label.SubCategoryName": "उप श्रेणी का नाम",
    "setup.label.TotalQuestions": "कुल प्रश्न",
    "setup.label.QuestionType": "प्रश्न प्रकार",
    "setup.label.QuestionText": "प्रश्न पाठ",
    "setup.label.CustomerFeedback": "ग्राहक प्रतिक्रिया",
    "setup.label.TicketId": "टिकट आईडी",
    "setup.label.LinkedAt": "लिंक किया गया समय",
    "setup.label.Remarks": "टिप्पणियाँ",
    "setup.label.AddFeedback": "प्रतिक्रिया जोड़ें",
    "setup.label.PendingForApproval": "मंजूरी के लिए लंबित",
    "setup.label.user_availability": "उपयोगकर्ता की उपलब्धता",
    "setup.label.all_users_availability": "सभी उपयोगकर्ताओं की उपलब्धता",
    "setup.label.create_user_availability": "उपयोगकर्ता की उपलब्धता बनाएं",
    "setup.label.LeaveManagement": "अवकाश प्रबंधन",
    "setup.label.CreateLeave": "अवकाश बनाएँ",
    "setup.label.EditLeave": "अवकाश संपादित करें",
    "setup.label.ViewLeave": "अवकाश देखें",
    "setup.label.AllUserLeaves": "सभी उपयोगकर्ता अवकाश",
    "setup.label.MyLeaves": "मेरे अवकाश",
    "setup.label.ConfigId": "कॉन्फ़िग आईडी",
    "setup.label.edit_user_availability": "उपयोगकर्ता की उपलब्धता संपादित करें",
    "setup.label.view_user_availability": "उपयोगकर्ता की उपलब्धता देखें",
    "setup.label.unavailability_date": "अप्राप्य तिथि",
    "setup.label.start_time": "प्रारंभ समय",
    "setup.label.end_time": "समाप्ति समय",
    "setup.label.my_availability": "मेरी उपलब्धता",
    "setup.label.user": "उपयोगकर्ता",
    "setup.label.EditShift": "शिफ्ट संपादित करें",
    "setup.label.UserWorkingShift": "उपयोगकर्ता कार्य शिफ्ट",
    "setup.label.CreateUserWorkingShift": "उपयोगकर्ता कार्य शिफ्ट बनाएँ",
    "setup.label.EditUserWorkingShift": "उपयोगकर्ता कार्य शिफ्ट संपादित करें",
    "setup.label.ViewUserWorkingShift": "उपयोगकर्ता की कार्य शिफ्ट देखें",
    "setup.label.TeamName": "टीम का नाम",
    "setup.label.Shift": "शिफ्ट",
    "setup.label.ShiftManagement": "शिफ्ट प्रबंधन",
    "setup.label.CreateShift": "शिफ्ट बनाएँ",
    "setup.label.ShiftName": "शिफ्ट का नाम",
    "setup.label.Session": "सत्र",
    "setup.label.SessionType": "सत्र का प्रकार",
    "setup.label.LeaveDetails": "अवकाश का विवरण",
    "setup.label.SessionStartTime": "सत्र प्रारंभ समय",
    "setup.label.SessionEndTime": "सत्र समाप्ति समय",
    "setup.label.LeaveType": "अवकाश का प्रकार",
    "setup.label.AddAnotherDate": "एक और तिथि जोड़ें",
    "setup.label.Apn_Zone": "APN ज़ोन",
    "setup.label.FeeMaster": "शुल्क मास्टर",
    "setup.label.Number_Zone": "नंबर ज़ोन",
    "setup.label.DeleteRUM": "RUM हटाएं",
    "setup.label.Edit_TimeModel": "समय मॉडल संपादित करें",
    "setup.label.Edit_Year": "वर्ष संपादित करें",
    "setup.label.scenario_name": "परिदृश्य नाम",
    "setup.label.event_name": "ईवेंट नाम",
    "setup.label.Edit_Month": "महीना संपादित करें",
    "setup.label.Edit_Day": "दिन संपादित करें",
    "setup.label.Edit_Time": "समय संपादित करें",
    "setup.label.Delete_TimeModel": "समय मॉडल हटाएं",
    "setup.label.Delete_Year": "वर्ष हटाएं",
    "setup.label.Delete_Month": "महीना हटाएं",
    "setup.label.Delete_Day": "दिन हटाएं",
    "setup.label.Delete_Time": "समय हटाएं",
    "setup.label.Are_you_sure_?": "क्या आप सुनिश्चित हैं?",
    "setup.label.Save": "सहेजें",
    "setup.label.TemplateDefinition": "टेम्पलेट परिभाषा",
    "setup.label.EditQuantityTier": "मात्रा स्तर संपादित करें",
    "setup.label.Usage_Rate_Balance": "उपयोग दर शेष राशि",
    "setup.label.Template_Name": "टेम्पलेट नाम",
    "setup.label.Delimiter": "विभाजक",
    "setup.label.Number_Of_Fields": "फ़ील्ड की संख्या",
    "setup.label.Header_Recorder_Type": "हेडर रिकॉर्डर प्रकार",
    "setup.label.Event_Record_Type": "इवेंट रिकॉर्ड प्रकार",
    "setup.label.CreateUOM": "माप इकाई बनाएं",
    "setup.label.TimePeriod": "समय अवधि",
    "setup.label.Usage_Rate_Plan": "उपयोग दर योजना",
    "setup.label.TemplateDefinition": "टेम्पलेट परिभाषा",
    "setup.label.CreateRUM": "RUM बनाएं",
    "setup.label.CreateTimePeriod": "समय अवधि बनाएं",
    "setup.label.TimemodelName": "समय मॉडल नाम",
    "setup.label.TimePeriodName": "समय अवधि नाम",
    "setup.label.StartYear": "प्रारंभ वर्ष",
    "setup.label.EndYear": "अंतिम वर्ष",
    "setup.label.UsageRatePlan": "उपयोग दर योजना",
    "setup.label.Create_Usage_Rate_Plan": "उपयोग दर योजना बनाएं",
    "setup.label.Id": "पहचान",
    "setup.label.PlanName": "योजना नाम",
    "setup.label.ProductName": "उत्पाद का नाम",
    "setup.label.ChargeCode": "चार्ज कोड",
    "setup.label.TimeModelName": "समय मॉडल नाम",
    "setup.label.RatingType": "रेटिंग प्रकार",
    "setup.label.RumName": "RUM नाम",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "क्या आप वाकई हटाना चाहते हैं?",
    "setup.label.UOM": "मापन इकाई",
    "setup.label.RUM": "RUM",
    "setup.label.ImpactCategory": "प्रभाव श्रेणी",
    "setup.label.Resource": "संसाधन",
    "setup.label.GLID": "GLID",
    "setup.label.Unit": "इकाई",
    "setup.label.Rate": "दर",
    "setup.label.Action": "क्रिया",
    "setup.label.options_selected": "चयनित विकल्प",
    "setup.label.UsageRateBalance": "उपयोग दर शेष",
    "setup.label.EndYear": "अंतिम वर्ष",
    "setup.label.StartMonth": "प्रारंभ माह",
    "setup.label.EndMonth": "अंतिम माह",
    "setup.label.StartDay": "प्रारंभ दिन",
    "setup.label.EndDay": "अंतिम दिन",
    "setup.label.StartTime": "प्रारंभ समय",
    "setup.label.Time_Model_Name": "समय मॉडल नाम",
    "setup.label.model_includes_which_all_Bands_?":
      "मॉडल में कौन-कौन से बैंड शामिल हैं?",
    "setup.label.YearRestriction": "वर्ष प्रतिबंध",
    "setup.label.MonthRestriction": "महीना प्रतिबंध",
    "setup.label.DayRestriction": "दिन प्रतिबंध",
    "setup.label.TimeRestriction": "समय प्रतिबंध",
    "setup.label.Code": "कोड",
    "setup.label.Name": "नाम",
    "setup.label.PriorityMapping": "प्राथमिकता मानचित्रण",
    "setup.label.AddJurisdiction": "क्षेत्र जोड़ें",
    "setup.label.Are_you_sure_?": "क्या आप सुनिश्चित हैं?",
    "setup.label.Country": "देश",
    "setup.label.State": "राज्य",
    "setup.label.District": "ज़िला",
    "setup.label.RateType": "दर प्रकार",
    "setup.label.Remove": "हटाएं",
    "setup.label.TaxMaster": "कर मास्टर",
    "setup.label.Team": "टीम",
    "setup.label.Add": "जोड़ें",
    "setup.label.FeeMaster": "शुल्क मास्टर",
    "setup.label.DeleteChargeCode": "चार्ज कोड हटाएं",
    "setup.label.SelectSearch": "खोज चुनें",
    "setup.label.Select_Content_Tag_Value": "सामग्री टैग मान चुनें",
    "setup.label.Plan_Content": "प्लान सामग्री",
    "setup.label.Plan": "प्लान",
    "setup.label.ProductPrice": "उत्पाद मूल्य",
    "setup.label.SelectedPromotions": "चयनित प्रचार",
    "setup.label.AvailablePromotions": "उपलब्ध प्रचार",
    "setup.label.SelectType": "प्रकार चुनें",
    "setup.label.Type": "प्रकार",
    "setup.label.No_versions_available": "कोई संस्करण उपलब्ध नहीं",
    "setup.label.Version": "संस्करण",
    "setup.label.ListPrice": "सूची मूल्य",
    "setup.label.SellingPrice": "बिक्री मूल्य",
    "setup.label.EnterPlanDescription": "योजना विवरण दर्ज करें",
    "setup.label.AddPrice": "मूल्य जोड़ें",
    "setup.label.Save": "सहेजें",
    "setup.label.AddDiscount": "छूट जोड़ें",
    "setup.label.AvailablePlans": "उपलब्ध योजनाएं",
    "setup.label.SelectedPlans": "चयनित योजनाएं",
    "setup.label.PlanType": "योजना प्रकार",
    "setup.label.Plan_Start_Date": "योजना प्रारंभ तिथि",
    "setup.label.Plan_End_Date": "योजना समाप्ति तिथि",
    "setup.label.Bill_Type": "बिल प्रकार",
    "setup.label.AttributeTypes": "गुण विशेषताएँ",
    "setup.label.Add": "जोड़ें",
    "setup.label.Select_Content_Tag": "सामग्री टैग चुनें",
    "setup.label.PlanName": "योजना का नाम",
    "setup.label.AvailableDiscounts": "उपलब्ध छूट",
    "setup.label.Search": "खोजें...",
    "setup.label.MoveRight": "दाएँ ले जाएँ",
    "setup.label.MoveLeft": "बाएँ ले जाएँ",
    "setup.label.SelectedDiscounts": "चयनित छूट",
    "setup.label.SelectType": "प्रकार चुनें",
    "setup.label.SelectLanguage": "भाषा चुनें",
    "setup.label.SelectContentTag": "सामग्री टैग चुनें",
    "setup.label.SelectContentTagValue": "सामग्री टैग मान चुनें",
    "setup.label.DigitalContent": "डिजिटल सामग्री",
    "setup.label.Enter_Plan_Description": "योजना का विवरण दर्ज करें",
    "setup.label.DC_Rule": "डीसी नियम",
    "setup.label.PlanAttribute": "योजना विशेषता",
    "setup.label.AdvanceView": "उन्नत दृश्य",
    "setup.label.Update": "अपडेट करें",
    "setup.label.ProductMapping": "उत्पाद मैपिंग",
    "setup.label.Service": "सेवा",
    "setup.label.SubProducts": "उप-उत्पाद",
    "setup.label.Type": "प्रकार",
    "setup.label.EnterValue": "मान दर्ज करें",
    "setup.label.PriceRegion": "मूल्य क्षेत्र",
    "setup.label.Enter_service_Description": "सेवा विवरण दर्ज करें",
    "setup.label.ParamName": "पैरामीटर नाम",
    "setup.label.Category": "श्रेणी",
    "setup.label.Type": "प्रकार",
    "setup.label.EnterValue": "मान दर्ज करें",
    "setup.label.SalesCatalogue": "बिक्री सूची",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "क्या आप वाकई इसे हटाना चाहते हैं?",
    "setup.label.Channel": "चैनल",
    "setup.label.Broadcaster": "प्रसारक",
    "setup.label.AddPrice": "मूल्य जोड़ें",
    "setup.label.DeleteMediaEvent": "मीडिया इवेंट हटाएँ",
    "setup.label.AdvMedia": "विज्ञापन मीडिया",
    "setup.label.EditMedia": "मीडिया संपादित करें",
    "setup.label.AddEvent": "इवेंट जोड़ें",
    "setup.label.AddAttributes": "गुण जोड़ें",
    "setup.label.AddLocation": "स्थान जोड़ें",
    "setup.label.DeleteEvent": "इवेंट हटाएँ",
    "setup.label.Are_you_sure_?": "क्या आप निश्चित हैं?",
    "setup.label.Add": "जोड़ें",
    "setup.label.ViewEvent": "इवेंट देखें",
    "setup.label.Event": "इवेंट",
    "setup.label.RUM": "RUM",
    "setup.label.OptType": "विकल्प प्रकार",
    "setup.label.Currency": "मुद्रा",
    "setup.label.Amount": "राशि",
    "setup.label.Add": "जोड़ें",
    "setup.label.Save": "सहेजें",
    "setup.label.AddDiscount": "छूट जोड़ें",
    "setup.label.EnterEventCode": "इवेंट कोड दर्ज करें",
    "setup.label.EnterEventDescription": "इवेंट विवरण दर्ज करें",
    "setup.label.EventDescription": "इवेंट विवरण",
    "setup.label.EventCategory": "इवेंट श्रेणी",
    "setup.label.ChargeCode": "चार्ज कोड",
    "setup.label.SelectEventValidity": "इवेंट की वैधता चुनें",
    "setup.label.EditEvent": "इवेंट संपादित करें",
    "setup.label.UnitCode": "यूनिट कोड",
    "setup.label.MediaTitle": "मीडिया शीर्षक",
    "setup.label.ContentProvider": "सामग्री प्रदाता",
    "setup.label.MediaType": "मीडिया प्रकार",
    "setup.label.Rated": "रेटेड",
    "setup.label.MediaCategory": "मीडिया श्रेणी",
    "setup.label.Rating": "रेटिंग",
    "setup.label.Poster": "पोस्टर",
    "setup.label.Status": "स्थिति",
    "setup.label.MovieDuration": "फिल्म की अवधि",
    "setup.label.ReleaseDate": "रिलीज़ की तारीख",
    "setup.label.Genre": "शैली",
    "setup.label.Subject": "विषय",
    "setup.label.Overview": "अवलोकन",
    "setup.label.Share(%)": "हिस्सा (%)",
    "setup.label.Cast": "कलाकार",
    "setup.label.AttributeType": "गुण प्रकार",
    "setup.label.CaptionValue": "कैप्शन मान",
    "setup.label.NickName": "उपनाम",
    "setup.label.Image": "छवि",
    "setup.label.Language": "भाषा",
    "setup.label.Format": "प्रारूप",
    "setup.label.Location": "स्थान",
    "setup.label.CustomerType": "ग्राहक प्रकार",
    "setup.label.FormatType": "प्रारूप प्रकार",
    "setup.label.DiscountCode": "छूट कोड",
    "setup.label.ReProcess": "पुनः प्रक्रिया करें",
    "setup.label.Code": "कोड",
    "setup.label.Description": "विवरण",
    "setup.label.PropertyCodeType": "प्रॉपर्टी कोड प्रकार",
    "setup.label.ReferenceValue": "संदर्भ मान",
    "setup.label.EditProperty": "संपत्ति संपादित करें",
    "setup.label.EditPropertyMaster": "प्रॉपर्टी मास्टर संपादित करें",
    "setup.label.Cancel": "रद्द करें",
    "setup.label.View": "देखें",
    "setup.label.Edit": "संपादित करें",
    "setup.label.Browse_file_to_Upload": "अपलोड करने के लिए फ़ाइल ब्राउज़ करें",
    "setup.label.CreatePropertyMaster": "प्रॉपर्टी मास्टर बनाएँ",
    "setup.label.Property": "संपत्ति",
    "setup.label.PropertyMaster": "प्रॉपर्टी मास्टर",
    "setup.label.ViewProperty": "संपत्ति देखें",
    "setup.label.ViewPropertyMaster": "प्रॉपर्टी मास्टर देखें",
    "setup.label.Are_you_sure_?": "क्या आप सुनिश्चित हैं?",
    "setup.label.Edit": "संपादित करें",
    "setup.label.Code": "कोड",
    "setup.label.Name": "नाम",
    "setup.label.AddState": "राज्य जोड़ें",
    "setup.label.AddDistrict": "जिला जोड़ें",
    "setup.label.AddCity": "शहर जोड़ें",
    "setup.label.EditCountry": "देश संपादित करें",
    "setup.label.EditState": "राज्य संपादित करें",
    "setup.label.EditDistrict": "जिला संपादित करें",
    "setup.label.EditCity": "शहर संपादित करें",
    "setup.label.DeleteCountry": "देश हटाएं",
    "setup.label.DeleteState": "राज्य हटाएं",
    "setup.label.DeleteDistrict": "जिला हटाएं",
    "setup.label.DeleteCity": "शहर हटाएं",
    "setup.label.ServiceAvailablity": "सेवा उपलब्धता",
    "setup.label.EnterCountryCode": "देश कोड दर्ज करें",
    "setup.label.EnterCode": "कोड दर्ज करें",
    "setup.label.EnterName": "नाम दर्ज करें",
    "setup.label.Service_Availablity_for_the": "के लिए सेवा उपलब्धता",
    "setup.label.SelectServices": "सेवाएं चुनें",
    "setup.label.Select_One_or_More": "एक या अधिक चुनें",
    "setup.label.options_selected": "विकल्प चयनित",
    "setup.label.PromotionName": "प्रमोशन का नाम",
    "setup.label.PromotionCode": "प्रमोशन कोड",
    "setup.label.BussinesType": "व्यवसाय प्रकार",
    "setup.label.OrderType": "ऑर्डर प्रकार",
    "setup.label.PaymentType": "भुगतान प्रकार",
    "setup.label.SelectCategory": "श्रेणी चुनें",
    "setup.label.PromotionTrigger": "प्रमोशन ट्रिगर",
    "setup.label.PromotionRule": "प्रमोशन नियम",
    "setup.label.PromotionTriggerCondition": "प्रमोशन ट्रिगर की शर्त",
    "setup.label.DiscountTriggerCondition": "डिस्काउंट ट्रिगर शर्त",
    "setup.label.DiscountRule": "डिस्काउंट नियम",
    "setup.label.DiscountTrigger": "डिस्काउंट ट्रिगर",
    "setup.label.EditTriggerCondition": "ट्रिगर शर्त संपादित करें",
    "setup.label.Rate": "दर",
    "setup.label.EditRule": "नियम संपादित करें",
    "setup.label.AddRate": "दर जोड़ें",
    "setup.label.Download": "डाउनलोड",
    "setup.label.Process": "प्रक्रिया",
    "setup.label.ViewVendor": "विक्रेता देखें",
    "setup.label.VendorCode": "विक्रेता कोड",
    "setup.label.VendorName": "विक्रेता नाम",
    "setup.label.select_Currency": "मुद्रा चुनें",
    "setup.label.select_Country": "देश चुनें",
    "setup.label.Filter_List": "सूची फ़िल्टर करें",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "क्या आप वाकई हटाना चाहते हैं?",
    "setup.label.DeleteVoucher": "वाउचर हटाएं",
    "setup.label.UpdatePin": "पिन अपडेट करें",
    "setup.label.UpdateVoucher": "वाउचर अपडेट करें",
    "setup.label.select_from_dropdown": "ड्रॉपडाउन से चुनें",
    "setup.label.ItemModel": "आइटम मॉडल",
    "setup.label.price": "मूल्य",
    "setup.label.Edit": "संपादित करें",
    "setup.label.Delete": "हटाएं",
    "setup.label.Item": "आइटम",
    "setup.label.EnterSupplierAddress": "आपूर्तिकर्ता का पता दर्ज करें",
    "setup.label.Title": "शीर्षक",
    "setup.label.AddPromotionTriggerCondition": "प्रचार ट्रिगर शर्त जोड़ें",
    "setup.label.EditPromotionTriggerCondition":
      "प्रचार ट्रिगर शर्त संपादित करें",
    "setup.label.AssignTo": "को सौंपें",
    "setup.label.Version": "संस्करण",
    "setup.label.IsOverride": "क्या अधिलेखित है",
    "setup.label.PlanAttribute": "योजना विशेषता",
    "setup.label.ValidationRule": "मान्यकरण नियम",
    "setup.label.SaveAndContinue": "सहेजें और जारी रखें",
    "setup.label.PlanManagement": "योजना प्रबंधन",
    "setup.label.Plan": "योजना",
    "setup.label.DiscountTriggerCondition": "छूट ट्रिगर शर्त",
    "setup.label.AddDiscountTriggerCondition": "छूट ट्रिगर शर्त जोड़ें",
    "setup.label.SalesChannel": "बिक्री चैनल",
    "setup.label.PaymentType": "भुगतान प्रकार",
    "setup.label.OrderType": "ऑर्डर प्रकार",
    "setup.label.BusinessType": "व्यवसाय प्रकार",
    "setup.label.ViewDigitalContent": "डिजिटल सामग्री देखें",
    "setup.label.EditDigitalContent": "डिजिटल सामग्री संपादित करें",
    "setup.label.AddDigitalContent": "डिजिटल सामग्री जोड़ें",
    "setup.label.PromotionRuleName": "प्रचार नियम का नाम",
    "setup.label.PromotionTriggerCondition": "प्रमोशन ट्रिगर की शर्त",
    "setup.label.AddPromotionTriggerCondition": "प्रमोशन ट्रिगर की शर्त जोड़ें",
    "setup.label.BussinesType": "व्यवसाय प्रकार",
    "setup.label.requestApproval": "अनुमोदन का अनुरोध करें",
    "setup.label.validity_uom": "वैधता की इकाई",
    "setup.label.validity_value": "वैधता मान",
    "setup.label.ViewItemModel": "आइटम मॉडल देखें",
    "setup.label.ItemType": "आइटम प्रकार",
    "setup.label.ViewSupplier": "आपूर्तिकर्ता देखें",
    "setup.label.SupplierCode": "आपूर्तिकर्ता कोड",
    "setup.label.SupplierDescription": "आपूर्तिकर्ता विवरण",
    "setup.label.SupplierAddress": "आपूर्तिकर्ता पता",
    "setup.label.DeleteSupplier": "आपूर्तिकर्ता हटाएं",
    "setup.label.CreateContract": "अनुबंध बनाएं",
    "setup.label.RateTierName": "दर स्तर का नाम",
    "setup.label.RangeType": "रेंज प्रकार",
    "setup.label.CreateDiscountRule": "छूट नियम बनाएं",
    "setup.label.RuleCondition": "नियम शर्त",
    "setup.label.CreateRuleCondition": "नियम शर्त बनाएँ",
    "setup.label.CreateRule": "नियम बनाएं",
    "setup.label.Entity": "इकाई",
    "setup.label.EntityField": "इकाई क्षेत्र",
    "setup.label.contentTag": "सामग्री टैग",
    "setup.label.contentTagValue": "सामग्री टैग मान",
    "setup.label.ExecutionType": "प्रवर्तन प्रकार",
    "setup.label.OperationMode": "ऑपरेशन मोड",
    "setup.label.AggregationType": "एकत्रीकरण प्रकार",
    "setup.label.DurationInDays": "अवधि (दिनों में)",
    "setup.label.CreateTicketTeamUser": "टिकट टीम उपयोगकर्ता बनाएं",
    "setup.label.termsConditions": "नियम एवं शर्तें",
    "setup.label.updateTermsConditions": "नियम एवं शर्तें अपडेट करें",
    "setup.label.updateDigitalContent": "डिजिटल सामग्री अपडेट करें",
    "setup.label.createDigitalContent": "डिजिटल सामग्री बनाएं",
    "setup.label.createTermsConditions": "नियम एवं शर्तें बनाएं",
    "setup.label.digitalContent": "डिजिटल सामग्री",
    "setup.label.planContent": "योजना सामग्री",
    "setup.label.selectPlanContent": "योजना सामग्री का चयन करें",
    "setup.label.FilterType": "फ़िल्टर प्रकार",
    "setup.label.FilterValue": "फ़िल्टर मान",
    "setup.label.ExternalPlanId": "बाहरी योजना आईडी",
    "setup.label.ExternalProductId": "बाहरी उत्पाद आईडी",
    "setup.label.ContractPeriod": "संविदा अवधि",
    "setup.label.AddContract": "अनुबंध जोड़ें",
    "setup.label.EditContract": "अनुबंध संपादित करें",
    "setup.label.ViewContract": "अनुबंध देखें",
    "setup.label.ContractType": "करार का प्रकार",
    "setup.label.ContractUnit": "अनुबंध इकाई",
    "setup.label.updateNetMask": "नेट मास्क अपडेट करें",
    "setup.label.Update": "अपडेट करें",
    "setup.label.BillType": "बिल का प्रकार",
    "setup.label.BillFrequency": "बिल की आवृत्ति",
    "setup.label.PlanEndDate": "योजना की समाप्ति तिथि",
    "setup.label.AddContent": "सामग्री जोड़ें",
    "setup.label.CreatePlanContent": "योजना सामग्री बनाएं",
    "setup.label.SelectLanguage": "भाषा चुनें",
    "setup.label.UploadDigitalImage": "डिजिटल छवि अपलोड करें",
    "setup.label.ViewPlanContent": "योजना सामग्री देखें",
    "setup.label.ExternalPlanName": "बाहरी योजना का नाम",
    "setup.label.ExternalProductName": "बाहरी उत्पाद का नाम",
    "setup.label.ViewPrice": "मूल्य देखें",
    "setup.label.SelectedPlanDiscounts": "चयनित योजना छूट,",
    "setup.label.ProductDiscount": "उत्पाद छूट,",
    "setup.label.PlanValidationRules": "योजना सत्यापन नियम",
    "setup.label.CreateValidationRule": "सत्यापन नियम बनाएं",
    "setup.label.EditValidationRule": "सत्यापन नियम संपादित करें",
    "setup.label.InputPlanId": "योजना आईडी दर्ज करें",
    "setup.label.CheckinPlanId": "सत्यापन योजना आईडी",
    "setup.label.RuleAppliesTo": "यूनिट",
    "setup.label.Rule": "नियम",
    "setup.label.ViewValidationRule": "व्यू वैलिडेशन नियम",
    "setup.label.ValidationRule": "वैलिडेशन नियम",
    "setup.label.createIpPool": "आईपी पूल बनाएं",
    "setup.label.editIpPool": "आईपी पूल संपादित करें",
    "setup.label.AddOrEditDiscount": "छूट जोड़ें/संपादित करें",
    "setup.label.Next": "अगला",
    "setup.label.MainCategory": "मुख्य श्रेणी",
    "setup.label.SubCategory": "उपश्रेणी",
    "setup.label.select_date": "तारीख चुनें",
    "setup.label.AddDiscountTrigger": "डिस्काउंट ट्रिगर जोड़ें",
    "setup.label.AddPromotionTrigger": "प्रमोशन ट्रिगर जोड़ें",
    "setup.label.edit_promotion_trigger": "प्रमोशन ट्रिगर संपादित करें",
    "setup.label.DiscountTrigger": "डिस्काउंट ट्रिगर",
    "setup.label.TriggerName": "ट्रिगर नाम",
    "setup.label.When": "कब",
    "setup.label.CustomerType": "ग्राहक प्रकार",
    "setup.label.Criteria": "मानदंड",
    "setup.label.Values": "मान",
    "setup.label.ApplicableTo": "लागू",
    "setup.label.ApplicableValues": "लागू मान",
    "setup.label.DiscountRulesAndRates": "डिस्काउंट नियम और दरें",
    "setup.label.RuleName": "नियम का नाम",
    "setup.label.MaxDiscount": "अधिकतम छूट",
    "setup.label.ResourceId": "संसाधन आईडी",
    "setup.label.DiscountRateType": "डिस्काउंट दर प्रकार",
    "setup.label.Unit": "इकाई",
    "setup.label.DiscountId": "डिस्काउंट आईडी",
    "setup.label.DiscountName": "डिस्काउंट नाम",
    "setup.label.Priority": "प्राथमिकता",
    "setup.label.Items": "आइटम",
    "setup.label.ItemCode": "आइटम कोड",
    "setup.label.ItemDescription": "आइटम विवरण",
    "setup.label.Units": "इकाइयाँ",
    "setup.label.Total": "कुल",
    "setup.label.Warranty": "वारंटी",
    "setup.label.UsedItems": "उपयुक्त आइटम",
    "setup.label.Balanced": "संतुलित",
    "setup.label.IsProvisioning": "प्रोविजनिंग है",
    "setup.label.CreateItem": "आइटम बनाएं",
    "setup.label.ItemClass": "आइटम वर्ग",
    "setup.label.ReorderLevel": "पुनरावृत्ति स्तर",
    "setup.label.WarrantyPeriod": "वारंटी अवधि",
    "setup.label.Currency": "मुद्रा",
    "setup.label.DefaultPrice": "डिफ़ॉल्ट मूल्य",
    "setup.label.IsSelector": "चयनकर्ता है",
    "setup.label.SelectorMenu": "चयनकर्ता मेनू",
    "setup.label.Selector": "चयनकर्ता",
    "setup.label.VariablePrice": "वेरिएबल मूल्य",
    "setup.label.ItemModel": "आइटम मॉडल",
    "setup.label.Price": "मूल्य",
    "setup.label.Action": "क्रिया",
    "setup.label.Cancel": "रद्द करें",
    "setup.label.planPrice": "योजना मूल्य",
    "setup.label.listview": "सूची दृश्य",
    "setup.label.Submit": "प्रस्तुत करें",
    "setup.label.EditItem": "आइटम संपादित करें",
    "setup.label.Id": "आईडी",
    "setup.label.ItemMasterId": "आइटम मास्टर आईडी",
    "setup.label.RegionId": "क्षेत्र आईडी",
    "setup.label.Edit": "संपादित करें",
    "setup.label.ViewItem": "आइटम देखें",
    "setup.label.UnitPrice": "यूनिट मूल्य",
    "setup.label.ItemModels": "आइटम मॉडल",
    "setup.label.NetworkElement": "नेटवर्क तत्व",
    "setup.label.Model": "मॉडल",
    "setup.label.Make": "बनाना",
    "setup.label.CreateItemModel": "आइटम मॉडल बनाएं",
    "setup.label.Reset": "रीसेट",
    "setup.label.EditItemModel": "आइटम मॉडल संपादित करें",
    "setup.label.ServiceCode": "सेवा कोड",
    "setup.label.ServiceDescription": "सेवा विवरण",
    "setup.label.ServiceType": "सेवा प्रकार",
    "setup.label.Isoptional": "वैकल्पिक है",
    "setup.label.Isautoprovision": "स्वचालित प्रावधान है",
    "setup.label.CreateService": "सेवा बनाएँ",
    "setup.label.Code": "कोड",
    "setup.label.Description": "विवरण",
    "setup.label.Type": "प्रकार",
    "setup.label.EditService": "सेवा संपादित करें",
    "setup.label.ServiceParameter": "सेवा पैरामीटर",
    "setup.label.ParamName": "पैरामीटर नाम",
    "setup.label.ParamType": "पैरामीटर प्रकार",
    "setup.label.ParamCategory": "पैरामीटर श्रेणी",
    "setup.label.ParamValue": "पैरामीटर मान",
    "setup.label.BB": "बीबी",
    "setup.label.Delete": "हटाएं",
    "setup.label.ServiceCategory": "सेवा श्रेणी",
    "setup.label.DeleteServices": "सेवाएँ हटाएं",
    "setup.label.Confirm": "पुष्टि करें",
    "setup.label.Service": "सेवा",
    "setup.label.Status": "स्थिति",
    "setup.label.Bouquet": "गुलदस्ता",
    "setup.label.Actions": "क्रियाएँ",
    "setup.label.CreateProduct": "उत्पाद बनाएँ",
    "setup.label.ProductParameter": "उत्पाद पैरामीटर",
    "setup.label.EditProduct": "उत्पाद संपादित करें",
    "setup.label.ProductDescription": "उत्पाद विवरण",
    "setup.label.ProductCategory": "उत्पाद श्रेणी",
    "setup.label.BroadcasterCode": "प्रसारक कोड",
    "setup.label.BroadcasterName": "प्रसारक का नाम",
    "setup.label.GstRegNumber": "GST पंजीकरण संख्या",
    "setup.label.ContactPerson": "संपर्क व्यक्ति",
    "setup.label.ContactMobile": "संपर्क मोबाइल",
    "setup.label.Email": "ईमेल",
    "setup.label.CreateBroadcaster": "प्रसारक बनाएं",
    "setup.label.Address": "पता",
    "setup.label.MobileNo": "मोबाइल नंबर",
    "setup.label.LandlineNo": "लैंडलाइन नंबर",
    "setup.label.EditBroadcaster": "प्रसारक संपादित करें",
    "setup.label.ChannelName": "चैनल का नाम",
    "setup.label.ChannelType": "चैनल प्रकार",
    "setup.label.DeleteBroadcaster": "प्रसारक हटाएं",
    "setup.label.ChannelCategory": "चैनल की श्रेणी",
    "setup.label.ChannelSequence": "चैनल क्रम",
    "setup.label.IsHdChannel": "एचडी चैनल है",
    "setup.label.CreateChannel": "चैनल बनाएं",
    "setup.label.Language": "भाषा",
    "setup.label.IsLocalChannel": "स्थानीय चैनल है",
    "setup.label.Genre": "शैली",
    "setup.label.BroadcasterId": "प्रसारक आईडी",
    "setup.label.EditChannel": "चैनल संपादित करें",
    "setup.label.DeleteChannel": "चैनल हटाएं",
    "setup.label.ProductMapping": "उत्पाद मैपिंग",
    "setup.label.CreateProductChannelMapping": "उत्पाद चैनल मैपिंग बनाएं",
    "setup.label.ProductId": "उत्पाद आईडी",
    "setup.label.AvailableChannels": "उपलब्ध चैनल",
    "setup.label.SelectedChannels": "चयनित चैनल",
    "setup.label.EditChannelMapping": "चैनल मैपिंग संपादित करें",
    "setup.label.PlanPricing": "योजना और मूल्य निर्धारण",
    "setup.label.CreatePlan": "योजना बनाएं",
    "setup.label.PlanCode": "योजना कोड",
    "setup.label.PlanDescription": "योजना विवरण",
    "setup.label.PlanStatus": "योजना की स्थिति",
    "setup.label.PlanProvisionSystem": "योजना प्रावधान प्रणाली",
    "setup.label.PlanStartDate": "योजना प्रारंभ तिथि",
    "setup.label.IsPrepaid": "प्रीपेड है",
    "setup.label.Duration": "अवधि",
    "setup.label.PlanType": "योजना का प्रकार",
    "setup.label.BillingRule": "बिलिंग नियम",
    "setup.label.EndDate": "समाप्ति तिथि",
    "setup.label.IsProvision": "प्रावधान है",
    "setup.label.EditPlan": "योजना संपादित करें",
    "setup.label.SelectProduct": "उत्पाद चुनें",
    "setup.label.ViewPlan": "योजना देखें",
    "setup.label.ProvisioningSystem": "प्रावधान प्रणाली",
    "setup.label.DeletePlan": "योजना हटाएं",
    "setup.label.Prices": "मूल्य",
    "setup.label.ChargeOwner": "शुल्क मालिक",
    "setup.label.DiscountCode": "डिस्काउंट कोड",
    "setup.label.PriceRegion": "मूल्य क्षेत्र",
    "setup.label.Resource": "संसाधन",
    "setup.label.SalesChannel": "बिक्री चैनल",
    "setup.label.OrderType": "आदेश प्रकार",
    "setup.label.BusinessType": "व्यापार के प्रकार",
    "setup.label.RoundingType": "गोलाई प्रकार",
    "setup.label.GLID": "जीएल आईडी",
    "setup.label.Value": "मूल्य",
    "setup.label.TemplateDefinition": "टेम्पलेट परिभाषा",
    "setup.label.CreateTemplateDefinition": "टेम्पलेट परिभाषा बनाएं",
    "setup.label.TemplateName": "टेम्पलेट नाम",
    "setup.label.Delimiter": "विभाजक",
    "setup.label.NumberOfFields": "क्षेत्रों की संख्या",
    "setup.label.HeaderRecorderType": "हेडर रिकॉर्डर प्रकार",
    "setup.label.EventRecordType": "घटना रिकॉर्ड प्रकार",
    "setup.label.ProductCode": "उत्पाद कोड",
    "setup.label.IsHeader": "हेडर है",
    "setup.label.FieldType": "क्षेत्र प्रकार",
    "setup.label.FieldName": "क्षेत्र का नाम",
    "setup.label.IdentifierType": "पहचानकर्ता प्रकार",
    "setup.label.Length": "लंबाई",
    "setup.label.ExistsTemplateDefinition": "मौजूदा टेम्पलेट परिभाषा",
    "setup.label.UOM(Unit Of measurement)": "UOM (मापन की इकाई)",
    "setup.label.CreateUOM": "UOM बनाएं",
    "setup.label.Name": "नाम",
    "setup.label.EditTemplateDefinition": "टेम्पलेट परिभाषा संपादित करें",
    "setup.label.EditUOM": "UOM संपादित करें",
    "setup.label.Save": "सहेजें",
    "setup.label.DeleteUOM": "UOM को हटाएं",
    "setup.label.Ok": "ठीक है",
    "setup.label.ViewUOM": "UOM देखें",
    "setup.label.RUM(RatableUsageMetric)": "RUM (रेटेबल उपयोग मैट्रिक)",
    "setup.label.CreateRUM": "RUM बनाएं",
    "setup.label.ChargeName": "शुल्क का नाम",
    "setup.label.Template Name": "टेम्पलेट का नाम",
    "setup.label.RumName": "Rum का नाम",
    "setup.label.RumExpression": "Rum अभिव्यक्ति",
    "setup.label.Operators": "ऑपरेटर्स",
    "setup.label.EditRUM": "RUM संपादित करें",
    "setup.label.ViewRUM": "RUM देखें",
    "setup.label.TimePeriod": "समय अवधि",
    "setup.label.CreateTimePeriod": "समय अवधि बनाएं",
    "setup.label.TimeModelName": "समय मॉडल का नाम",
    "setup.label.StartYear": "प्रारंभ वर्ष",
    "setup.label.EndYear": "अंत वर्ष",
    "setup.label.StartMonth": "प्रारंभ माह",
    "setup.label.EndMonth": "अंत माह",
    "setup.label.StartDay": "प्रारंभ दिन",
    "setup.label.EndDay": "अंत दिन",
    "setup.label.StartTime": "प्रारंभ समय",
    "setup.label.EndTime": "अंत समय",
    "setup.label.CreateTimeModel": "समय मॉडल बनाएं",
    "setup.label.ExpandAll / CollapseAll":
      "सभी विस्तृत करें / सभी संक्षिप्त करें",
    "setup.label.AddTimemodel": "समय मॉडल जोड़ें",
    "setup.label.UsageRatePlan": "उपयोग दर योजना",
    "setup.label.CreateUsageRatePlan": "उपयोग दर योजना बनाएं",
    "setup.label.PlanName": "योजना का नाम",
    "setup.label.ProductName": "उत्पाद का नाम",
    "setup.label.ChargeCode": "चार्ज कोड",
    "setup.label.TimemodelName": "समय मॉडल का नाम",
    "setup.label.ViewUsageRatePlan": "उपयोग दर योजना देखें",
    "setup.label.RUM": "रम",
    "setup.label.RatingType": "रेटिंग प्रकार",
    "setup.label.TimeModel": "समय मॉडल",
    "setup.label.ZoneModel": "जोन मॉडल",
    "setup.label.ViewQuantityTier": "मात्रा स्तर देखें",
    "setup.label.QuantityTier": "मात्रा स्तर",
    "setup.label.TierName": "स्तर का नाम",
    "setup.label.CumulativeResource": "संचयी संसाधन",
    "setup.label.TierRange": "स्तर सीमा",
    "setup.label.StepName": "चरण का नाम",
    "setup.label.StartRange": "प्रारंभ सीमा",
    "setup.label.EndRange": "अंत सीमा",
    "setup.label.AddQuantityTier": "मात्रा स्तर जोड़ें",
    "setup.label.NumberZone": "संख्या क्षेत्र",
    "setup.label.CreateNumberZone": "संख्या क्षेत्र बनाएं",
    "setup.label.SourceNumberPrefix": "स्रोत संख्या उपसर्ग",
    "setup.label.DestinationNumberPrefix": "गंतव्य संख्या उपसर्ग",
    "setup.label.ImpactCategory": "प्रभाव श्रेणी",
    "setup.label.Rank": "रैंक",
    "setup.label.APNZone": "APN क्षेत्र",
    "setup.label.APN": "APN",
    "setup.label.CreateAPNZone": "APN क्षेत्र बनाएं",
    "setup.label.OperatorZone": "ऑपरेटर क्षेत्र",
    "setup.label.CreateOperatorZone": "ऑपरेटर क्षेत्र बनाएं",
    "setup.label.SourceOperatorCode": "स्रोत ऑपरेटर कोड",
    "setup.label.DestinationOperatorCode": "गंतव्य ऑपरेटर कोड",
    "setup.label.ICZone": "IC क्षेत्र",
    "setup.label.IncomingTrunkid": "आने वाली ट्रंकआईडी",
    "setup.label.OutcomingTrunkid": "बाहर जाने वाली ट्रंकआईडी",
    "setup.label.CreateChargeCode": "शुल्क कोड बनाएं",
    "setup.label.ChargeDescription": "शुल्क विवरण",
    "setup.label.ChargeType": "शुल्क प्रकार",
    "setup.label.ChargeDuration": "शुल्क अवधि",
    "setup.label.DurationType": "अवधि प्रकार",
    "setup.label.TaxInclusive": "कर सम्मिलित",
    "setup.label.BillFrequencyCode": "बिल आवृत्ति कोड",
    "setup.label.TaxCode": "कर कोड",
    "setup.label.IsAggregate": "क्या संपूर्ण है",
    "setup.label.EditChargeCode": "शुल्क कोड संपादित करें",
    "setup.label.TaxMaster": "कर मास्टर",
    "setup.label.CreateTaxMaster": "कर मास्टर बनाएँ",
    "setup.label.GroupType": "समूह प्रकार",
    "setup.label.GroupCode": "समूह कोड",
    "setup.label.StartDate": "प्रारंभ तिथि",
    "setup.label.Rate": "दर",
    "setup.label.BaseTaxCode": "बेस टैक्स कोड",
    "setup.label.Jurisdiction": "अधिकार क्षेत्र",
    "setup.label.RateType": "दर प्रकार",
    "setup.label.Location": "जगह",
    "setup.label.DeleteTax": "कर हटाएं",
    "setup.label.CreateDiscount": "डिस्काउंट बनाएं",
    "setup.label.DiscountDescription": "डिस्काउंट विवरण",
    "setup.label.DiscountType": "डिस्काउंट प्रकार",
    "setup.label.DiscountRate": "डिस्काउंट दर",
    "setup.label.DiscountDetails": "डिस्काउंट विवरण",
    "setup.label.ClientCategory": "ग्राहक श्रेणी",
    "setup.label.CustomerCategory": "ग्राहक श्रेणी",
    "setup.label.EditDiscount": "डिस्काउंट संपादित करें",
    "setup.label.DeleteDiscount": "डिस्काउंट हटाएं",
    "setup.label.CreatePromotion": "प्रमोशन बनाएं",
    "setup.label.PromotionCode": "प्रमोशन कोड",
    "setup.label.PromotionName": "प्रमोशन का नाम",
    "setup.label.PromotionId": "प्रमोशन आईडी",
    "setup.label.PromotionDescription": "प्रमोशन विवरण",
    "setup.label.EditPromotionCode": "प्रमोशन कोड संपादित करें",
    "setup.label.ListOfDiscounts": "छूट की सूची",
    "setup.label.ListofTimePeriods": "समय अवधियों की सूची",
    "setup.label.CreatePriceRegion": "मूल्य क्षेत्र बनाएं",
    "setup.label.RegionCode": "क्षेत्र कोड",
    "setup.label.RegionName": "क्षेत्र का नाम",
    "setup.label.Country": "देश",
    "setup.label.States": "राज्य",
    "setup.label.EditPriceRegion": "मूल्य क्षेत्र संपादित करें",
    "setup.label.DeletePriceRegion": "मूल्य क्षेत्र हटाएं",
    "setup.label.CreateSalesCatalogue": "बिक्री सूची बनाएं",
    "setup.label.SalesCatalogueName": "बिक्री कैटलॉग का नाम",
    "setup.label.AssignUsers": "उपयोगकर्ताओं को असाइन करें",
    "setup.label.SalesPlanCategory": "बिक्री योजना श्रेणी",
    "setup.label.Plans": "योजनाएँ",
    "setup.label.EditSalesCatalogue": "बिक्री सूची संपादित करें",
    "setup.label.DeleteSalesCatalogue": "बिक्री सूची हटाएं",
    "setup.label.UserId": "उपयोगकर्ता आईडी",
    "setup.label.UserName": "उपयोगकर्ता नाम",
    "setup.label.CreateUsersCatalogue": "उपयोगकर्ता सूची बनाएं",
    "setup.label.Catalogue": "सूची",
    "setup.label.EditUserCatalogue": "उपयोगकर्ता सूची संपादित करें",
    "setup.label.VoucherPins": "वाउचर पिन",
    "setup.label.CreateVoucherPins": "वाउचर पिन बनाएँ",
    "setup.label.Voucher": "वाउचर",
    "setup.label.Coupon": "कूपन",
    "setup.label.LCO": "एलसीओ",
    "setup.label.LengthOfPins": "पिन की लंबाई",
    "setup.label.SerialNoLength": "सीरियल नंबर की लंबाई",
    "setup.label.NumberValue ": "संख्यात्मक मान",
    "setup.label.PinValue ": "पिन मान",
    "setup.label.BatchName": "बैच का नाम",
    "setup.label.PinCategory": "पिन श्रेणी",
    "setup.label.BeginWith": "से प्रारंभ",
    "setup.label.Quantity": "मात्रा",
    "setup.label.PinType": "पिन प्रकार",
    "setup.label.SIMNumbers": "सिम नंबर",
    "setup.label.CreateSIMNumber": "सिम नंबर बनाएँ",
    "setup.label.NumberCategory": "नंबर श्रेणी",
    "setup.label.ExpiryDate": "समाप्ति तिथि",
    "setup.label.Partner": "साझेदार",
    "setup.label.LengthofNumber": "नंबर की लंबाई",
    "setup.label.LengthofSerialNumber": "सीरियल नंबर की लंबाई",
    "setup.label.NumberType": "नंबर प्रकार",
    "setup.label.Product": "उत्पाद",
    "setup.label.Supplier": "आपूर्तिकर्ता",
    "setup.label.CreateSupplier": "आपूर्तिकर्ता बनाएँ",
    "setup.label.EditSupplier": "आपूर्तिकर्ता संपादित करें",
    "setup.label.AddressMaster": "मुख्य पता",
    "setup.label.CountryName": "देश का नाम",
    "setup.label.StateName": "राज्य का नाम",
    "setup.label.DistrictName": "जिले का नाम",
    "setup.label.CityName": "शहर का नाम",
    "setup.label.TreeView": "वृक्ष दृश्य",
    "setup.label.AddCountry": "देश जोड़ें",
    "setup.label.CountryCode": "देश कोड",
    "setup.label.TeamHead": "टीम प्रमुख",
    "setup.label.CreateTicketTeam": "टिकट टीम बनाएं",
    "setup.label.TeamCode": "टीम कोड",
    "setup.label.TeamDescription": "टीम विवरण",
    "setup.label.TeamCategory": "टीम श्रेणी",
    "setup.label.CreateTicketTeamUsers": "टिकट टीम उपयोगकर्ता बनाएं",
    "setup.label.TeamEmail": "टीम ईमेल",
    "setup.label.AvailableUsers": "उपलब्ध उपयोगकर्ता",
    "setup.label.SelectedUsers": "चयनित उपयोगकर्ता",
    "setup.label.TeamId": "टीम आईडी",
    "setup.label.ViewTeam": "टीम देखें",
    "setup.label.DeleteTeam": "टीम हटाएं",
    "setup.label.EditTicketTeam": "टिकट टीम संपादित करें",
    "setup.label.TeamUser": "टीम उपयोगकर्ता",
    "setup.label.EditTicketUsers": "टिकट उपयोगकर्ता संपादित करें",
    "setup.label.DeleteTeamUser": "टीम उपयोगकर्ता हटाएं",
    "setup.label.VendorManagement": "विक्रेता प्रबंधन",
    "setup.label.CreateVendor": "विक्रेता बनाएँ",
    "setup.label.ContactName": "संपर्क नाम",
    "setup.label.Mobile": "मोबाइल",
    "setup.label.Landline": "लैंडलाइन",
    "setup.label.CreateNewVendor": "नया विक्रेता बनाएँ",
    "setup.label.EditVendor": "विक्रेता संपादित करें",
    "setup.label.FeeMaster": "शुल्क मास्टर",
    "setup.label.CreateFeeMaster": "शुल्क मास्टर बनाएं",
    "setup.label.FeeMasterCode": "शुल्क मास्टर कोड",
    "setup.label.FeeMasterDescription": "शुल्क मास्टर विवरण",
    "setup.label.FeeMasterTransactionType": "शुल्क मास्टर लेनदेन प्रकार",
    "setup.label.VariablePricing": "परिवर्तनीय मूल्य निर्धारण",
    "setup.label.Regions": "क्षेत्र",
    "setup.label.Amount": "राशि",
    "setup.label.EditFeeMaster": "शुल्क मास्टर संपादित करें",
    "setup.label.ManageMessage": "संदेश प्रबंधित करें",
    "setup.label.AddMessage": "संदेश जोड़ें",
    "setup.label.TemplateDescription": "टेम्पलेट विवरण",
    "setup.label.Subject": "विषय",
    "setup.label.MessageType": "संदेश प्रकार",
    "setup.label.Header": "हेडर",
    "setup.label.Body": "बॉडी",
    "setup.label.Footer": "फुटर",
    "setup.label.CreateMessageTemplate": "संदेश टेम्पलेट बनाएं",
    "setup.label.MessageParams": "संदेश पैरामीटर",
    "setup.label.Parameter": "पैरामीटर",
    "setup.label.Params": "पैरामीटर",
    "setup.label.DeleteMessage": "संदेश हटाएं",
    "setup.label.EditMessage": "संदेश संपादित करें",
    "setup.label.GroupsDetails": "समूह विवरण",
    "setup.label.GroupName": "समूह का नाम",
    "setup.label.GroupAddress": "समूह का पता",
    "setup.label.CountNo's": "संख्या गिनें",
    "setup.label.AddGroup": "समूह जोड़ें",
    "setup.label.AdditionalInformation": "अतिरिक्त जानकारी",
    "setup.label.GroupCIR": "समूह CIR",
    "setup.label.DIR": "DIR",
    "setup.label.MemberCIR": "सदस्य CIR",
    "setup.label.IpPoolManagement": "आईपी पूल प्रबंधन",
    "setup.label.UpdateNetMask": "नेट मास्क अपडेट करें",
    "setup.label.IpAddress": "आईपी पता",
    "setup.label.NetMark": "नेट मार्क",
    "setup.label.IpType": "आईपी प्रकार",
    "setup.label.CoustomerId": "ग्राहक आईडी",
    "setup.label.CustomerName": "ग्राहक का नाम",
    "setup.label.Notes": "नोट्स",
    "setup.label.Subnet": "उप-नेट",
    "setup.label.DetailsOfMedia": "मीडिया का विवरण",
    "setup.label.Media": "मीडिया",
    "setup.label.AddMedia": "मीडिया जोड़ें",
    "setup.label.MediaTitle": "मीडिया शीर्षक",
    "setup.label.MediaCatagory": "मीडिया श्रेणी",
    "setup.label.ContentProvider": "सामग्री प्रदाता",
    "setup.label.Share": "शेयर(%)",
    "setup.label.AddMediaDetails": "मीडिया विवरण जोड़ें",
    "setup.label.MediaLocation": "मीडिया स्थान",
    "setup.label.SelectMediaCategory": "मीडिया श्रेणी चुनें",
    "setup.label.Movies": "फिल्में",
    "setup.label.ViewMedia": "मीडिया देखें",
    "setup.label.EditMedia": "मीडिया संपादित करें",
    "setup.label.MediaAttributes": "मीडिया गुण",
    "setup.label.Cast": "कलाकार",
    "setup.label.AttributeType": "गुण प्रकार",
    "setup.label.CaptionValue": "कैप्शन मान",
    "setup.label.NickName": "उपनाम",
    "setup.label.Image": "छवि",
    "setup.label.AddMediaLocations": "मीडिया स्थान जोड़ें",
    "setup.label.LanguageData": "भाषा डेटा",
    "setup.label.FormatData": "स्वरूप डेटा",
    "setup.label.MediaLocations": "मीडिया स्थान",
    "setup.label.DetailsOfEvent": "इवेंट का विवरण",
    "setup.label.EventName": "इवेंट का नाम",
    "setup.label.EventCode": "इवेंट कोड",
    "setup.label.SelectedMediaService": "चयनित मीडिया सेवा",
    "setup.label.AvailableMedia": "उपलब्ध मीडिया",
    "setup.label.EventDescription": "इवेंट का विवरण",
    "setup.label.EventCategory": "इवेंट श्रेणी",
    "setup.label.CreateEvent": "इवेंट बनाएं",
    "setup.label.DetailsOfProperty": "संपत्ति का विवरण",
    "setup.label.PropertyCode": "संपत्ति कोड",
    "setup.label.PropertyType": "संपत्ति का प्रकार",
    "setup.label.Parcel": "पार्सल",
    "setup.label.BuildingCode": "बिल्डिंग कोड",
    "setup.label.Precinct": "प्रिसिंक्ट",
    "setup.label.Allocated": "आवंटित",
    "setup.label.UploadPropertyData": "संपत्ति डेटा अपलोड करें",
    "setup.label.Clear": "साफ करें",
    "setup.label.CreateProperty": "संपत्ति बनाएं",
    "setup.label.PropertyDataUpload": "संपत्ति डेटा अपलोड करें",
    "setup.label.Street": "सड़क",
    "setup.label.PaymentType": "भुगतान का प्रकार",
    "setup.label.PoBox": "पीओ बॉक्स",
    "setup.label.State": "राज्य",
    "setup.label.District": "ज़िला",
    "setup.label.Floor": "मंज़िल",
    "setup.label.LimitCode": "सीमा कोड",
    "setup.label.PropertyMaster": "संपत्ति मास्टर",
    "setup.label.CodeDescription": "कोड विवरण",
    "setup.label.ReferenceValue": "संदर्भ मूल्य",
    "setup.label.Services": "सेवाएं",
    "setup.label.IsBouquet": "बुके है",
    "setup.label.Broadcaster": "प्रसारक",
    "setup.label.Channel": "चैनल",
    "setup.label.ContactNumber": "संपर्क नंबर",
    "setup.label.UOM": "मात्रक",
    "setup.label.DeleteTemplateDefinition": "टेम्पलेट परिभाषा हटाएं",
    "setup.label.Discount": "छूट",
    "setup.label.SalseCatalogue": "विक्रय सूची",
    "setup.label.UserCatalogue": "उपयोगकर्ता सूची",
    "setup.label.Team": "टीम",
    "setup.label.MediaDetails": "मीडिया विवरण",
    "setup.label.Event": "घटना",
    "setup.label.Properties": "गुण",
    "setup.label.ServicesProducts": "सेवाएं और उत्पाद",
    "setup.label.BroadcasterChannelMapping": "प्रसारक, चैनल और मैपिंग",
    "setup.label.UsageRating": "उपयोग रेटिंग",
    "setup.label.ZoneSetup": "क्षेत्र सेटअप",
    "setup.label.Promotion": "प्रचार",
    "setup.label.PromotionTrigger": "प्रमोशन ट्रिगर",
    "setup.label.PromotionRulesAndRates": "पदोन्नति नियम और दरें",
    "setup.label.CatalogeMapping": "कैटलॉग मैपिंग",
    "setup.label.VoucherPin": "वाउचर पिन",
    "setup.label.SIMNumber": "सिम नंबर",
    "setup.label.TeamTeamUser": "टीम और टीम उपयोगकर्ता",
    "setup.label.MessageTemplate": "संदेश टेम्पलेट",
    "setup.label.ClosedUserGroup": "बंद उपयोगकर्ता समूह",
    "setup.label.IpManagement": "आईपी प्रबंधन",
    "setup.label.PropertyDefinition": "संपत्ति परिभाषा",
    "setup.label.PriorityMapping": "प्राथमिकता मानचित्रण",
    "setup.label.AddProducts": "उत्पाद जोड़ें",
    "setup.label.AddDiscount": "छूट जोड़ें",
    "setup.label.Products": "उत्पाद",
    "setup.label.ChargeCodeData": "चार्ज कोड डेटा",
    "setup.label.TaxMapping": "कर मैपिंग",
    "setup.label.TaxRegion": "कर क्षेत्र",
    "setup.label.CreateUserCatalogue": "उपयोगकर्ता कैटलॉग बनाएँ",
    "setup.label.IcZone": "Ic ज़ोन",
    "setup.label.ViewIcZone": "Ic ज़ोन देखें",
    "setup.label.ViewNumberZone": "नंबर ज़ोन देखें",
    "setup.label.EditNumberZone": "नंबर ज़ोन संपादित करें",
    "setup.label.DeleteNumberZone": "नंबर ज़ोन हटाएं",
    "setup.label.AreYouSure": "क्या आप निश्चित हैं?",
    "setup.label.ViewAPNZone": "APN ज़ोन देखें",
    "setup.label.EditAPNZone": "APN ज़ोन संपादित करें",
    "setup.label.DeleteAPNZone": "APN ज़ोन हटाएं",
    "setup.label.ViewOperatorZone": "ऑपरेटर ज़ोन देखें",
    "setup.label.EditOperatorZone": "ऑपरेटर ज़ोन संपादित करें",
    "setup.label.CreateICZone": "IC ज़ोन बनाएँ",
    "setup.label.EditICZone": "IC ज़ोन संपादित करें",
    "setup.label.DeleteOperatorZone": "ऑपरेटर ज़ोन हटाएं",
    "setup.label.DeleteIcZone": "IC ज़ोन हटाएं",
    "setup.label.MobileNumber": "मोबाइल नंबर",
    "setup.label.LandlineNumber": "लैंडलाइन नंबर (वैकल्पिक)",
    "setup.label.RatePlanName": "दर योजना का नाम",
    "setup.label.UsageRateBalance": "उपयोग दर शेष",
    "setup.label.ValidityType": "वैधता प्रकार",
    "setup.label.ListOfRateTires": "रेट टायरों की सूची",
    "setup.label.Validity": "वैधता",
    "setup.label.CreatePlanName": "योजना का नाम बनाएं",
    "setup.label.EditPlanContent": "योजना सामग्री संपादित करें",
    "setup.label.CreatePlanDescription": "योजना विवरण बनाएं",
    "setup.label.ContentType": "सामग्री प्रकार",
    "setup.label.CreateFeatureList": "विशेषता सूची बनाएं",
    "setup.label.Area": "क्षेत्र",
    "setup.label.TaxPercentage": "कर प्रतिशत",
    "setup.label.Add": "जोड़ें",
    "setup.label.Remove": "निकालना",
    "setup.label.CreateVoucherPin": "वाउचर पिन बनाएं",
    "setup.label.EditSubCategory": "उपश्रेणी संपादित करें",
    "setup.label.CreateSubCategory": "उपश्रेणी बनाएं",
    "setup.label.ViewSubCategory": "उप श्रेणी देखें",
    "setup.label.TimeTaken": "समय लिया",
    "setup.label.TeamMapping": "टीम मानचित्रण",
    "setup.label.CreateTeamMapping": "टीम मानचित्रण बनाएँ",
    "setup.label.Category": "श्रेणी",
    "setup.label.external_promotional_code": "बाहरी प्रचार कोड",
    "setup.label.Subcategory": "उपश्रेणी",
    "setup.label.DeleteItemMapping": "आइटम मानचित्रण हटाएं",
    "setup.label.EditTeamMapping": "टीम मानचित्रण संपादित करें",
    "setup.label.ViewTeamMapping": "टीम मानचित्रण देखें",
    "setup.label.DeletePriorityMapping": "प्राथमिकता मानचित्रण हटाएं",
    "setup.label.discount_rule": "छूट नियम",
    "setup.label.promotion_rule": "पदोन्नति नियम",
    "setup.label.discount_rate": "छूट दर",
    "setup.label.create_discount_rule": "छूट नियम बनाएं",
    "setup.label.edit_promotion_rule": "पदोन्नति नियम संपादित करें",
    "setup.label.create_promotion_rule": "प्रमोशन नियम बनाएं",
    "setup.label.create_discount_rate": "छूट दर बनाएं",
    "setup.label.add_discount_rate": "छूट दर जोड़ें",
    "setup.label.add_promotion_rate": "प्रमोशन दर जोड़ें",
    "setup.label.edit_discount": "छूट संपादित करें",
    "setup.label.edit_promotion": "प्रचार संपादित करें",
    "setup.label.edit_discount_trigger": "छूट ट्रिगर संपादित करें",
    "setup.label.edit_discount_rule": "छूट नियम संपादित करें",
    "setup.label.collection_process": "संग्रह प्रक्रिया",
    "setup.label.create_collection_profile": "संग्रह प्रोफ़ाइल बनाएँ",
    "setup.label.collection_profile": "संग्रह प्रोफ़ाइल",
    "setup.label.collection_profile_id": "संग्रह प्रोफ़ाइल आईडी",
    "setup.label.region": "क्षेत्र",
    "setup.label.collection": "संग्रह",
    "setup.label.collection_trigger": "संग्रह ट्रिगर",
    "setup.label.collection_scenario": "संग्रह परिदृश्य",
    "setup.label.add_collection_trigger": "संग्रह ट्रिगर जोड़ें",
    "setup.label.add_collection_scenario": "संग्रह परिदृश्य जोड़ें",
    "setup.label.trigger_id": "ट्रिगर आईडी",
    "setup.label.criteria_type": "मानदंड प्रकार",
    "setup.label.due_balance": "बकाया राशि",
    "setup.label.ageing_days": "वृद्धि के दिन",
    "setup.label.scenario_id": "परिदृश्य आईडी",
    "setup.label.action_name": "क्रिया का नाम",
    "setup.label.age": "उम्र",
    "setup.label.create_collection_trigger": "संग्रह ट्रिगर बनाएँ",
    "setup.label.create_collection_scenario": "संग्रह परिदृश्य बनाएँ",
    "setup.label.edit_collection_profile": "संग्रह प्रोफ़ाइल संपादित करें",
    "setup.label.edit_collection_trigger": "संग्रह ट्रिगर संपादित करें",
    "setup.label.edit_collection_scenario": "संग्रह परिदृश्य संपादित करें",
    "setup.label.SlaInHours": "घंटों में एस.एल.ए",
    "setup.label.contractduration": "अनुबंध अवधि",
    "setup.label.chargesperiodicity": "शुल्क की अवधि",
  },

  ka: {
    "setup.label.Enter_product_Description": "პროდუქტის აღწერის შეყვანა",
    "setup.label.FeedbackStatus": "გამოხმაურების სტატუსი",
    "setup.label.EnterCountryName": "ქვეყნის სახელის შეყვანა",
    "setup.label.location": "მდებარეობა",
    "setup.label.selectLocation": "მდებარეობის არჩევა",
    "setup.label.create_group_ticket": "ჯგუფის ბილეთის შექმნა",
    "setup.label.default": "ნაგულისხმები",
    "setup.label.customerFeedback": "კლიენტის გამოხმაურება",
    "setup.label.automation": "ავტომატიზაცია",
    "setup.label.automation_master": "ავტომატიზაციის მთავარი",
    "setup.label.create_automation": "ავტომატიზაციის შექმნა",
    "setup.label.edit_automation": "ავტომატიზაციის რედაქტირება",
    "setup.label.automation_detail": "ავტომატიზაციის დეტალები",
    "setup.label.automation_steps": "ავტომატიზაციის ნაბიჯები",
    "setup.label.add_automation_step": "ავტომატიზაციის ნაბიჯის დამატება",
    "setup.label.AutomationId": "ავტომატიზაციის ID",
    "setup.label.EntityName": "ერთეულის სახელი",
    "setup.label.EntityType": "ერთეულის ტიპი",
    "setup.label.WorkflowName": "სამუშაო პროცესის სახელი",
    "setup.label.CreateAutomationScenario": "ავტომატიზაციის სცენარის შექმნა",
    "setup.label.EditAutomationStep": "ავტომატიზაციის ნაბიჯის რედაქტირება",
    "setup.label.ActionType": "ქმედების ტიპი",
    "setup.label.ActionDetails": "ქმედების დეტალები",
    "setup.label.StepOrder": "ნაბიჯების თანმიმდევრობა",
    "setup.label.questionAnswerSet": "შეკითხვებისა და პასუხების ნაკრები",
    "setup.label.addQuestionSet": "შეკითხვის ნაკრების დამატება",
    "setup.label.EditQuestionSet": "შეკითხვის ნაკრების რედაქტირება",
    "setup.label.CategoryName": "კატეგორიის სახელი",
    "setup.label.SubCategoryName": "ქვეკატეგორიის სახელი",
    "setup.label.TotalQuestions": "სულ კითხვები",
    "setup.label.QuestionType": "შეკითხვის ტიპი",
    "setup.label.QuestionText": "შეკითხვის ტექსტი",
    "setup.label.CustomerFeedback": "კლიენტის გამოხმაურება",
    "setup.label.TicketId": "ბილეთის ID",
    "setup.label.LinkedAt": "დაკავშირებულია დროს",
    "setup.label.Remarks": "შენიშვნები",
    "setup.label.AddFeedback": "გამოხმაურების დამატება",
    "setup.label.PendingForApproval": "მოსათხოვარია დამტკიცება",
    "setup.label.user_availability": "მომხმარებლის ხელმისაწვდომობა",
    "setup.label.all_users_availability": "ყველა მომხმარებლის ხელმისაწვდომობა",
    "setup.label.create_user_availability":
      "მომხმარებლის ხელმისაწვდომობის შექმნა",
    "setup.label.edit_user_availability":
      "მომხმარებლის ხელმისაწვდომობის რედაქტირება",
    "setup.label.LeaveManagement": "დასვენების მართვა",
    "setup.label.CreateLeave": "დასვენების შექმნა",
    "setup.label.EditLeave": "დასვენების რედაქტირება",
    "setup.label.ViewLeave": "დასვენების ნახვა",
    "setup.label.AllUserLeaves": "მომხმარებელთა ყველა დასვენება",
    "setup.label.MyLeaves": "ჩემი დასვენებები",
    "setup.label.ConfigId": "კონფიგურაციის ID",
    "setup.label.view_user_availability": "მომხმარებლის ხელმისაწვდომობის ნახვა",
    "setup.label.unavailability_date": "მიუწვდომლობის თარიღი",
    "setup.label.start_time": "დაწყების დრო",
    "setup.label.end_time": "დასრულების დრო",
    "setup.label.my_availability": "ჩემი ხელმისაწვდომობა",
    "setup.label.user": "მომხმარებელი",
    "setup.label.EditShift": "ცვლის რედაქტირება",
    "setup.label.UserWorkingShift": "მომხმარებლის სამუშაო ცვლა",
    "setup.label.CreateUserWorkingShift": "მომხმარებლის სამუშაო ცვლის შექმნა",
    "setup.label.EditUserWorkingShift":
      "მომხმარებლის სამუშაო ცვლის რედაქტირება",
    "setup.label.ViewUserWorkingShift": "მომხმარებლის სამუშაო ცვლის ნახვა",
    "setup.label.TeamName": "გუნდის სახელი",
    "setup.label.Shift": "ცვლა",
    "setup.label.ShiftManagement": "ცვლების მართვა",
    "setup.label.CreateShift": "ცვლის შექმნა",
    "setup.label.ShiftName": "ცვლის სახელი",
    "setup.label.Session": "სესია",
    "setup.label.SessionType": "სესიის ტიპი",
    "setup.label.LeaveDetails": "დასვენების დეტალები",
    "setup.label.SessionStartTime": "სესიის დაწყების დრო",
    "setup.label.SessionEndTime": "სესიის დასრულების დრო",
    "setup.label.LeaveType": "დაკარგული დროის ტიპი",
    "setup.label.AddAnotherDate": "სხვა თარიღის დამატება",
    "setup.label.Apn_Zone": "APN ზონა",
    "setup.label.FeeMaster": "გადასახადის მმართველი",
    "setup.label.Number_Zone": "ნომრის ზონა",
    "setup.label.DeleteRUM": "RUM-ის წაშლა",
    "setup.label.Edit_TimeModel": "დროის მოდელის რედაქტირება",
    "setup.label.Edit_Year": "წლის რედაქტირება",
    "setup.label.scenario_name": "სცენარის სახელი",
    "setup.label.event_name": "אירონის სახელი",
    "setup.label.Edit_Month": "თვის რედაქტირება",
    "setup.label.Edit_Day": "დღის რედაქტირება",
    "setup.label.Edit_Time": "დროის რედაქტირება",
    "setup.label.Delete_TimeModel": "დროის მოდელის წაშლა",
    "setup.label.Delete_Year": "წლის წაშლა",
    "setup.label.Delete_Month": "თვის წაშლა",
    "setup.label.Delete_Day": "დღის წაშლა",
    "setup.label.Delete_Time": "დროის წაშლა",
    "setup.label.Are_you_sure_?": "დარწმუნებული ხარ?",
    "setup.label.Save": "შენახვა",
    "setup.label.TemplateDefinition": "შაბლონის განსაზღვრა",
    "setup.label.EditQuantityTier": "რაოდენობის დონის რედაქტირება",
    "setup.label.Usage_Rate_Balance": "გამოყენების ტარიფის ბალანსი",
    "setup.label.Template_Name": "შაბლონის სახელი",
    "setup.label.Delimiter": "გამყოფი სიმბოლო",
    "setup.label.Number_Of_Fields": "ველების რაოდენობა",
    "setup.label.Header_Recorder_Type": "სათაურის ჩანაწერის ტიპი",
    "setup.label.Event_Record_Type": "მოვლენის ჩანაწერის ტიპი",
    "setup.label.CreateUOM": "ზომის ერთეულის შექმნა",
    "setup.label.TimePeriod": "დროის პერიოდი",
    "setup.label.Usage_Rate_Plan": "გამოყენების ტარიფის გეგმა",
    "setup.label.TemplateDefinition": "შაბლონის აღწერა",
    "setup.label.CreateRUM": "RUM-ის შექმნა",
    "setup.label.CreateTimePeriod": "დროის პერიოდის შექმნა",
    "setup.label.TimemodelName": "დროის მოდელის სახელი",
    "setup.label.TimePeriodName": "დროის პერიოდის სახელი",
    "setup.label.StartYear": "დაწყების წელი",
    "setup.label.EndYear": "დასრულების წელი",
    "setup.label.UsageRatePlan": "გამოყენების ტარიფის გეგმა",
    "setup.label.Create_Usage_Rate_Plan": "გამოყენების ტარიფის გეგმის შექმნა",
    "setup.label.Id": "იდენტიფიკატორი",
    "setup.label.PlanName": "გეგმის სახელი",
    "setup.label.ProductName": "პროდუქტის სახელი",
    "setup.label.ChargeCode": "გადახდის კოდი",
    "setup.label.TimeModelName": "დროის მოდელის სახელი",
    "setup.label.RatingType": "შეფასების ტიპი",
    "setup.label.RumName": "RUM-ის სახელი",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "დარწმუნებული ხართ, რომ გსურთ წაშლა?",
    "setup.label.UOM": "ზომის ერთეული",
    "setup.label.RUM": "RUM",
    "setup.label.ImpactCategory": "ზემოქმედების კატეგორია",
    "setup.label.Resource": "რესურსი",
    "setup.label.GLID": "GLID",
    "setup.label.Unit": "ერთეული",
    "setup.label.Rate": "ტარიფი",
    "setup.label.Action": "მოქმედება",
    "setup.label.options_selected": "არჩეული ვარიანტები",
    "setup.label.UsageRateBalance": "გამოყენების ბალანსი",
    "setup.label.EndYear": "დასრულების წელი",
    "setup.label.StartMonth": "დაწყების თვე",
    "setup.label.EndMonth": "დასრულების თვე",
    "setup.label.StartDay": "დაწყების დღე",
    "setup.label.EndDay": "დასრულების დღე",
    "setup.label.StartTime": "დაწყების დრო",
    "setup.label.Time_Model_Name": "დროის მოდელის სახელი",
    "setup.label.model_includes_which_all_Bands_?":
      "რომელი ზოლებია შედგენილი მოდელში?",
    "setup.label.YearRestriction": "წლის შეზღუდვა",
    "setup.label.MonthRestriction": "თვის შეზღუდვა",
    "setup.label.DayRestriction": "დღის შეზღუდვა",
    "setup.label.TimeRestriction": "დროის შეზღუდვა",
    "setup.label.Code": "კოდი",
    "setup.label.Name": "სახელი",
    "setup.label.PriorityMapping": "პრიორიტეტების რუკა",
    "setup.label.AddJurisdiction": "იურისდიქციის დამატება",
    "setup.label.Are_you_sure_?": "დარწმუნებული ხარ?",
    "setup.label.Country": "ქვეყანა",
    "setup.label.State": "შტატი",
    "setup.label.District": "რაიონი",
    "setup.label.RateType": "გადასახადის ტიპი",
    "setup.label.Remove": "წაშლა",
    "setup.label.TaxMaster": "საგადასახადო მასტერი",
    "setup.label.Team": "გუნდი",
    "setup.label.Add": "დამატება",
    "setup.label.FeeMaster": "გადასახადის მმართველი",
    "setup.label.DeleteChargeCode": "წაშალეთ გადასახადის კოდი",
    "setup.label.SelectSearch": "აირჩიეთ ძიება",
    "setup.label.Select_Content_Tag_Value":
      "აირჩიეთ შიგთავსის ჭდის მნიშვნელობა",
    "setup.label.Plan_Content": "გეგმური შიგთავსი",
    "setup.label.Plan": "გეგმა",
    "setup.label.ProductPrice": "პროდუქტის ფასი",
    "setup.label.SelectedPromotions": "არჩეული აქციები",
    "setup.label.AvailablePromotions": "ხელმისაწვდომი აქციები",
    "setup.label.SelectType": "აირჩიეთ ტიპი",
    "setup.label.Type": "ტიპი",
    "setup.label.No_versions_available": "ვერსიები არ არის ხელმისაწვდომი",
    "setup.label.Version": "ვერსია",
    "setup.label.ListPrice": "სიის ფასი",
    "setup.label.SellingPrice": "გაყიდვის ფასი",
    "setup.label.EnterPlanDescription": "შეიყვანეთ გეგმის აღწერა",
    "setup.label.AddPrice": "ფასის დამატება",
    "setup.label.Save": "შენახვა",
    "setup.label.AddDiscount": "დამატება ფასდაკლების",
    "setup.label.AvailablePlans": "ხელმისაწვდომი გეგმები",
    "setup.label.SelectedPlans": "არჩეული გეგმები",
    "setup.label.PlanType": "გეგმის ტიპი",
    "setup.label.Plan_Start_Date": "გეგმის დაწყების თარიღი",
    "setup.label.Plan_End_Date": "გეგმის დასრულების თარიღი",
    "setup.label.Bill_Type": "ანგარიშის ტიპი",
    "setup.label.AttributeTypes": "ატრიბუტის ტიპები",
    "setup.label.Add": "დამატება",
    "setup.label.Select_Content_Tag": "შეარჩიეთ კონტენტის ტეგი",
    "setup.label.PlanName": "გეგმის სახელი",
    "setup.label.AvailableDiscounts": "ხელმისაწვდომი ფასდაკლებები",
    "setup.label.Search": "ძებნა...",
    "setup.label.MoveRight": "მარჯვენა მიმართულებით გადაადგილება",
    "setup.label.MoveLeft": "მარცხენა მიმართულებით გადაადგილება",
    "setup.label.SelectedDiscounts": "არჩეული ფასდაკლებები",
    "setup.label.SelectType": "აირჩიეთ ტიპი",
    "setup.label.SelectLanguage": "აირჩიეთ ენა",
    "setup.label.SelectContentTag": "აირჩიეთ შიგთავსის ტეგი",
    "setup.label.SelectContentTagValue": "აირჩიეთ ტეგის მნიშვნელობა",
    "setup.label.DigitalContent": "ციფრული შიგთავსი",
    "setup.label.Enter_Plan_Description": "შეიყვანეთ გეგმის აღწერა",
    "setup.label.DC_Rule": "DC წესი",
    "setup.label.PlanAttribute": "გეგმის ატრიბუტი",
    "setup.label.AdvanceView": "გაფართოებული ხედი",
    "setup.label.Update": "განახლება",
    "setup.label.ProductMapping": "პროდუქტის მიბმა",
    "setup.label.Service": "სერვისი",
    "setup.label.SubProducts": "ქვეპროდუქტები",
    "setup.label.Type": "ტიპი",
    "setup.label.EnterValue": "შეიყვანეთ მნიშვნელობა",
    "setup.label.PriceRegion": "ფასების რეგიონი",
    "setup.label.Enter_service_Description": "შეიყვანეთ სერვისის აღწერა",
    "setup.label.ParamName": "პარამეტრის სახელი",
    "setup.label.Category": "კატეგორია",
    "setup.label.Type": "ტიპი",
    "setup.label.EnterValue": "შეიყვანეთ მნიშვნელობა",
    "setup.label.SalesCatalogue": "გაყიდვების კატალოგი",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "დარწმუნებული ხართ, რომ გსურთ წაშლა?",
    "setup.label.Channel": "არხი",
    "setup.label.Broadcaster": "მაუწყებელი",
    "setup.label.AddPrice": "ფასის დამატება",
    "setup.label.DeleteMediaEvent": "მედია ღონისძიების წაშლა",
    "setup.label.AdvMedia": "სარეკლამო მედია",
    "setup.label.EditMedia": "მედიის რედაქტირება",
    "setup.label.AddEvent": "ღონისძიების დამატება",
    "setup.label.AddAttributes": "ატრიბუტების დამატება",
    "setup.label.AddLocation": "მდებარეობის დამატება",
    "setup.label.DeleteEvent": "ღონისძიების წაშლა",
    "setup.label.Are_you_sure_?": "დარწმუნებული ხართ?",
    "setup.label.Add": "დამატება",
    "setup.label.ViewEvent": "ღონისძიების ნახვა",
    "setup.label.Event": "ღონისძიება",
    "setup.label.RUM": "RUM",
    "setup.label.OptType": "ოპციის ტიპი",
    "setup.label.Currency": "ვალუტა",
    "setup.label.Amount": "თანხა",
    "setup.label.Add": "დამატება",
    "setup.label.Save": "შენახვა",
    "setup.label.AddDiscount": "ფასდაკლების დამატება",
    "setup.label.EnterEventCode": "შეიყვანეთ ღონისძიების კოდი",
    "setup.label.EnterEventDescription": "შეიყვანეთ ღონისძიების აღწერა",
    "setup.label.EventDescription": "ღონისძიების აღწერა",
    "setup.label.EventCategory": "ღონისძიების კატეგორია",
    "setup.label.ChargeCode": "დასაკისრი კოდი",
    "setup.label.SelectEventValidity": "აირჩიეთ ღონისძიების ვალიდურობა",
    "setup.label.EditEvent": "ღონისძიების რედაქტირება",
    "setup.label.UnitCode": "ერთეულის კოდი",
    "setup.label.MediaTitle": "მედიის სათაური",
    "setup.label.ContentProvider": "შინაარსის მომწოდებელი",
    "setup.label.MediaType": "მედიის ტიპი",
    "setup.label.Rated": "შეფასებული",
    "setup.label.MediaCategory": "მედიის კატეგორია",
    "setup.label.Rating": "რეიტინგი",
    "setup.label.Poster": "პოსტერი",
    "setup.label.Status": "სტატუსი",
    "setup.label.MovieDuration": "ფილმის ხანგრძლივობა",
    "setup.label.ReleaseDate": "გამოშვების თარიღი",
    "setup.label.Genre": "ჟანრი",
    "setup.label.Subject": "თემა",
    "setup.label.Overview": "მიმოხილვა",
    "setup.label.Share(%)": "წილი (%)",
    "setup.label.Cast": "მსახიობები",
    "setup.label.AttributeType": "ატრიბუტის ტიპი",
    "setup.label.CaptionValue": "სუბტიტრის მნიშვნელობა",
    "setup.label.NickName": "მეტსახელი",
    "setup.label.Image": "სურათი",
    "setup.label.Language": "ენა",
    "setup.label.Format": "ფორმატი",
    "setup.label.Location": "მდებარეობა",
    "setup.label.CustomerType": "მომხმარებლის ტიპი",
    "setup.label.FormatType": "ფორმატის ტიპი",
    "setup.label.DiscountCode": "ფასდაკლების კოდი",
    "setup.label.ReProcess": "გადამუშავება",
    "setup.label.Code": "კოდი",
    "setup.label.Description": "აღწერა",
    "setup.label.PropertyCodeType": "ქონების კოდის ტიპი",
    "setup.label.ReferenceValue": "საკვანძო მნიშვნელობა",
    "setup.label.EditProperty": "ქონების რედაქტირება",
    "setup.label.EditPropertyMaster": "მთავარი ქონების რედაქტირება",
    "setup.label.Cancel": "გაუქმება",
    "setup.label.View": "ნახვა",
    "setup.label.Edit": "რედაქტირება",
    "setup.label.Browse_file_to_Upload": "აირჩიეთ ფაილი ასატვირთად",
    "setup.label.CreatePropertyMaster": "მთავარი ქონების შექმნა",
    "setup.label.Property": "ქონება",
    "setup.label.PropertyMaster": "მთავარი ქონება",
    "setup.label.ViewProperty": "ქონების ნახვა",
    "setup.label.ViewPropertyMaster": "მთავარი ქონების ნახვა",
    "setup.label.Are_you_sure_?": "დარწმუნებული ხართ?",
    "setup.label.Edit": "რედაქტირება",
    "setup.label.Code": "კოდი",
    "setup.label.Name": "სახელი",
    "setup.label.AddState": "შეიყვანეთ შტატი",
    "setup.label.AddDistrict": "დაამატეთ რაიონი",
    "setup.label.AddCity": "დაამატეთ ქალაქი",
    "setup.label.EditCountry": "ქვეყნის რედაქტირება",
    "setup.label.EditState": "შტატის რედაქტირება",
    "setup.label.EditDistrict": "რაიონის რედაქტირება",
    "setup.label.EditCity": "ქალაქის რედაქტირება",
    "setup.label.DeleteCountry": "ქვეყნის წაშლა",
    "setup.label.DeleteState": "შტატის წაშლა",
    "setup.label.DeleteDistrict": "რაიონის წაშლა",
    "setup.label.DeleteCity": "ქალაქის წაშლა",
    "setup.label.ServiceAvailablity": "მომსახურების ხელმისაწვდომობა",
    "setup.label.EnterCountryCode": "შეიყვანეთ ქვეყნის კოდი",
    "setup.label.EnterCode": "შეიყვანეთ კოდი",
    "setup.label.EnterName": "შეიყვანეთ სახელი",
    "setup.label.Service_Availablity_for_the": "მომსახურების ხელმისაწვდომობა",
    "setup.label.SelectServices": "აირჩიეთ სერვისები",
    "setup.label.Select_One_or_More": "აირჩიეთ ერთი ან მეტი",
    "setup.label.options_selected": "არჩეული ვარიანტები",
    "setup.label.PromotionName": "აქციის სახელი",
    "setup.label.PromotionCode": "აქციის კოდი",
    "setup.label.BussinesType": "ბიზნესის ტიპი",
    "setup.label.OrderType": "შეკვეთის ტიპი",
    "setup.label.PaymentType": "გადახდის ტიპი",
    "setup.label.SelectCategory": "აირჩიეთ კატეგორია",
    "setup.label.PromotionTrigger": "აქციის გამშვები",
    "setup.label.PromotionRule": "აქციის წესი",
    "setup.label.PromotionTriggerCondition": "აქციის გამშვები პირობა",
    "setup.label.DiscountTriggerCondition": "ფასდაკლების მაწვევის პირობა",
    "setup.label.DiscountRule": "ფასდაკლების წესი",
    "setup.label.DiscountTrigger": "ფასდაკლების მაწვევი",
    "setup.label.EditTriggerCondition": "მაწვევის პირობის რედაქტირება",
    "setup.label.Rate": "ტარიფი",
    "setup.label.EditRule": "წესის რედაქტირება",
    "setup.label.AddRate": "ტარიფის დამატება",
    "setup.label.Download": "გადმოწერა",
    "setup.label.Process": "დამუშავება",
    "setup.label.ViewVendor": "მომწოდებლის ნახვა",
    "setup.label.VendorCode": "მომწოდებლის კოდი",
    "setup.label.VendorName": "მომწოდებლის სახელი",
    "setup.label.select_Currency": "აირჩიეთ ვალუტა",
    "setup.label.select_Country": "აირჩიეთ ქვეყანა",
    "setup.label.Filter_List": "სიის გაფილტვრა",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "დარწმუნებული ხართ, რომ გსურთ წაშლა?",
    "setup.label.DeleteVoucher": "ვაუჩერის წაშლა",
    "setup.label.UpdatePin": "პინის განახლება",
    "setup.label.UpdateVoucher": "ვაუჩერის განახლება",
    "setup.label.select_from_dropdown": "აირჩიეთ ჩამოსაშლელი მენიუდან",
    "setup.label.ItemModel": "ნივთის მოდელი",
    "setup.label.price": "ფასი",
    "setup.label.Edit": "რედაქტირება",
    "setup.label.Delete": "წაშლა",
    "setup.label.Item": "ნივთი",
    "setup.label.EnterSupplierAddress": "შეიყვანეთ მომწოდებლის მისამართი",
    "setup.label.Title": "სათაური",
    "setup.label.AddPromotionTriggerCondition":
      "დაამატეთ აქციის გაშვების პირობა",
    "setup.label.EditPromotionTriggerCondition":
      "შეცვალეთ აქციის გაშვების პირობა",
    "setup.label.AssignTo": "მინიჭება",
    "setup.label.Version": "ვერსია",
    "setup.label.IsOverride": "გადაფარვაა?",
    "setup.label.PlanAttribute": "გეგმური ატრიბუტი",
    "setup.label.ValidationRule": "ვერიფიკაციის წესი",
    "setup.label.SaveAndContinue": "შენახვა და გაგრძელება",
    "setup.label.PlanManagement": "გეგმების მართვა",
    "setup.label.Plan": "გეგმა",
    "setup.label.DiscountTriggerCondition": "ფასდაკლების გამშვები პირობა",
    "setup.label.AddDiscountTriggerCondition":
      "დაამატე ფასდაკლების გამშვები პირობა",
    "setup.label.SalesChannel": "გაყიდვების არხი",
    "setup.label.PaymentType": "გადახდის ტიპი",
    "setup.label.OrderType": "შეკვეთის ტიპი",
    "setup.label.BusinessType": "ბიზნესის ტიპი",
    "setup.label.ViewDigitalContent": "ციფრული შინაარსის ნახვა",
    "setup.label.EditDigitalContent": "ციფრული შინაარსის რედაქტირება",
    "setup.label.AddDigitalContent": "დაამატეთ ციფრული შიგთავსი",
    "setup.label.PromotionRuleName": "აქციის წესის სახელი",
    "setup.label.PromotionTriggerCondition": "პრომოციის ჩართვის პირობა",
    "setup.label.AddPromotionTriggerCondition":
      "დაამატეთ პრომოციის ჩართვის პირობა",
    "setup.label.BussinesType": "ბიზნესის ტიპი",
    "setup.label.requestApproval": "მოთხოვნა დასამტკიცებლად",
    "setup.label.validity_uom": "ვალიდურობის ერთეული",
    "setup.label.validity_value": "ვალიდურობის მნიშვნელობა",
    "setup.label.ViewItemModel": "ნახეთ ნივთის მოდელი",
    "setup.label.ItemType": "ნივთის ტიპი",
    "setup.label.ViewSupplier": "მომწოდებლის ნახვა",
    "setup.label.SupplierCode": "მომწოდებლის კოდი",
    "setup.label.SupplierDescription": "მომწოდებლის აღწერა",
    "setup.label.SupplierAddress": "მომწოდებლის მისამართი",
    "setup.label.DeleteSupplier": "მომწოდებლის წაშლა",
    "setup.label.CreateContract": "შეიქმნას კონტრაქტი",
    "setup.label.RateTierName": "შეაფასეთ დონის სახელი",
    "setup.label.RangeType": "დიაპაზონის ტიპი",
    "setup.label.CreateDiscountRule": "შექმენით ფასდაკლების წესი",
    "setup.label.RuleCondition": "წესის პირობა",
    "setup.label.CreateRuleCondition": "შექმენით წესის პირობა",
    "setup.label.CreateRule": "წესის შექმნა",
    "setup.label.Entity": "ერთეული",
    "setup.label.EntityField": "სუბიექტის ველი",
    "setup.label.contentTag": "შინაარსის წარწერა",
    "setup.label.contentTagValue": "შინაარსის წარწერის მნიშვნელობა",
    "setup.label.ExecutionType": "შესრულების ტიპი",
    "setup.label.OperationMode": "ოპერაციის რეჟიმი",
    "setup.label.AggregationType": "აგრეგაციის ტიპი",
    "setup.label.DurationInDays": "ხანგრძლივობა დღეებში",
    "setup.label.CreateTicketTeamUser": "ბილეთების გუნდის მომხმარებლის შექმნა",
    "setup.label.termsConditions": "წესები და პირობები",
    "setup.label.updateTermsConditions": "განაახლეთ წესები და პირობები",
    "setup.label.updateDigitalContent": "განაახლეთ ციფრული კონტენტი",
    "setup.label.createDigitalContent": "შექმენით ციფრული კონტენტი",
    "setup.label.createTermsConditions": "შექმენით წესები და პირობები",
    "setup.label.digitalContent": "ციფრული კონტენტი",
    "setup.label.planContent": "გეგმის შინაარსი",
    "setup.label.selectPlanContent": "აირჩიეთ გეგმის შინაარსი",
    "setup.label.FilterType": "ფილტრის ტიპი",
    "setup.label.FilterValue": "ფილტრის მნიშვნელობა",
    "setup.label.ContractPeriod": "Კონტრაქტის პერიოდი",
    "setup.label.AddContract": "ხელშეკრულების დამატება",
    "setup.label.EditContract": "ხელშეკრულების რედაქტირება",
    "setup.label.ViewContract": "კონტრაქტის ნახვა",
    "setup.label.ExternalPlanId": "გარე გეგმის ID",
    "setup.label.ExternalProductId": "გარე პროდუქტის ID",
    "setup.label.SelectedPlanDiscounts": "არჩეული გეგმის ფასდაკლებები,",
    "setup.label.ProductDiscount": "პროდუქტის ფასდაკლებები,",
    "setup.label.ContractType": "კონტრაქტის ტიპი",
    "setup.label.ContractUnit": "საკონტრაქტო განყოფილება",
    "setup.label.updateNetMask": "ನೆಟ್ ಮಾಸ್ಕ್ ನವೀಕರಿಸಿ",
    "setup.label.Update": "ನವೀಕರಿಸಿ",
    "setup.label.BillType": "გადასახდელის ტიპი",
    "setup.label.BillFrequency": "გადასახდელის სიხშირე",
    "setup.label.PlanEndDate": "გეგმის დასრულების თარიღი",
    "setup.label.AddContent": "შე追加内容",
    "setup.label.CreatePlanContent": "გეგმის შინაარსის შექმნა",
    "setup.label.SelectLanguage": "ენის არჩევა",
    "setup.label.UploadDigitalImage": "ციფრული გამოსახულების ატვირთვა",
    "setup.label.ViewPlanContent": "გეგმის შინაარსის ნახვა",
    "setup.label.ExternalPlanName": "გარე გეგმის სახელი",
    "setup.label.ExternalProductName": "გარე პროდუქტის სახელი",
    "setup.label.ViewPrice": "ფასის ნახვა",
    "setup.label.createIpPool": "IP ಪೂಲ್ ರಚಿಸಿ",
    "setup.label.editIpPool": "IP ಪೂಲ್ ಸಂಪಾದಿಸಿ",
    "setup.label.AddOrEditDiscount": "ფასდაკლების დამატება/რედაქტირება",
    "setup.label.Next": "ಮುಂದೆ",
    "setup.label.PlanValidationRules": "ಯೋಜನೆ ಮಾನ್ಯತೆ ನಿಯಮಗಳು",
    "setup.label.CreateValidationRule": "ಮಾನ್ಯತೆ ನಿಯಮ ರಚಿಸಿ",
    "setup.label.EditValidationRule": "ಮಾನ್ಯತೆ ನಿಯಮ ಸಂಪಾದಿಸಿ",
    "setup.label.InputPlanId": "ಯೋಜನೆ ಐಡಿ ನಮೂದಿಸಿ",
    "setup.label.CheckinPlanId": "ಯೋಜನೆ ಮಾನ್ಯತೆ ಐಡಿ",
    "setup.label.RuleAppliesTo": "ಯೂನಿಟ್",
    "setup.label.Rule": "ನಿಯಮ",
    "setup.label.ViewValidationRule": "ವೀಕ್ಷಣೆ ಮಾನ್ಯತೆ ನಿಯಮ",
    "setup.label.ValidationRule": "ಮಾನ್ಯತೆ ನಿಯಮ",
    "setup.label.MainCategory": "მთავარი კატეგორია",
    "setup.label.SubCategory": "ქვეკატეგორია",
    "setup.label.select_date": "ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    "setup.label.AddDiscountTrigger": "ರಿಯಾಯಿತಿ ಟ್ರಿಗರ್ ಸೇರಿಸಿ",
    "setup.label.AddPromotionTrigger": "სარეკლამო ტრიგერის დამატება",
    "setup.label.edit_promotion_trigger": "სარეკლამო ტრიგერის რედაქტირება",
    "setup.label.DiscountTrigger": "ರಿಯಾಯಿತಿ ಟ್ರಿಗರ್",
    "setup.label.TriggerName": "ಟ್ರಿಗರ್ ಹೆಸರು",
    "setup.label.When": "ಯಾವಾಗ",
    "setup.label.CustomerType": "ಗ್ರಾಹಕ ಪ್ರಕಾರ",
    "setup.label.Criteria": "ಮಾಪದಂಡಗಳು",
    "setup.label.Values": "ಮೌಲ್ಯಗಳು",
    "setup.label.ApplicableTo": "ಲಾಗುವಾದ",
    "setup.label.ApplicableValues": "ಲಾಗುವ ಮೌಲ್ಯಗಳು",
    "setup.label.DiscountRulesAndRates": "ರಿಯಾಯಿತಿ ನಿಯಮಗಳು ಮತ್ತು ದರಗಳು",
    "setup.label.RuleName": "ನಿಯಮದ ಹೆಸರು",
    "setup.label.MaxDiscount": "ಗರಿಷ್ಠ ರಿಯಾಯಿತಿ",
    "setup.label.ResourceId": "ಸಂಪತ್ತಿನ ಐಡಿ",
    "setup.label.DiscountRateType": "ರಿಯಾಯಿತಿ ದರ ಪ್ರಕಾರ",
    "setup.label.Unit": "ಘಟಕ",
    "setup.label.DiscountId": "ರಿಯಾಯಿತಿ ಐಡಿ",
    "setup.label.DiscountName": "ರಿಯಾಯಿತಿ ಹೆಸರು",
    "setup.label.Priority": "ಆದ್ಯತೆ",
    "setup.label.Items": "ნივთები",
    "setup.label.ItemCode": "ნივთის კოდი",
    "setup.label.ItemDescription": "ნივთის აღწერა",
    "setup.label.Units": "ერთეულები",
    "setup.label.Total": "სულ",
    "setup.label.Warranty": "გარანტია",
    "setup.label.UsedItems": "გამოყენებული ნივთები",
    "setup.label.Balanced": "საზოგადოებრივი",
    "setup.label.IsProvisioning": "არის პროვიზია",
    "setup.label.CreateItem": "ნივთის შექმნა",
    "setup.label.ItemClass": "ნივთის კლასი",
    "setup.label.ReorderLevel": "ხელოვნების დონე",
    "setup.label.WarrantyPeriod": "გარანტიის პერიოდი",
    "setup.label.Currency": "ვალუტა",
    "setup.label.DefaultPrice": "ნაგულისხმევი ფასი",
    "setup.label.IsSelector": "არის შერჩევარი",
    "setup.label.SelectorMenu": "შერჩევარის მენიუ",
    "setup.label.Selector": "შერჩევარი",
    "setup.label.VariablePrice": "საცვლებადი ფასი",
    "setup.label.ItemModel": "ნივთის მოდელი",
    "setup.label.Price": "ფასი",
    "setup.label.Action": "ქმედება",
    "setup.label.Cancel": "გაუქმება",
    "setup.label.planPrice": "გეგმის ფასი",
    "setup.label.listview": "სიის ხედი",
    "setup.label.Submit": "წარმოადგენეთ",
    "setup.label.EditItem": "ნივთის რედაქტირება",
    "setup.label.Id": "ID",
    "setup.label.ItemMasterId": "ნივთის მთავარი ID",
    "setup.label.RegionId": "რეგიონის ID",
    "setup.label.Edit": "რედაქტირება",
    "setup.label.ViewItem": "ნახვა ნივთი",
    "setup.label.UnitPrice": "ერთეულის ფასი",
    "setup.label.ItemModels": "ნივთის მოდელები",
    "setup.label.NetworkElement": "ქსელის ელემენტი",
    "setup.label.Model": "მოდელი",
    "setup.label.Make": "შექმნა",
    "setup.label.CreateItemModel": "ნივთის მოდელის შექმნა",
    "setup.label.Reset": "გადაყენება",
    "setup.label.EditItemModel": "ნივთის მოდელის რედაქტირება",
    "setup.label.ServiceCode": "სერვისის კოდი",
    "setup.label.ServiceDescription": "სერვისის აღწერა",
    "setup.label.ServiceType": "სერვისის ტიპი",
    "setup.label.Isoptional": "არის არჩევითი",
    "setup.label.Isautoprovision": "არის ავტომატური პროვიზია",
    "setup.label.CreateService": "შექმენით სერვისი",
    "setup.label.Code": "კოდი",
    "setup.label.Description": "აღწერა",
    "setup.label.Type": "ტიპი",
    "setup.label.EditService": "სერვისის რედაქტირება",
    "setup.label.ServiceParameter": "სერვისის პარამეტრი",
    "setup.label.ParamName": "პარამეტრის სახელი",
    "setup.label.ParamType": "პარამეტრის ტიპი",
    "setup.label.ParamCategory": "პარამეტრის კატეგორია",
    "setup.label.ParamValue": "პარამეტრის მნიშვნელობა",
    "setup.label.BB": "BB",
    "setup.label.Delete": "წაშლა",
    "setup.label.ServiceCategory": "სერვისის კატეგორია",
    "setup.label.DeleteServices": "სერვისების წაშლა",
    "setup.label.Confirm": "დადასტურება",
    "setup.label.Service": "სერვისი",
    "setup.label.Status": "სტატუსი",
    "setup.label.Bouquet": "ბუკეტი",
    "setup.label.Actions": "მოქმედებები",
    "setup.label.CreateProduct": "შექმენით პროდუქტი",
    "setup.label.ProductParameter": "პროდუქტის პარამეტრი",
    "setup.label.EditProduct": "პროდუქტის რედაქტირება",
    "setup.label.ProductDescription": "პროდუქტის აღწერა",
    "setup.label.ProductCategory": "პროდუქტის კატეგორია",
    "setup.label.BroadcasterCode": "მაუწყებლის კოდი",
    "setup.label.BroadcasterName": "მაუწყებლის სახელი",
    "setup.label.GstRegNumber": "GST რეგისტრაციის ნომერი",
    "setup.label.ContactPerson": "საკონტაქტო პირი",
    "setup.label.ContactMobile": "საკონტაქტო მობილური",
    "setup.label.Email": "ელ.ფოსტა",
    "setup.label.CreateBroadcaster": "მაუწყებლის შექმნა",
    "setup.label.Address": "მისამართი",
    "setup.label.MobileNo": "მობილური ნომერი",
    "setup.label.LandlineNo": "ლანდლაინ ნომერი",
    "setup.label.EditBroadcaster": "მაუწყებლის რედაქტირება",
    "setup.label.ChannelName": "არხის სახელი",
    "setup.label.ChannelType": "არხის ტიპი",
    "setup.label.DeleteBroadcaster": "მაუწყებლის წაშლა",
    "setup.label.ChannelCategory": "არხის კატეგორია",
    "setup.label.ChannelSequence": "არხის მიმდევრობა",
    "setup.label.IsHdChannel": "არის HD არხი",
    "setup.label.CreateChannel": "არხის შექმნა",
    "setup.label.Language": "ენა",
    "setup.label.IsLocalChannel": "ადგილობრივი არხი",
    "setup.label.Genre": "ჟანრი",
    "setup.label.BroadcasterId": "მაუწყებლის ID",
    "setup.label.EditChannel": "არხის რედაქტირება",
    "setup.label.DeleteChannel": "არხის წაშლა",
    "setup.label.ProductMapping": "პროდუქტის რუკა",
    "setup.label.CreateProductChannelMapping": "არხის რუკის შექმნა",
    "setup.label.ProductId": "პროდუქტის ID",
    "setup.label.AvailableChannels": "ხელმისაწვდომი არხები",
    "setup.label.SelectedChannels": "არჩეული არხები",
    "setup.label.EditChannelMapping": "არხის რუკის რედაქტირება",
    "setup.label.PlanPricing": "გეგმა და ფასები",
    "setup.label.CreatePlan": "გეგმის შექმნა",
    "setup.label.PlanCode": "გეგმის კოდი",
    "setup.label.PlanDescription": "გეგმის აღწერა",
    "setup.label.PlanStatus": "გეგმის სტატუსი",
    "setup.label.PlanProvisionSystem": "გეგმის უზრუნველყოფის სისტემა",
    "setup.label.PlanStartDate": "გეგმის დაწყების თარიღი",
    "setup.label.IsPrepaid": "წინასწარ გადახდილი",
    "setup.label.Duration": "ხანგრძლივობა",
    "setup.label.PlanType": "გეგმის ტიპი",
    "setup.label.BillingRule": "ბილინგის წესი",
    "setup.label.EndDate": "დასრულების თარიღი",
    "setup.label.IsProvision": "მოწოდებულია",
    "setup.label.EditPlan": "გეგმის რედაქტირება",
    "setup.label.SelectProduct": "პროდუქტის არჩევა",
    "setup.label.ViewPlan": "გეგმის ნახვა",
    "setup.label.ProvisioningSystem": "მომარაგების სისტემა",
    "setup.label.DeletePlan": "გეგმის წაშლა",
    "setup.label.Prices": "ფასები",
    "setup.label.ChargeOwner": "დასაგილების მფლობელი",
    "setup.label.DiscountCode": "ფასდაკლების კოდი",
    "setup.label.PriceRegion": "ფასების რეგიონი",
    "setup.label.Resource": "რესურსი",
    "setup.label.SalesChannel": "გაყიდვების არხი",
    "setup.label.OrderType": "შეკვეთის ტიპი",
    "setup.label.BusinessType": "ბიზნესის ტიპი",
    "setup.label.RoundingType": "მარგიანი ტიპი",
    "setup.label.GLID": "GL ID",
    "setup.label.Value": "მნიშვნელობა",
    "setup.label.TemplateDefinition": "შაბლონის განს",
    "setup.label.CreateTemplateDefinition": "შაბლონის განსაზღვრის შექმნა",
    "setup.label.TemplateName": "შაბლონის სახელი",
    "setup.label.Delimiter": "გამოყოფილება",
    "setup.label.NumberOfFields": "ველების რაოდენობა",
    "setup.label.HeaderRecorderType": "ჰედერის ჩაწერის ტიპი",
    "setup.label.EventRecordType": "ღონისძიების ჩაწერის ტიპი",
    "setup.label.ProductCode": "პროდუქტის კოდი",
    "setup.label.IsHeader": "სათაურია",
    "setup.label.FieldType": "ველის ტიპი",
    "setup.label.FieldName": "ველის სახელი",
    "setup.label.IdentifierType": "იდენტიფიკატორის ტიპი",
    "setup.label.Length": "სიგრძე",
    "setup.label.ExistsTemplateDefinition": "არსებული შაბლონის განსაზღვრა",
    "setup.label.UOM(Unit Of measurement)": "UOM (ერთეული განზომილება)",
    "setup.label.CreateUOM": "UOM-ის შექმნა",
    "setup.label.Name": "სახელი",
    "setup.label.EditTemplateDefinition": "შაბლონის განახლება",
    "setup.label.EditUOM": "UOM-ის განახლება",
    "setup.label.Save": "დამახსოვრება",
    "setup.label.DeleteUOM": "UOM-ის წაშლა",
    "setup.label.Ok": "კარგი",
    "setup.label.ViewUOM": "UOM-ის ნახვა",
    "setup.label.RUM(RatableUsageMetric)": "RUM (შენახავადი მეტრიკა)",
    "setup.label.CreateRUM": "შექმნა RUM",
    "setup.label.ChargeName": "დასახელება",
    "setup.label.Template Name": "თარგის დასახელება",
    "setup.label.RumName": "Rum-ის დასახელება",
    "setup.label.RumExpression": "Rum გამოსახულება",
    "setup.label.Operators": "Პერატორები",
    "setup.label.EditRUM": "RUM-ის რედაქტირება",
    "setup.label.ViewRUM": "RUM-ის ნახვა",
    "setup.label.TimePeriod": "დროის პერიოდი",
    "setup.label.CreateTimePeriod": "დროის პერიოდის შექმნა",
    "setup.label.TimeModelName": "დროის მოდელის სახელი",
    "setup.label.StartYear": "დაწყების წელი",
    "setup.label.EndYear": "დასრულების წელი",
    "setup.label.StartMonth": "დაწყების თვე",
    "setup.label.EndMonth": "დასრულების თვე",
    "setup.label.StartDay": "დაწყების დღე",
    "setup.label.EndDay": "დასრულების დღე",
    "setup.label.StartTime": "დაწყების დრო",
    "setup.label.EndTime": "დასრულების დრო",
    "setup.label.CreateTimeModel": "დროის მოდელის შექმნა",
    "setup.label.ExpandAll / CollapseAll": "ყველას გახსნა / ყველას დახურვა",
    "setup.label.AddTimemodel": "დროის მოდელის დამატება",
    "setup.label.UsageRatePlan": "გამოყენების ტარიფების გეგმა",
    "setup.label.CreateUsageRatePlan": "გამოყენების ტარიფების გეგმის შექმნა",
    "setup.label.PlanName": "გეგმის სახელი",
    "setup.label.ProductName": "პროდუქტის სახელი",
    "setup.label.TimemodelName": "დროის მოდელის სახელი",
    "setup.label.ViewUsageRatePlan": "გამოყენების ტარიფების გეგმის ნახვა",
    "setup.label.RUM": "RUM",
    "setup.label.RatingType": "რეიტინგის ტიპი",
    "setup.label.TimeModel": "დროის მოდელი",
    "setup.label.ZoneModel": "ზონის მოდელი",
    "setup.label.ViewQuantityTier": "მოცულობის დონის ნახვა",
    "setup.label.QuantityTier": "მოცულობის დონე",
    "setup.label.TierName": "დონის სახელი",
    "setup.label.CumulativeResource": "კუმულაციური რესურსი",
    "setup.label.TierRange": "დონის სპექტრი",
    "setup.label.StepName": "ნაბიჯის სახელი",
    "setup.label.StartRange": "დაწყების სპექტრი",
    "setup.label.EndRange": "დასრულების სპექტრი",
    "setup.label.AddQuantityTier": "დამატება რაოდენობის დონე",
    "setup.label.NumberZone": "ნომრის ზონა",
    "setup.label.CreateNumberZone": "ნომრის ზონის შექმნა",
    "setup.label.SourceNumberPrefix": "წყაროს ნომრის პრეფიქსი",
    "setup.label.DestinationNumberPrefix": "დანიშნულების ნომრის პრეფიქსი",
    "setup.label.ImpactCategory": "გავლენის კატეგორია",
    "setup.label.Rank": "რანგი",
    "setup.label.APNZone": "APN ზონა",
    "setup.label.APN": "APN",
    "setup.label.CreateAPNZone": "APN ზონის შექმნა",
    "setup.label.OperatorZone": "ოპერატორის ზონა",
    "setup.label.CreateOperatorZone": "ოპერატორის ზონის შექმნა",
    "setup.label.SourceOperatorCode": "წყაროს ოპერატორის კოდი",
    "setup.label.DestinationOperatorCode": "დანიშნულების ოპერატორის კოდი",
    "setup.label.ICZone": "IC ზონა",
    "setup.label.IncomingTrunkid": "შემომავალი Trunkid",
    "setup.label.OutcomingTrunkid": "გამავალი Trunkid",
    "setup.label.CreateChargeCode": "დაკისრების კოდის შექმნა",
    "setup.label.ChargeDescription": "დაკისრების აღწერა",
    "setup.label.ChargeType": "დაკისრების ტიპი",
    "setup.label.ChargeDuration": "დაკისრების ხანგრძლივობა",
    "setup.label.DurationType": "ხანგრძლივობის ტიპი",
    "setup.label.TaxInclusive": "ტექნიკური ჩართულია",
    "setup.label.BillFrequencyCode": "ბილ კოდის სიხშირე",
    "setup.label.TaxCode": "საგადასახადო კოდი",
    "setup.label.IsAggregate": "არის აგრეგატი",
    "setup.label.EditChargeCode": "დაკისრების კოდის რედაქტირება",
    "setup.label.TaxMaster": "საგადასახადო ოსტატი",
    "setup.label.CreateTaxMaster": "შექმენით საგადასახადო ოსტატი",
    "setup.label.GroupType": "ჯგუფის ტიპი",
    "setup.label.GroupCode": "ჯგუფის კოდი",
    "setup.label.StartDate": "დაწყების თარიღი",
    "setup.label.Rate": "შეფასება",
    "setup.label.BaseTaxCode": "საბაზო საგადასახადო კოდექსი",
    "setup.label.Jurisdiction": "იურისდიქცია",
    "setup.label.RateType": "შეფასების ტიპი",
    "setup.label.Location": "მდებარეობა",
    "setup.label.DeleteTax": "წაშალეთ გადასახადი",
    "setup.label.CreateDiscount": "ფასდაკლების შექმნა",
    "setup.label.DiscountDescription": "ფასდაკლების აღწერა",
    "setup.label.DiscountType": "ფასდაკლების ტიპი",
    "setup.label.DiscountRate": "ფასდაკლების განაკვეთი",
    "setup.label.DiscountDetails": "ფასდაკლების დეტალები",
    "setup.label.ClientCategory": "მომხმარებლის კატეგორია",
    "setup.label.CustomerCategory": "მომხმარებლის კატეგორია",
    "setup.label.EditDiscount": "ფასდაკლების რედაქტირება",
    "setup.label.DeleteDiscount": "ფასდაკლების წაშლა",
    "setup.label.CreatePromotion": "წახალისების შექმნა",
    "setup.label.PromotionCode": "წახალისების კოდი",
    "setup.label.PromotionName": "სარეკლამო სახელი",
    "setup.label.PromotionId": "დაწინაურების ID",
    "setup.label.PromotionDescription": "წახალისების აღწერა",
    "setup.label.EditPromotionCode": "წახალისების კოდის რედაქტირება",
    "setup.label.ListOfDiscounts": "ფასდაკლებების სია",
    "setup.label.ListofTimePeriods": "დროის პერიოდების სია",
    "setup.label.CreatePriceRegion": "შექმენით ფასის რეგიონი",
    "setup.label.RegionCode": "რეგიონის კოდი",
    "setup.label.RegionName": "რეგიონის სახელი",
    "setup.label.Country": "ქვეყანა",
    "setup.label.States": "შტატები",
    "setup.label.EditPriceRegion": "რედაქტირება ფასის რეგიონი",
    "setup.label.DeletePriceRegion": "წაშლა ფასის რეგიონი",
    "setup.label.CreateSalesCatalogue": "გაყიდვების კატალოგის შექმნა",
    "setup.label.SalesCatalogueName": "გაყიდვების კატალოგის სახელი",
    "setup.label.AssignUsers": "მომხმარებლების მინიჭება",
    "setup.label.SalesPlanCategory": "გაყიდვების გეგმის კატეგორია",
    "setup.label.Plans": "გეგმები",
    "setup.label.EditSalesCatalogue": "გაყიდვების კატალოგის რედაქტირება",
    "setup.label.DeleteSalesCatalogue": "გაყიდვების კატალოგის წაშლა",
    "setup.label.UserId": "მომხმარებლის ID",
    "setup.label.UserName": "მომხმარებლის სახელი",
    "setup.label.CreateUsersCatalogue": "მომხმარებლის კატალოგის შექმნა",
    "setup.label.Catalogue": "კატალოგი",
    "setup.label.EditUserCatalogue": "მომხმარებლის კატალოგის რედაქტირება",
    "setup.label.VoucherPins": "ვაუჩერის პინები",
    "setup.label.CreateVoucherPins": "შექმენით ვაუჩერის პინები",
    "setup.label.Voucher": "ვაუჩერი",
    "setup.label.Coupon": "კუპონი",
    "setup.label.LCO": "LCO",
    "setup.label.LengthOfPins": "პინების სიგრძე",
    "setup.label.SerialNoLength": "სერიული ნომრის სიგრძე",
    "setup.label.NumberValue ": "ნომერული მნიშვნელობა",
    "setup.label.PinValue ": "პინის მნიშვნელობა",
    "setup.label.BatchName": "პარტიის სახელი",
    "setup.label.PinCategory": "პინის კატეგორია",
    "setup.label.BeginWith": "დაიწყეთ",
    "setup.label.Quantity": "რაოდენობა",
    "setup.label.PinType": "პინის ტიპი",
    "setup.label.SIMNumbers": "SIM ნომრები",
    "setup.label.CreateSIMNumber": "შექმენით SIM ნომერი",
    "setup.label.NumberCategory": "ნომრის კატეგორია",
    "setup.label.ExpiryDate": "ვადის გასვლის თარიღი",
    "setup.label.Partner": "პარტნიორი",
    "setup.label.LengthofNumber": "ნომრის სიგრძე",
    "setup.label.LengthofSerialNumber": "სერიული ნომრის სიგრძე",
    "setup.label.NumberType": "ნომრის ტიპი",
    "setup.label.Product": "პროდუქტი",
    "setup.label.Supplier": "მომწოდებელი",
    "setup.label.CreateSupplier": "მომწოდებლის შექმნა",
    "setup.label.EditSupplier": "მომწოდებლის რედაქტირება",
    "setup.label.AddressMaster": "მისამართების მთავარი",
    "setup.label.CountryName": "ქვეყნის სახელი",
    "setup.label.StateName": "სახელმწიფოს სახელი",
    "setup.label.DistrictName": "რაიონის სახელი",
    "setup.label.CityName": "ქალაქის სახელი",
    "setup.label.TreeView": "ხის ხედვა",
    "setup.label.AddCountry": "ქვეყნის დამატება",
    "setup.label.CountryCode": "ქვეყნის კოდი",
    "setup.label.TeamHead": "ჯგუფის ხელმძღვანელი",
    "setup.label.CreateTicketTeam": "ბილეთის გუნდის შექმნა",
    "setup.label.TeamCode": "ჯგუფის კოდი",
    "setup.label.TeamDescription": "ჯგუფის აღწერა",
    "setup.label.TeamCategory": "ჯგუფის კატეგორია",
    "setup.label.CreateTicketTeamUsers": "ბილეთის გუნდის მომხმარებლების შექმნა",
    "setup.label.TeamEmail": "ჯგუფის ელფოსტა",
    "setup.label.AvailableUsers": "ხელმისაწვდომი მომხმარებლები",
    "setup.label.SelectedUsers": "არჩევული მომხმარებლები",
    "setup.label.TeamId": "ჯგუფის ID",
    "setup.label.ViewTeam": "ჯგუფის ნახვა",
    "setup.label.DeleteTeam": "ჯგუფის წაშლა",
    "setup.label.EditTicketTeam": "ბილეთის გუნდის რედაქტირება",
    "setup.label.TeamUser": "ჯგუფის მომხმარებელი",
    "setup.label.EditTicketUsers": "ბილეთის მომხმარებლების რედაქტირება",
    "setup.label.DeleteTeamUser": "ჯგუფის მომხმარებლის წაშლა",
    "setup.label.VendorManagement": "გამყიდველის მართვა",
    "setup.label.CreateVendor": "გამყიდველის შექმნა",
    "setup.label.ContactName": "საკონტაქტო სახელი",
    "setup.label.Mobile": "მობილური",
    "setup.label.Landline": "ქალაქური ტელეფონი",
    "setup.label.CreateNewVendor": "ახალი გამყიდველის შექმნა",
    "setup.label.EditVendor": "გამყიდველის რედაქტირება",
    "setup.label.FeeMaster": "საფასურის ოსტატი",
    "setup.label.CreateFeeMaster": "შექმენით საფასურის ოსტატი",
    "setup.label.FeeMasterCode": "საფასურის ოსტატის კოდი",
    "setup.label.FeeMasterDescription": "საფასურის ოსტატის აღწერა",
    "setup.label.FeeMasterTransactionType":
      "საფასურის ოსტატის ტრანზაქციის ტიპი",
    "setup.label.ChargeCode": "დაკისრების კოდი",
    "setup.label.VariablePricing": "ცვლადი ფასები",
    "setup.label.Regions": "რეგიონები",
    "setup.label.Amount": "თანხა",
    "setup.label.EditFeeMaster": "საფასურის ოსტატის რედაქტირება",
    "setup.label.ManageMessage": "მართეთ შეტყობინება",
    "setup.label.AddMessage": "შეტყობინების დამატება",
    "setup.label.TemplateDescription": "თარგის აღწერა",
    "setup.label.Subject": "საგანი",
    "setup.label.MessageType": "შეტყობინების ტიპი",
    "setup.label.Header": "სათაური",
    "setup.label.Body": "შიგთავსი",
    "setup.label.Footer": "ქვედა კოლონტიტული",
    "setup.label.CreateMessageTemplate": "შექმენით შეტყობინების თარგი",
    "setup.label.MessageParams": "შეტყობინების პარამეტრები",
    "setup.label.Parameter": "პარამეტრი",
    "setup.label.Params": "პარამეტრები",
    "setup.label.DeleteMessage": "შეტყობინების წაშლა",
    "setup.label.EditMessage": "შეტყობინების რედაქტირება",
    "setup.label.GroupsDetails": "ჯგუფების დეტალები",
    "setup.label.GroupName": "ჯგუფის სახელი",
    "setup.label.GroupAddress": "ჯგუფის მისამართი",
    "setup.label.CountNo's": "ნომრების რაოდენობა",
    "setup.label.AddGroup": "ჯგუფის დამატება",
    "setup.label.AdditionalInformation": "დამატებითი ინფორმაცია",
    "setup.label.GroupCIR": "ჯგუფის CIR",
    "setup.label.DIR": "DIR",
    "setup.label.MemberCIR": "წევრის CIR",
    "setup.label.IpPoolManagement": "IP აუზის მართვა",
    "setup.label.UpdateNetMask": "ქსელის ნიღბის განახლება",
    "setup.label.IpAddress": "IP მისამართი",
    "setup.label.NetMark": "ქსელის ნიშანი",
    "setup.label.IpType": "IP ტიპი",
    "setup.label.CoustomerId": "მომხმარებლის ID",
    "setup.label.CustomerName": "მომხმარებლის სახელი",
    "setup.label.Notes": "ಸೂಚನೆಗಳು",
    "setup.label.Subnet": "ქვე-ქსელი",
    "setup.label.DetailsOfMedia": "მედიის დეტალები",
    "setup.label.Media": "მედია",
    "setup.label.AddMedia": "მედიის დამატება",
    "setup.label.MediaTitle": "მედიის სათაური",
    "setup.label.MediaCatagory": "მედიის კატეგორია",
    "setup.label.ContentProvider": "შინაარსის მიმწოდებელი",
    "setup.label.Share": "გაზიარება(%)",
    "setup.label.AddMediaDetails": "მედიის დეტალების დამატება",
    "setup.label.MediaLocation": "მედიის მდებარეობა",
    "setup.label.SelectMediaCategory": "მედიის კატეგორიის არჩევა",
    "setup.label.Movies": "ფილმები",
    "setup.label.ViewMedia": "მედიის ნახვა",
    "setup.label.EditMedia": "მედიის რედაქტირება",
    "setup.label.MediaAttributes": "მედიის ატრიბუტები",
    "setup.label.Cast": "მსახიობები",
    "setup.label.AttributeType": "ატრიბუტის ტიპი",
    "setup.label.CaptionValue": "სათაურის მნიშვნელობა",
    "setup.label.NickName": "მეტსახელი",
    "setup.label.Image": "სურათი",
    "setup.label.AddMediaLocations": "მედიის ადგილმდებარეობის დამატება",
    "setup.label.LanguageData": "ენის მონაცემები",
    "setup.label.FormatData": "ფორმატის მონაცემები",
    "setup.label.MediaLocations": "მედიის ადგილმდებარეობა",
    "setup.label.DetailsOfEvent": "ღონისძიების დეტალები",
    "setup.label.EventName": "ღონისძიების სახელი",
    "setup.label.EventCode": "ღონისძიების კოდი",
    "setup.label.SelectedMediaService": "არჩეული მედია სერვისი",
    "setup.label.AvailableMedia": "ხელმისაწვდომი მედია",
    "setup.label.EventDescription": "ღონისძიების აღწერა",
    "setup.label.EventCategory": "ღონისძიების კატეგორია",
    "setup.label.CreateEvent": "ღონისძიების შექმნა",
    "setup.label.DetailsOfProperty": "ქონების დეტალები",
    "setup.label.PropertyCode": "ქონების კოდი",
    "setup.label.PropertyType": "ქონების ტიპი",
    "setup.label.Parcel": "პაკეტი",
    "setup.label.BuildingCode": "შენობის კოდი",
    "setup.label.Precinct": "წინამძღოლი",
    "setup.label.Allocated": "გადანაწილებული",
    "setup.label.UploadPropertyData": "ქონების მონაცემების ატვირთვა",
    "setup.label.Clear": "გასუფთავება",
    "setup.label.CreateProperty": "ქონების შექმნა",
    "setup.label.PropertyDataUpload": "ქონების მონაცემების ატვირთვა",
    "setup.label.Street": "ქუჩა",
    "setup.label.PaymentType": "გადახდის ტიპი",
    "setup.label.PoBox": "საფოსტო ყუთი",
    "setup.label.State": "სახელმწიფო",
    "setup.label.District": "უბანი",
    "setup.label.Floor": "სართული",
    "setup.label.LimitCode": "ლიმიტის კოდი",
    "setup.label.PropertyMaster": "ქონების ოსტატი",
    "setup.label.CodeDescription": "კოდის აღწერა",
    "setup.label.ReferenceValue": "მითითების ღირებულება",
    "setup.label.Services": "სამსახური",
    "setup.label.IsBouquet": "მოულოდნელი",
    "setup.label.Broadcaster": "მაუწყებელი",
    "setup.label.Channel": "არხი",
    "setup.label.ContactNumber": "საკონტაქტო ნომერი",
    "setup.label.UOM": "ერთეული",
    "setup.label.DeleteTemplateDefinition": "თარგის განმარტების წაშლა",
    "setup.label.Discount": "ფასდაკლება",
    "setup.label.SalseCatalogue": "გაყიდვების კატალოგი",
    "setup.label.UserCatalogue": "მომხმარებლის კატალოგი",
    "setup.label.Team": "გუნდი",
    "setup.label.MediaDetails": "მედიის დეტალები",
    "setup.label.Event": "მოვლენა",
    "setup.label.Properties": "თვისებები",
    "setup.label.ServicesProducts": "სერვისები და პროდუქტები",
    "setup.label.BroadcasterChannelMapping": "მაუწყებელი, არხი და რუქა",
    "setup.label.UsageRating": "გამოყენების შეფასება",
    "setup.label.ZoneSetup": "ზონის კონფიგურაცია",
    "setup.label.Promotion": "აქცია",
    "setup.label.PromotionTrigger": "სარეკლამო ტრიგერი",
    "setup.label.PromotionRulesAndRates": "აქციის წესები და ტარიფები",
    "setup.label.CatalogeMapping": "კატალოგის რუქა",
    "setup.label.VoucherPin": "ვაუჩერის პინი",
    "setup.label.SIMNumber": "SIM ნომერი",
    "setup.label.TeamTeamUser": "გუნდი და გუნდის მომხმარებელი",
    "setup.label.MessageTemplate": "შეტყობინების შაბლონი",
    "setup.label.ClosedUserGroup": "დახურული მომხმარებლის ჯგუფი",
    "setup.label.IpManagement": "IP მართვა",
    "setup.label.PropertyDefinition": "ქონების განსაზღვრა",
    "setup.label.PriorityMapping": "პრიორიტეტული რუქა",
    "setup.label.AddProducts": "პროდუქტების დამატება",
    "setup.label.AddDiscount": "ფასდაკლების დამატება",
    "setup.label.Products": "პროდუქტები",
    "setup.label.ChargeCodeData": "მოწყობილობის მონაცემები",
    "setup.label.TaxMapping": "საგადასახადო რუქა",
    "setup.label.TaxRegion": "საგადასახადო რეგიონი",
    "setup.label.CreateUserCatalogue": "შექმენით მომხმარებლის კატალოგი",
    "setup.label.IcZone": "Ic ზონა",
    "setup.label.ViewIcZone": "Ic ზონის ნახვა",
    "setup.label.ViewNumberZone": "ნომრების ზონის ნახვა",
    "setup.label.EditNumberZone": "ნომრების ზონის რედაქტირება",
    "setup.label.DeleteNumberZone": "ნომრების ზონის წაშლა",
    "setup.label.AreYouSure": "დარწმუნებული ხართ?",
    "setup.label.ViewAPNZone": "APN ზონის ნახვა",
    "setup.label.EditAPNZone": "APN ზონის რედაქტირება",
    "setup.label.DeleteAPNZone": "APN ზონის წაშლა",
    "setup.label.ViewOperatorZone": "ოპერატორის ზონის ნახვა",
    "setup.label.EditOperatorZone": "ოპერატორის ზონის რედაქტირება",
    "setup.label.CreateICZone": "IC ზონის შექმნა",
    "setup.label.EditICZone": "IC ზონის რედაქტირება",
    "setup.label.DeleteOperatorZone": "ოპერატორის ზონის წაშლა",
    "setup.label.DeleteIcZone": "IC ზონის წაშლა",
    "setup.label.MobileNumber": "მობილური ნომერი",
    "setup.label.LandlineNumber": "ಲೆಂಡ್ಲೈನ್ ನಂಬರ್ (ಐಚ್ಛಿಕ)",
    "setup.label.RatePlanName": "საკონტაქტო გეგმის სახელი",
    "setup.label.UsageRateBalance": "ಬಳಕೆ ದರ ಶೇಷ",
    "setup.label.ValidityType": "მოქმედების ტიპი",
    "setup.label.ListOfRateTires": "განაკვეთის საბურავების სია",
    "setup.label.Validity": "ಮಾನ್ಯತೆ",
    "setup.label.CreatePlanName": "შექმენით გეგმის სახელი",
    "setup.label.EditPlanContent": "გეგმის შინაარსის რედაქტირება",
    "setup.label.CreatePlanDescription": "შექმენით გეგმის აღწერა",
    "setup.label.ContentType": "შინაარსის ტიპი",
    "setup.label.CreateFeatureList": "შექმენით ფუნქციების სია",
    "setup.label.Area": "ფართობი",
    "setup.label.TaxPercentage": "საგადასახადო პროცენტი",
    "setup.label.Add": "ಸೇರಿಸು",
    "setup.label.Remove": "ამოღება",
    "setup.label.CreateVoucherPin": "ბონის კოდის შექმნა",
    "setup.label.EditSubCategory": "ქვეკატეგორიის რედაქტირება",
    "setup.label.CreateSubCategory": "ქვეკატეგორიის შექმნა",
    "setup.label.ViewSubCategory": "ქვეკატეგორიის ნახვა",
    "setup.label.TimeTaken": "აღებული დრო",
    "setup.label.TeamMapping": "ತಂಡದ ಮ್ಯಾಪಿಂಗ್",
    "setup.label.CreateTeamMapping": "ತಂಡದ ಮ್ಯಾಪಿಂಗ್ ರಚಿಸಿ",
    "setup.label.Category": "ವರ್ಗ",
    "setup.label.external_promotional_code": "გარე სარეკლამო კოდი",
    "setup.label.Subcategory": "ಉಪವರ್ಗ",
    "setup.label.DeleteItemMapping": "ಐಟಂ ಮ್ಯಾಪಿಂಗ್ ಅಳಿಸಿ",
    "setup.label.EditTeamMapping": "ತಂಡದ ಮ್ಯಾಪಿಂಗ್ ತಿದ್ದು",
    "setup.label.ViewTeamMapping": "ತಂಡದ ಮ್ಯಾಪಿಂಗ್ ವೀಕ್ಷಿಸಿ",
    "setup.label.DeletePriorityMapping": "ಪ್ರಾಧಾನ್ಯತೆ ಮ್ಯಾಪಿಂಗ್ ಅಳಿಸಿ",
    "setup.label.discount_rule": "ფასდაკლების წესი",
    "setup.label.promotion_rule": "დაწინაურების წესი",
    "setup.label.discount_rate": "ფასდაკლების განაკვეთი",
    "setup.label.create_discount_rule": "შექმენით ფასდაკლების წესი",
    "setup.label.edit_promotion_rule": "რედაქტირება სარეკლამო წესი",
    "setup.label.create_promotion_rule": "შექმენით სარეკლამო წესი",
    "setup.label.create_discount_rate": "შექმენით ფასდაკლების კურსი",
    "setup.label.add_discount_rate": "დაამატეთ ფასდაკლების განაკვეთი",
    "setup.label.add_promotion_rate": "დაამატეთ სარეკლამო ფასი",
    "setup.label.edit_discount": "ფასდაკლების რედაქტირება",
    "setup.label.edit_promotion": "აქციის რედაქტირება",
    "setup.label.edit_discount_trigger": "ფასდაკლების ტრიგერის რედაქტირება",
    "setup.label.edit_discount_rule": "ფასდაკლების წესის რედაქტირება",
    "setup.label.collection_process": "შეგროვების პროცესი",
    "setup.label.create_collection_profile": "შექმენით შეგროვების პროფილი",
    "setup.label.collection_profile": "შეგროვების პროფილი",
    "setup.label.collection_profile_id": "შეგროვების პროფილის ID",
    "setup.label.region": "რეგიონი",
    "setup.label.collection": "შეგროვება",
    "setup.label.collection_trigger": "შეგროვების ტრიაგერი",
    "setup.label.collection_scenario": "შეგროვების სცენარი",
    "setup.label.add_collection_trigger": "დაამატეთ შეგროვების ტრიაგერი",
    "setup.label.add_collection_scenario": "დაამატეთ შეგროვების სცენარი",
    "setup.label.trigger_id": "ტრიგერის ID",
    "setup.label.criteria_type": "კრიტერიუმის ტიპი",
    "setup.label.due_balance": "გადასახდელი ბალანსი",
    "setup.label.ageing_days": "დღეების გადაჭარბება",
    "setup.label.scenario_id": "სცენარის ID",
    "setup.label.action_name": "მოქმედების სახელი",
    "setup.label.age": "ასაკი",
    "setup.label.create_collection_trigger": "შექმენით შეგროვების ტრიაგერი",
    "setup.label.create_collection_scenario": "შექმენით შეგროვების სცენარი",
    "setup.label.edit_collection_profile": "შეგროვების პროფილის რედაქტირება",
    "setup.label.edit_collection_trigger": "შეგროვების ტრიაგერის რედაქტირება",
    "setup.label.edit_collection_scenario": "შეგროვების სცენარის რედაქტირება",
    "setup.label.SlaInHours": "SLA საათებში",
    "setup.label.contractduration": "ხელშეკრულების ხანგრძლივობა",
    "setup.label.chargesperiodicity": "გადასახადების პერიოდულობა",
  },

  lo: {
    "setup.label.Enter_product_Description": "ໃສ່ລາຍລະອຽດຂອງຜະລິດຕະພັນ",
    "setup.label.FeedbackStatus": "ສະຖານະຂອງຄໍາຕິຊົມ",
    "setup.label.EnterCountryName": "ໃສ່ຊື່ປະເທດ",
    "setup.label.location": "ສະຖານທີ",
    "setup.label.selectLocation": "ເລືອກສະຖານທີ",
    "setup.label.create_group_ticket": "ສ້າງບິນກຸ່ມ",
    "setup.label.default": "ຄ່າດັດແກ້",
    "setup.label.customerFeedback": "ຄໍາຄິດເຫັນຂອງລູກຄ້າ",
    "setup.label.automation": "ການອັດຕະໂນມັດ",
    "setup.label.automation_master": "ຕົ້ນແບບການອັດຕະໂນມັດ",
    "setup.label.create_automation": "ສ້າງການອັດຕະໂນມັດ",
    "setup.label.edit_automation": "ແກ້ໄຂການອັດຕະໂນມັດ",
    "setup.label.automation_detail": "ລາຍລະອຽດການອັດຕະໂນມັດ",
    "setup.label.automation_steps": "ຂັ້ນຕອນການອັດຕະໂນມັດ",
    "setup.label.add_automation_step": "ເພີ່ມຂັ້ນຕອນການອັດຕະໂນມັດ",
    "setup.label.AutomationId": "ID ການອັດຕະໂນມັດ",
    "setup.label.EntityName": "ຊື່ເອກະສານ",
    "setup.label.EntityType": "ປະເພດເອກະສານ",
    "setup.label.WorkflowName": "ຊື່ການໄຫຼຂອງວຽກ",
    "setup.label.CreateAutomationScenario": "ສ້າງສະຖານການອັດຕະໂນມັດ",
    "setup.label.EditAutomationStep": "ແກ້ໄຂຂັ້ນຕອນການອັດຕະໂນມັດ",
    "setup.label.ActionType": "ປະເພດການປະຕິບັດ",
    "setup.label.ActionDetails": "ລາຍລະອຽດການປະຕິບັດ",
    "setup.label.StepOrder": "ລຳດັບຂັ້ນຕອນ",
    "setup.label.questionAnswerSet": "ຊຸດຄໍາຖາມແລະຄໍາຕອບ",
    "setup.label.addQuestionSet": "ເພີ່ມຊຸດຄໍາຖາມ",
    "setup.label.EditQuestionSet": "ແກ້ໄຂຊຸດຄໍາຖາມ",
    "setup.label.CategoryName": "ຊື່ໝວດ",
    "setup.label.SubCategoryName": "ຊື່ໝວດຍ່ອຍ",
    "setup.label.TotalQuestions": "ຄໍາຖາມທັງໝົດ",
    "setup.label.QuestionType": "ປະເພດຄໍາຖາມ",
    "setup.label.QuestionText": "ຂໍ້ຄວາມຄໍາຖາມ",
    "setup.label.CustomerFeedback": "ຄໍາຄິດເຫັນຂອງລູກຄ້າ",
    "setup.label.TicketId": "ລະຫັດບິນ",
    "setup.label.LinkedAt": "ເຊື່ອມຕໍ່ໃນວັນທີ",
    "setup.label.Remarks": "ຄໍາເຫັນ",
    "setup.label.AddFeedback": "ເພີ່ມຄໍາຄິດເຫັນ",
    "setup.label.PendingForApproval": "ລໍຖ້າການອະນຸມັດ",
    "setup.label.user_availability": "ຄວາມພ້ອມໃຊ້ຂອງຜູ້ໃຊ້",
    "setup.label.all_users_availability": "ຄວາມພ້ອມໃຊ້ຂອງຜູ້ໃຊ້ທັງໝົດ",
    "setup.label.create_user_availability": "ສ້າງຄວາມພ້ອມໃຊ້ຂອງຜູ້ໃຊ້",
    "setup.label.LeaveManagement": "ການຄຸ້ມຄອງການລາ",
    "setup.label.CreateLeave": "ສ້າງການລາ",
    "setup.label.EditLeave": "ແກ້ໄຂການລາ",
    "setup.label.ViewLeave": "ເບິ່ງການລາ",
    "setup.label.AllUserLeaves": "ການລາຂອງຜູ້ໃຊ້ທັງໝົດ",
    "setup.label.MyLeaves": "ການລາຂອງຂ້ອຍ",
    "setup.label.ConfigId": "ID ການຕັ້ງຄ່າ",
    "setup.label.edit_user_availability": "ແກ້ໄຂຄວາມພ້ອມໃຊ້ຂອງຜູ້ໃຊ້",
    "setup.label.view_user_availability": "ເບິ່ງຄວາມພ້ອມໃຊ້ຂອງຜູ້ໃຊ້",
    "setup.label.unavailability_date": "ວັນທີບໍ່ສາມາດໃຊ້ງານ",
    "setup.label.start_time": "ເວລາເລີ່ມຕົ້ນ",
    "setup.label.end_time": "ເວລາສິ້ນສຸດ",
    "setup.label.my_availability": "ຄວາມພ້ອມຂອງຂ້ອຍ",
    "setup.label.user": "ຜູ້ໃຊ້",
    "setup.label.EditShift": "ແກ້ໄຂກະຈອງ",
    "setup.label.UserWorkingShift": "ການເຮັດວຽກຂອງຜູ້ໃຊ້",
    "setup.label.CreateUserWorkingShift": "ສ້າງການເຮັດວຽກຂອງຜູ້ໃຊ້",
    "setup.label.EditUserWorkingShift": "ແກ້ໄຂການເຮັດວຽກຂອງຜູ້ໃຊ້",
    "setup.label.ViewUserWorkingShift": "ເບິ່ງການເຮັດວຽກຂອງຜູ້ໃຊ້",
    "setup.label.TeamName": "ຊື່ທີມ",
    "setup.label.Shift": "ກະຈອງ",
    "setup.label.ShiftManagement": "ການຄວບຄຸມກະຈອງ",
    "setup.label.CreateShift": "ສ້າງກະຈອງ",
    "setup.label.ShiftName": "ຊື່ກະຈອງ",
    "setup.label.Session": "ເຊດຊັນ",
    "setup.label.SessionType": "ປະເພດເຊດຊັນ",
    "setup.label.LeaveDetails": "ລາຍລະອຽດການພັກ",
    "setup.label.SessionStartTime": "ເວລາເລີ່ມເຊດຊັນ",
    "setup.label.SessionEndTime": "ເວລາສິ້ນສຸດເຊດຊັນ",
    "setup.label.LeaveType": "ປະເພດການລາ",
    "setup.label.AddAnotherDate": "ເພີ່ມວັນທີອື່ນ",
    "setup.label.Apn_Zone": "ເຂດ APN",
    "setup.label.FeeMaster": "ຜູ້ຄຸ້ມຄອງຄ່າທຳນຽມ",
    "setup.label.Number_Zone": "ເຂດເລກໂທ",
    "setup.label.DeleteRUM": "ລຶບ RUM",
    "setup.label.Edit_TimeModel": "ແກ້ໄຂແບບແມ່ນເວລາ",
    "setup.label.Edit_Year": "ແກ້ໄຂປີ",
    "setup.label.scenario_name": "ຊື່ສະຫຼະທົບ",
    "setup.label.event_name": "ຊື່ງານ",
    "setup.label.Edit_Month": "ແກ້ໄຂເດືອນ",
    "setup.label.Edit_Day": "ແກ້ໄຂວັນ",
    "setup.label.Edit_Time": "ແກ້ໄຂເວລາ",
    "setup.label.Delete_TimeModel": "ລຶບແບບເວລາ",
    "setup.label.Delete_Year": "ລຶບປີ",
    "setup.label.Delete_Month": "ລຶບເດືອນ",
    "setup.label.Delete_Day": "ລຶບວັນ",
    "setup.label.Delete_Time": "ລຶບເວລາ",
    "setup.label.Are_you_sure_?": "ເຈົ້າແນ່ໃຈບໍ?",
    "setup.label.Save": "ບັນທຶກ",
    "setup.label.TemplateDefinition": "ຄຳນິຍາມແບບແຜນ",
    "setup.label.EditQuantityTier": "ແກ້ໄຂລະດັບຈຳນວນ",
    "setup.label.Usage_Rate_Balance": "ຍອດເງິນຄົງເຫຼືອອັດຕາການໃຊ້",
    "setup.label.Template_Name": "ຊື່ແມ່ແບບ",
    "setup.label.Delimiter": "ຕົວແບ່ງ",
    "setup.label.Number_Of_Fields": "ຈໍານວນຊ່ອງຂໍ້ມູນ",
    "setup.label.Header_Recorder_Type": "ປະເພດບັນທຶກຫົວຂໍ້",
    "setup.label.Event_Record_Type": "ປະເພດບັນທຶກເຫດການ",
    "setup.label.CreateUOM": "ສ້າງຫົວໜ່ວຍວັດ",
    "setup.label.TimePeriod": "ໄລຍະເວລາ",
    "setup.label.Usage_Rate_Plan": "ແຜນອັດຕາການໃຊ້",
    "setup.label.TemplateDefinition": "ຄຳຈຳກັດຄວາມແມ່ແບບ",
    "setup.label.CreateRUM": "ສ້າງ RUM",
    "setup.label.CreateTimePeriod": "ສ້າງໄລຍະເວລາ",
    "setup.label.TimemodelName": "ຊື່ໂມເດລເວລາ",
    "setup.label.TimePeriodName": "ຊື່ໄລຍະເວລາ",
    "setup.label.StartYear": "ປີເລີ່ມຕົ້ນ",
    "setup.label.EndYear": "ປີສິ້ນສຸດ",
    "setup.label.UsageRatePlan": "ແຜນອັດຕາການໃຊ້",
    "setup.label.Create_Usage_Rate_Plan": "ສ້າງແຜນອັດຕາການໃຊ້",
    "setup.label.Id": "ID",
    "setup.label.PlanName": "ຊື່ແຜນ",
    "setup.label.ProductName": "ຊື່ຜະລິດຕະພັນ",
    "setup.label.ChargeCode": "ລະຫັດການເກັບເງິນ",
    "setup.label.TimeModelName": "ຊື່ໂມເດລເວລາ",
    "setup.label.RatingType": "ປະເພດການໃຫ້ຄະແນນ",
    "setup.label.RumName": "ຊື່ RUM",
    "setup.label.Are_you_sure_you_want_to_delete_?": "ທ່ານແນ່ໃຈບໍວ່າຈະລົບ?",
    "setup.label.UOM": "ຫົວໜ່ວຍ",
    "setup.label.RUM": "RUM",
    "setup.label.ImpactCategory": "ປະເພດຜົນກະທົບ",
    "setup.label.Resource": "ຊັບພະຍາກອນ",
    "setup.label.GLID": "GLID",
    "setup.label.Unit": "ຫົວໜ່ວຍ",
    "setup.label.Rate": "ອັດຕາ",
    "setup.label.Action": "ການດຳເນີນງານ",
    "setup.label.options_selected": "ຕົວເລືອກທີ່ເລືອກ",
    "setup.label.UsageRateBalance": "ຍອດເຫຼືອການນຳໃຊ້",
    "setup.label.EndYear": "ປີສິ້ນສຸດ",
    "setup.label.StartMonth": "ເດືອນເລີ່ມຕົ້ນ",
    "setup.label.EndMonth": "ເດືອນສິ້ນສຸດ",
    "setup.label.StartDay": "ວັນເລີ່ມຕົ້ນ",
    "setup.label.EndDay": "ວັນສິ້ນສຸດ",
    "setup.label.StartTime": "ເວລາເລີ່ມຕົ້ນ",
    "setup.label.Time_Model_Name": "ຊື່ແບບເວລາ",
    "setup.label.model_includes_which_all_Bands_?":
      "ແບບນີ້ມີຄວາມຄຸ້ມຄອງແບນໃດບ້າງ?",
    "setup.label.YearRestriction": "ຈຳກັດປີ",
    "setup.label.MonthRestriction": "ຈຳກັດເດືອນ",
    "setup.label.DayRestriction": "ຈຳກັດວັນ",
    "setup.label.TimeRestriction": "ຈຳກັດເວລາ",
    "setup.label.Code": "ລະຫັດ",
    "setup.label.Name": "ຊື່",
    "setup.label.PriorityMapping": "ແຜນທີ່ລຳດັບຄວາມສຳຄັນ",
    "setup.label.AddJurisdiction": "ເພີ່ມຂອບເຂດ",
    "setup.label.Are_you_sure_?": "ເຈົ້າແນ່ໃຈບໍ?",
    "setup.label.Country": "ປະເທດ",
    "setup.label.State": "ລັດ/ແຂວງ",
    "setup.label.District": "ເມືອງ",
    "setup.label.RateType": "ປະເພດອັດຕາ",
    "setup.label.Remove": "ລຶບ",
    "setup.label.TaxMaster": "ຕົວຄວບຄຸມພາສີ",
    "setup.label.Team": "ທີມ",
    "setup.label.Add": "ເພີ່ມ",
    "setup.label.FeeMaster": "ຜູ້ຄຸ້ມຄອງຄ່າທຳນຽມ",
    "setup.label.DeleteChargeCode": "ລຶບລະຫັດຄ່າທຳນຽມ",
    "setup.label.SelectSearch": "ເລືອກການຊອກຫາ",
    "setup.label.Select_Content_Tag_Value": "ເລືອກຄ່າແທັກເນື້ອຫາ",
    "setup.label.Plan_Content": "ເນື້ອຫາແຜນ",
    "setup.label.Plan": "ແຜນ",
    "setup.label.ProductPrice": "ລາຄາສິນຄ້າ",
    "setup.label.SelectedPromotions": "ໂປຣໂມຊັນທີ່ເລືອກ",
    "setup.label.AvailablePromotions": "ໂປຣໂມຊັນທີ່ມີ",
    "setup.label.SelectType": "ເລືອກປະເພດ",
    "setup.label.Type": "ປະເພດ",
    "setup.label.No_versions_available": "ບໍ່ມີລຸ້ນໃຫ້ເລືອກ",
    "setup.label.Version": "ລຸ້ນ",
    "setup.label.ListPrice": "ລາຄາໃນບັນຊີ",
    "setup.label.SellingPrice": "ລາຄາຂາຍ",
    "setup.label.EnterPlanDescription": "ໃສ່ລາຍລະອຽດແຜນ",
    "setup.label.AddPrice": "ເພີ່ມລາຄາ",
    "setup.label.Save": "ບັນທຶກ",
    "setup.label.AddDiscount": "ເພີ່ມສ່ວນຫຼຸດ",
    "setup.label.AvailablePlans": "ແຜນທີ່ມີ",
    "setup.label.SelectedPlans": "ແຜນທີ່ເລືອກ",
    "setup.label.PlanType": "ປະເພດແຜນ",
    "setup.label.Plan_Start_Date": "ວັນທີ່ເລີ່ມແຜນ",
    "setup.label.Plan_End_Date": "ວັນທີ່ສິ້ນສຸດແຜນ",
    "setup.label.Bill_Type": "ປະເພດໃບບິນ",
    "setup.label.AttributeTypes": "ປະເພດຄຸນສົມບັດ",
    "setup.label.Add": "ເພີ່ມ",
    "setup.label.Select_Content_Tag": "ເລືອກແທັກເນື້ອໃນ",
    "setup.label.PlanName": "ຊື່ແຜນການ",
    "setup.label.AvailableDiscounts": "ສ່ວນຫຼຸດທີ່ມີ",
    "setup.label.Search": "ຊອກຫາ...",
    "setup.label.MoveRight": "ເລື່ອນໄປຂວາ",
    "setup.label.MoveLeft": "ເລື່ອນໄປຊ້າຍ",
    "setup.label.SelectedDiscounts": "ສ່ວນຫຼຸດທີ່ເລືອກ",
    "setup.label.SelectType": "ເລືອກປະເພດ",
    "setup.label.SelectLanguage": "ເລືອກພາສາ",
    "setup.label.SelectContentTag": "ເລືອກແທັກເນື້ອໃນ",
    "setup.label.SelectContentTagValue": "ເລືອກຄ່າແທັກ",
    "setup.label.DigitalContent": "ເນື້ອໃນດິຈິຕອລ",
    "setup.label.Enter_Plan_Description": "ໃສ່ຄໍາອະທິບາຍແຜນ",
    "setup.label.DC_Rule": "ກົດ DC",
    "setup.label.PlanAttribute": "ຄຸນສົມບັດແຜນ",
    "setup.label.AdvanceView": "ເບິ່ງແບບລະອຽດ",
    "setup.label.Update": "ປັບປຸງ",
    "setup.label.ProductMapping": "ແມບຜະລິດຕະພັນ",
    "setup.label.Service": "ບໍລິການ",
    "setup.label.SubProducts": "ຜະລິດຕະພັນຍ່ອຍ",
    "setup.label.Type": "ປະເພດ",
    "setup.label.EnterValue": "ໃສ່ຄ່າ",
    "setup.label.PriceRegion": "ພື້ນທີ່ລາຄາ",
    "setup.label.Enter_service_Description": "ໃສ່ລາຍລະອຽດການບໍລິການ",
    "setup.label.ParamName": "ຊື່ພາລາເມັເຕີ",
    "setup.label.Category": "ປະເພດ",
    "setup.label.Type": "ປະເພດ",
    "setup.label.EnterValue": "ໃສ່ຄ່າ",
    "setup.label.SalesCatalogue": "ລາຍການຂາຍ",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບ?",
    "setup.label.Channel": "ຊ່ອງ",
    "setup.label.Broadcaster": "ຜູ້ອອກອາກາດ",
    "setup.label.AddPrice": "ເພີ່ມລາຄາ",
    "setup.label.DeleteMediaEvent": "ລຶບເຫດການສື່ມວນຊົນ",
    "setup.label.AdvMedia": "ສື່ໂຄສະນາ",
    "setup.label.EditMedia": "ແກ້ໄຂສື່",
    "setup.label.AddEvent": "ເພີ່ມເຫດການ",
    "setup.label.AddAttributes": "ເພີ່ມຄຸນລັກສະນະ",
    "setup.label.AddLocation": "ເພີ່ມສະຖານທີ່",
    "setup.label.DeleteEvent": "ລຶບເຫດການ",
    "setup.label.Are_you_sure_?": "ທ່ານແນ່ໃຈບໍ?",
    "setup.label.Add": "ເພີ່ມ",
    "setup.label.ViewEvent": "ເບິ່ງເຫດການ",
    "setup.label.Event": "ເຫດການ",
    "setup.label.RUM": "RUM",
    "setup.label.OptType": "ປະເພດທາງເລືອກ",
    "setup.label.Currency": "ສະກຸນເງິນ",
    "setup.label.Amount": "ຈໍານວນເງິນ",
    "setup.label.Add": "ເພີ່ມ",
    "setup.label.Save": "ບັນທຶກ",
    "setup.label.AddDiscount": "ເພີ່ມສ່ວນຫຼຸດ",
    "setup.label.EnterEventCode": "ໃສ່ລະຫັດເຫດການ",
    "setup.label.EnterEventDescription": "ໃສ່ລາຍລະອຽດເຫດການ",
    "setup.label.EventDescription": "ລາຍລະອຽດເຫດການ",
    "setup.label.EventCategory": "ປະເພດເຫດການ",
    "setup.label.ChargeCode": "ລະຫັດຄ່າທຳນຽມ",
    "setup.label.SelectEventValidity": "ເລືອກຄວາມຖືກຕ້ອງຂອງເຫດການ",
    "setup.label.EditEvent": "ແກ້ໄຂເຫດການ",
    "setup.label.UnitCode": "ລະຫັດໜ່ວຍ",
    "setup.label.MediaTitle": "ຫົວຂໍ້ສື່",
    "setup.label.ContentProvider": "ຜູ້ສະໜອງເນື້ອຫາ",
    "setup.label.MediaType": "ປະເພດສື່",
    "setup.label.Rated": "ໄດ້ຮັບການຈັດອັນດັບ",
    "setup.label.MediaCategory": "ໝວດໝູ່ສື່",
    "setup.label.Rating": "ການຈັດອັນດັບ",
    "setup.label.Poster": "ໂປສເຕີ",
    "setup.label.Status": "ສະຖານະ",
    "setup.label.MovieDuration": "ໄລຍະເວລາຮູບເງົາ",
    "setup.label.ReleaseDate": "ວັນທີອອກສູ່ສາທາລະນະ",
    "setup.label.Genre": "ປະເພດ",
    "setup.label.Subject": "ຫົວຂໍ້",
    "setup.label.Overview": "ພາບລວມ",
    "setup.label.Share(%)": "ແບ່ງປັນ (%)",
    "setup.label.Cast": "ນັກສະແດງ",
    "setup.label.AttributeType": "ປະເພດຄຸນລັກສະນະ",
    "setup.label.CaptionValue": "ຄ່າຄຳບັນຍາຍ",
    "setup.label.NickName": "ຊື່ຫຼີ້ນ",
    "setup.label.Image": "ຮູບພາບ",
    "setup.label.Language": "ພາສາ",
    "setup.label.Format": "ຮູບແບບ",
    "setup.label.Location": "ສະຖານທີ່",
    "setup.label.CustomerType": "ປະເພດລູກຄ້າ",
    "setup.label.FormatType": "ປະເພດຮູບແບບ",
    "setup.label.DiscountCode": "ລະຫັດສ່ວນຫຼຸດ",
    "setup.label.ReProcess": "ການປະມວນຜົນອີກຄັ້ງ",
    "setup.label.Code": "ລະຫັດ",
    "setup.label.Description": "ຄຳອະທິບາຍ",
    "setup.label.PropertyCodeType": "ປະເພດລະຫັດສະມບັດ",
    "setup.label.ReferenceValue": "ຄ່າອ້າງອີງ",
    "setup.label.EditProperty": "ແກ້ໄຂສະມບັດ",
    "setup.label.EditPropertyMaster": "ແກ້ໄຂຜູ້ຄຸ້ມຄອງສະມບັດ",
    "setup.label.Cancel": "ຍົກເລີກ",
    "setup.label.View": "ເບິ່ງ",
    "setup.label.Edit": "ແກ້ໄຂ",
    "setup.label.Browse_file_to_Upload": "ເລືອກໄຟລ໌ເພື່ອອັບໂຫຼດ",
    "setup.label.CreatePropertyMaster": "ສ້າງຜູ້ຄຸ້ມຄອງສະມບັດ",
    "setup.label.Property": "ສະມບັດ",
    "setup.label.PropertyMaster": "ຜູ້ຄຸ້ມຄອງສະມບັດ",
    "setup.label.ViewProperty": "ເບິ່ງສະມບັດ",
    "setup.label.ViewPropertyMaster": "ເບິ່ງຜູ້ຄຸ້ມຄອງສະມບັດ",
    "setup.label.Are_you_sure_?": "ທ່ານແນ່ໃຈບໍ?",
    "setup.label.Edit": "ແກ້ໄຂ",
    "setup.label.Code": "ລະຫັດ",
    "setup.label.Name": "ຊື່",
    "setup.label.AddState": "ເພີ່ມລັດ",
    "setup.label.AddDistrict": "ເພີ່ມເມືອງ",
    "setup.label.AddCity": "ເພີ່ມເມືອງໃຫຍ່",
    "setup.label.EditCountry": "ແກ້ໄຂປະເທດ",
    "setup.label.EditState": "ແກ້ໄຂລັດ",
    "setup.label.EditDistrict": "ແກ້ໄຂເມືອງ",
    "setup.label.EditCity": "ແກ້ໄຂເມືອງໃຫຍ່",
    "setup.label.DeleteCountry": "ລຶບປະເທດ",
    "setup.label.DeleteState": "ລຶບລັດ",
    "setup.label.DeleteDistrict": "ລຶບເມືອງ",
    "setup.label.DeleteCity": "ລຶບເມືອງໃຫຍ່",
    "setup.label.ServiceAvailablity": "ການໃຫ້ບໍລິການ",
    "setup.label.EnterCountryCode": "ໃສ່ລະຫັດປະເທດ",
    "setup.label.EnterCode": "ໃສ່ລະຫັດ",
    "setup.label.EnterName": "ໃສ່ຊື່",
    "setup.label.Service_Availablity_for_the": "ການໃຫ້ບໍລິການສໍາລັບ",
    "setup.label.SelectServices": "ເລືອກການບໍລິການ",
    "setup.label.Select_One_or_More": "ເລືອກໜຶ່ງຫຼືຫຼາຍຢ່າງ",
    "setup.label.options_selected": "ທາງເລືອກທີ່ເລືອກ",
    "setup.label.PromotionName": "ຊື່ສົ່ງເສີມການຂາຍ",
    "setup.label.PromotionCode": "ລະຫັດສົ່ງເສີມ",
    "setup.label.BussinesType": "ປະເພດທຸລະກິດ",
    "setup.label.OrderType": "ປະເພດຄຳສັ່ງ",
    "setup.label.PaymentType": "ປະເພດການຈ່າຍເງິນ",
    "setup.label.SelectCategory": "ເລືອກປະເພດ",
    "setup.label.PromotionTrigger": "ການກະຕຸ້ນສົ່ງເສີມ",
    "setup.label.PromotionRule": "ກົດການສົ່ງເສີມ",
    "setup.label.PromotionTriggerCondition": "ເງື່ອນໄຂການກະຕຸ້ນສົ່ງເສີມ",
    "setup.label.DiscountTriggerCondition": "ເງື່ອນໄຂການໃຫ້ສ່ວນຫຼຸດ",
    "setup.label.DiscountRule": "ກົດລະບຽບສ່ວນຫຼຸດ",
    "setup.label.DiscountTrigger": "ຕົວເປີດໃຫ້ສ່ວນຫຼຸດ",
    "setup.label.EditTriggerCondition": "ແກ້ໄຂເງື່ອນໄຂ",
    "setup.label.Rate": "ອັດຕາ",
    "setup.label.EditRule": "ແກ້ໄຂກົດລະບຽບ",
    "setup.label.AddRate": "ເພີ່ມອັດຕາ",
    "setup.label.Download": "ດາວໂຫຼດ",
    "setup.label.Process": "ປະມວນຜົນ",
    "setup.label.ViewVendor": "ເບິ່ງຜູ້ຂາຍ",
    "setup.label.VendorCode": "ລະຫັດຜູ້ຂາຍ",
    "setup.label.VendorName": "ຊື່ຜູ້ຂາຍ",
    "setup.label.select_Currency": "ເລືອກເງິນຕາ",
    "setup.label.select_Country": "ເລືອກປະເທດ",
    "setup.label.Filter_List": "ກັ່ນຕອງລາຍການ",
    "setup.label.Are_you_sure_you_want_to_delete_?": "ທ່ານແນ່ໃຈບໍ່ວ່າຈະລຶບ?",
    "setup.label.DeleteVoucher": "ລຶບບັດວິເຊີ",
    "setup.label.UpdatePin": "ປັບປຸງ PIN",
    "setup.label.UpdateVoucher": "ປັບປຸງບັດວິເຊີ",
    "setup.label.select_from_dropdown": "ເລືອກຈາກລາຍການດຶງລົງ",
    "setup.label.ItemModel": "ຮູບແບບລາຍການ",
    "setup.label.price": "ລາຄາ",
    "setup.label.Edit": "ແກ້ໄຂ",
    "setup.label.Delete": "ລຶບ",
    "setup.label.Item": "ລາຍການ",
    "setup.label.EnterSupplierAddress": "ໃສ່ທີ່ຢູ່ຜູ້ສະໜອງ",
    "setup.label.Title": "ຫົວຂໍ້",
    "setup.label.AddPromotionTriggerCondition": "ເພີ່ມເງື່ອນໄຂການໂປໂມຊັນ",
    "setup.label.EditPromotionTriggerCondition": "ແກ້ໄຂເງື່ອນໄຂການໂປໂມຊັນ",
    "setup.label.AssignTo": "ມອບໃຫ້",
    "setup.label.Version": "ລຸ້ນ",
    "setup.label.IsOverride": "ແມ່ນເອົາທັບທຽມບໍ່",
    "setup.label.PlanAttribute": "ຄຸນສົມບັດແຜນ",
    "setup.label.ValidationRule": "ກົດການກວດສອບ",
    "setup.label.SaveAndContinue": "ບັນທຶກ ແລະ ສືບຕໍ່",
    "setup.label.PlanManagement": "ການຄຸ້ມຄອງແຜນ",
    "setup.label.Plan": "ແຜນ",
    "setup.label.DiscountTriggerCondition": "ເງື່ອນໄຂການສ່ວນຫຼຸດ",
    "setup.label.AddDiscountTriggerCondition": "ເພີ່ມເງື່ອນໄຂການສ່ວນຫຼຸດ",
    "setup.label.SalesChannel": "ຊ່ອງທາງຂາຍ",
    "setup.label.PaymentType": "ປະເພດການຈ່າຍເງິນ",
    "setup.label.OrderType": "ປະເພດຄຳສັ່ງ",
    "setup.label.BusinessType": "ປະເພດທຸລະກິດ",
    "setup.label.ViewDigitalContent": "ເບິ່ງເນື້ອຫາດິຈິຕອນ",
    "setup.label.EditDigitalContent": "ແກ້ໄຂເນື້ອຫາດິຈິຕອນ",
    "setup.label.AddDigitalContent": "ເພີ່ມເນື້ອຫາດິຈິຕ້ອນ",
    "setup.label.PromotionRuleName": "ຊື່ກົດລະບຽບການສົ່ງເສີມ",
    "setup.label.PromotionTriggerCondition": "ເງື່ອນໄຂການກະຕຸ້ນໂປຣໂມຊັນ",
    "setup.label.AddPromotionTriggerCondition":
      "ເພີ່ມເງື່ອນໄຂການກະຕຸ້ນໂປຣໂມຊັນ",
    "setup.label.BussinesType": "ປະເພດທຸລະກິດ",
    "setup.label.requestApproval": "ຂໍການອະນຸມັດ",
    "setup.label.validity_uom": "ຫົວໜ່ວຍຂອງຄວາມຖືກຕ້ອງ",
    "setup.label.validity_value": "ຄ່າຄວາມຖືກຕ້ອງ",
    "setup.label.ViewItemModel": "ເບິ່ງແບບສິນຄ້າ",
    "setup.label.ItemType": "ປະເພດລາຍການ",
    "setup.label.ViewSupplier": "ເບິ່ງຜູ້ສະໜອງ",
    "setup.label.SupplierCode": "ລະຫັດຜູ້ສະໜອງ",
    "setup.label.SupplierDescription": "ລາຍລະອຽດຜູ້ສະໜອງ",
    "setup.label.SupplierAddress": "ທີ່ຢູ່ຜູ້ສະໜອງ",
    "setup.label.DeleteSupplier": "ລົບຜູ້ສະໜອງ",
    "setup.label.CreateContract": "ສ້າງສັນຍາ",
    "setup.label.RateTierName": "ໃຫ້ຄະແນນຊື່ລະດັບ",
    "setup.label.RangeType": "ປະເພດຊ່ວງ",
    "setup.label.CreateDiscountRule": "ສ້າງກົດລະບຽບການຫຼຸດລາຄາ",
    "setup.label.RuleCondition": "ເງື່ອນໄຂຂອງກົດລະບຽບ",
    "setup.label.CreateRuleCondition": "ສ້າງເງື່ອນໄຂກົດລະບຽບ",
    "setup.label.CreateRule": "ສ້າງກົດລະບຽບ",
    "setup.label.Entity": "ນິຕິບຸກຄົນ",
    "setup.label.EntityField": "ຊ່ອງຂໍ້ມູນຫນ່ວຍງານ",
    "setup.label.contentTag": "ປ້າຍກຳກັບເນື້ອໃນ",
    "setup.label.contentTagValue": "ຄ່າຂອງປ້າຍກຳກັບເນື້ອໃນ",
    "setup.label.ExecutionType": "ປະເພດການປະຕິບັດ",
    "setup.label.OperationMode": "ໂໝດການເຮັດວຽກ",
    "setup.label.AggregationType": "ປະເພດການລວມລວມ",
    "setup.label.DurationInDays": "ໄລຍະເວລາໃນມື້",
    "setup.label.CreateTicketTeamUser": "ສ້າງຜູ້ໃຊ້ທີມປະຕິບັດ",
    "setup.label.termsConditions": "ຂໍ້ກຳນົດ ແລະເງື່ອນໄຂ",
    "setup.label.updateTermsConditions": "ອັບເດດຂໍ້ກຳນົດ ແລະເງື່ອນໄຂ",
    "setup.label.updateDigitalContent": "ອັບເດດເນື້ອຫາດິຈິຕອນ",
    "setup.label.createDigitalContent": "ສ້າງເນື້ອຫາດິຈິຕອນ",
    "setup.label.createTermsConditions": "ສ້າງຂໍ້ກໍານົດ & ເງື່ອນໄຂ",
    "setup.label.digitalContent": "ເນື້ອຫາດິຈິຕອນ",
    "setup.label.planContent": "ເນື້ອໃນແຜນການ",
    "setup.label.selectPlanContent": "ເລືອກເນື້ອໃນແຜນການ",
    "setup.label.FilterType": "ປະເພດການກອງ",
    "setup.label.FilterValue": "ຄ່າການກອງ",
    "setup.label.ContractPeriod": "ໄລຍະເວລາສັນຍາ",
    "setup.label.AddContract": "ເພີ່ມສັນຍາ",
    "setup.label.ExternalPlanId": "ແຜນງານຫົວໜ່ວຍພາຍນອກ",
    "setup.label.ExternalProductId": "ສິນຄ້າຫົວໜ່ວຍພາຍນອກ",
    "setup.label.SelectedPlanDiscounts": "ສ່ວນຫຼຸດຂອງແຜນທີ່ເລືອກ,",
    "setup.label.ProductDiscount": "ສ່ວນຫຼຸດຂອງຜະລິດຕະພັນ,",
    "setup.label.EditContract": "ແກ້ໄຂສັນຍາ",
    "setup.label.ViewContract": "ເບິ່ງສັນຍາ",
    "setup.label.ContractType": "ປະເພດສັນຍາ",
    "setup.label.ContractUnit": "ຫນ່ວຍງານສັນຍາ",
    "setup.label.updateNetMask": "ອັບເດດເຄືອຂ່າຍເມສ",
    "setup.label.Update": "ອັບເດດ",
    "setup.label.BillType": "ປະເພດໃບບິນ",
    "setup.label.BillFrequency": "ຄວາມຖີໃນການອອກໃບບິນ",
    "setup.label.PlanEndDate": "ວັນທີໝົດອາຍຸແຜນ",
    "setup.label.AddContent": "ເພີ່ມເນື້ອຫາ",
    "setup.label.CreatePlanContent": "ສ້າງເນື້ອຫາແຜນ",
    "setup.label.SelectLanguage": "ເລືອກພາສາ",
    "setup.label.UploadDigitalImage": "ອັບໂຫຼດຮູບດິຈິຕອນ",
    "setup.label.ViewPlanContent": "ເບິ່ງເນື້ອຫາແຜນ",
    "setup.label.ExternalPlanName": "ຊື່ແຜນພາຍນອກ",
    "setup.label.ExternalProductName": "ຊື່ຜະລິດຕະພັນພາຍນອກ",
    "setup.label.ViewPrice": "ເບິ່ງລາຄາ",
    "setup.label.createIpPool": "ສ້າງກຸ່ມຊອກ IP",
    "setup.label.editIpPool": "ແກ້ໄຂກຸ່ມຊອກ IP",
    "setup.label.PlanValidationRules": "ກົດເຫົາການຢຶມຢັນຢຸດ",
    "setup.label.CreateValidationRule": "ສ້າງກົດເຫົາຢຶມຢັນ",
    "setup.label.EditValidationRule": "ແກ້ໄຂກົດເຫົາຢຶມຢັນ",
    "setup.label.InputPlanId": "ປ້ອນເຫົາກັບວະກົດເຫົາ",
    "setup.label.CheckinPlanId": "ອອກປົກກະກອນເທັກເວົາ",
    "setup.label.RuleAppliesTo": "ສາຍ",
    "setup.label.Rule": "ກົດ",
    "setup.label.ViewValidationRule": "ກົດລະບຽບການກວດສອບວິວ",
    "setup.label.ValidationRule": "ກົດລະບຽບການກວດສອບ",
    "setup.label.AddOrEditDiscount": "ເພີ່ມ/ແກ້ໄຂສ່ວນຫຼຸດt",
    "setup.label.Next": "ຖັດໄປ",
    "setup.label.MainCategory": "ປະເພດຫຼັກ",
    "setup.label.SubCategory": "ໝວດຍ່ອຍ",
    "setup.label.select_date": "ເລືອກວັນທີ",
    "setup.label.AddDiscountTrigger": "ເພີ່ມຕົ້ນເຫດສ່ວນຫຼຸດ",
    "setup.label.AddPromotionTrigger": "ເພີ່ມຕົວກະຕຸ້ນການສົ່ງເສີມ",
    "setup.label.edit_promotion_trigger": "ແກ້ໄຂຕົວກະຕຸ້ນການສົ່ງເສີມ",
    "setup.label.DiscountTrigger": "ຕົ້ນເຫດສ່ວນຫຼຸດ",
    "setup.label.TriggerName": "ຊື່ຕົ້ນເຫດ",
    "setup.label.When": "ເມື່ອໃດ",
    "setup.label.CustomerType": "ປະເພດລູກຄ້າ",
    "setup.label.Criteria": "ເງື່ອນໄຂ",
    "setup.label.Values": "ຄ່າ",
    "setup.label.ApplicableTo": "ເໝາະສົມກັບ",
    "setup.label.ApplicableValues": "ຄ່າທີ່ເໝາະສົມ",
    "setup.label.DiscountRulesAndRates": "ກົດເກນສ່ວນຫຼຸດແລະອັດຕາ",
    "setup.label.RuleName": "ຊື່ກົດເກນ",
    "setup.label.MaxDiscount": "ສ່ວນຫຼຸດສູງສຸດ",
    "setup.label.ResourceId": "ID ຂອງຊັບພະຍາກອນ",
    "setup.label.DiscountRateType": "ປະເພດອັດຕາສ່ວນຫຼຸດ",
    "setup.label.Unit": "ໜ່ວຍ",
    "setup.label.DiscountId": "ລະຫັດສ່ວນຫຼຸດ",
    "setup.label.DiscountName": "ຊື່ສ່ວນຫຼຸດ",
    "setup.label.Priority": "ລຳດັບຄວາມສຳຄັນ",
    "setup.label.Items": "ລາຍການ",
    "setup.label.ItemCode": "ລະຫັດລາຍການ",
    "setup.label.ItemDescription": "ລາຍລະອຽດຂອງລາຍການ",
    "setup.label.Units": "ຫົວໜ່ວຍ",
    "setup.label.Total": "ທັງໝົດ",
    "setup.label.Warranty": "ຄໍາຖາມ",
    "setup.label.UsedItems": "ລາຍການທີ່ໃຊ້ກັບການຄ້າ",
    "setup.label.Balanced": "ມີຄ່າກັບຄູ່",
    "setup.label.IsProvisioning": "ເປີດການສະຖານະ",
    "setup.label.CreateItem": "ສ້າງລາຍການ",
    "setup.label.ItemClass": "ຫມວດຫມູສ",
    "setup.label.ReorderLevel": "ລະດັບການຈັດລາຍການຄ້າສ່ຽງ",
    "setup.label.WarrantyPeriod": "ສາຍພິມເຕີ",
    "setup.label.Currency": "ເງິນ",
    "setup.label.DefaultPrice": "ລາຄາເລີ່ມຕົ້ນ",
    "setup.label.IsSelector": "ເປີດໃຊ້ງານ",
    "setup.label.SelectorMenu": "ເມນູການເລືອກ",
    "setup.label.Selector": "ເມນູ",
    "setup.label.VariablePrice": "ລາຄາບັດປະຈຳ",
    "setup.label.ItemModel": "ໂມໂດລາຍການ",
    "setup.label.Price": "ລາຄາ",
    "setup.label.Action": "ການດຳເນີນການ",
    "setup.label.Cancel": "ຍົກເລີກ",
    "setup.label.planPrice": "ລາຄາແຜນ",
    "setup.label.listview": "ມອບລາຍການ",
    "setup.label.Submit": "ສົ່ງຜ່ານ",
    "setup.label.EditItem": "ແກ້ໄຂຜະລິດ",
    "setup.label.Id": "ລະຫັດ",
    "setup.label.ItemMasterId": "ID ຜະລິດຕະພັນ",
    "setup.label.RegionId": "ID ພູມຄ້າ",
    "setup.label.Edit": "ແກ້ໄຂ",
    "setup.label.ViewItem": "ເບິ່ງລາຍການ",
    "setup.label.UnitPrice": "ລາຄາໜ້າຮ້ານ",
    "setup.label.ItemModels": "ຮູບແບບຜະລິດ",
    "setup.label.NetworkElement": "ສະຖານທີ່ດ້ານດ້ວຍເວລາ",
    "setup.label.Model": "ຮູບແບບ",
    "setup.label.Make": "ສ້າງ",
    "setup.label.CreateItemModel": "ສ້າງຮູບແບບຜະລິດ",
    "setup.label.Reset": "ປ່ຽນລະຫວ່າງ",
    "setup.label.EditItemModel": "ແກ້ໄຂຮູບແບບຜະລິດ",
    "setup.label.ServiceCode": "ລະຫັດການບໍລິການ",
    "setup.label.ServiceDescription": "ລາຍລະອຽດການບໍລິການ",
    "setup.label.ServiceType": "ປະເພດການບໍລິການ",
    "setup.label.Isoptional": "ເປັນທາງເລືອກ",
    "setup.label.Isautoprovision": "ເປັນການຕັດສິນໃຈເອງ",
    "setup.label.CreateService": "ສ້າງການບໍລິການ",
    "setup.label.Code": "ລະຫັດ",
    "setup.label.Description": "ລາຍລະອຽດ",
    "setup.label.Type": "ປະເພດ",
    "setup.label.EditService": "ແກ້ໄຂການບໍລິການ",
    "setup.label.ServiceParameter": "ພາລາມິດການບໍລິການ",
    "setup.label.ParamName": "ຊື່ພາລາມິດ",
    "setup.label.ParamType": "ປະເພດພາລາມິດ",
    "setup.label.ParamCategory": "ປະເພດພາລາມິດ",
    "setup.label.ParamValue": "ຄ່າພາລາມິດ",
    "setup.label.BB": "BB",
    "setup.label.Delete": "ລຶບ",
    "setup.label.ServiceCategory": "ປະເພດການບໍລິການ",
    "setup.label.DeleteServices": "ລຶບການບໍລິການ",
    "setup.label.Confirm": "ຢືນຢັນ",
    "setup.label.Service": "ການບໍລິການ",
    "setup.label.Status": "ສະຖານະ",
    "setup.label.Bouquet": "ຊໍາ",
    "setup.label.Actions": "ການກະທຳ",
    "setup.label.CreateProduct": "ສ້າງຜະລິດຕະພັນ",
    "setup.label.ProductParameter": "ພາລາມິດຜະລິດຕະພັນ",
    "setup.label.EditProduct": "ແກ້ໄຂຜະລິດຕະພັນ",
    "setup.label.ProductDescription": "ລາຍລະອຽດຜະລິດຕະພັນ",
    "setup.label.ProductCategory": "ປະເພດຜະລິດຕະພັນ",
    "setup.label.BroadcasterCode": "ລະຫັດຜູ້ສົ່ງ",
    "setup.label.BroadcasterName": "ຊື່ຜູ້ສົ່ງ",
    "setup.label.GstRegNumber": "ເລກທະບຽນ GST",
    "setup.label.ContactPerson": "ບຸກຄົນຕິດຕໍ່",
    "setup.label.ContactMobile": "ໂທລະສັບມືຖືຕິດຕໍ່",
    "setup.label.Email": "ອີເມວ",
    "setup.label.CreateBroadcaster": "ສ້າງຜູ້ສົ່ງ",
    "setup.label.Address": "ທີ່ຢູ່",
    "setup.label.MobileNo": "ເບີໂທມືຖື",
    "setup.label.LandlineNo": "ເບີໂທສາຍດ້ານ",
    "setup.label.EditBroadcaster": "ແກ້ໄຂຜູ້ສົ່ງ",
    "setup.label.ChannelName": "ຊື່ຊ່ອງ",
    "setup.label.ChannelType": "ປະເພດຊ່ອງ",
    "setup.label.DeleteBroadcaster": "ລຶບຜູ້ສົ່ງ",
    "setup.label.ChannelCategory": "ປະເພດຊ່ອງ",
    "setup.label.ChannelSequence": "ລຳດັບຊ່ອງ",
    "setup.label.IsHdChannel": "ແມ່ນຊ່ອງ HD",
    "setup.label.CreateChannel": "ສ້າງຊ່ອງ",
    "setup.label.Language": "ພາສາ",
    "setup.label.IsLocalChannel": "ແມ່ນຊ່ອງທ້ອງຖິ່ນ",
    "setup.label.Genre": "ປະເພດ",
    "setup.label.BroadcasterId": "ID ຜູ້ສົ່ງ",
    "setup.label.EditChannel": "ແກ້ໄຂຊ່ອງ",
    "setup.label.DeleteChannel": "ລຶບຊ່ອງ",
    "setup.label.ProductMapping": "ການແຜ່ນທີ່ສິນຄ້າ",
    "setup.label.CreateProductChannelMapping": "ສ້າງການແຜ່ນທີ່ຊ່ອງຂອງສິນຄ້າ",
    "setup.label.ProductId": "ID ສິນຄ້າ",
    "setup.label.AvailableChannels": "ຊ່ອງທີ່ມີຢູ່",
    "setup.label.SelectedChannels": "ຊ່ອງທີ່ເລືອກໄວ້",
    "setup.label.EditChannelMapping": "ແກ້ໄຂການແຜ່ນທີ່ຊ່ອງ",
    "setup.label.PlanPricing": "ແຜນ&ລາຄາ",
    "setup.label.CreatePlan": "ສ້າງແຜນ",
    "setup.label.PlanCode": "ລະຫັດແຜນ",
    "setup.label.PlanDescription": "ລາຍລະອຽດແຜນ",
    "setup.label.PlanStatus": "ສະຖານະແຜນ",
    "setup.label.PlanProvisionSystem": "ລະບົບການຈັດຫມາຍແຜນ",
    "setup.label.PlanStartDate": "ວັນທີເລີ່ມແຜນ",
    "setup.label.IsPrepaid": "ເປັນການຈ່າຍລ່ວງໜ້າ",
    "setup.label.Duration": "ໄລຍະເວລາ",
    "setup.label.PlanType": "ປະເພດແຜນ",
    "setup.label.BillingRule": "ກົດການເກັບເງິນ",
    "setup.label.EndDate": "ວັນທີສິ້ນສຸດ",
    "setup.label.IsProvision": "ເປັນການຈັດຫມາຍ",
    "setup.label.EditPlan": "ແກ້ໄຂແຜນ",
    "setup.label.SelectProduct": "ເລືອກຜະລິດຕະພັນ",
    "setup.label.ViewPlan": "ເບິ່ງແຜນ",
    "setup.label.ProvisioningSystem": "ລະບົບການຈັດຫມາຍ",
    "setup.label.DeletePlan": "ລຶບແຜນ",
    "setup.label.Prices": "ລາຄາ",
    "setup.label.ChargeOwner": "ແຫລະຜູ້ເກັບເງິນ",
    "setup.label.DiscountCode": "ລະຫັດສ່ວນຫຼຸດ",
    "setup.label.PriceRegion": "ເຂດລາຄາ",
    "setup.label.Resource": "ຊັບສົມບັດ",
    "setup.label.SalesChannel": "ຊ່ອງທາງການຂາຍ",
    "setup.label.OrderType": "ປະເພດຄໍາສັ່ງ",
    "setup.label.BusinessType": "ປະເພດທຸລະກິດ",
    "setup.label.rounding_type": "ຮູບແບບສຸດທິ",
    "setup.label.gl_id": "GL Id",
    "setup.label.duration": "ຂໍ້ມູນການດໍາເນີນການ",
    "setup.label.value": "ຄ່າ",
    "setup.label.TemplateDefinition": "ການກໍານົດແບບເອກະສານ",
    "setup.label.CreateTemplateDefinition": "ສ້າງການກໍານົດແບບເອກະສານ",
    "setup.label.TemplateName": "ຊື່ແບບເອກະສານ",
    "setup.label.Delimiter": "ຕົວປ່ຽນ",
    "setup.label.NumberOfFields": "ຈຳນວນຄໍາສັ່ງ",
    "setup.label.HeaderRecorderType": "ປະເພດບັນຊີປະຈຸບັນ",
    "setup.label.EventRecordType": "ປະເພດການລະບຸຫຼັກ",
    "setup.label.ProductCode": "ລະຫັດຜະລິດຕິນ",
    "setup.label.IsHeader": "ແທັບຕົວປ່ຽນ",
    "setup.label.FieldType": "ປະເພດສິ່ງ",
    "setup.label.FieldName": "ຊື່ສິ່ງ",
    "setup.label.IdentifierType": "ປະເພດລະຫັດລັດ",
    "setup.label.Length": "ຄວາມສູງ",
    "setup.label.ExistsTemplateDefinition": "ມີການກໍານົດແບບເອກະສານ",
    "setup.label.UOM(Unit Of measurement)": "UOM (ລວມການຈັດສະຖານະ)",
    "setup.label.CreateUOM": "ສ້າງ UOM",
    "setup.label.Name": "ຊື່",
    "setup.label.EditTemplateDefinition": "ແກ້ໄຂຄວາມເຂົ້າຮ່ວມການ",
    "setup.label.EditUOM": "ແກ້ໄຂ UOM",
    "setup.label.Save": "ບັນທຶກ",
    "setup.label.DeleteUOM": "ລຶບ UOM",
    "setup.label.Ok": "ຕົກລົງ",
    "setup.label.ViewUOM": "ເບິ່ງ UOM",
    "setup.label.RUM(RatableUsageMetric)": "RUM (ຄໍາຖາມການໃຊ້ໄດ້)",
    "setup.label.CreateRUM": "ສ້າງ RUM",
    "setup.label.ChargeName": "ຊື່ເພື່ອຈ່າຍ",
    "setup.label.Template Name": "ຊື່ເພື່ອຕັ້ງຄ່າ",
    "setup.label.RumName": "ຊື່ Rum",
    "setup.label.RumExpression": "ການສ້າງຕົວຈິງ Rum",
    "setup.label.Operators": "ປະຕິບັດ",
    "setup.label.EditRUM": "ແກ້ໄຂ RUM",
    "setup.label.ViewRUM": "ເບິ່ງ RUM",
    "setup.label.TimePeriod": "ໄລຍະເວລາ",
    "setup.label.CreateTimePeriod": "ສ້າງໄລຍະເວລາ",
    "setup.label.TimeModelName": "ຊື່ແບບສະໝອງ",
    "setup.label.StartYear": "ປີເລີ່ມຕົ້ນ",
    "setup.label.EndYear": "ປີສິ້ນສຸດ",
    "setup.label.StartMonth": "ເດືອນເລີ່ມຕົ້ນ",
    "setup.label.EndMonth": "ເດືອນສິ້ນສຸດ",
    "setup.label.StartDay": "ວັນເລີ່ມຕົ້ນ",
    "setup.label.EndDay": "ວັນສິ້ນສຸດ",
    "setup.label.StartTime": "ເວລາເລີ່ມຕົ້ນ",
    "setup.label.EndTime": "ເວລາສິ້ນສຸດ",
    "setup.label.CreateTimeModel": "ສ້າງແບບສະໝອງ",
    "setup.label.ExpandAll / CollapseAll": "ເປີດທັງໝົດ / ຍ້ອນທັງໝົດ",
    "setup.label.AddTimemodel": "ເພີ່ມແບບສະໝອງ",
    "setup.label.UsageRatePlan": "ແຜນອັດຕາການໃຊ້ງານ",
    "setup.label.CreateUsageRatePlan": "ສ້າງແຜນອັດຕາການໃຊ້ງານ",
    "setup.label.PlanName": "ຊື່ແຜນ",
    "setup.label.ProductName": "ຊື່ຜະລິດຕະພັນ",
    "setup.label.TimemodelName": "ຊື່ແບບເວລາ",
    "setup.label.ViewUsageRatePlan": "ເບິ່ງແຜນອັດຕາການໃຊ້ງານ",
    "setup.label.RUM": "RUM",
    "setup.label.RatingType": "ປະເພດການປະເມີນ",
    "setup.label.TimeModel": "ແບບເວລາ",
    "setup.label.ZoneModel": "ແບບເຂດ",
    "setup.label.ViewQuantityTier": "ເບິ່ງລະດັບຈໍານວນ",
    "setup.label.QuantityTier": "ລະດັບຈໍານວນ",
    "setup.label.TierName": "ຊື່ລະດັບ",
    "setup.label.CumulativeResource": "ຊັບພະຍາກອນສະສົມ",
    "setup.label.TierRange": "ຂອບເຂດລະດັບ",
    "setup.label.StepName": "ຊື່ຂັ້ນຕອນ",
    "setup.label.StartRange": "ຂອບເຂດເລີ່ມຕົ້ນ",
    "setup.label.EndRange": "ຂອບເຂດສິ້ນສຸດ",
    "setup.label.AddQuantityTier": "ເພີ່ມຂັ້ນຕອນຈໍານວນ",
    "setup.label.NumberZone": "ເຂດຫມາຍເລກ",
    "setup.label.CreateNumberZone": "ສ້າງເຂດຫມາຍເລກ",
    "setup.label.SourceNumberPrefix": "ຄໍານໍາໜ້າຫມາຍເລກແຫຼ່ງ",
    "setup.label.DestinationNumberPrefix": "ຄໍານໍາໜ້າຫມາຍເລກປາຍທາງ",
    "setup.label.ImpactCategory": "ປະເພດຜົນກະທົບ",
    "setup.label.Rank": "ອັນດັບ",
    "setup.label.APNZone": "ເຂດ APN",
    "setup.label.APN": "APN",
    "setup.label.CreateAPNZone": "ສ້າງເຂດ APN",
    "setup.label.OperatorZone": "ເຂດຄົນຂັບລົດ",
    "setup.label.CreateOperatorZone": "ສ້າງເຂດຄົນຂັບລົດ",
    "setup.label.SourceOperatorCode": "ລະຫັດຄົນຂັບລົດແຫຼ່ງ",
    "setup.label.DestinationOperatorCode": "ລະຫັດຄົນຂັບລົດປາຍທາງ",
    "setup.label.ICZone": "ເຂດ IC",
    "setup.label.IncomingTrunkid": "Trunkid ເຂົ້າມາ",
    "setup.label.OutcomingTrunkid": "Trunkid ອອກ",
    "setup.label.CreateChargeCode": "ສ້າງລະຫັດການຄິດຄ່າບໍລິການ",
    "setup.label.ChargeDescription": "ລາຍລະອຽດການຄິດຄ່າບໍລິການ",
    "setup.label.ChargeType": "ປະເພດການຄິດຄ່າບໍລິການ",
    "setup.label.ChargeDuration": "ໄລຍະເວລາການຄິດຄ່າບໍລິການ",
    "setup.label.DurationType": "ປະເພດໄລຍະເວລາ",
    "setup.label.TaxInclusive": "ລວມພາສີ",
    "setup.label.BillFrequencyCode": "ລະຫັດຄວາມຖີ່ບິນ",
    "setup.label.TaxCode": "ລະຫັດພາສີ",
    "setup.label.IsAggregate": "ແມ່ນລວມທັງໝົດ",
    "setup.label.EditChargeCode": "ແກ້ໄຂລະຫັດການຄິດຄ່າບໍລິການ",
    "setup.label.TaxMaster": "ປຶດສະການສາລະກອນ",
    "setup.label.CreateTaxMaster": "ສ້າງປຶດສະການສາລະກອນ",
    "setup.label.GroupType": "ປະເພດກຸ່ມ",
    "setup.label.GroupCode": "ລະຫັດກຸ່ມ",
    "setup.label.StartDate": "ວັນເລີ່ມຕົ້ນ",
    "setup.label.Rate": "ອັດຕາ",
    "setup.label.BaseTaxCode": "ລະຫັດພາສີພື້ນຖານ",
    "setup.label.Jurisdiction": "ຂອບເຂດ",
    "setup.label.RateType": "ປະເພດອັດຕາ",
    "setup.label.Location": "ສະຖານທີ່",
    "setup.label.DeleteTax": "ລຶບພາສີ",
    "setup.label.CreateDiscount": "ສ້າງສ່ວນຫຼຸດ",
    "setup.label.DiscountDescription": "ຄຳອະທິບາຍສ່ວນຫຼຸດ",
    "setup.label.DiscountType": "ປະເພດສ່ວນຫຼຸດ",
    "setup.label.DiscountRate": "ອັດຕາສ່ວນຫຼຸດ",
    "setup.label.DiscountDetails": "ລາຍລະອຽດສ່ວນຫຼຸດ",
    "setup.label.ClientCategory": "ປະເພດລູກຄ້າ",
    "setup.label.CustomerCategory": "ປະເພດລູກຄ້າ",
    "setup.label.EditDiscount": "ແກ້ໄຂສ່ວນຫຼຸດ",
    "setup.label.DeleteDiscount": "ລຶບສ່ວນຫຼຸດ",
    "setup.label.CreatePromotion": "ສ້າງການສົ່ງເສີມການຂາຍ",
    "setup.label.PromotionCode": "ລະຫັດການສົ່ງເສີມການຂາຍ",
    "setup.label.PromotionName": "ຊື່ໂປຣໂມຊັນ",
    "setup.label.PromotionId": "ID ໂປຣໂມຊັນ",
    "setup.label.PromotionDescription": "ລາຍລະອຽດການສົ່ງເສີມການຂາຍ",
    "setup.label.EditPromotionCode": "ແກ້ໄຂລະຫັດການສົ່ງເສີມການຂາຍ",
    "setup.label.ListOfDiscounts": "ລາຍການສ່ວນຫຼຸດ",
    "setup.label.ListofTimePeriods": "ລາຍການໄລຍະເວລາ",
    "setup.label.CreatePriceRegion": "ສ້າງພາກລາຄາ",
    "setup.label.RegionCode": "ລະຫັດພາກ",
    "setup.label.RegionName": "ຊື່ພາກ",
    "setup.label.Country": "ປະເທດ",
    "setup.label.States": "ລັດ",
    "setup.label.EditPriceRegion": "ແກ້ໄຂພາກລາຄາ",
    "setup.label.DeletePriceRegion": "ລຶບພາກລາຄາ",
    "setup.label.CreateSalesCatalogue": "ສ້າງລາຍການຂາຍ",
    "setup.label.SalesCatalogueName": "ຊື່ຫຼັກສູດການຂາຍ",
    "setup.label.AssignUsers": "ມອບໝາຍຜູ້ໃຊ້",
    "setup.label.SalesPlanCategory": "ປະເພດແຜນການຂາຍ",
    "setup.label.Plans": "ແຜນ",
    "setup.label.EditSalesCatalogue": "ແກ້ໄຂລາຍການຂາຍ",
    "setup.label.DeleteSalesCatalogue": "ລຶບລາຍການຂາຍ",
    "setup.label.UserId": "ID ຜູ້ໃຊ້",
    "setup.label.UserName": "ຊື່ຜູ້ໃຊ້",
    "setup.label.CreateUsersCatalogue": "ສ້າງລາຍການຜູ້ໃຊ້",
    "setup.label.Catalogue": "ລາຍການ",
    "setup.label.EditUserCatalogue": "ແກ້ໄຂລາຍການຜູ້ໃຊ້",
    "setup.label.VoucherPins": "ລະຫັດບັດກຸມ",
    "setup.label.CreateVoucherPins": "ສ້າງລະຫັດບັດກຸມ",
    "setup.label.Voucher": "ບັດ",
    "setup.label.Coupon": "ຄູປອງ",
    "setup.label.LCO": "LCO",
    "setup.label.LengthOfPins": "ຄວາມຍາວຂອງພິນ",
    "setup.label.SerialNoLength": "ຄວາມຍາວເລກລຳດັບ",
    "setup.label.NumberValue ": "ຄ່າເລກ",
    "setup.label.PinValue ": "ຄ່າພິນ",
    "setup.label.BatchName": "ຊື່ລັດຊະນະ",
    "setup.label.PinCategory": "ປະເພດລະຫັດ",
    "setup.label.BeginWith": "ເລີ່ມດ້ວຍ",
    "setup.label.Quantity": "ປະລິມານ",
    "setup.label.PinType": "ປະເພດລະຫັດ",
    "setup.label.Value": "ມູນຄ່າ",
    "setup.label.SIMNumbers": "ເລກ SIM",
    "setup.label.CreateSIMNumber": "ສ້າງເລກ SIM",
    "setup.label.NumberCategory": "ປະເພດເລກ",
    "setup.label.ExpiryDate": "ວັນທີໝົດອາຍຸ",
    "setup.label.Partner": "ຫຼັກສູດ",
    "setup.label.LengthofNumber": "ຄວາມຍາວຂອງເລກ",
    "setup.label.LengthofSerialNumber": "ຄວາມຍາວຂອງລຳດັບເລກ",
    "setup.label.NumberType": "ປະເພດເລກ",
    "setup.label.Product": "ຜະລິດຕະພັນ",
    "setup.label.Supplier": "ຜູ້ສະໜອງ",
    "setup.label.CreateSupplier": "ສ້າງຜູ້ສະໜອງ",
    "setup.label.EditSupplier": "ແກ້ໄຂຜູ້ສະໜອງ",
    "setup.label.AddressMaster": "ທີ່ຢູ່ຫຼັກ",
    "setup.label.CountryName": "ຊື່ປະເທດ",
    "setup.label.StateName": "ຊື່ແຂວງ",
    "setup.label.DistrictName": "ຊື່ເມືອງ",
    "setup.label.CityName": "ຊື່ນະຄອນ",
    "setup.label.TreeView": "ມຸມມອງຕົ້ນໄມ້",
    "setup.label.AddCountry": "ເພີ່ມປະເທດ",
    "setup.label.CountryCode": "ລະຫັດປະເທດ",
    "setup.label.TeamHead": "ຫົວໜ້າທີມ",
    "setup.label.CreateTicketTeam": "ສ້າງທີມຕົວເລືອກ",
    "setup.label.TeamCode": "ລະຫັດທີມ",
    "setup.label.TeamDescription": "ລາຍລະອຽດທີມ",
    "setup.label.TeamCategory": "ປະເພດທີມ",
    "setup.label.CreateTicketTeamUsers": "ສ້າງຜູ້ໃຊ້ທີມຕົວເລືອກ",
    "setup.label.TeamEmail": "ອີເມວທີມ",
    "setup.label.AvailableUsers": "ຜູ້ໃຊ້ທີ່ມີ",
    "setup.label.SelectedUsers": "ຜູ້ໃຊ້ທີ່ເລືອກ",
    "setup.label.TeamId": "ລະຫັດທີມ",
    "setup.label.ViewTeam": "ເບິ່ງທີມ",
    "setup.label.DeleteTeam": "ລົບທີມ",
    "setup.label.EditTicketTeam": "ແກ້ໄຂທີມຕົວເລືອກ",
    "setup.label.TeamUser": "ຜູ້ໃຊ້ທີມ",
    "setup.label.EditTicketUsers": "ແກ້ໄຂຜູ້ໃຊ້ທີມຕົວເລືອກ",
    "setup.label.DeleteTeamUser": "ລົບຜູ້ໃຊ້ທີມ",
    "setup.label.VendorManagement": "ການຈັດການຜູ້ຂາຍ",
    "setup.label.CreateVendor": "ສ້າງຜູ້ຂາຍ",
    "setup.label.ContactName": "ຊື່ຜູ້ຕິດຕໍ່",
    "setup.label.Mobile": "ໂທລະສັບມືຖື",
    "setup.label.Landline": "ໂທລະສັບພື້ນຖານ",
    "setup.label.CreateNewVendor": "ສ້າງຜູ້ຂາຍໃຫມ່",
    "setup.label.EditVendor": "ແກ້ໄຂຜູ້ຂາຍ",
    "setup.label.FeeMaster": "ຄູ້ມຄອງຄ່າທໍານຽມ",
    "setup.label.CreateFeeMaster": "ສ້າງຄູ້ມຄອງຄ່າທໍານຽມ",
    "setup.label.FeeMasterCode": "ລະຫັດຄ່າທໍານຽມ",
    "setup.label.FeeMasterDescription": "ລາຍລະອຽດຄ່າທໍານຽມ",
    "setup.label.FeeMasterTransactionType": "ປະເພດການເຮັດທຸລະກໍາຂອງຄ່າທໍານຽມ",
    "setup.label.ChargeCode": "ລະຫັດເກັບເງິນ",
    "setup.label.VariablePricing": "ການຕັ້ງລາຄາແບບປ່ຽນແປງໄດ້",
    "setup.label.Regions": "ພາກພື້ນ",
    "setup.label.Amount": "ຈໍານວນເງິນ",
    "setup.label.EditFeeMaster": "ແກ້ໄຂຄ່າທໍານຽມ",
    "setup.label.ManageMessage": "ຄຸ້ມຄອງຂໍ້ຄວາມ",
    "setup.label.AddMessage": "ເພີ່ມຂໍ້ຄວາມ",
    "setup.label.TemplateDescription": "ລາຍລະອຽດແມ່ແບບ",
    "setup.label.Subject": "ຫົວຂໍ້",
    "setup.label.MessageType": "ປະເພດຂໍ້ຄວາມ",
    "setup.label.Header": "ສ່ວນຫົວ",
    "setup.label.Body": "ເນື້ອໃນ",
    "setup.label.Footer": "ສ່ວນທ້າຍ",
    "setup.label.CreateMessageTemplate": "ສ້າງແມ່ແບບຂໍ້ຄວາມ",
    "setup.label.MessageParams": "ພາລາມິເຕີຂໍ້ຄວາມ",
    "setup.label.Parameter": "ພາລາມິເຕີ",
    "setup.label.Params": "ພາລາມິເຕີ",
    "setup.label.DeleteMessage": "ລຶບຂໍ້ຄວາມ",
    "setup.label.EditMessage": "ແກ້ໄຂຂໍ້ຄວາມ",
    "setup.label.GroupsDetails": "ລາຍລະອຽດກຸ່ມ",
    "setup.label.GroupName": "ຊື່ກຸ່ມ",
    "setup.label.GroupAddress": "ທີ່ຢູ່ກຸ່ມ",
    "setup.label.CountNo's": "ນັບເລກ",
    "setup.label.AddGroup": "ເພີ່ມກຸ່ມ",
    "setup.label.AdditionalInformation": "ຂໍ້ມູນເພີ່ມເຕີມ",
    "setup.label.GroupCIR": "CIR ກຸ່ມ",
    "setup.label.DIR": "DIR",
    "setup.label.MemberCIR": "CIR ສະມາຊິກ",
    "setup.label.IpPoolManagement": "ການຈັດການ IP Pool",
    "setup.label.UpdateNetMask": "ອັບເດດ Net Mask",
    "setup.label.IpAddress": "ທີ່ຢູ່ IP",
    "setup.label.NetMark": "Net Mark",
    "setup.label.IpType": "ປະເພດ IP",
    "setup.label.CoustomerId": "ລະຫັດລູກຄ້າ",
    "setup.label.CustomerName": "ຊື່ລູກຄ້າ",
    "setup.label.Notes": "ຫມາຍເຫດ",
    "setup.label.Subnet": "Subnet",
    "setup.label.DetailsOfMedia": "ລາຍລະອຽດຂອງສື່",
    "setup.label.Media": "ສື່",
    "setup.label.AddMedia": "ເພີ່ມສື່",
    "setup.label.MediaTitle": "ຊື່ສື່",
    "setup.label.MediaCatagory": "ປະເພດສື່",
    "setup.label.ContentProvider": "ຜູ້ໃຫ້ບໍລິການເນື້ອຫາ",
    "setup.label.Share": "ແບ່ງປັນ(%)",
    "setup.label.AddMediaDetails": "ເພີ່ມລາຍລະອຽດຂອງສື່",
    "setup.label.MediaLocation": "ສະຖານທີ່ຂອງສື່",
    "setup.label.SelectMediaCategory": "ເລືອກປະເພດສື່",
    "setup.label.Movies": "ຮູບເງົາ",
    "setup.label.ViewMedia": "ເບິ່ງສື່",
    "setup.label.EditMedia": "ແກ້ໄຂສື່",
    "setup.label.MediaAttributes": "ຄຸນສົມບັດຂອງສື່",
    "setup.label.Cast": "ນັກສະແດງ",
    "setup.label.AttributeType": "ປະເພດຄຸນສົມບັດ",
    "setup.label.CaptionValue": "ຄ່າຄຳອະທິບາຍ",
    "setup.label.NickName": "ຊື່ຫຼີ້ນ",
    "setup.label.Image": "ຮູບພາບ",
    "setup.label.AddMediaLocations": "ເພີ່ມສະຖານທີ່ສື່",
    "setup.label.LanguageData": "ຂໍ້ມູນພາສາ",
    "setup.label.FormatData": "ຂໍ້ມູນຮູບແບບ",
    "setup.label.MediaLocations": "ສະຖານທີ່ສື່",
    "setup.label.DetailsOfEvent": "ລາຍລະອຽດຂອງເຫດການ",
    "setup.label.EventName": "ຊື່ເຫດການ",
    "setup.label.EventCode": "ລະຫັດເຫດການ",
    "setup.label.SelectedMediaService": "ບໍລິການສື່ທີ່ເລືອກ",
    "setup.label.AvailableMedia": "ສື່ທີ່ມີຢູ່",
    "setup.label.EventDescription": "ລາຍລະອຽດເຫດການ",
    "setup.label.EventCategory": "ປະເພດເຫດການ",
    "setup.label.CreateEvent": "ສ້າງເຫດການ",
    "setup.label.DetailsOfProperty": "ລາຍລະອຽດຂອງຊັບຊິນ",
    "setup.label.PropertyCode": "ລະຫັດຊັບຊິນ",
    "setup.label.PropertyType": "ປະເພດຊັບຊິນ",
    "setup.label.Parcel": "ພາດສະລີ",
    "setup.label.BuildingCode": "ລະຫັດອາຄານ",
    "setup.label.Precinct": "ບ້ານ",
    "setup.label.Allocated": "ຈັດສັນ",
    "setup.label.UploadPropertyData": "ອັບໂຫລດຂໍ້ມູນຊັບຊິນ",
    "setup.label.Clear": "ລົບ",
    "setup.label.CreateProperty": "ສ້າງຊັບຊິນ",
    "setup.label.PropertyDataUpload": "ອັບໂຫລດຂໍ້ມູນຊັບຊິນ",
    "setup.label.Street": "ຖະໜົນ",
    "setup.label.PaymentType": "ປະເພດການຈ່າຍເງິນ",
    "setup.label.PoBox": "ປ່ອງໄປສະນີ",
    "setup.label.State": "ລັດ",
    "setup.label.District": "ເມືອງ",
    "setup.label.Floor": "ຊັ້ນ",
    "setup.label.LimitCode": "ລະຫັດຂອບເຂດ",
    "setup.label.PropertyMaster": "ຜູ້ບໍລິຫານຊັບສິນ",
    "setup.label.CodeDescription": "ລາຍລະອຽດລະຫັດ",
    "setup.label.ReferenceValue": "ຄ່າອ້າງອິງ",
    "setup.label.Services": "ການບໍລິການ",
    "setup.label.IsBouquet": "ເປັນກຸ່ມດອກໄມ້",
    "setup.label.Broadcaster": "ຜູ້ຖ່າຍທອດ",
    "setup.label.Channel": "ຊ່ອງ",
    "setup.label.ContactNumber": "ເບີຕິດຕໍ່",
    "setup.label.UOM": "ຫົວໜ່ວຍ",
    "setup.label.DeleteTemplateDefinition": "ລຶບການກຳນົດແມ່ແບບ",
    "setup.label.Discount": "ສ່ວນຫຼຸດ",
    "setup.label.SalseCatalogue": "ລາຍການຂາຍ",
    "setup.label.UserCatalogue": "ລາຍການຜູ້ໃຊ້",
    "setup.label.Team": "ທີມ",
    "setup.label.MediaDetails": "ລາຍລະອຽດສື່",
    "setup.label.Event": "ເຫດການ",
    "setup.label.Properties": "ຄຸນສົມບັດ",
    "setup.label.ServicesProducts": "ບໍລິການແລະຜະລິດຕະພັນ",
    "setup.label.BroadcasterChannelMapping": "ຜູ້ຖ່າຍທອດ, ຊ່ອງແລະການສ້າງແຜນທີ່",
    "setup.label.UsageRating": "ການປະເມີນການໃຊ້ງານ",
    "setup.label.ZoneSetup": "ການຕັ້ງຄ່າເຂດ",
    "setup.label.Promotion": "ສໍາລັບການສໍາລັບ",
    "setup.label.PromotionTrigger": "ກະຕຸ້ນສົ່ງເສີມ",
    "setup.label.PromotionRulesAndRates": "ກົດລະບຽບການສົ່ງເສີມແລະອັດຕາ",
    "setup.label.CatalogeMapping": "ການສ້າງແຜນທີ່ແຄຕາລອກ",
    "setup.label.VoucherPin": "ລະຫັດປີນ",
    "setup.label.SIMNumber": "ເລກ SIM",
    "setup.label.TeamTeamUser": "ທີມແລະຜູ້ໃຊ້ທີມ",
    "setup.label.MessageTemplate": "ແມ່ແບບຂໍ້ຄວາມ",
    "setup.label.ClosedUserGroup": "ກຸ່ມຜູ້ໃຊ້ປິດ",
    "setup.label.IpManagement": "ການຄຸ້ມຄອງ IP",
    "setup.label.PropertyDefinition": "ຄຳນິຍາມຊັບສິນ",
    "setup.label.PriorityMapping": "ແຜນທີ່ບູລິມະສິດ",
    "setup.label.AddProducts": "ເພີ່ມຜະລິດຕະພັນ",
    "setup.label.AddDiscount": "ເພີ່ມສ່ວນຫຼຸດ",
    "setup.label.Products": "ຜະລິດຕະພັນ",
    "setup.label.ChargeCodeData": "ຂໍ້ມູນລະຫັດຄ່າທຳນຽມ",
    "setup.label.TaxMapping": "ການສັນຖານພາສີ",
    "setup.label.TaxRegion": "ພາກພາສີ",
    "setup.label.CreateUserCatalogue": "ສ້າງແຄັດຕາລ໋ອກຜູ້ໃຊ້",
    "setup.label.IcZone": "ເຂດ Ic",
    "setup.label.ViewIcZone": "ເບິ່ງເຂດ Ic",
    "setup.label.ViewNumberZone": "ເບິ່ງເຂດໝາຍເລກ",
    "setup.label.EditNumberZone": "ແກ້ໄຂເຂດໝາຍເລກ",
    "setup.label.DeleteNumberZone": "ລົບເຂດໝາຍເລກ",
    "setup.label.AreYouSure": "ເຈົ້າແນ່ໃຈບໍ?",
    "setup.label.ViewAPNZone": "ເບິ່ງເຂດ APN",
    "setup.label.EditAPNZone": "ແກ້ໄຂເຂດ APN",
    "setup.label.DeleteAPNZone": "ລົບເຂດ APN",
    "setup.label.ViewOperatorZone": "ເບິ່ງເຂດຜູ້ດຳເນີນງານ",
    "setup.label.EditOperatorZone": "ແກ້ໄຂເຂດຜູ້ດຳເນີນງານ",
    "setup.label.CreateICZone": "ສ້າງເຂດ IC",
    "setup.label.EditICZone": "ແກ້ໄຂເຂດ IC",
    "setup.label.DeleteOperatorZone": "ລົບເຂດຜູ້ດຳເນີນງານ",
    "setup.label.DeleteIcZone": "ລົບເຂດ IC",
    "setup.label.MobileNumber": "ເລກມືຖື",
    "setup.label.LandlineNumber": "ເບີໂທຫັດຄອບ (ທາງເລືອກ)",
    "setup.label.RatePlanName": "ຊື່ແຜນອັດຕາ",
    "setup.label.UsageRateBalance": "ຍອດຄົງເຫລືອອັດຕາໃຊ້",
    "setup.label.ValidityType": "ປະເພດຄວາມຖືກຕ້ອງ",
    "setup.label.ListOfRateTires": "ບັນຊີລາຍຊື່ຂອງຢາງລົດອັດຕາ",
    "setup.label.Validity": "ຄວາມຖືກຕ້ອງ",
    "setup.label.CreatePlanName": "ສ້າງຊື່ແຜນ",
    "setup.label.EditPlanContent": "ແກ້ໄຂເນື້ອໃນແຜນ",
    "setup.label.CreatePlanDescription": "ສ້າງຄໍາອະທິບາຍແຜນ",
    "setup.label.ContentType": "ປະເພດເນື້ອໃນ",
    "setup.label.CreateFeatureList": "ສ້າງບັນຊີລາຍການຄຸນສົມບັດ",
    "setup.label.Area": "ພື້ນທີ່",
    "setup.label.TaxPercentage": "ອັດຕາພາສີ",
    "setup.label.Add": "ເພີ່ມ",
    "setup.label.Remove": "ເອົາອອກ",
    "setup.label.CreateVoucherPin": "ສ້າງລະຫັດບັດຂອງຂວັນ",
    "setup.label.EditSubCategory": "ແກ້ໄຂປະເພດຍ່ອຍ",
    "setup.label.CreateSubCategory": "ສ້າງປະເພດຍ່ອຍ",
    "setup.label.ViewSubCategory": "ເບິ່ງປະເພດຍ່ອຍ",
    "setup.label.TimeTaken": "ເວລາປະຕິບັດ",
    "setup.label.TeamMapping": "ການແມບທີມ",
    "setup.label.CreateTeamMapping": "ສ້າງການແມບທີມ",
    "setup.label.Category": "ໝວດຝູ່",
    "setup.label.external_promotional_code": "ລະຫັດສົ່ງເສີມການຂາຍພາຍນອກ",
    "setup.label.Subcategory": "ຊັ້ນຕໍ່ຂອງຫມວດຝູ່",
    "setup.label.DeleteItemMapping": "ລຶບການແມບລາຍການ",
    "setup.label.EditTeamMapping": "ແກ້ໄຂການແມບທີມ",
    "setup.label.ViewTeamMapping": "ເບິ່ງການແມບທີມ",
    "setup.label.DeletePriorityMapping": "ລຶບການກຳນົດຄວາມສຳຄັນ",
    "setup.label.discount_rule": "ກົດການສ່ວນລຸດ",
    "setup.label.promotion_rule": "ກົດລະບຽບການສົ່ງເສີມ",
    "setup.label.discount_rate": "ອັດຕາສ່ວນລຸດ",
    "setup.label.create_discount_rule": "ສ້າງກົດລະບຽບການຫຼຸດລາຄາ",
    "setup.label.edit_promotion_rule": "ແກ້ໄຂກົດລະບຽບການສົ່ງເສີມ",
    "setup.label.create_promotion_rule": "ສ້າງກົດລະບຽບການສົ່ງເສີມ",
    "setup.label.create_discount_rate": "ສ້າງອັດຕາສ່ວນຫຼຸດ",
    "setup.label.add_discount_rate": "ເພີ່ມອັດຕາສ່ວນລຸດ",
    "setup.label.add_promotion_rate": "ເພີ່ມອັດຕາການສົ່ງເສີມ",
    "setup.label.edit_discount": "ແກ້ໄຂສ່ວນລຸດ",
    "setup.label.edit_promotion": "ແກ້ໄຂໂປຣໂມຊັນ",
    "setup.label.edit_discount_trigger": "ແກ້ໄຂການເປີດເບີກສ່ວນລຸດ",
    "setup.label.edit_discount_rule": "ແກ້ໄຂກົດການສ່ວນລຸດ",
    "setup.label.collection_process": "ການເກັບກຳ",
    "setup.label.create_collection_profile": "ສ້າງໂປຣໄຟລ໌ການເກັບກຳ",
    "setup.label.collection_profile": "ໂປຣໄຟລ໌ການເກັບກຳ",
    "setup.label.collection_profile_id": "ID ໂປຣໄຟລ໌ການເກັບກຳ",
    "setup.label.region": "ເຂດພື້ນທີ່",
    "setup.label.collection": "ການເກັບກຳ",
    "setup.label.collection_trigger": "ການເກັບກຳທີ່ເລີ່ມຕົ້ນ",
    "setup.label.collection_scenario": "ສະຖານະການການເກັບກຳ",
    "setup.label.add_collection_trigger": "ເພີ່ມການເລີ່ມຕົ້ນການເກັບກຳ",
    "setup.label.add_collection_scenario": "ເພີ່ມສະຖານະການການເກັບກຳ",
    "setup.label.trigger_id": "ຊື່ໄອດີ",
    "setup.label.criteria_type": "ປະເພດເກນ",
    "setup.label.due_balance": "ຍອດຄົງເຫຼືອຄ້າງ",
    "setup.label.ageing_days": "ວັນທີການເຕີບໂຕ",
    "setup.label.scenario_id": "ຊື່ສະຖານະການ",
    "setup.label.action_name": "ຊື່ການກະທຳ",
    "setup.label.age": "ອາຍຸ",
    "setup.label.create_collection_trigger": "ສ້າງການເລີ່ມຕົ້ນການເກັບກຳ",
    "setup.label.create_collection_scenario": "ສ້າງສະຖານະການການເກັບກຳ",
    "setup.label.edit_collection_profile": "ແກ້ໄຂໂປຣໄຟລ໌ການເກັບກຳ",
    "setup.label.edit_collection_trigger": "ແກ້ໄຂການເລີ່ມຕົ້ນການເກັບກຳ",
    "setup.label.edit_collection_scenario": "ແກ້ໄຂສະຖານະການການເກັບກຳ",
    "setup.label.SlaInHours": "SLA ໃນຊົ່ວໂມງ",
    "setup.label.contractduration": "ໄລຍະເວລາສັນຍາ",
    "setup.label.chargesperiodicity": "ໄລຍະເວລາຄ່າໃຊ້ຈ່າຍ",
  },

  my_MM: {
    "setup.label.Enter_product_Description": "ထုတ်ကုန်ဖော်ပြချက်ထည့်ပါ",
    "setup.label.FeedbackStatus": "တုံ့ပြန်ချက်အခြေအနေ",
    "setup.label.EnterCountryName": "နိုင်ငံအမည်ထည့်ပါ",
    "setup.label.location": "တည်နေရာ",
    "setup.label.selectLocation": "တည်နေရာရွေးချယ်ပါ",
    "setup.label.create_group_ticket": "အုပ်စုလက်မှတ်ဖန်တီးပါ",
    "setup.label.default": "အခြေခံ",
    "setup.label.customerFeedback": "ဖောက်သည်တုံ့ပြန်ချက်",
    "setup.label.automation": "အော်တိုမိတ်",
    "setup.label.automation_master": "အော်တိုမိတ် မာစတာ",
    "setup.label.create_automation": "အော်တိုမိတ်ဖန်တီးရန်",
    "setup.label.edit_automation": "အော်တိုမိတ်တည်းဖြတ်ရန်",
    "setup.label.automation_detail": "အော်တိုမိတ်အသေးစိတ်",
    "setup.label.automation_steps": "အော်တိုမိတ်အဆင့်များ",
    "setup.label.add_automation_step": "အော်တိုမိတ်အဆင့်ထည့်ရန်",
    "setup.label.AutomationId": "အော်တိုမိတ် ID",
    "setup.label.EntityName": "အဖွဲ့အစည်းအမည်",
    "setup.label.EntityType": "အဖွဲ့အစည်းအမျိုးအစား",
    "setup.label.WorkflowName": "အလုပ်စဉ်အမည်",
    "setup.label.CreateAutomationScenario": "အော်တိုမိတ်အခြေအနေဖန်တီးရန်",
    "setup.label.EditAutomationStep": "အော်တိုမိတ်အဆင့်တည်းဖြတ်ရန်",
    "setup.label.ActionType": "လုပ်ဆောင်မှုအမျိုးအစား",
    "setup.label.ActionDetails": "လုပ်ဆောင်မှုအသေးစိတ်",
    "setup.label.StepOrder": "အဆင့်အတိုင်းအတာ",
    "setup.label.questionAnswerSet": "မေးခွန်းနှင့်တုံ့ပြန်ချက်စနစ်",
    "setup.label.addQuestionSet": "မေးခွန်းစနစ်ထည့်ရန်",
    "setup.label.EditQuestionSet": "မေးခွန်းစနစ်ပြင်ဆင်ရန်",
    "setup.label.CategoryName": "အမျိုးအစားအမည်",
    "setup.label.SubCategoryName": "အဆင့်အလိုက်အမည်",
    "setup.label.TotalQuestions": "စုစုပေါင်းမေးခွန်းများ",
    "setup.label.QuestionType": "မေးခွန်းအမျိုးအစား",
    "setup.label.QuestionText": "မေးခွန်းစာသား",
    "setup.label.CustomerFeedback": "ဖောက်သည်တုံ့ပြန်ချက်",
    "setup.label.TicketId": "တိုက်ပွဲ ID",
    "setup.label.LinkedAt": "ချိတ်ဆက်ခဲ့သောအချိန်",
    "setup.label.Remarks": "မှတ်ချက်များ",
    "setup.label.AddFeedback": "တုံ့ပြန်ချက်ထည့်ရန်",
    "setup.label.PendingForApproval": "အတည်ပြုချက်အတွက်ဆိုင်းငံ့နေပါသည်",
    "setup.label.user_availability": "အသုံးပြုသူရရှိနိုင်မှု",
    "setup.label.all_users_availability": "အသုံးပြုသူအားလုံးရရှိနိုင်မှု",
    "setup.label.create_user_availability": "အသုံးပြုသူရရှိနိုင်မှု ဖန်တီးရန်",
    "setup.label.LeaveManagement": "အလုပ်လွတ်စီမံခန့်ခွဲမှု",
    "setup.label.CreateLeave": "အလုပ်လွတ်ဖန်တီးရန်",
    "setup.label.EditLeave": "အလုပ်လွတ်တည်းဖြတ်ရန်",
    "setup.label.ViewLeave": "အလုပ်လွတ်ကြည့်ရန်",
    "setup.label.AllUserLeaves": "အသုံးပြုသူများ၏အလုပ်လွတ်အားလုံး",
    "setup.label.MyLeaves": "ကျွန်ုပ်၏အလုပ်လွတ်များ",
    "setup.label.ConfigId": "ဖွဲ့စည်းမှု ID",
    "setup.label.edit_user_availability": "အသုံးပြုသူရရှိနိုင်မှု တည်းဖြတ်ရန်",
    "setup.label.view_user_availability": "အသုံးပြုသူရရှိနိုင်မှု ကြည့်ရန်",
    "setup.label.unavailability_date": "မရရှိနိုင်သောရက်စွဲ",
    "setup.label.start_time": "စတင်ချိန်",
    "setup.label.end_time": "ပြီးဆုံးချိန်",
    "setup.label.my_availability": "ကျွန်ုပ်၏ရရှိနိုင်မှု",
    "setup.label.user": "အသုံးပြုသူ",
    "setup.label.EditShift": "အလှည့်အချိန် တည်းဖြတ်ရန်",
    "setup.label.UserWorkingShift": "အသုံးပြုသူ၏ အလုပ်အမှုဆောင်အချိန်",
    "setup.label.CreateUserWorkingShift":
      "အသုံးပြုသူ၏ အလုပ်အမှုဆောင်အချိန် ဖန်တီးရန်",
    "setup.label.EditUserWorkingShift":
      "အသုံးပြုသူ၏ အလုပ်အမှုဆောင်အချိန် တည်းဖြတ်ရန်",
    "setup.label.ViewUserWorkingShift": "အသုံးပြုသူအလုပ်အမှာစာကြည့်ရန်",
    "setup.label.TeamName": "အဖွဲ့အမည်",
    "setup.label.Shift": "အလှည့်ကျအချိန်",
    "setup.label.ShiftManagement": "အလှည့်ကျအချိန် စီမံခန့်ခွဲမှု",
    "setup.label.CreateShift": "အလှည့်ကျအချိန် ဖန်တီးရန်",
    "setup.label.ShiftName": "အလှည့်အချိန်အမည်",
    "setup.label.Session": "အစည်းအဝေး",
    "setup.label.SessionType": "အစည်းအဝေးအမျိုးအစား",
    "setup.label.LeaveDetails": "အသေးစိတ်အလုပ်လွတ်",
    "setup.label.SessionStartTime": "အစည်းအဝေးစတင်ချိန်",
    "setup.label.SessionEndTime": "အစည်းအဝေးပြီးဆုံးချိန်",
    "setup.label.LeaveType": "အားလပ်ချိန်အမျိုးအစား",
    "setup.label.AddAnotherDate": "နောက်ထပ်ရက်စွဲ ထည့်ရန်",
    "setup.label.Apn_Zone": "APN ဒေသ",
    "setup.label.FeeMaster": "ကြေးအုပ်ချုပ်သူ",
    "setup.label.Number_Zone": "နံပါတ်ဒေသ",
    "setup.label.DeleteRUM": "RUM ဖျက်ပါ",
    "setup.label.Edit_TimeModel": "အချိန်မော်ဒယ် တည်းဖြတ်ပါ",
    "setup.label.Edit_Year": "နှစ် တည်းဖြတ်ပါ",
    "setup.label.scenario_name": "သဘောတူညီချက်အမည်",
    "setup.label.event_name": "ဖြစ်ရပ်အမည်",
    "setup.label.Edit_Month": "လ တည်းဖြတ်ပါ",
    "setup.label.Edit_Day": "နေ့ တည်းဖြတ်ပါ",
    "setup.label.Edit_Time": "အချိန် တည်းဖြတ်ပါ",
    "setup.label.Delete_TimeModel": "အချိန်မော်ဒယ် ဖျက်ပါ",
    "setup.label.Delete_Year": "နှစ် ဖျက်ပါ",
    "setup.label.Delete_Month": "လ ဖျက်ပါ",
    "setup.label.Delete_Day": "နေ့ ဖျက်ပါ",
    "setup.label.Delete_Time": "အချိန် ဖျက်ပါ",
    "setup.label.Are_you_sure_?": "သေချာပါသလား?",
    "setup.label.Save": "သိမ်းဆည်းပါ",
    "setup.label.TemplateDefinition": "ပုံစံ သတ်မှတ်ချက်",
    "setup.label.EditQuantityTier": "အရေအတွက်အဆင့် တည်းဖြတ်ပါ",
    "setup.label.Usage_Rate_Balance": "အသုံးပြုနှုန်း လက်ကျန်ငွေ",
    "setup.label.Template_Name": "ပုံစံအမည်",
    "setup.label.Delimiter": "ခွဲခြားသတ်မှတ်ချက်",
    "setup.label.Number_Of_Fields": "ကွက်အရေအတွက်",
    "setup.label.Header_Recorder_Type": "ခေါင်းစဉ်မှတ်တမ်းအမျိုးအစား",
    "setup.label.Event_Record_Type": "ဖြစ်ရပ်မှတ်တမ်းအမျိုးအစား",
    "setup.label.CreateUOM": "ယူနစ်ဖန်တီးမည်",
    "setup.label.TimePeriod": "အချိန်ကာလ",
    "setup.label.Usage_Rate_Plan": "အသုံးပြုနှုန်းအစီအစဉ်",
    "setup.label.TemplateDefinition": "ပုံစံအဓိပ္ပါယ်ဖော်ပြချက်",
    "setup.label.CreateRUM": "RUM ဖန်တီးမည်",
    "setup.label.CreateTimePeriod": "အချိန်ကာလဖန်တီးမည်",
    "setup.label.TimemodelName": "အချိန်မော်ဒယ်အမည်",
    "setup.label.TimePeriodName": "အချိန်ကာလအမည်",
    "setup.label.StartYear": "စတင်နှစ်",
    "setup.label.EndYear": "ပြီးဆုံးနှစ်",
    "setup.label.UsageRatePlan": "အသုံးပြုနှုန်းအစီအစဉ်",
    "setup.label.Create_Usage_Rate_Plan": "အသုံးပြုနှုန်းအစီအစဉ်ဖန်တီးမည်",
    "setup.label.Id": "အိုင်ဒီ",
    "setup.label.PlanName": "အစီအစဉ်အမည်",
    "setup.label.ProductName": "ထုတ်ကုန်အမည်",
    "setup.label.ChargeCode": "အခကြေးငွေကုဒ်",
    "setup.label.TimeModelName": "အချိန်မော်ဒယ်အမည်",
    "setup.label.RatingType": "အဆင့်သတ်မှတ်မှုအမျိုးအစား",
    "setup.label.RumName": "RUM အမည်",
    "setup.label.Are_you_sure_you_want_to_delete_?": "ဖျက်ရန်သေချာပါသလား?",
    "setup.label.UOM": "တိုင်းတာယူနစ်",
    "setup.label.RUM": "RUM",
    "setup.label.ImpactCategory": "သက်ရောက်မှုအမျိုးအစား",
    "setup.label.Resource": "အရင်းအမြစ်",
    "setup.label.GLID": "GLID",
    "setup.label.Unit": "ယူနစ်",
    "setup.label.Rate": "နှုန်းထား",
    "setup.label.Action": "လှုပ်ရှားမှု",
    "setup.label.options_selected": "ရွေးချယ်ထားသောရွေးချယ်မှုများ",
    "setup.label.UsageRateBalance": "သုံးစွဲမှုနှုန်းအကျန်",
    "setup.label.EndYear": "ပြီးဆုံးသည့်နှစ်",
    "setup.label.StartMonth": "စတင်လ",
    "setup.label.EndMonth": "ပြီးဆုံးလ",
    "setup.label.StartDay": "စတင်သောနေ့",
    "setup.label.EndDay": "ပြီးဆုံးသောနေ့",
    "setup.label.StartTime": "စတင်ချိန်",
    "setup.label.Time_Model_Name": "အချိန်မော်ဒယ်အမည်",
    "setup.label.model_includes_which_all_Bands_?":
      "မော်ဒယ်တွင်ဘယ်ဘန်များ ပါဝင်သလဲ?",
    "setup.label.YearRestriction": "နှစ်ကန့်သတ်ချက်",
    "setup.label.MonthRestriction": "လကန့်သတ်ချက်",
    "setup.label.DayRestriction": "နေ့ကန့်သတ်ချက်",
    "setup.label.TimeRestriction": "အချိန်ကန့်သတ်ချက်",
    "setup.label.Code": "ကုဒ်",
    "setup.label.Name": "နာမည်",
    "setup.label.PriorityMapping": "ဦးစားပေးအဆင့်ချထားခြင်း",
    "setup.label.AddJurisdiction": "တရားဝင်နယ်မြေရေးထည့်ပါ",
    "setup.label.Are_you_sure_?": "သေချာပါသလား?",
    "setup.label.Country": "နိုင်ငံ",
    "setup.label.State": "ပြည်နယ်/တိုင်း",
    "setup.label.District": "ခရိုင်",
    "setup.label.RateType": "အခွန်နှုန်းအမျိုးအစား",
    "setup.label.Remove": "ဖျက်ပါ",
    "setup.label.TaxMaster": "အခွန်စီမံခန့်ခွဲမှု",
    "setup.label.Team": "အဖွဲ့",
    "setup.label.Add": "ထည့်ပါ",
    "setup.label.FeeMaster": "ကြေး စီမံခန့်ခွဲသူ",
    "setup.label.DeleteChargeCode": "ခေါ်ယူကုဒ်ဖျက်ပါ",
    "setup.label.SelectSearch": "ရှာဖွေရန်ရွေးပါ",
    "setup.label.Select_Content_Tag_Value":
      "အကြောင်းအရာတပ်ထားသောတန်ဖိုးကို ရွေးပါ",
    "setup.label.Plan_Content": "အစီအစဉ်အကြောင်းအရာ",
    "setup.label.Plan": "အစီအစဉ်",
    "setup.label.ProductPrice": "ကုန်ပစ္စည်းဈေးနှုန်း",
    "setup.label.SelectedPromotions": "ရွေးချယ်ထားသော ပရိုမိုးရှင်းများ",
    "setup.label.AvailablePromotions": "ရရှိနိုင်သော ပရိုမိုးရှင်းများ",
    "setup.label.SelectType": "အမျိုးအစား ရွေးချယ်ပါ",
    "setup.label.Type": "အမျိုးအစား",
    "setup.label.No_versions_available": "ဗားရှင်း မရှိပါ",
    "setup.label.Version": "ဗားရှင်း",
    "setup.label.ListPrice": "စျေးနှုန်းစာရင်း",
    "setup.label.SellingPrice": "ရောင်းချမှုစျေးနှုန်း",
    "setup.label.EnterPlanDescription": "အစီအစဉ်ဖော်ပြချက် ထည့်ပါ",
    "setup.label.AddPrice": "စျေးနှုန်းထည့်ပါ",
    "setup.label.Save": "သိမ်းဆည်းပါ",
    "setup.label.AddDiscount": "လျော့ဈေးထည့်ပါ",
    "setup.label.AvailablePlans": "ရရှိနိုင်သော အစီအစဉ်များ",
    "setup.label.SelectedPlans": "ရွေးချယ်ထားသော အစီအစဉ်များ",
    "setup.label.PlanType": "အစီအစဉ် အမျိုးအစား",
    "setup.label.Plan_Start_Date": "အစီအစဉ် စတင်မည့်နေ့",
    "setup.label.Plan_End_Date": "အစီအစဉ် အဆုံးသတ်နေ့",
    "setup.label.Bill_Type": "ဘီလ် အမျိုးအစား",
    "setup.label.AttributeTypes": "ဂုဏ်သတ္တိများ အမျိုးအစား",
    "setup.label.Add": "ထည့်ပါ",
    "setup.label.Select_Content_Tag": "အကြောင်းအရာ တပ်ဆင်ရန် ရွေးချယ်ပါ",
    "setup.label.PlanName": "အစီအစဉ်အမည်",
    "setup.label.AvailableDiscounts": "ရရှိနိုင်သော လျှော့စျေးများ",
    "setup.label.Search": "ရှာဖွေပါ...",
    "setup.label.MoveRight": "ညာဘက်သို့ရွှေ့ပါ",
    "setup.label.MoveLeft": "ဘယ်ဘက်သို့ရွှေ့ပါ",
    "setup.label.SelectedDiscounts": "ရွေးချယ်ထားသော လျှော့စျေးများ",
    "setup.label.SelectType": "အမျိုးအစားရွေးချယ်ပါ",
    "setup.label.SelectLanguage": "ဘာသာစကားရွေးချယ်ပါ",
    "setup.label.SelectContentTag": "အကြောင်းအရာတပ်ဆင်မှုရွေးပါ",
    "setup.label.SelectContentTagValue": "တပ်ဆင်မှုတန်ဖိုးရွေးပါ",
    "setup.label.DigitalContent": "ဒစ်ဂျစ်တယ်အကြောင်းအရာ",
    "setup.label.Enter_Plan_Description": "အစီအစဉ်ဖော်ပြချက် ထည့်သွင်းပါ",
    "setup.label.DC_Rule": "DC စည်းမျဉ်း",
    "setup.label.PlanAttribute": "အစီအစဉ် ဂုဏ်သတ္တိများ",
    "setup.label.AdvanceView": "အဆင့်မြင့်မြင်ကွင်း",
    "setup.label.Update": "အပ်ဒိတ်လုပ်ပါ",
    "setup.label.ProductMapping": "ထုတ်ကုန်ချိတ်ဆက်မှု",
    "setup.label.Service": "ဝန်ဆောင်မှု",
    "setup.label.SubProducts": "ထုတ်ကုန်ခွဲများ",
    "setup.label.Type": "အမျိုးအစား",
    "setup.label.EnterValue": "တန်ဖိုးထည့်ပါ",
    "setup.label.PriceRegion": "ဈေးနှုန်းဒေသ",
    "setup.label.Enter_service_Description": "ဝန်ဆောင်မှုဖော်ပြချက် ထည့်ပါ",
    "setup.label.ParamName": "ပါရာမီတာအမည်",
    "setup.label.Category": "အမျိုးအစား",
    "setup.label.Type": "အမျိုးအစား",
    "setup.label.EnterValue": "တန်ဖိုး ထည့်ပါ",
    "setup.label.SalesCatalogue": "အရောင်းစာရင်း",
    "setup.label.Are_you_sure_you_want_to_delete_?": "ဖျက်ချင်တာသေချာလား?",
    "setup.label.Channel": "ချန်နယ်",
    "setup.label.Broadcaster": "ထုတ်လွှင့်သူ",
    "setup.label.AddPrice": "စျေးနှုန်းထည့်ရန်",
    "setup.label.DeleteMediaEvent": "မီဒီယာဖြစ်ရပ် ဖျက်ရန်",
    "setup.label.AdvMedia": "ကြော်ငြာမီဒီယာ",
    "setup.label.EditMedia": "မီဒီယာ တည်းဖြတ်ရန်",
    "setup.label.AddEvent": "ဖြစ်ရပ်ထည့်ရန်",
    "setup.label.AddAttributes": "Attribute များထည့်ရန်",
    "setup.label.AddLocation": "တည်နေရာထည့်ရန်",
    "setup.label.DeleteEvent": "ဖြစ်ရပ်ဖျက်ရန်",
    "setup.label.Are_you_sure_?": "သေချာပါသလား?",
    "setup.label.Add": "ထည့်ရန်",
    "setup.label.ViewEvent": "ဖြစ်ရပ်ကြည့်ရန်",
    "setup.label.Event": "ဖြစ်ရပ်",
    "setup.label.RUM": "RUM",
    "setup.label.OptType": "ရွေးချယ်မှုအမျိုးအစား",
    "setup.label.Currency": "ငွေကြေး",
    "setup.label.Amount": "ငွေပမာဏ",
    "setup.label.Add": "ထည့်ပါ",
    "setup.label.Save": "သိမ်းဆည်းပါ",
    "setup.label.AddDiscount": "လျှော့စျေးထည့်ပါ",
    "setup.label.EnterEventCode": "အဖြစ်အပျက်ကုဒ်ထည့်ပါ",
    "setup.label.EnterEventDescription": "အဖြစ်အပျက်ဖော်ပြချက်ထည့်ပါ",
    "setup.label.EventDescription": "အဖြစ်အပျက်ဖော်ပြချက်",
    "setup.label.EventCategory": "အဖြစ်အပျက်အမျိုးအစား",
    "setup.label.ChargeCode": "ခွန်ကုဒ်",
    "setup.label.SelectEventValidity": "အဖြစ်အပျက်တရားဝင်မှုရွေးချယ်ပါ",
    "setup.label.EditEvent": "အဖြစ်အပျက်တည်းဖြတ်ရန်",
    "setup.label.UnitCode": "ယူနစ်ကုဒ်",
    "setup.label.MediaTitle": "မီဒီယာခေါင်းစဉ်",
    "setup.label.ContentProvider": "အကြောင်းအရာပေးသူ",
    "setup.label.MediaType": "မီဒီယာအမျိုးအစား",
    "setup.label.Rated": "အဆင့်သတ်မှတ်ထားသည်",
    "setup.label.MediaCategory": "မီဒီယာအမျိုးအစား",
    "setup.label.Rating": "အဆင့်သတ်မှတ်မှု",
    "setup.label.Poster": "ပို့စတာ",
    "setup.label.Status": "အခြေအနေ",
    "setup.label.MovieDuration": "ရုပ်ရှင်ကြာချိန်",
    "setup.label.ReleaseDate": "ထုတ်ဝေသည့်နေ့",
    "setup.label.Genre": "အမျိုးအစား",
    "setup.label.Subject": "အကြောင်းအရာ",
    "setup.label.Overview": "အနှစ်ချုပ်",
    "setup.label.Share(%)": "ဝေစုခြမ်း (%)",
    "setup.label.Cast": "သရုပ်ဆောင်များ",
    "setup.label.AttributeType": "Attribute အမျိုးအစား",
    "setup.label.CaptionValue": "စာတန်းထိုးတန်ဖိုး",
    "setup.label.NickName": "အမည်တို",
    "setup.label.Image": "ပုံရိပ်",
    "setup.label.Language": "ဘာသာစကား",
    "setup.label.Format": "ဖော်မတ်",
    "setup.label.Location": "တည်နေရာ",
    "setup.label.CustomerType": "ဖောက်သည်အမျိုးအစား",
    "setup.label.FormatType": "ဖော်မတ်အမျိုးအစား",
    "setup.label.DiscountCode": "လျှော့စျေးကုဒ်",
    "setup.label.ReProcess": "ပြန်လည်လုပ်ဆောင်ရန်",
    "setup.label.Code": "ကုဒ်",
    "setup.label.Description": "ဖော်ပြချက်",
    "setup.label.PropertyCodeType": "ပိုင်ဆိုင်မှုကုဒ်အမျိုးအစား",
    "setup.label.ReferenceValue": "ရည်ညွှန်းတန်ဖိုး",
    "setup.label.EditProperty": "ပိုင်ဆိုင်မှုတည်းဖြတ်မည်",
    "setup.label.EditPropertyMaster": "ပိုင်ဆိုင်မှုမောင်းသူကိုတည်းဖြတ်မည်",
    "setup.label.Cancel": "ပယ်ဖျက်မည်",
    "setup.label.View": "ကြည့်မည်",
    "setup.label.Edit": "တည်းဖြတ်မည်",
    "setup.label.Browse_file_to_Upload": "ဖိုင်ရွေးချယ်ပြီးတင်မည်",
    "setup.label.CreatePropertyMaster": "ပိုင်ဆိုင်မှုမောင်းသူဖန်တီးမည်",
    "setup.label.Property": "ပိုင်ဆိုင်မှု",
    "setup.label.PropertyMaster": "ပိုင်ဆိုင်မှုမောင်းသူ",
    "setup.label.ViewProperty": "ပိုင်ဆိုင်မှုကြည့်မည်",
    "setup.label.ViewPropertyMaster": "ပိုင်ဆိုင်မှုမောင်းသူကြည့်မည်",
    "setup.label.Are_you_sure_?": "သင်သေချာပါသလား?",
    "setup.label.Edit": "တည်းဖြတ်ရန်",
    "setup.label.Code": "ကုဒ်",
    "setup.label.Name": "အမည်",
    "setup.label.AddState": "ပြည်နယ်ထည့်ရန်",
    "setup.label.AddDistrict": "ခရိုင်ထည့်ရန်",
    "setup.label.AddCity": "မြို့ထည့်ရန်",
    "setup.label.EditCountry": "နိုင်ငံပြင်ဆင်ရန်",
    "setup.label.EditState": "ပြည်နယ်ပြင်ဆင်ရန်",
    "setup.label.EditDistrict": "ခရိုင်ပြင်ဆင်ရန်",
    "setup.label.EditCity": "မြို့ပြင်ဆင်ရန်",
    "setup.label.DeleteCountry": "နိုင်ငံဖျက်ရန်",
    "setup.label.DeleteState": "ပြည်နယ်ဖျက်ရန်",
    "setup.label.DeleteDistrict": "ခရိုင်ဖျက်ရန်",
    "setup.label.DeleteCity": "မြို့ဖျက်ရန်",
    "setup.label.ServiceAvailablity": "ဝန်ဆောင်မှုရရှိနိုင်မှု",
    "setup.label.EnterCountryCode": "နိုင်ငံကုဒ်ထည့်ပါ",
    "setup.label.EnterCode": "ကုဒ်ထည့်ပါ",
    "setup.label.EnterName": "အမည်ထည့်ပါ",
    "setup.label.Service_Availablity_for_the": "အတွက်ဝန်ဆောင်မှုရရှိနိုင်မှု",
    "setup.label.SelectServices": "ဝန်ဆောင်မှုများရွေးပါ",
    "setup.label.Select_One_or_More": "တစ်ခု သို့မဟုတ် တစ်ခုထက်ပို၍ ရွေးပါ",
    "setup.label.options_selected": "ရွေးချယ်ထားသောရွေးချယ်မှုများ",
    "setup.label.PromotionName": "ပရိုမိုးရှင်းအမည်",
    "setup.label.PromotionCode": "ပရိုမိုးရှင်းကုဒ်",
    "setup.label.BussinesType": "လုပ်ငန်းအမျိုးအစား",
    "setup.label.OrderType": "အမှာစာအမျိုးအစား",
    "setup.label.PaymentType": "ငွေပေးချေမှုအမျိုးအစား",
    "setup.label.SelectCategory": "အမျိုးအစားရွေးပါ",
    "setup.label.PromotionTrigger": "ပရိုမိုးရှင်းစတင်ခြင်း",
    "setup.label.PromotionRule": "ပရိုမိုးရှင်းစည်းကမ်း",
    "setup.label.PromotionTriggerCondition": "ပရိုမိုးရှင်းစတင်ခြင်းအခြေအနေ",
    "setup.label.DiscountTriggerCondition": "လျှော့စျေးဖြစ်စေသောအခြေအနေ",
    "setup.label.DiscountRule": "လျှော့စျေးစည်းမျဉ်း",
    "setup.label.DiscountTrigger": "လျှော့စျေးဖြစ်စေသောအချက်",
    "setup.label.EditTriggerCondition": "လျှော့စျေးအခြေအနေ ပြင်ဆင်ရန်",
    "setup.label.Rate": "နှုန်းထား",
    "setup.label.EditRule": "စည်းမျဉ်း ပြင်ဆင်ရန်",
    "setup.label.AddRate": "နှုန်းထား ထည့်ရန်",
    "setup.label.Download": "ဒေါင်းလုဒ်",
    "setup.label.Process": "လုပ်ဆောင်မှု",
    "setup.label.ViewVendor": "အရောင်းသည်ကိုကြည့်မည်",
    "setup.label.VendorCode": "အရောင်းသည်ကုဒ်",
    "setup.label.VendorName": "အရောင်းသည်အမည်",
    "setup.label.select_Currency": "ငွေကြေးရွေးပါ",
    "setup.label.select_Country": "နိုင်ငံရွေးပါ",
    "setup.label.Filter_List": "စာရင်းစစ်ထုတ်ပါ",
    "setup.label.Are_you_sure_you_want_to_delete_?": "ဖျက်မှာသေချာပါသလား?",
    "setup.label.DeleteVoucher": "ဗောက်ချာဖျက်မည်",
    "setup.label.UpdatePin": "ပင်နံပါတ်အသစ်လုပ်မည်",
    "setup.label.UpdateVoucher": "ဗောက်ချာကိုအပ်ဒိတ်လုပ်မည်",
    "setup.label.select_from_dropdown":
      "ရွေးချယ်ရန် မျှောင့်ချန်စာရင်းမှ ရွေးပါ",
    "setup.label.ItemModel": "ပစ္စည်း မော်ဒယ်",
    "setup.label.price": "စျေးနှုန်း",
    "setup.label.Edit": "တည်းဖြတ်ပါ",
    "setup.label.Delete": "ဖျက်ပါ",
    "setup.label.Item": "ပစ္စည်း",
    "setup.label.EnterSupplierAddress": "ပေးသွင်းသူလိပ်စာထည့်ပါ",
    "setup.label.Title": "ခေါင်းစဉ်",
    "setup.label.AddPromotionTriggerCondition":
      "ပရိုမိုးရှင်းဖန်တီးမှုအခြေအနေထည့်ရန်",
    "setup.label.EditPromotionTriggerCondition":
      "ပရိုမိုးရှင်းဖန်တီးမှုအခြေအနေပြင်ရန်",
    "setup.label.AssignTo": "ပေးအပ်ရန်",
    "setup.label.Version": "ဗားရှင်း",
    "setup.label.IsOverride": "အစားထိုးမလား",
    "setup.label.PlanAttribute": "အစီအစဉ်လက္ခဏာ",
    "setup.label.ValidationRule": "အတည်ပြုမှုစည်းမျဉ်း",
    "setup.label.SaveAndContinue": "သိမ်းဆည်းပြီး ဆက်လက်လုပ်ဆောင်ရန်",
    "setup.label.PlanManagement": "အစီအစဉ်စီမံခန့်ခွဲမှု",
    "setup.label.Plan": "အစီအစဉ်",
    "setup.label.DiscountTriggerCondition": "လျှော့စျေးဖန်တီးမှုအခြေအနေ",
    "setup.label.AddDiscountTriggerCondition":
      "လျှော့စျေးဖန်တီးမှုအခြေအနေထည့်ရန်",
    "setup.label.SalesChannel": "ရောင်းချမှုလမ်းကြောင်း",
    "setup.label.PaymentType": "ငွေပေးချေမှုအမျိုးအစား",
    "setup.label.OrderType": "အော်ဒါအမျိုးအစား",
    "setup.label.BusinessType": "လုပ်ငန်းအမျိုးအစား",
    "setup.label.ViewDigitalContent": "ဒစ်ဂျစ်တယ်အကြောင်းအရာကြည့်မည်",
    "setup.label.EditDigitalContent": "ဒစ်ဂျစ်တယ်အကြောင်းအရာပြင်မည်",
    "setup.label.AddDigitalContent": "ဒီဂျစ်တယ်အကြောင်းအရာထည့်ပါ",
    "setup.label.PromotionRuleName": "မြှင့်တင်မှုစည်းကမ်းအမည်",
    "setup.label.PromotionTriggerCondition": "အထူးပရိုမိုးရှင်း သတ်မှတ်ချက်",
    "setup.label.AddPromotionTriggerCondition":
      "အထူးပရိုမိုးရှင်း သတ်မှတ်ချက် ထည့်ရန်",
    "setup.label.BussinesType": "စီးပွားရေးအမျိုးအစား",
    "setup.label.requestApproval": "အတည်ပြုမှု တောင်းဆိုမည်",
    "setup.label.validity_uom": "တရားဝင်မှုယူနစ်",
    "setup.label.validity_value": "တရားဝင်မှုတန်ဖိုး",
    "setup.label.ViewItemModel": "ပစ္စည်းမော်ဒယ်ကို ကြည့်ပါ",
    "setup.label.ItemType": "ပစ္စည်းအမျိုးအစား",
    "setup.label.ViewSupplier": "ပေးသွင်းသူကို ကြည့်ပါ",
    "setup.label.SupplierCode": "ပေးသွင်းသူကုဒ်",
    "setup.label.SupplierDescription": "ပေးသွင်းသူအကြောင်းဖော်ပြချက်",
    "setup.label.SupplierAddress": "ပေးသွင်းသူလိပ်စာ",
    "setup.label.DeleteSupplier": "ပေးသွင်းသူကို ဖျက်ပါ",
    "setup.label.CreateContract": "စာချုပ်တစ်စောင်ဖန်တီးပါ",
    "setup.label.RateTierName": "အဆင့်အမည်ကို အဆင့်သတ်မှတ်ပါ။",
    "setup.label.RangeType": "အမျိုးအစား",
    "setup.label.CreateDiscountRule": "လျှော့စျေးစည်းမျဉ်းကိုဖန်တီးပါ။",
    "setup.label.RuleCondition": "စည်းကမ်းအခြေအနေ",
    "setup.label.CreateRuleCondition": "စည်းကမ်းသတ်မှတ်ချက်ကို ဖန်တီးပါ။",
    "setup.label.CreateRule": "စည်းကမ်းဖန်တီးပါ။",
    "setup.label.Entity": "ဘဘ",
    "setup.label.EntityField": "ဘဘ အကွက်",
    "setup.label.contentTag": "အကြောင်းအရာတံဆိပ်",
    "setup.label.contentTagValue": "အကြောင်းအရာတံဆိပ်တန်ဖိုး",
    "setup.label.ExecutionType": "အကောင်အထည်ဖော်ခြင်း အမျိုးအစား",
    "setup.label.OperationMode": "စစ်ဆင်ရေး ရိုးများ",
    "setup.label.AggregationType": "စုစည်းမှု အမျိုးအစား",
    "setup.label.DurationInDays": "နေ့ရက်များအတွင်း",
    "setup.label.CreateTicketTeamUser": "လက်မှတ်အသင်းအသုံးပြုသူဖန်တီးပါ",
    "setup.label.termsConditions": "စည်းကမ်းသတ်မှတ်ချက်များ",
    "setup.label.updateTermsConditions":
      "စည်းမျဥ်းစည်းကမ်းများကို အပ်ဒိတ်လုပ်ပါ။",
    "setup.label.updateDigitalContent":
      "ဒစ်ဂျစ်တယ် အကြောင်းအရာကို အပ်ဒိတ်လုပ်ပါ။",
    "setup.label.createDigitalContent": "ဒစ်ဂျစ်တယ်အကြောင်းအရာဖန်တီးပါ။",
    "setup.label.createTermsConditions": "စည်းမျဥ်းစည်းကမ်းများကို ဖန်တီးပါ။",
    "setup.label.digitalContent": "ဒစ်ဂျစ်တယ် အကြောင်းအရာ",
    "setup.label.planContent": "အကြောင်းအရာအစီအစဉ်",
    "setup.label.selectPlanContent": "အစီအစဉ်အကြောင်းအရာကို ရွေးပါ။",
    "setup.label.FilterType": "စစ်ထုတ်ခြင်းအမျိုးအစား",
    "setup.label.ExternalPlanId": "ပြင်ပအစီအစဉ်အိုင်ဒီ",
    "setup.label.ExternalProductId": "ပြင်ပကုန်ပစ္စည်းအိုင်ဒီ",
    "setup.label.SelectedPlanDiscounts":
      "အထူးရွေးချယ်ထားသောအစီအစဉ်လျှော့ဈေးများ,",
    "setup.label.ProductDiscount": "ထုတ်ကုန်လျှော့ဈေးများ,",
    "setup.label.FilterValue": "စစ်ထုတ်ခြင်းတန်ဖိုး",
    "setup.label.ContractPeriod": "စာချုပ်ကာလ",
    "setup.label.AddContract": "စာချုပ်ထည့်ပါ။",
    "setup.label.EditContract": "စာချုပ်ကို တည်းဖြတ်ပါ။",
    "setup.label.ViewContract": "စာချုပ်ကိုကြည့်ပါ။",
    "setup.label.ContractType": "စာချုပ်အမျိုးအစား",
    "setup.label.ContractUnit": "စာချုပ်ယူနစ်",
    "setup.label.updateNetMask": "နက် မက်ခ်ကို အပ်ဒိတ်လုပ်ပါ",
    "setup.label.Update": "အပ်ဒိတ်",
    "setup.label.BillType": "ဘిల్အမျိုးအစား",
    "setup.label.BillFrequency": "ဘီလ်ထွက် frequency",
    "setup.label.PlanEndDate": "အစီအစဉ်အဆုံးသတ်နေ့",
    "setup.label.AddContent": "အကြောင်းအရာထည့်ပါ",
    "setup.label.CreatePlanContent": "အစီအစဉ်အကြောင်းအရာဖန်တီးပါ",
    "setup.label.SelectLanguage": "ဘာသာစကားရွေးပါ",
    "setup.label.UploadDigitalImage": "ဓာတ်ပုံဒစ်ဂျစ်တယ်တင်ပါ",
    "setup.label.ViewPlanContent": "အစီအစဉ်အကြောင်းအရာကြည့်ပါ",
    "setup.label.ExternalPlanName": "ပြင်ပအစီအစဉ်အမည်",
    "setup.label.ExternalProductName": "ပြင်ပထုတ်ကုန်အမည်",
    "setup.label.ViewPrice": "ဈေးနှုန်းကြည့်ပါ",
    "setup.label.PlanValidationRules": "စီမံကိန်းအတည်ပြုချိန်ကာလများ",
    "setup.label.CreateValidationRule": "အတည်ပြုချိန်ကာလ စည်းမျဥ်းသစ်ဖန်တီးရန်",
    "setup.label.EditValidationRule": "အတည်ပြုချိန်ကာလ စည်းမျဥ်းပြင်ဆင်ရန်",
    "setup.label.InputPlanId": "စီမံကိန်း ID ရိုက်ထည့်ပါ",
    "setup.label.CheckinPlanId": "စီမံကိန်းအတည်ပြု ID",
    "setup.label.RuleAppliesTo": "ယူနစ်",
    "setup.label.Rule": "စည်းမျဥ်း",
    "setup.label.ViewValidationRule": "မြင်ကွင်း အတည်ပြုချက် စည်းကမ်း",
    "setup.label.ValidationRule": "အတည်ပြုချက် စည်းကမ်း",
    "setup.label.createIpPool": "IP ကူးစက်မှုကို ဖန်တီးပါ",
    "setup.label.editIpPool": "IP ကူးစက်မှုကို တည်းဖြတ်ပါ",
    "setup.label.AddOrEditDiscount": "လျှော့စျေးထည့်/တည်းဖြတ်ပါ။",
    "setup.label.Next": "နောက်တစ်ခု",
    "setup.label.MainCategory": "ပင်မအမျိုးအစား",
    "setup.label.SubCategory": "အမျိုးအစားခွဲ",
    "setup.label.select_date": "ရက်စွဲရွေးပါ",
    "setup.label.AddDiscountTrigger": "လျှော့စျေး စနစ်တက်ရှက်ထည့်ပါ",
    "setup.label.AddPromotionTrigger": "ပရိုမိုးရှင်းအစပျိုးထည့်ပါ။",
    "setup.label.edit_promotion_trigger": "ပရိုမိုးရှင်းအစပျိုးကို တည်းဖြတ်ပါ။",
    "setup.label.DiscountTrigger": "လျှော့စျေး စနစ်တက်ရှက်",
    "setup.label.TriggerName": "စနစ်တက်ရှက် နာမည်",
    "setup.label.When": "အခါ",
    "setup.label.CustomerType": "ဖောက်သည် အမျိုးအစား",
    "setup.label.Criteria": "စံနှုန်းများ",
    "setup.label.Values": "တန်ဖိုးများ",
    "setup.label.ApplicableTo": "သက်ဆိုင်ရာ",
    "setup.label.ApplicableValues": "သက်ဆိုင်ရာတန်ဖိုးများ",
    "setup.label.DiscountRulesAndRates":
      "လျှော့စျေး စည်းမျဉ်းများနှင့်နှုန်းများ",
    "setup.label.RuleName": "စည်းမျဉ်း နာမည်",
    "setup.label.MaxDiscount": "အများဆုံးလျှော့စျေး",
    "setup.label.ResourceId": "အရင်းအမြစ် အိုင်ဒီ",
    "setup.label.DiscountRateType": "လျှော့စျေးနှုန်း အမျိုးအစား",
    "setup.label.Unit": "ယူနစ်",
    "setup.label.DiscountId": "လျှော့စျေး အိုင်ဒီ",
    "setup.label.DiscountName": "လျှော့စျေး အမည်",
    "setup.label.Priority": "ဦးစားပေး",
    "setup.label.Items": "ပစ္စည်းများ",
    "setup.label.ItemCode": "ပစ္စည်းကုဒ်",
    "setup.label.ItemDescription": "ပစ္စည်းဖြေကြားချက်",
    "setup.label.Units": "ယူနစ်",
    "setup.label.Total": "စုစုပေါင်း",
    "setup.label.Warranty": "အရောင်းအဝယ်",
    "setup.label.UsedItems": "သုံးစွဲသောပစ္စည်းများ",
    "setup.label.Balanced": "သောက်ဆေးနိုင်",
    "setup.label.IsProvisioning": "ပေးပြီးလျှင်",
    "setup.label.CreateItem": "ပစ္စည်းဖွင့်ရန်",
    "setup.label.ItemClass": "ပစ္စည်းအမျိုးအစား",
    "setup.label.ReorderLevel": "ပြင်ရန်စျေးနှုန်းအနေဖြင့်ပြန်လည်ရှိပါသည်",
    "setup.label.WarrantyPeriod": "အရောင်းအဝယ်အကြားကိန်း",
    "setup.label.Currency": "ငွေကြေး",
    "setup.label.DefaultPrice": "ပုံမှန်စျေးနှုန်း",
    "setup.label.IsSelector": "ရွေးချယ်သောအောက်ပါအတိုင်း",
    "setup.label.SelectorMenu": "ရွေးချယ်သောအောက်ပါအတိုင်းမီနူး",
    "setup.label.Selector": "ရွေးချယ်သောအောက်ပါအတိုင်း",
    "setup.label.VariablePrice": "စျေးနှုန်းအရှိန်",
    "setup.label.ItemModel": "ပစ္စည်းများမှာအမျိုးအစား",
    "setup.label.Price": "စျေးနှုန်း",
    "setup.label.Action": "လုပ်ဆောင်ချက်",

    "setup.label.Cancel": "ပယ်ဖျက်မည်",
    "setup.label.planPrice": "အစီအစဉ်ဈေးနှုန်း",
    "setup.label.listview": "စာရင်းကိုမြင်သည်",
    "setup.label.Submit": "တင်သွင်းမည်",
    "setup.label.EditItem": "ပစ္စည်းတစ်ခုတည်းဖြတ်ပါ",
    "setup.label.Id": "အမှတ်",
    "setup.label.ItemMasterId": "ပစ္စည်းသင်္ဘောဆိုက်ရန်အမှတ်",
    "setup.label.RegionId": "ဒေတာအမှတ်",
    "setup.label.Edit": "တည်းဖြတ်ပါ",
    "setup.label.ViewItem": "ကြည့်ရှုလုပ်ပါ",
    "setup.label.UnitPrice": "ယူနစ်စျေးနှုန်း",
    "setup.label.ItemModels": "ပစ္စည်းများအမြင့်",
    "setup.label.NetworkElement": "ကွန်ပျူတာအခြေအနေ",
    "setup.label.Model": "မိုးခွင့်",
    "setup.label.Make": "ဖန်တီးပါ",
    "setup.label.CreateItemModel": "ပစ္စည်းမိုးစကြည့်ပါ",
    "setup.label.Reset": "ပြန်စစ်သည်",
    "setup.label.EditItemModel": "ပစ္စည်းမိုးစနစ်ကိုတည်းဖြတ်ပါ",
    "setup.label.ServiceCode": "ဝန်ဆောင်မှုကုတ်",
    "setup.label.ServiceDescription": "ဝန်ဆောင်မှုဖော်ပြချက်",
    "setup.label.ServiceType": "ဝန်ဆောင်မှုအမျိုးအစား",
    "setup.label.Isoptional": "ရွေးချယ်နိုင်သော",
    "setup.label.Isautoprovision": "အလိုအလျောက်ပြုလုပ်မှု",
    "setup.label.CreateService": "ဝန်ဆောင်မှုဖန်တီးပါ",
    "setup.label.Code": "ကုတ်",
    "setup.label.Description": "ဖော်ပြချက်",
    "setup.label.Type": "အမျိုးအစား",
    "setup.label.EditService": "ဝန်ဆောင်မှုတည်းဖြတ်ပါ",
    "setup.label.ServiceParameter": "ဝန်ဆောင်မှုပါရာမီတာ",
    "setup.label.ParamName": "ပါရာမီတာနာမည်",
    "setup.label.ParamType": "ပါရာမီတာအမျိုးအစား",
    "setup.label.ParamCategory": "ပါရာမီတာအမျိုးအစား",
    "setup.label.ParamValue": "ပါရာမီတာတန်ဖိုး",
    "setup.label.BB": "BB",

    "setup.label.Delete": "ဖျက်ပါ",
    "setup.label.ServiceCategory": "ဝန်ဆောင်မှုအမျိုးအစား",
    "setup.label.DeleteServices": "ဝန်ဆောင်မှုများဖျက်ပါ",
    "setup.label.Confirm": "အတည်ပြုပါ",

    "setup.label.Service": "ဝန်ဆောင်မှု",
    "setup.label.Status": "အခြေအနေ",
    "setup.label.Bouquet": "ပန်းစည်း",
    "setup.label.Actions": "လှုပ်ရှားမှုများ",
    "setup.label.CreateProduct": "ထုတ်ကုန်ဖန်တီးပါ",
    "setup.label.ProductParameter": "ထုတ်ကုန်ပါရာမီတာ",
    "setup.label.EditProduct": "ထုတ်ကုန်တည်းဖြတ်ပါ",
    "setup.label.ProductDescription": "ထုတ်ကုန်ဖော်ပြချက်",
    "setup.label.ProductCategory": "ထုတ်ကုန်အမျိုးအစား",
    "setup.label.BroadcasterCode": "ရေဒီယိုအခြေစိုက်ကုဒ်",
    "setup.label.BroadcasterName": "ရေဒီယိုအခြေစိုက်နာမည်",
    "setup.label.GstRegNumber": "GST မှတ်ပုံတင်နံပါတ်",
    "setup.label.ContactPerson": "ဆက်သွယ်ရန်ပုဂ္ဂိုလ်",
    "setup.label.ContactMobile": "ဆက်သွယ်ရန်မိုဘိုင်း",
    "setup.label.Email": "အီးမေးလ်",
    "setup.label.CreateBroadcaster": "ရေဒီယိုအခြေစိုက်တည်ဆောက်ပါ",
    "setup.label.Address": "လိပ်စာ",
    "setup.label.MobileNo": "မိုဘိုင်းနံပါတ်",
    "setup.label.LandlineNo": "မြေပြင်လိုင်းနံပါတ်",
    "setup.label.EditBroadcaster": "ရေဒီယိုအခြေစိုက်တည်းဖြတ်ပါ",

    "setup.label.ChannelName": "ချန်နယ်နာမည်",
    "setup.label.ChannelType": "ချန်နယ်အမျိုးအစား",
    "setup.label.DeleteBroadcaster": "ရေဒီယိုအခြေစိုက်ကိုဖျက်ပါ",

    "setup.label.ChannelCategory": "ချန်နယ်အမျိုးအစား",
    "setup.label.ChannelSequence": "ချန်နယ်အမှတ်စဉ်",

    "setup.label.IsHdChannel": "HD ချန်နယ်ဖြစ်သည်",
    "setup.label.CreateChannel": "ချန်နယ်ဖန်တီးပါ",
    "setup.label.Language": "ဘာသာစကား",
    "setup.label.IsLocalChannel": "တိုင်းရင်းဆိုင်ရာချန်နယ်ဖြစ်သည်",
    "setup.label.Genre": "အမျိုးအစား",

    "setup.label.BroadcasterId": "ရေဒီယိုအခြေစိုက် ID",
    "setup.label.EditChannel": "ချန်နယ်တည်းဖြတ်ပါ",
    "setup.label.DeleteChannel": "ချန်နယ်ကိုဖျက်ပါ",

    "setup.label.ProductMapping": "ကုန်ပစ္စည်းမြေပုံဖွဲ့စည်းမှု",
    "setup.label.CreateProductChannelMapping":
      "ကုန်ပစ္စည်းချန်နယ်မြေပုံဖွဲ့စည်းမှုဖန်တီးပါ",
    "setup.label.ProductId": "ကုန်ပစ္စည်း ID",
    "setup.label.AvailableChannels": "ရရှိနိုင်သောချန်နယ်များ",
    "setup.label.SelectedChannels": "ရွေးချယ်ထားသောချန်နယ်များ",
    "setup.label.EditChannelMapping": "ချန်နယ်မြေပုံဖွဲ့စည်းမှုကိုတည်းဖြတ်ပါ",
    "setup.label.PlanPricing": "အစီအစဉ်နှင့် စျေးနှုန်း",
    "setup.label.CreatePlan": "အစီအစဉ်ဖန်တီးပါ",
    "setup.label.PlanCode": "အစီအစဉ်ကုဒ်",
    "setup.label.PlanDescription": "အစီအစဉ်အကြောင်းအရာ",
    "setup.label.PlanStatus": "အစီအစဉ်အခြေအနေ",
    "setup.label.PlanProvisionSystem": "အစီအစဉ်ရောက်ရှိရေးစနစ်",
    "setup.label.PlanStartDate": "အစီအစဉ်စတင်သည့်နေ့",
    "setup.label.IsPrepaid": "ကြိုတင်ငွေပေးချေထားသည်",
    "setup.label.Duration": "ကြာချိန်",
    "setup.label.PlanType": "အစီအစဉ်အမျိုးအစား",
    "setup.label.BillingRule": "ဘီလ်အတွက် စည်းမျဉ်းများ",
    "setup.label.EndDate": "ပြီးဆုံးသည့်နေ့",

    "setup.label.IsProvision": "ရောက်ရှိရေးလုပ်ဆောင်ခြင်း",

    "setup.label.EditPlan": "အစီအစဉ်တည်းဖြတ်ပါ",
    "setup.label.SelectProduct": "ထုတ်ကုန်ကို ရွေးပါ",
    "setup.label.ViewPlan": "အစီအစဉ်ကြည့်ရှုပါ",

    "setup.label.ProvisioningSystem": "ရောက်ရှိရေးစနစ်",

    "setup.label.DeletePlan": "အစီအစဉ်ကို ဖျက်ပါ",
    "setup.label.Prices": "စျေးနှုန်းများ",

    "setup.label.ChargeOwner": "ငွေပေးချေသူ",
    "setup.label.DiscountCode": "လျှော့စျေးကုဒ်",
    "setup.label.PriceRegion": "စျေးနှုန်းယူနစ်",
    "setup.label.Resource": "ရင်းမြတ်",
    "setup.label.SalesChannel": "အရောင်းချန်နယ်",
    "setup.label.OrderType": "အော်ဒါအမျိုးအစား",
    "setup.label.BusinessType": "လုပ်ငန်းအမျိုးအစား",
    "setup.label.rounding_type": "ကုန်ပစ္စည်းအမျိုးအစား",
    "setup.label.gl_id": "GL Id",
    "setup.label.duration": "ကျင်းပ",
    "setup.label.value": "တန်ဖိုး",
    "setup.label.TemplateDefinition": "တိုင်ကြားပြန်ကြားမှု",
    "setup.label.CreateTemplateDefinition": "တိုင်ကြားပြန်ကြားမှုထည့်သွင်းမှု",
    "setup.label.TemplateName": "ထုတ်ယူသည့်ပုံစံ",
    "setup.label.Delimiter": "ထုတ်ယူသည့်ခွဲခြား",
    "setup.label.NumberOfFields": "စာရင်းနံပါတ်",
    "setup.label.HeaderRecorderType": "ခေါင်းစဉ်များရယူသည့်အမျိုးအစား",
    "setup.label.EventRecordType": "အဖွဲ့အစည်းစာရင်း",

    "setup.label.ProductCode": "ကုန်ပစ္စည်းကုဒ်",
    "setup.label.IsHeader": "ခေါင်းစဥ်ဖြင့်",
    "setup.label.FieldType": "စာရင်းအမျိုးအစား",
    "setup.label.FieldName": "စာရင်းနာမည်",
    "setup.label.IdentifierType": "စာရင်းတည်ရာများအမျိုးအစား",
    "setup.label.Length": "အရွယ်အစား",
    "setup.label.ExistsTemplateDefinition": "တည်နေရာရှိသောတင်ပြီးမှု",

    "setup.label.UOM(Unit Of measurement)": "UOM (အမျိုးအစားတည်း)",
    "setup.label.CreateUOM": "UOM ဖန်တီးပါ",
    "setup.label.Name": "အမည်",
    "setup.label.EditTemplateDefinition": "ထုတ်ယူသည့်ပုံစံကိုတည်းဖြတ်ပါ",
    "setup.label.EditUOM": "UOM တည်းဖြတ်ပါ",
    "setup.label.Save": "သိမ်းဆည်းပါ",
    "setup.label.DeleteUOM": "UOM ဖျက်ပါ",
    "setup.label.Ok": "အိုကေ",
    "setup.label.ViewUOM": "UOM ကြည့်ပါ",
    "setup.label.RUM(RatableUsageMetric)": "RUM (Ratable Usage Metric)",
    "setup.label.CreateRUM": "RUM ဖန်တီးပါ",
    "setup.label.ChargeName": "ငွေပေးချေနိုင်သည့်အမည်",
    "setup.label.Template Name": "ထုတ်ယူသည့်ပုံစံအမည်",
    "setup.label.RumName": "Rum အမည်",
    "setup.label.RumExpression": "Rum ထုတ်ယူသည့်ပုံစံ",

    "setup.label.Operators": "လုပ်ဆောင်သည့်လျှိပ်များ",
    "setup.label.EditRUM": "RUM တည်းဖြတ်ပါ",
    "setup.label.ViewRUM": "RUM ကြည့်ပါ",
    "setup.label.TimePeriod": "အချိန်ကာလ",
    "setup.label.CreateTimePeriod": "အချိန်ကာလ ဖန်တီးပါ",
    "setup.label.TimeModelName": "အချိန်မော်ဒယ်အမည်",
    "setup.label.StartYear": "အစတစ်နှစ်",
    "setup.label.EndYear": "အဆုံးတစ်နှစ်",
    "setup.label.StartMonth": "အစတစ်လ",
    "setup.label.EndMonth": "အဆုံးတစ်လ",
    "setup.label.StartDay": "အစတစ်ရက်",
    "setup.label.EndDay": "အဆုံးတစ်ရက်",
    "setup.label.StartTime": "အစအချိန်",
    "setup.label.EndTime": "အဆုံးအချိန်",
    "setup.label.CreateTimeModel": "အချိန်မော်ဒယ် ဖန်တီးပါ",
    "setup.label.ExpandAll / CollapseAll":
      "အားလုံးတိုးချဲ့ပါ / အားလုံးခေါ်ယူပါ",
    "setup.label.AddTimemodel": "အချိန်မော်ဒယ် ထည့်ပါ",
    "setup.label.UsageRatePlan": "အသုံးပြုမှုနှုန်းထားအစီအစဉ်",
    "setup.label.CreateUsageRatePlan": "အသုံးပြုမှုနှုန်းထားအစီအစဉ် ဖန်တီးပါ",
    "setup.label.PlanName": "အစီအစဉ်အမည်",
    "setup.label.ProductName": "ထုတ်ကုန်အမည်",
    "setup.label.TimemodelName": "အချိန်မော်ဒယ်အမည်",

    "setup.label.ViewUsageRatePlan": "အသုံးပြုမှုနှုန်းထားအစီအစဉ် ကြည့်ပါ",
    "setup.label.RUM": "RUM",
    "setup.label.RatingType": "အဆင့်သတ်မှတ်ခြင်းအမျိုးအစား",
    "setup.label.TimeModel": "အချိန်မော်ဒယ်",
    "setup.label.ZoneModel": "ဇုန်မော်ဒယ်",
    "setup.label.ViewQuantityTier": "အရေအတွက်အဆင့်ကြည့်ပါ",
    "setup.label.QuantityTier": "အရေအတွက်အဆင့်",
    "setup.label.TierName": "အဆင့်အမည်",
    "setup.label.CumulativeResource": "စုဆောင်းသောအရင်းအမြစ်",
    "setup.label.TierRange": "အဆင့်အကွာအဝေး",
    "setup.label.StepName": "အဆင့်အမည်",
    "setup.label.StartRange": "စတင်ကာလ",
    "setup.label.EndRange": "ဆုံးမှတ်ကာလ",
    "setup.label.AddQuantityTier": "အရေအတွက်အဆင့်ထည့်ပါ",
    "setup.label.NumberZone": "နံပါတ်ဇုန်",
    "setup.label.CreateNumberZone": "နံပါတ်ဇုန်ဖန်တီးပါ",
    "setup.label.SourceNumberPrefix": "အရင်းအမြစ်နံပါတ်ပရီဖစ်",
    "setup.label.DestinationNumberPrefix": "ဦးတည်ရာနံပါတ်ပရီဖစ်",
    "setup.label.ImpactCategory": "သက်ရောက်မှုအမျိုးအစား",
    "setup.label.Rank": "နံပါတ်",
    "setup.label.APNZone": "APN ဇုန်",
    "setup.label.APN": "APN",
    "setup.label.CreateAPNZone": "APN ဇုန်ဖန်တီးပါ",
    "setup.label.OperatorZone": "အော်ပရေတာဇုန်",
    "setup.label.CreateOperatorZone": "အော်ပရေတာဇုန်ဖန်တီးပါ",
    "setup.label.SourceOperatorCode": "အရင်းအမြစ်အော်ပရေတာကုဒ်",
    "setup.label.DestinationOperatorCode": "ဦးတည်ရာအော်ပရေတာကုဒ်",
    "setup.label.ICZone": "IC ဇုန်",
    "setup.label.IncomingTrunkid": "ဝင်ရောက်လာသော Trunkid",
    "setup.label.OutcomingTrunkid": "ထွက်နေသော Trunkid",
    "setup.label.CreateChargeCode": "အခကြေးငွေကုဒ်ဖန်တီးပါ",
    "setup.label.ChargeDescription": "အခကြေးငွေဖော်ပြချက်",
    "setup.label.ChargeType": "အခကြေးငွေ အမျိုးအစား",
    "setup.label.ChargeDuration": "အခကြေးငွေသတ်မှတ်ချိန်",
    "setup.label.DurationType": "ကြာမြင့်ချိန် အမျိုးအစား",
    "setup.label.TaxInclusive": "အခွန်ပါဝင်သည်",
    "setup.label.BillFrequencyCode": "ဘီလ် အကြိမ်နှုန်းကုဒ်",

    "setup.label.TaxCode": "အခွန်ကုဒ်",
    "setup.label.IsAggregate": "စုစုပေါင်းဖြစ်ပါသလား",
    "setup.label.EditChargeCode": "အခကြေးငွေကုဒ် တည်းဖြတ်ပါ",
    "setup.label.TaxMaster": "အခွန် မာစတာ",
    "setup.label.CreateTaxMaster": "အခွန် မာစတာဖန်တီးပါ",

    "setup.label.GroupType": "အုပ်စု အမျိုးအစား",
    "setup.label.GroupCode": "အုပ်စုကုဒ်",

    "setup.label.StartDate": "စတင်သည့်ရက်စွဲ",

    "setup.label.Rate": "နှုန်း",
    "setup.label.BaseTaxCode": "အခြေခံအခွန်ကုဒ်",
    "setup.label.Jurisdiction": "တရားဝင်ခွင့်",
    "setup.label.RateType": "နှုန်း အမျိုးအစား",
    "setup.label.Location": "တည်နေရာ",
    "setup.label.DeleteTax": "အခွန် ဖျက်ပါ",
    "setup.label.CreateDiscount": "လျှော့စျေးဖန်တီးပါ",

    "setup.label.DiscountDescription": "လျှော့စျေးဖော်ပြချက်",
    "setup.label.DiscountType": "လျှော့စျေးအမျိုးအစား",
    "setup.label.DiscountRate": "လျှော့စျေးနှုန်း",
    "setup.label.DiscountDetails": "လျှော့စျေးအသေးစိတ်",
    "setup.label.ClientCategory": "ဖောက်သည်အမျိုးအစား",
    "setup.label.CustomerCategory": "ဖောက်သည်အမျိုးအစား",

    "setup.label.EditDiscount": "လျှော့စျေးတည်းဖြတ်ပါ",
    "setup.label.DeleteDiscount": "လျှော့စျေးဖျက်ပါ",
    "setup.label.CreatePromotion": "ပရိုမိုးရှင်းဖန်တီးပါ",
    "setup.label.PromotionCode": "ပရိုမိုးရှင်းကုဒ်",
    "setup.label.PromotionName": "ပရိုမိုးရှင်းအမည်",
    "setup.label.PromotionId": "ပရိုမိုးရှင်း ID",
    "setup.label.PromotionDescription": "ပရိုမိုးရှင်းဖော်ပြချက်",

    "setup.label.EditPromotionCode": "ပရိုမိုးရှင်းကုဒ်တည်းဖြတ်ပါ",
    "setup.label.ListOfDiscounts": "လျှော့စျေးစာရင်း",
    "setup.label.ListofTimePeriods": "အချိန်ကာလများစာရင်း",

    "setup.label.CreatePriceRegion": "စျေးနှုန်းဒေသဖန်တီးပါ",
    "setup.label.RegionCode": "ဒေသကုဒ်",
    "setup.label.RegionName": "ဒေသအမည်",
    "setup.label.Country": "နိုင်ငံ",
    "setup.label.States": "ပြည်နယ်များ",
    "setup.label.EditPriceRegion": "စျေးနှုန်းဒေသကိုတည်းဖြတ်ပါ",
    "setup.label.DeletePriceRegion": "စျေးနှုန်းဒေသကိုဖျက်ပါ",

    "setup.label.CreateSalesCatalogue": "ရောင်းအားကတ်တလောက်ဖန်တီးပါ",
    "setup.label.SalesCatalogueName": "အရောင်း Catalouge အမည်",
    "setup.label.AssignUsers": "အသုံးပြုသူများကို ချမှတ်ပါ",
    "setup.label.SalesPlanCategory": "ရောင်းအားအစီအစဉ်အမျိုးအစား",
    "setup.label.Plans": "အစီအစဉ်များ",
    "setup.label.EditSalesCatalogue": "ရောင်းအားကတ်တလောက်ကိုတည်းဖြတ်ပါ",
    "setup.label.DeleteSalesCatalogue": "ရောင်းအားကတ်တလောက်ကိုဖျက်ပါ",

    "setup.label.UserId": "အသုံးပြုသူ ID",
    "setup.label.UserName": "အသုံးပြုသူအမည်",
    "setup.label.CreateUsersCatalogue": "အသုံးပြုသူများစာရင်းဖန်တီးပါ",
    "setup.label.Catalogue": "စာရင်း",
    "setup.label.EditUserCatalogue": "အသုံးပြုသူများစာရင်းကိုတည်းဖြတ်ပါ",
    "setup.label.VoucherPins": "ဗောက်ချာ ပင်များ",
    "setup.label.CreateVoucherPins": "ဗောက်ချာ ပင်များ ဖန်တီးပါ",
    "setup.label.Voucher": "ဗောက်ချာ",
    "setup.label.Coupon": "ကူပွန်",
    "setup.label.LCO": "LCO",
    "setup.label.LengthOfPins": "ပင်အရေအတွက်",
    "setup.label.SerialNoLength": "စီးရီးနံပါတ်အရှည်",
    "setup.label.NumberValue ": "နံပါတ်တန်ဖိုး",
    "setup.label.PinValue ": "ပင်တန်ဖိုး",
    "setup.label.BatchName": "ဘတ်ချ်အမည်",
    "setup.label.PinCategory": "ပင်အမျိုးအစား",

    "setup.label.BeginWith": "စတင်ရန်",
    "setup.label.Quantity": "ပမာဏ",
    "setup.label.PinType": "ပင်အမျိုးအစား",
    "setup.label.Value": "တန်ဖိုး",
    "setup.label.SIMNumbers": "SIM နံပါတ်များ",
    "setup.label.CreateSIMNumber": "SIM နံပါတ် ဖန်တီးပါ",
    "setup.label.NumberCategory": "နံပါတ်အမျိုးအစား",
    "setup.label.ExpiryDate": "သက်တမ်းကုန်စက်",
    "setup.label.Partner": "ပါတနာ",
    "setup.label.LengthofNumber": "နံပါတ်၏ အရှည်",
    "setup.label.LengthofSerialNumber": "စီးရီးနံပါတ်၏ အရှည်",
    "setup.label.NumberType": "နံပါတ်အမျိုးအစား",
    "setup.label.Product": "ထုတ်ကုန်",
    "setup.label.Supplier": "ပေးသွင်းသူ",
    "setup.label.CreateSupplier": "ပေးသွင်းသူ ဖန်တီးပါ",
    "setup.label.SupplierCode": "ပေးသွင်းသူ ကုဒ်",
    "setup.label.SupplierDescription": "ပေးသွင်းသူ ဖော်ပြချက်",
    "setup.label.SupplierAddress": "ပေးသွင်းသူလိပ်စာ",
    "setup.label.EditSupplier": "ပေးသွင်းသူ တည်းဖြတ်ပါ",
    "setup.label.AddressMaster": "လိပ်စာမာစတာ",
    "setup.label.CountryName": "နိုင်ငံအမည်",
    "setup.label.StateName": "ပြည်နယ်အမည်",
    "setup.label.DistrictName": "ခရိုင်အမည်",
    "setup.label.CityName": "မြို့အမည်",
    "setup.label.TreeView": "သစ်ပင်ကြည့်မူ",
    "setup.label.AddCountry": "နိုင်ငံ ထည့်ပါ",
    "setup.label.CountryCode": "နိုင်ငံကုဒ်",
    "setup.label.TeamHead": "အဖွဲ့ခေါင်းဆောင်",
    "setup.label.CreateTicketTeam": "လက်မှတ်အဖွဲ့ကို ဖန်တီးပါ",
    "setup.label.TeamCode": "အဖွဲ့ကုဒ်",
    "setup.label.TeamDescription": "အဖွဲ့အကြောင်းအရာ",
    "setup.label.TeamCategory": "အဖွဲ့အမျိုးအစား",
    "setup.label.CreateTicketTeamUsers":
      "လက်မှတ်အဖွဲ့အသုံးပြုသူများကို ဖန်တီးပါ",
    "setup.label.TeamEmail": "အဖွဲ့အီးမေးလ်",
    "setup.label.AvailableUsers": "ရရှိနိုင်သော အသုံးပြုသူများ",
    "setup.label.SelectedUsers": "ရွေးချယ်ထားသော အသုံးပြုသူများ",
    "setup.label.TeamId": "အဖွဲ့ ID",
    "setup.label.ViewTeam": "အဖွဲ့ကို ကြည့်ပါ",
    "setup.label.DeleteTeam": "အဖွဲ့ကို ဖျက်ပါ",
    "setup.label.EditTicketTeam": "လက်မှတ်အဖွဲ့ကို တည်းဖြတ်ပါ",
    "setup.label.TeamUser": "အဖွဲ့အသုံးပြုသူ",
    "setup.label.EditTicketUsers": "လက်မှတ်အသုံးပြုသူများကို တည်းဖြတ်ပါ",
    "setup.label.DeleteTeamUser": "အဖွဲ့အသုံးပြုသူကို ဖျက်ပါ",
    "setup.label.VendorManagement": "လက်ကားရောင်းသူစီမံခန့်ခွဲမှု",
    "setup.label.CreateVendor": "လက်ကားရောင်းသူဖန်တီးပါ",

    "setup.label.ContactName": "ဆက်သွယ်ရန်နာမည်",
    "setup.label.Mobile": "မိုဘိုင်း",
    "setup.label.Landline": "မြေနီ",

    "setup.label.CreateNewVendor": "လက်ကားရောင်းသူအသစ်ဖန်တီးပါ",
    "setup.label.EditVendor": "လက်ကားရောင်းသူတည်းဖြတ်ပါ",
    "setup.label.FeeMaster": "ကြေးဝန်ကြီး",
    "setup.label.CreateFeeMaster": "ကြေးဝန်ကြီး ဖန်တီးပါ",
    "setup.label.FeeMasterCode": "ကြေးဝန်ကြီး ကုဒ်",
    "setup.label.FeeMasterDescription": "ကြေးဝန်ကြီး ဖော်ပြချက်",
    "setup.label.FeeMasterTransactionType": "ကြေးဝန်ကြီး လုပ်ငန်းအမျိုးအစား",
    "setup.label.ChargeCode": "အခကြေးငွေ ကုဒ်",
    "setup.label.VariablePricing": "ပြောင်းလဲနိုင်သော စျေးနှုန်း",
    "setup.label.Regions": "တိုင်းဒေသကြီးများ",
    "setup.label.Amount": "ငွေပမာဏ",

    "setup.label.EditFeeMaster": "ကြေးဝန်ကြီး တည်းဖြတ်ပါ",
    "setup.label.ManageMessage": "မက်ဆေ့ချ်ကိုစီမံပါ",
    "setup.label.AddMessage": "မက်ဆေ့ချ်ထည့်ပါ",
    "setup.label.TemplateDescription": "နမူနာ ဖော်ပြချက်",
    "setup.label.Subject": "ခေါင်းစဉ်",
    "setup.label.MessageType": "မက်ဆေ့ခ််အမျိုးအစား",
    "setup.label.Header": "ခေါင်းစီး",
    "setup.label.Body": "ကိုယ်",
    "setup.label.Footer": "အောက်ခြေ",
    "setup.label.CreateMessageTemplate": "မက်ဆေ့ချ် နမူနာ ဖန်တီးပါ",
    "setup.label.MessageParams": "မက်ဆေ့ချ် ပါရာမီတာများ",
    "setup.label.Parameter": "ပါရာမီတာ",
    "setup.label.Params": "ပါရာမီတာများ",
    "setup.label.DeleteMessage": "မက်ဆေ့ချ်ကိုဖျက်ပါ",
    "setup.label.EditMessage": "မက်ဆေ့စ်တည်းဖြတ်ပါ",
    "setup.label.GroupsDetails": "အုပ်စုအသေးစိတ်",
    "setup.label.GroupName": "အဖွဲ့အမည်",
    "setup.label.GroupAddress": "အဖွဲ့လိပ်စာ",
    "setup.label.CountNo's": "နံပါတ်များကိုရေတွက်ပါ",
    "setup.label.AddGroup": "အဖွဲ့ထည့်ပါ",
    "setup.label.AdditionalInformation": "ထပ်မံသတင်းအချက်အလက်များ",
    "setup.label.GroupCIR": "အဖွဲ့ CIR",
    "setup.label.DIR": "DIR",
    "setup.label.MemberCIR": "အဖွဲ့ဝင် CIR",
    "setup.label.IpPoolManagement": "IP စင်ကူစုစည်းမှု စီမံခန့်ခွဲမှု",
    "setup.label.UpdateNetMask": "Net Mask အပ်ဒိတ်လုပ်ပါ",
    "setup.label.IpAddress": "IP လိပ်စာ",
    "setup.label.NetMark": "Net Mark",
    "setup.label.IpType": "IP အမျိုးအစား",
    "setup.label.CoustomerId": "ဖောက်သည် ID",
    "setup.label.CustomerName": "ဖောက်သည်အမည်",
    "setup.label.Notes": "မှတ်စုများ",
    "setup.label.Subnet": "Subnet",

    "setup.label.DetailsOfMedia": "မီဒီယာအသေးစိတ်",
    "setup.label.Media": "မီဒီယာ",
    "setup.label.AddMedia": "မီဒီယာထည့်ပါ",
    "setup.label.MediaTitle": "မီဒီယာခေါင်းစဉ်",
    "setup.label.MediaCatagory": "မီဒီယာအမျိုးအစား",
    "setup.label.ContentProvider": "အကြောင်းအရာပေးသူ",
    "setup.label.Share": "ဝေစု(%)",
    "setup.label.AddMediaDetails": "မီဒီယာအသေးစိတ်ထည့်ပါ",
    "setup.label.MediaLocation": "မီဒီယာတည်နေရာ",
    "setup.label.SelectMediaCategory": "မီဒီယာအမျိုးအစားရွေးပါ",
    "setup.label.Movies": "ရုပ်ရှင်",

    "setup.label.ViewMedia": "မီဒီယာကြည့်ရှုပါ",
    "setup.label.EditMedia": "မီဒီယာတည်းဖြတ်ပါ",
    "setup.label.MediaAttributes": "မီဒီယာအသေးစိတ်",
    "setup.label.Cast": "သရုပ်ဆောင်များ",
    "setup.label.AttributeType": "အသေးစိတ်အမျိုးအစား",
    "setup.label.CaptionValue": "နာမည်တပ်တန်ဖိုး",
    "setup.label.NickName": "နာမည်လေး",
    "setup.label.Image": "ပုံ",
    "setup.label.AddMediaLocations": "မီဒီယာတည်နေရာထည့်ပါ",
    "setup.label.LanguageData": "ဘာသာစကားအချက်အလက်",
    "setup.label.FormatData": "ဖော်မတ်အချက်အလက်",
    "setup.label.MediaLocations": "မီဒီယာတည်နေရာများ",
    "setup.label.DetailsOfEvent": "ပွဲ၏ အသေးစိတ်",
    "setup.label.EventName": "ပွဲ အမည်",
    "setup.label.EventCode": "ဖြစ်ရပ်ကုဒ်",
    "setup.label.SelectedMediaService": "ရွေးချယ်ထားသောမီဒီယာဝန်ဆောင်မှု",
    "setup.label.AvailableMedia": "ရရှိနိုင်သောမီဒီယာ",
    "setup.label.EventDescription": "ပွဲ အကြောင်းအရာ",
    "setup.label.EventCategory": "ပွဲ အမျိုးအစား",
    "setup.label.CreateEvent": "ပွဲ ဖန်တီးမည်",
    "setup.label.DetailsOfProperty": "ပိုင်ဆိုင်မှု၏ အသေးစိတ်",
    "setup.label.PropertyCode": "ပိုင်ဆိုင်မှု ကုဒ်",
    "setup.label.PropertyType": "ပိုင်ဆိုင်မှု အမျိုးအစား",
    "setup.label.Parcel": "စည်ပင်",
    "setup.label.BuildingCode": "အဆောက်အဦ ကုဒ်",
    "setup.label.Precinct": "အနီးအနား",
    "setup.label.Allocated": "ပေးအပ်ခြင်း",
    "setup.label.UploadPropertyData": "ပိုင်ဆိုင်မှု ဒေတာ တင်မည်",
    "setup.label.Clear": "ရှင်းလင်းသည်",
    "setup.label.CreateProperty": "ပိုင်ဆိုင်မှု ဖန်တီးမည်",
    "setup.label.PropertyDataUpload": "ပိုင်ဆိုင်မှု ဒေတာ တင်မည်",
    "setup.label.Street": "လမ်း",
    "setup.label.PaymentType": "ငွေပေးချေမှု အမျိုးအစား",
    "setup.label.PoBox": "စာတိုက်",
    "setup.label.State": "ပြည်နယ်",
    "setup.label.District": "ခရိုင်",
    "setup.label.Floor": "ထပ်",

    "setup.label.LimitCode": "ကန့်သတ်ကုဒ်",
    "setup.label.PropertyMaster": "ပိုင်ဆိုင်မှု မာစတာ",
    "setup.label.CodeDescription": "ကုဒ် ဖေါ်ပြချက်",
    "setup.label.ReferenceValue": "ရည်ညွှန်း အဘိုး",
    "setup.label.Services": "ဝန်ဆောင်မှုများ",

    "setup.label.IsBouquet": "ပန်းစည်းပါသလား",
    "setup.label.Broadcaster": "ထုတ်လွှင့်သူ",
    "setup.label.Channel": "လွှင့်တင်လိုက်ပါ",

    "setup.label.ContactNumber": "ဆက်သွယ်ရန်နံပါတ်",

    "setup.label.UOM": "ယူအိုအမ်",

    "setup.label.DeleteTemplateDefinition": "အမျိုးအစားညွှန်းကိန်းကို ဖျက်ပါ",

    "setup.label.Discount": "လျှော့စျေး",

    "setup.label.SalseCatalogue": "အရောင်းစာရင်း",
    "setup.label.UserCatalogue": "အသုံးပြုသူစာရင်း",
    "setup.label.Team": "အသင်း",

    "setup.label.MediaDetails": "မီဒီယာအသေးစိတ်",
    "setup.label.Event": "ဖြစ်ရပ်",
    "setup.label.Properties": "အိမ်ခြံမြေ",

    "setup.label.ServicesProducts": "ဝန်ဆောင်မှုများနှင့် ထုတ်ကုန်များ",
    "setup.label.BroadcasterChannelMapping":
      "ထုတ်လွှင့်သူ, လမ်းကြောင်းနှင့် မြေပုံ",

    "setup.label.UsageRating": "အသုံးပြုမှုအဆင့်သတ်မှတ်ချက်",
    "setup.label.ZoneSetup": "ဇုန်ချိန်ညှိမှု",
    "setup.label.Promotion": "ကြိုးပမ်းမှု",
    "setup.label.PromotionTrigger": "ပရိုမိုးရှင်းအစပျိုး",
    "setup.label.PromotionRulesAndRates":
      "ပရိုမိုးရှင်း စည်းကမ်းများနှင့် စျေးနှုန်းများ",
    "setup.label.CatalogeMapping": "စာရင်းပြုစုခြင်း",
    "setup.label.VoucherPin": "ဗောက်ချာ",
    "setup.label.SIMNumber": "SIM နံပါတ်",
    "setup.label.TeamTeamUser": "အသင်းနှင့် အသင်းအသုံးပြုသူ",
    "setup.label.MessageTemplate": "သတင်းစကားပုံ",
    "setup.label.ClosedUserGroup": "ပိတ်ထားသောအသုံးပြုသူအဖွဲ့",
    "setup.label.IpManagement": "IP စီမံခန့်ခွဲမှု",
    "setup.label.PropertyDefinition": "ပိုင်ဆိုင်မှုအဓိပ္ပါယ်",
    "setup.label.PriorityMapping": "ဦးစားပေးမြေပုံဆွဲခြင်း။",
    "setup.label.AddProducts": "ထုတ်ကုန်များ ထည့်မည်",
    "setup.label.AddDiscount": "လျှော့စျေး ထည့်မည်",
    "setup.label.Products": "ထုတ်ကုန်များ",
    "setup.label.ChargeCodeData": "အခကြေးငွေကုဒ်ဒေတာ",
    "setup.label.TaxMapping": "အခွန်မြေပုံ",
    "setup.label.TaxRegion": "အခွန်တိုင်းဒေသကြီး",
    "setup.label.CreateUserCatalogue": "အသုံးပြုသူစာရင်းပြုစုပါ",
    "setup.label.IcZone": "Ic ဧရိယာ",
    "setup.label.ViewIcZone": "Ic ဧရိယာကြည့်ရှုပါ",
    "setup.label.ViewNumberZone": "နံပါတ်ဇုန်ကိုကြည့်ပါ",

    "setup.label.EditNumberZone": "နံပါတ်ဇုန်ကိုတည်းဖြတ်ပါ",
    "setup.label.DeleteNumberZone": "နံပါတ်ဇုန်ကိုဖျက်ပါ",
    "setup.label.AreYouSure": "သေချာပါသလား?",
    "setup.label.ViewAPNZone": "APN ဇုန်ကိုကြည့်ပါ",
    "setup.label.EditAPNZone": "APN ဇုန်ကိုတည်းဖြတ်ပါ",
    "setup.label.DeleteAPNZone": "APN ဇုန်ကိုဖျက်ပါ",
    "setup.label.ViewOperatorZone": "စစ်ဆင်ရေးဇုန်ကိုကြည့်ပါ",
    "setup.label.EditOperatorZone": "စစ်ဆင်ရေးဇုန်ကိုတည်းဖြတ်ပါ",

    "setup.label.CreateICZone": "IC ဇုန်ကိုဖန်တီးပါ",
    "setup.label.EditICZone": "IC ဇုန်ကိုတည်းဖြတ်ပါ",
    "setup.label.DeleteOperatorZone": "စစ်ဆင်ရေးဇုန်ကိုဖျက်ပါ",
    "setup.label.DeleteIcZone": "IC ဇုန်ကိုဖျက်ပါ",
    "setup.label.MobileNumber": "မိုဘိုင်းနံပါတ်",
    "setup.label.LandlineNumber": "လက်ကိုင်ဖုန်းနံပါတ် (ရွေးချယ်နိုင်သည်)",
    "setup.label.RatePlanName": "အမီတာအစီအစဉ်အမည်",
    "setup.label.UsageRateBalance": "အသုံးပြုမှုနှုန်း လက်ကျန်",
    "setup.label.ValidityType": "တရားဝင်မှုအမျိုးအစား",
    "setup.label.ListOfRateTires": "နှုန်းထား တာယာများစာရင်း",
    "setup.label.Validity": "တရားဝင်မှု",
    "setup.label.CreatePlanName": "အစီအစဉ်အမည်ဖန်တီးပါ",
    "setup.label.EditPlanContent": "အစီအစဉ်အကြောင်းအရာကိုတည်းဖြတ်ပါ",
    "setup.label.CreatePlanDescription": "အစီအစဉ်ဖော်ပြချက်ဖန်တီးပါ",
    "setup.label.ContentType": "အကြောင်းအရာအမျိုးအစား",
    "setup.label.CreateFeatureList": "အင်္ဂါရပ်စာရင်းဖန်တီးပါ",
    "setup.label.Area": "ဧရိယာ",
    "setup.label.TaxPercentage": "အခွန်ရာခိုင်နှုန်း",
    "setup.label.Add": "ထည့်ပါ",
    "setup.label.Remove": "ဖယ်ရှားပါ။",
    "setup.label.CreateVoucherPin": "ဗောက်ချာပင်ဖန်တီးပါ",
    "setup.label.EditSubCategory": "အမျိုးအစားခွဲများကို တည်းဖြတ်ပါ။",
    "setup.label.CreateSubCategory": "အမျိုးအစားခွဲများကို ဖန်တီးပါ။",
    "setup.label.ViewSubCategory": "အမျိုးအစားခွဲများကို ကြည့်ရှုပါ။",
    "setup.label.TimeTaken": "အချိန်ယူ",
    "setup.label.TeamMapping": "အသင်းဖြစ်မှုတူညီမှု",
    "setup.label.CreateTeamMapping": "အသင်းဖြစ်မှုတူညီမှုဖန်တီးမည်",

    "setup.label.Category": "အမျိုးအစား",
    "setup.label.external_promotional_code": "ပြင်ပ ပရိုမိုးရှင်းကုဒ်",
    "setup.label.Subcategory": "အမျိုးအစားခွဲ",

    "setup.label.DeleteItemMapping": "အရာဝတ္ထုပစ္စည်းတူညီမှုဖျက်မည်",
    "setup.label.EditTeamMapping": "အသင်းဖြစ်မှုတူညီမှုတည်းဖြတ်မည်",
    "setup.label.ViewTeamMapping": "အသင်းဖြစ်မှုတူညီမှုကြည့်မည်",
    "setup.label.DeletePriorityMapping": "အဓိကဖြစ်မှုတူညီမှုဖျက်မည်",
    "setup.label.discount_rule": "လျှော့စျေး စည်းမျဉ်း",
    "setup.label.promotion_rule": "ပရိုမိုးရှင်းစည်းမျဉ်း",
    "setup.label.discount_rate": "လျှော့စျေးနှုန်း",
    "setup.label.create_discount_rule": "လျှော့စျေးစည်းမျဉ်းကိုဖန်တီးပါ။",
    "setup.label.edit_promotion_rule": "ပရိုမိုးရှင်းစည်းမျဉ်းကို တည်းဖြတ်ပါ။",
    "setup.label.create_promotion_rule": "မြှင့်တင်ရေးစည်းမျဉ်းကို ဖန်တီးပါ။",
    "setup.label.create_discount_rate": "လျှော့စျေးနှုန်းကိုဖန်တီးပါ။",
    "setup.label.add_discount_rate": "လျှော့စျေးနှုန်း ထည့်ပါ",
    "setup.label.add_promotion_rate": "ပရိုမိုးရှင်းနှုန်းထည့်ပါ။",
    "setup.label.edit_discount": "လျှော့စျေးပြင်ဆင်ရန်",
    "setup.label.edit_promotion": "ပရိုမိုးရှင်းကို တည်းဖြတ်ပါ။",
    "setup.label.edit_discount_trigger": "လျှော့စျေး ဦးတည်ချက် ပြင်ဆင်ရန်",
    "setup.label.edit_discount_rule": "လျှော့စျေး စည်းမျဉ်း ပြင်ဆင်ရန်",
    "setup.label.collection_process": "ການເກັບກຳ",
    "setup.label.create_collection_profile": "ສ້າງໂປຣໄຟລ໌ການເກັບກຳ",
    "setup.label.collection_profile": "ໂປຣໄຟລ໌ການເກັບກຳ",
    "setup.label.collection_profile_id": "ID ໂປຣໄຟລ໌ການເກັບກຳ",
    "setup.label.region": "ເຂດພື້ນທີ່",
    "setup.label.collection": "ການເກັບກຳ",
    "setup.label.collection_trigger": "ການເກັບກຳທີ່ເລີ່ມຕົ້ນ",
    "setup.label.collection_scenario": "ສະຖານະການການເກັບກຳ",
    "setup.label.add_collection_trigger": "ເພີ່ມການເລີ່ມຕົ້ນການເກັບກຳ",
    "setup.label.add_collection_scenario": "ເພີ່ມສະຖານະການການເກັບກຳ",
    "setup.label.trigger_id": "ဖြစ်စဉ် ID",
    "setup.label.criteria_type": "စာရင်းပေးချက် အမျိုးအစား",
    "setup.label.due_balance": "ကျန်ငွေ",
    "setup.label.ageing_days": "သက်တမ်းရက်",
    "setup.label.scenario_id": "သဘောထား ID",
    "setup.label.action_name": "လုပ်ဆောင်ချက် နာမည်",
    "setup.label.age": "အသက်",
    "setup.label.create_collection_trigger": "စုစည်းခြင်းဖြစ်စဉ် ဖန်တီးပါ",
    "setup.label.create_collection_scenario": "စုစည်းခြင်း သဘောထား ဖန်တီးပါ",
    "setup.label.edit_collection_profile": "စုစည်းခြင်းပရိုဖိုင်ကို တည်းဖြတ်ပါ",
    "setup.label.edit_collection_trigger": "စုစည်းခြင်းဖြစ်စဉ်ကို တည်းဖြတ်ပါ",
    "setup.label.edit_collection_scenario": "စုစည်းခြင်း သဘောထားကို တည်းဖြတ်ပါ",
    "setup.label.SlaInHours": "SLA အတွက် နာရီ",
    "setup.label.contractduration": "စာချုပ်သက်တမ်း",
    "setup.label.chargesperiodicity": "အခကြိမ်နှုန်း",
  },

  my: {
    "setup.label.Enter_product_Description": "ထုတ်ကုန်ဖော်ပြချက်ထည့်ပါ",
    "setup.label.FeedbackStatus": "တုံ့ပြန်ချက်အခြေအနေ",
    "setup.label.EnterCountryName": "နိုင်ငံအမည်ထည့်ပါ",
    "setup.label.location": "တည်နေရာ",
    "setup.label.selectLocation": "တည်နေရာရွေးပါ",
    "setup.label.create_group_ticket": "အဖွဲ့လက်မှတ် ဖန်တီးပါ",
    "setup.label.default": "အခြေခံ",
    "setup.label.customerFeedback": "ဖောက်သည်တုံ့ပြန်ချက်",
    "setup.label.automation": "အော်တိုမိတ်",
    "setup.label.automation_master": "အော်တိုမိတ် မာစတာ",
    "setup.label.create_automation": "အော်တိုမိတ်ဖန်တီးရန်",
    "setup.label.edit_automation": "အော်တိုမိတ်တည်းဖြတ်ရန်",
    "setup.label.automation_detail": "အော်တိုမိတ်အသေးစိတ်",
    "setup.label.automation_steps": "အော်တိုမိတ်အဆင့်များ",
    "setup.label.add_automation_step": "အော်တိုမိတ်အဆင့်ထည့်ရန်",
    "setup.label.AutomationId": "အော်တိုမိတ် ID",
    "setup.label.EntityName": "အဖွဲ့အစည်းအမည်",
    "setup.label.EntityType": "အဖွဲ့အစည်းအမျိုးအစား",
    "setup.label.WorkflowName": "အလုပ်စဉ်အမည်",
    "setup.label.CreateAutomationScenario": "အော်တိုမိတ်အခြေအနေဖန်တီးရန်",
    "setup.label.EditAutomationStep": "အော်တိုမိတ်အဆင့်တည်းဖြတ်ရန်",
    "setup.label.ActionType": "လုပ်ဆောင်မှုအမျိုးအစား",
    "setup.label.ActionDetails": "လုပ်ဆောင်မှုအသေးစိတ်",
    "setup.label.StepOrder": "အဆင့်အတိုင်းအတာ",
    "setup.label.questionAnswerSet": "မေးခွန်းနှင့်တုံ့ပြန်ချက်စနစ်",
    "setup.label.addQuestionSet": "မေးခွန်းစနစ်ထည့်ရန်",
    "setup.label.EditQuestionSet": "မေးခွန်းစနစ်ပြင်ဆင်ရန်",
    "setup.label.CategoryName": "အမျိုးအစားအမည်",
    "setup.label.SubCategoryName": "အဆင့်အလိုက်အမည်",
    "setup.label.TotalQuestions": "စုစုပေါင်းမေးခွန်းများ",
    "setup.label.QuestionType": "မေးခွန်းအမျိုးအစား",
    "setup.label.QuestionText": "မေးခွန်းစာသား",
    "setup.label.CustomerFeedback": "ဖောက်သည်တုံ့ပြန်ချက်",
    "setup.label.TicketId": "တိုက်ပွဲ ID",
    "setup.label.LinkedAt": "ချိတ်ဆက်ခဲ့သောအချိန်",
    "setup.label.Remarks": "မှတ်ချက်များ",
    "setup.label.AddFeedback": "တုံ့ပြန်ချက်ထည့်ရန်",
    "setup.label.PendingForApproval": "အတည်ပြုချက်အတွက်ဆိုင်းငံ့နေပါသည်",
    "setup.label.user_availability": "အသုံးပြုသူရရှိနိုင်မှု",
    "setup.label.all_users_availability": "အသုံးပြုသူအားလုံးရရှိနိုင်မှု",
    "setup.label.create_user_availability": "အသုံးပြုသူရရှိနိုင်မှု ဖန်တီးရန်",
    "setup.label.LeaveManagement": "အလုပ်လွတ်စီမံခန့်ခွဲမှု",
    "setup.label.CreateLeave": "အလုပ်လွတ်ဖန်တီးရန်",
    "setup.label.EditLeave": "အလုပ်လွတ်တည်းဖြတ်ရန်",
    "setup.label.ViewLeave": "အလုပ်လွတ်ကြည့်ရန်",
    "setup.label.AllUserLeaves": "အသုံးပြုသူများ၏အလုပ်လွတ်အားလုံး",
    "setup.label.MyLeaves": "ကျွန်ုပ်၏အလုပ်လွတ်များ",
    "setup.label.ConfigId": "ဖွဲ့စည်းမှု ID",
    "setup.label.edit_user_availability": "အသုံးပြုသူရရှိနိုင်မှု တည်းဖြတ်ရန်",
    "setup.label.view_user_availability": "အသုံးပြုသူရရှိနိုင်မှု ကြည့်ရန်",
    "setup.label.unavailability_date": "မရရှိနိုင်သောရက်စွဲ",
    "setup.label.start_time": "စတင်ချိန်",
    "setup.label.end_time": "ပြီးဆုံးချိန်",
    "setup.label.my_availability": "ကျွန်ုပ်၏ရရှိနိုင်မှု",
    "setup.label.user": "အသုံးပြုသူ",
    "setup.label.EditShift": "အလှည့်အချိန် တည်းဖြတ်ရန်",
    "setup.label.UserWorkingShift": "အသုံးပြုသူ၏ အလုပ်အမှုဆောင်အချိန်",
    "setup.label.CreateUserWorkingShift":
      "အသုံးပြုသူ၏ အလုပ်အမှုဆောင်အချိန် ဖန်တီးရန်",
    "setup.label.EditUserWorkingShift":
      "အသုံးပြုသူ၏ အလုပ်အမှုဆောင်အချိန် တည်းဖြတ်ရန်",
    "setup.label.ViewUserWorkingShift": "အသုံးပြုသူအလုပ်အမှာစာကြည့်ရန်",
    "setup.label.TeamName": "အဖွဲ့အမည်",
    "setup.label.Shift": "အလှည့်ကျအချိန်",
    "setup.label.ShiftManagement": "အလှည့်ကျအချိန် စီမံခန့်ခွဲမှု",
    "setup.label.CreateShift": "အလှည့်ကျအချိန် ဖန်တီးရန်",
    "setup.label.ShiftName": "အလှည့်အချိန်အမည်",
    "setup.label.Session": "အစည်းအဝေး",
    "setup.label.SessionType": "အစည်းအဝေးအမျိုးအစား",
    "setup.label.LeaveDetails": "အသေးစိတ်အလုပ်လွတ်",
    "setup.label.SessionStartTime": "အစည်းအဝေးစတင်ချိန်",
    "setup.label.SessionEndTime": "အစည်းအဝေးပြီးဆုံးချိန်",
    "setup.label.LeaveType": "အားလပ်ချိန်အမျိုးအစား",
    "setup.label.AddAnotherDate": "နောက်ထပ်ရက်စွဲ ထည့်ရန်",
    "setup.label.Apn_Zone": "APN ဒေသ",
    "setup.label.FeeMaster": "ကြေးအုပ်ချုပ်သူ",
    "setup.label.Number_Zone": "နံပါတ်ဒေသ",
    "setup.label.DeleteRUM": "RUM ဖျက်ပါ",
    "setup.label.Edit_TimeModel": "အချိန်မော်ဒယ် တည်းဖြတ်ပါ",
    "setup.label.Edit_Year": "နှစ် တည်းဖြတ်ပါ",
    "setup.label.scenario_name": "သဘောတူညီချက်အမည်",
    "setup.label.event_name": "ဖြစ်ရပ်အမည်",
    "setup.label.Edit_Month": "လ တည်းဖြတ်ပါ",
    "setup.label.Edit_Day": "နေ့ တည်းဖြတ်ပါ",
    "setup.label.Edit_Time": "အချိန် တည်းဖြတ်ပါ",
    "setup.label.Delete_TimeModel": "အချိန်မော်ဒယ် ဖျက်ပါ",
    "setup.label.Delete_Year": "နှစ် ဖျက်ပါ",
    "setup.label.Delete_Month": "လ ဖျက်ပါ",
    "setup.label.Delete_Day": "နေ့ ဖျက်ပါ",
    "setup.label.Delete_Time": "အချိန် ဖျက်ပါ",
    "setup.label.Are_you_sure_?": "သေချာပါသလား?",
    "setup.label.Save": "သိမ်းဆည်းပါ",
    "setup.label.TemplateDefinition": "ပုံစံ သတ်မှတ်ချက်",
    "setup.label.EditQuantityTier": "အရေအတွက်အဆင့် တည်းဖြတ်ပါ",
    "setup.label.Usage_Rate_Balance": "အသုံးအနှုန်းလက်ကျန်",
    "setup.label.Template_Name": "ပုံစံအမည်",
    "setup.label.Delimiter": "ခွဲခြားကိန်း",
    "setup.label.Number_Of_Fields": "ကွက်အရေအတွက်",
    "setup.label.Header_Recorder_Type": "ခေါင်းစဉ်မှတ်တမ်းအမျိုးအစား",
    "setup.label.Event_Record_Type": "ဖြစ်စဉ်မှတ်တမ်းအမျိုးအစား",
    "setup.label.CreateUOM": "ယူနစ်ဖန်တီးမည်",
    "setup.label.TimePeriod": "အချိန်ကာလ",
    "setup.label.Usage_Rate_Plan": "အသုံးအနှုန်းအစီအစဉ်",
    "setup.label.TemplateDefinition": "ပုံစံအဓိပ္ပါယ်ဖော်ပြချက်",
    "setup.label.CreateRUM": "RUM ဖန်တီးမည်",
    "setup.label.CreateTimePeriod": "အချိန်ကာလဖန်တီးမည်",
    "setup.label.TimemodelName": "အချိန်မော်ဒယ်အမည်",
    "setup.label.TimePeriodName": "အချိန်ကာလအမည်",
    "setup.label.StartYear": "စတင်နှစ်",
    "setup.label.EndYear": "ပြီးဆုံးနှစ်",
    "setup.label.UsageRatePlan": "အသုံးအနှုန်းအစီအစဉ်",
    "setup.label.Create_Usage_Rate_Plan": "အသုံးအနှုန်းအစီအစဉ်ဖန်တီးမည်",
    "setup.label.Id": "အိုင်ဒီ",
    "setup.label.PlanName": "အစီအစဉ်အမည်",
    "setup.label.ProductName": "ထုတ်ကုန်အမည်",
    "setup.label.ChargeCode": "ကျသင့်ငွေကုဒ်",
    "setup.label.TimeModelName": "အချိန်မော်ဒယ်အမည်",
    "setup.label.RatingType": "အဆင့်သတ်မှတ်မှုအမျိုးအစား",
    "setup.label.RumName": "RUM အမည်",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "ဖျက်ချင်သည်မှာသေချာပါသလား?",
    "setup.label.UOM": "တိုင်းတာယူနစ်",
    "setup.label.RUM": "RUM",
    "setup.label.ImpactCategory": "သက်ရောက်မှုအမျိုးအစား",
    "setup.label.Resource": "အရင်းအမြစ်",
    "setup.label.GLID": "GLID",
    "setup.label.Unit": "ယူနစ်",
    "setup.label.Rate": "နှုန်းထား",
    "setup.label.Action": "လှုပ်ရှားမှု",
    "setup.label.options_selected": "ရွေးချယ်ထားသောရွေးချယ်မှုများ",
    "setup.label.UsageRateBalance": "သုံးစွဲမှုနှုန်းအကျန်",
    "setup.label.EndYear": "ပြီးဆုံးသည့်နှစ်",
    "setup.label.StartMonth": "စတင်လ",
    "setup.label.EndMonth": "ပြီးဆုံးလ",
    "setup.label.StartDay": "စတင်သောနေ့",
    "setup.label.EndDay": "ပြီးဆုံးသောနေ့",
    "setup.label.StartTime": "စတင်ချိန်",
    "setup.label.Time_Model_Name": "အချိန်မော်ဒယ်အမည်",
    "setup.label.model_includes_which_all_Bands_?":
      "မော်ဒယ်တွင်ဘယ်ဘန်များ ပါဝင်သလဲ?",
    "setup.label.YearRestriction": "နှစ်ကန့်သတ်ချက်",
    "setup.label.MonthRestriction": "လကန့်သတ်ချက်",
    "setup.label.DayRestriction": "နေ့ကန့်သတ်ချက်",
    "setup.label.TimeRestriction": "အချိန်ကန့်သတ်ချက်",
    "setup.label.Code": "ကုဒ်",
    "setup.label.Name": "နာမည်",
    "setup.label.PriorityMapping": "ဦးစားပေးအဆင့်ချထားခြင်း",
    "setup.label.AddJurisdiction": "တရားဝင်နယ်မြေရေးထည့်ပါ",
    "setup.label.Are_you_sure_?": "သေချာပါသလား?",
    "setup.label.Country": "နိုင်ငံ",
    "setup.label.State": "ပြည်နယ်/တိုင်း",
    "setup.label.District": "ခရိုင်",
    "setup.label.RateType": "အခွန်နှုန်းအမျိုးအစား",
    "setup.label.Remove": "ဖျက်ပါ",
    "setup.label.TaxMaster": "အခွန်စီမံခန့်ခွဲမှု",
    "setup.label.Team": "အဖွဲ့",
    "setup.label.Add": "ထည့်ပါ",
    "setup.label.FeeMaster": "ကြေး စီမံခန့်ခွဲသူ",
    "setup.label.DeleteChargeCode": "ခေါ်ယူကုဒ်ဖျက်ပါ",
    "setup.label.SelectSearch": "ရှာဖွေရန်ရွေးပါ",
    "setup.label.Select_Content_Tag_Value":
      "အကြောင်းအရာတပ်ထားသောတန်ဖိုးကို ရွေးပါ",
    "setup.label.Plan_Content": "အစီအစဉ်အကြောင်းအရာ",
    "setup.label.Plan": "အစီအစဉ်",
    "setup.label.ProductPrice": "ကုန်ပစ္စည်းဈေးနှုန်း",
    "setup.label.SelectedPromotions": "ရွေးချယ်ထားသော ပရိုမိုးရှင်းများ",
    "setup.label.AvailablePromotions": "ရရှိနိုင်သော ပရိုမိုးရှင်းများ",
    "setup.label.SelectType": "အမျိုးအစား ရွေးချယ်ပါ",
    "setup.label.Type": "အမျိုးအစား",
    "setup.label.No_versions_available": "ဗားရှင်း မရှိပါ",
    "setup.label.Version": "ဗားရှင်း",
    "setup.label.ListPrice": "စျေးနှုန်းစာရင်း",
    "setup.label.SellingPrice": "ရောင်းချမှုစျေးနှုန်း",
    "setup.label.EnterPlanDescription": "အစီအစဉ်ဖော်ပြချက် ထည့်ပါ",
    "setup.label.AddPrice": "စျေးနှုန်းထည့်ပါ",
    "setup.label.Save": "သိမ်းဆည်းပါ",
    "setup.label.AddDiscount": "လျော့ဈေးထည့်ပါ",
    "setup.label.AvailablePlans": "ရရှိနိုင်သော အစီအစဉ်များ",
    "setup.label.SelectedPlans": "ရွေးချယ်ထားသော အစီအစဉ်များ",
    "setup.label.PlanType": "အစီအစဉ် အမျိုးအစား",
    "setup.label.Plan_Start_Date": "အစီအစဉ် စတင်မည့်နေ့",
    "setup.label.Plan_End_Date": "အစီအစဉ် အဆုံးသတ်နေ့",
    "setup.label.Bill_Type": "ဘီလ် အမျိုးအစား",
    "setup.label.AttributeTypes": "ဂုဏ်သတ္တိများ အမျိုးအစား",
    "setup.label.Add": "ထည့်ပါ",
    "setup.label.Select_Content_Tag": "အကြောင်းအရာ တပ်ဆင်ရန် ရွေးချယ်ပါ",
    "setup.label.PlanName": "အစီအစဉ်အမည်",
    "setup.label.AvailableDiscounts": "ရရှိနိုင်သော လျှော့စျေးများ",
    "setup.label.Search": "ရှာဖွေပါ...",
    "setup.label.MoveRight": "ညာဘက်သို့ရွှေ့ပါ",
    "setup.label.MoveLeft": "ဘယ်ဘက်သို့ရွှေ့ပါ",
    "setup.label.SelectedDiscounts": "ရွေးချယ်ထားသော လျှော့စျေးများ",
    "setup.label.SelectType": "အမျိုးအစားရွေးချယ်ပါ",
    "setup.label.SelectLanguage": "ဘာသာစကားရွေးချယ်ပါ",
    "setup.label.SelectContentTag": "အကြောင်းအရာတပ်ဆင်မှုရွေးပါ",
    "setup.label.SelectContentTagValue": "တပ်ဆင်မှုတန်ဖိုးရွေးပါ",
    "setup.label.DigitalContent": "ဒစ်ဂျစ်တယ်အကြောင်းအရာ",
    "setup.label.Enter_Plan_Description": "အစီအစဉ်ဖော်ပြချက် ထည့်သွင်းပါ",
    "setup.label.DC_Rule": "DC စည်းမျဉ်း",
    "setup.label.PlanAttribute": "အစီအစဉ် ဂုဏ်သတ္တိများ",
    "setup.label.AdvanceView": "အဆင့်မြင့်မြင်ကွင်း",
    "setup.label.Update": "အပ်ဒိတ်လုပ်ပါ",
    "setup.label.ProductMapping": "ထုတ်ကုန်ချိတ်ဆက်မှု",
    "setup.label.Service": "ဝန်ဆောင်မှု",
    "setup.label.SubProducts": "ထုတ်ကုန်ခွဲများ",
    "setup.label.Type": "အမျိုးအစား",
    "setup.label.EnterValue": "တန်ဖိုးထည့်ပါ",
    "setup.label.PriceRegion": "ဈေးနှုန်းဒေသ",
    "setup.label.Enter_service_Description": "ဝန်ဆောင်မှုဖော်ပြချက် ထည့်ပါ",
    "setup.label.ParamName": "ပါရာမီတာအမည်",
    "setup.label.Category": "အမျိုးအစား",
    "setup.label.Type": "အမျိုးအစား",
    "setup.label.EnterValue": "တန်ဖိုး ထည့်ပါ",
    "setup.label.SalesCatalogue": "အရောင်းစာရင်း",
    "setup.label.Are_you_sure_you_want_to_delete_?": "ဖျက်ချင်တာသေချာလား?",
    "setup.label.Channel": "ချန်နယ်",
    "setup.label.Broadcaster": "ထုတ်လွှင့်သူ",
    "setup.label.AddPrice": "စျေးနှုန်းထည့်ရန်",
    "setup.label.DeleteMediaEvent": "မီဒီယာဖြစ်ရပ် ဖျက်ရန်",
    "setup.label.AdvMedia": "ကြော်ငြာမီဒီယာ",
    "setup.label.EditMedia": "မီဒီယာ တည်းဖြတ်ရန်",
    "setup.label.AddEvent": "ဖြစ်ရပ်ထည့်ရန်",
    "setup.label.AddAttributes": "Attribute များထည့်ရန်",
    "setup.label.AddLocation": "တည်နေရာထည့်ရန်",
    "setup.label.DeleteEvent": "ဖြစ်ရပ်ဖျက်ရန်",
    "setup.label.Are_you_sure_?": "သေချာပါသလား?",
    "setup.label.Add": "ထည့်ရန်",
    "setup.label.ViewEvent": "ဖြစ်ရပ်ကြည့်ရန်",
    "setup.label.Event": "ဖြစ်ရပ်",
    "setup.label.RUM": "RUM",
    "setup.label.OptType": "ရွေးချယ်မှုအမျိုးအစား",
    "setup.label.Currency": "ငွေကြေး",
    "setup.label.Amount": "ငွေပမာဏ",
    "setup.label.Add": "ထည့်ပါ",
    "setup.label.Save": "သိမ်းဆည်းပါ",
    "setup.label.AddDiscount": "လျှော့စျေးထည့်ပါ",
    "setup.label.EnterEventCode": "အဖြစ်အပျက်ကုဒ်ထည့်ပါ",
    "setup.label.EnterEventDescription": "အဖြစ်အပျက်ဖော်ပြချက်ထည့်ပါ",
    "setup.label.EventDescription": "အဖြစ်အပျက်ဖော်ပြချက်",
    "setup.label.EventCategory": "အဖြစ်အပျက်အမျိုးအစား",
    "setup.label.ChargeCode": "ခွန်ကုဒ်",
    "setup.label.SelectEventValidity": "အဖြစ်အပျက်တရားဝင်မှုရွေးချယ်ပါ",
    "setup.label.EditEvent": "အဖြစ်အပျက်တည်းဖြတ်ရန်",
    "setup.label.UnitCode": "ယူနစ်ကုဒ်",
    "setup.label.MediaTitle": "မီဒီယာခေါင်းစဉ်",
    "setup.label.ContentProvider": "အကြောင်းအရာပေးသူ",
    "setup.label.MediaType": "မီဒီယာအမျိုးအစား",
    "setup.label.Rated": "အဆင့်သတ်မှတ်ထားသည်",
    "setup.label.MediaCategory": "မီဒီယာအမျိုးအစား",
    "setup.label.Rating": "အဆင့်သတ်မှတ်မှု",
    "setup.label.Poster": "ပို့စတာ",
    "setup.label.Status": "အခြေအနေ",
    "setup.label.MovieDuration": "ရုပ်ရှင်ကြာချိန်",
    "setup.label.ReleaseDate": "ထုတ်ဝေသည့်နေ့",
    "setup.label.Genre": "အမျိုးအစား",
    "setup.label.Subject": "အကြောင်းအရာ",
    "setup.label.Overview": "အနှစ်ချုပ်",
    "setup.label.Share(%)": "ဝေစု (%)",
    "setup.label.Cast": "သရုပ်ဆောင်",
    "setup.label.AttributeType": "Attribute အမျိုးအစား",
    "setup.label.CaptionValue": "စာတန်းတန်ဖိုး",
    "setup.label.NickName": "အမည်တို",
    "setup.label.Image": "ပုံ",
    "setup.label.Language": "ဘာသာစကား",
    "setup.label.Format": "ဖော်မတ်",
    "setup.label.Location": "တည်နေရာ",
    "setup.label.CustomerType": "ဖောက်သည်အမျိုးအစား",
    "setup.label.FormatType": "ဖော်မတ်အမျိုးအစား",
    "setup.label.DiscountCode": "လျှော့စျေးကုဒ်",
    "setup.label.ReProcess": "ျပန္လည္လုပ္ေဆာင္ရန္",
    "setup.label.Code": "ကုဒ္",
    "setup.label.Description": "ေဖာ္ျပခ်က္",
    "setup.label.PropertyCodeType": "ပိုင္ဆိုင္မႈကုဒ္အမ်ိဳးအစား",
    "setup.label.ReferenceValue": "ရည္ညႊန္းတန္ဖိုး",
    "setup.label.EditProperty": "ပိုင္ဆိုင္မႈတည္းျဖတ္ရန္",
    "setup.label.EditPropertyMaster": "ပိုင္ဆိုင္မႈမႉးတည္းျဖတ္ရန္",
    "setup.label.Cancel": "ဖ်က္သိမ္းရန္",
    "setup.label.View": "ၾကည့္ရန္",
    "setup.label.Edit": "တည္းျဖတ္ရန္",
    "setup.label.Browse_file_to_Upload": "တင္ရန္ ဖိုင္ေရြးပါ",
    "setup.label.CreatePropertyMaster": "ပိုင္ဆိုင္မႈမႉးဖန္တီးရန္",
    "setup.label.Property": "ပိုင္ဆိုင္မႈ",
    "setup.label.PropertyMaster": "ပိုင္ဆိုင္မႈမႉး",
    "setup.label.ViewProperty": "ပိုင္ဆိုင္မႈၾကည့္ရန္",
    "setup.label.ViewPropertyMaster": "ပိုင္ဆိုင္မႈမႉးၾကည့္ရန္",
    "setup.label.Are_you_sure_?": "သင္ေသခ်ာပါသလား?",
    "setup.label.Edit": "တည္းျဖတ္ရန္",
    "setup.label.Code": "ကုဒ္",
    "setup.label.Name": "အမည္",
    "setup.label.AddState": "ျပည္နယ္ထည့္ရန္",
    "setup.label.AddDistrict": "ခရိုင္ထည့္ရန္",
    "setup.label.AddCity": "ၿမိဳ႕ထည့္ရန္",
    "setup.label.EditCountry": "ႏိုင္ငံျပင္ဆင္ရန္",
    "setup.label.EditState": "ျပည္နယ္ျပင္ဆင္ရန္",
    "setup.label.EditDistrict": "ခရိုင္ျပင္ဆင္ရန္",
    "setup.label.EditCity": "ၿမိဳ႕ျပင္ဆင္ရန္",
    "setup.label.DeleteCountry": "ႏိုင္ငံဖ်က္ရန္",
    "setup.label.DeleteState": "ျပည္နယ္ဖ်က္ရန္",
    "setup.label.DeleteDistrict": "ခရိုင္ဖ်က္ရန္",
    "setup.label.DeleteCity": "ၿမိဳ႕ဖ်က္ရန္",
    "setup.label.ServiceAvailablity": "ဝန္ေဆာင္မႈရရွိႏိုင္မႈ",
    "setup.label.EnterCountryCode": "ႏိုင္ငံကုဒ္ထည့္ပါ",
    "setup.label.EnterCode": "ကုဒ္ထည့္ပါ",
    "setup.label.EnterName": "အမည္ထည့္ပါ",
    "setup.label.Service_Availablity_for_the": "အတြက္ ဝန္ေဆာင္မႈရရွိႏိုင္မႈ",
    "setup.label.SelectServices": "ဝန္ေဆာင္မႈမ်ားေရြးပါ",
    "setup.label.Select_One_or_More": "တစ္ခု သို႔မဟုတ္ မ်ားစြာေရြးပါ",
    "setup.label.options_selected": "ေရြးခ်ယ္ထားသည္မ်ား",
    "setup.label.PromotionName": "ပရိုမိုးရှင်းအမည်",
    "setup.label.PromotionCode": "ပရိုမိုးရှင်းကုဒ်",
    "setup.label.BussinesType": "လုပ်ငန်းအမျိုးအစား",
    "setup.label.OrderType": "အမှာစာအမျိုးအစား",
    "setup.label.PaymentType": "ငွေပေးချေမှုအမျိုးအစား",
    "setup.label.SelectCategory": "အမျိုးအစားရွေးပါ",
    "setup.label.PromotionTrigger": "ပရိုမိုးရှင်းစတင်ခြင်း",
    "setup.label.PromotionRule": "ပရိုမိုးရှင်းစည်းကမ်း",
    "setup.label.PromotionTriggerCondition": "ပရိုမိုးရှင်းစတင်ခြင်းအခြေအနေ",
    "setup.label.DiscountTriggerCondition": "လျှော့စျေးဖြစ်စေသောအခြေအနေ",
    "setup.label.DiscountRule": "လျှော့စျေးစည်းမျဉ်း",
    "setup.label.DiscountTrigger": "လျှော့စျေးဖြစ်စေသောအချက်",
    "setup.label.EditTriggerCondition": "လျှော့စျေးအခြေအနေ ပြင်ဆင်ရန်",
    "setup.label.Rate": "နှုန်းထား",
    "setup.label.EditRule": "စည်းမျဉ်း ပြင်ဆင်ရန်",
    "setup.label.AddRate": "နှုန်းထား ထည့်ရန်",
    "setup.label.Download": "ဒေါင်းလုဒ်",
    "setup.label.Process": "လုပ်ဆောင်မှု",
    "setup.label.ViewVendor": "အရောင်းသည်ကိုကြည့်မည်",
    "setup.label.VendorCode": "အရောင်းသည်ကုဒ်",
    "setup.label.VendorName": "အရောင်းသည်အမည်",
    "setup.label.select_Currency": "ငွေကြေးရွေးပါ",
    "setup.label.select_Country": "နိုင်ငံရွေးပါ",
    "setup.label.Filter_List": "စာရင်းစစ်ထုတ်ပါ",
    "setup.label.Are_you_sure_you_want_to_delete_?": "ဖျက်မှာသေချာပါသလား?",
    "setup.label.DeleteVoucher": "ဗောက်ချာဖျက်မည်",
    "setup.label.UpdatePin": "ပင်နံပါတ်အသစ်လုပ်မည်",
    "setup.label.UpdateVoucher": "ဗောက်ချာကိုအပ်ဒိတ်လုပ်မည်",
    "setup.label.select_from_dropdown":
      "ရွေးချယ်ရန် မျှောင့်ချန်စာရင်းမှ ရွေးပါ",
    "setup.label.ItemModel": "ပစ္စည်း မော်ဒယ်",
    "setup.label.price": "စျေးနှုန်း",
    "setup.label.Edit": "တည်းဖြတ်ပါ",
    "setup.label.Delete": "ဖျက်ပါ",
    "setup.label.Item": "ပစ္စည်း",
    "setup.label.EnterSupplierAddress": "ပေးသွင်းသူလိပ်စာထည့်ပါ",
    "setup.label.Title": "ခေါင်းစဉ်",
    "setup.label.AddPromotionTriggerCondition":
      "ပရိုမိုးရှင်းဖန်တီးမှုအခြေအနေထည့်ရန်",
    "setup.label.EditPromotionTriggerCondition":
      "ပရိုမိုးရှင်းဖန်တီးမှုအခြေအနေပြင်ရန်",
    "setup.label.AssignTo": "ပေးအပ်ရန်",
    "setup.label.Version": "ဗားရှင်း",
    "setup.label.IsOverride": "အစားထိုးမလား",
    "setup.label.PlanAttribute": "အစီအစဉ်လက္ခဏာ",
    "setup.label.ValidationRule": "အတည်ပြုမှုစည်းမျဉ်း",
    "setup.label.SaveAndContinue": "သိမ်းဆည်းပြီး ဆက်လက်လုပ်ဆောင်ရန်",
    "setup.label.PlanManagement": "အစီအစဉ်စီမံခန့်ခွဲမှု",
    "setup.label.Plan": "အစီအစဉ်",
    "setup.label.DiscountTriggerCondition": "လျှော့စျေးဖန်တီးမှုအခြေအနေ",
    "setup.label.AddDiscountTriggerCondition":
      "လျှော့စျေးဖန်တီးမှုအခြေအနေထည့်ရန်",
    "setup.label.SalesChannel": "ရောင်းချမှုလမ်းကြောင်း",
    "setup.label.PaymentType": "ငွေပေးချေမှုအမျိုးအစား",
    "setup.label.OrderType": "အော်ဒါအမျိုးအစား",
    "setup.label.BusinessType": "လုပ်ငန်းအမျိုးအစား",
    "setup.label.ViewDigitalContent": "ဒစ်ဂျစ်တယ်အကြောင်းအရာကြည့်မည်",
    "setup.label.EditDigitalContent": "ဒစ်ဂျစ်တယ်အကြောင်းအရာပြင်မည်",
    "setup.label.AddDigitalContent": "ဒီဂျစ်တယ်အကြောင်းအရာထည့်ပါ",
    "setup.label.PromotionRuleName": "မြှင့်တင်မှုစည်းကမ်းအမည်",
    "setup.label.PromotionTriggerCondition": "အထူးပရိုမိုးရှင်း သတ်မှတ်ချက်",
    "setup.label.AddPromotionTriggerCondition":
      "အထူးပရိုမိုးရှင်း သတ်မှတ်ချက် ထည့်ရန်",
    "setup.label.BussinesType": "စီးပွားရေးအမျိုးအစား",
    "setup.label.requestApproval": "အတည်ပြုမှု တောင်းဆိုမည်",
    "setup.label.validity_uom": "တရားဝင်မှုယူနစ်",
    "setup.label.validity_value": "တရားဝင်မှုတန်ဖိုး",
    "setup.label.ViewItemModel": "ပစ္စည်းမော်ဒယ်ကို ကြည့်ပါ",
    "setup.label.ItemType": "ပစ္စည်းအမျိုးအစား",
    "setup.label.ViewSupplier": "ပေးသွင်းသူကို ကြည့်ပါ",
    "setup.label.SupplierCode": "ပေးသွင်းသူကုဒ်",
    "setup.label.SupplierDescription": "ပေးသွင်းသူအကြောင်းဖော်ပြချက်",
    "setup.label.SupplierAddress": "ပေးသွင်းသူလိပ်စာ",
    "setup.label.DeleteSupplier": "ပေးသွင်းသူကို ဖျက်ပါ",
    "setup.label.CreateContract": "စာချုပ်တစ်စောင်ဖန်တီးပါ",
    "setup.label.RateTierName": "အဆင့်အမည်ကို အဆင့်သတ်မှတ်ပါ။",
    "setup.label.RangeType": "အမျိုးအစား",
    "setup.label.CreateDiscountRule": "လျှော့စျေးစည်းမျဉ်းကိုဖန်တီးပါ။",
    "setup.label.RuleCondition": "စည်းကမ်းအခြေအနေ",
    "setup.label.CreateRuleCondition": "စည်းကမ်းသတ်မှတ်ချက်ကို ဖန်တီးပါ။",
    "setup.label.CreateRule": "စည်းကမ်းဖန်တီးပါ။",
    "setup.label.Entity": "ဘဘ",
    "setup.label.EntityField": "ဘဘ အကွက်",
    "setup.label.contentTag": "အကြောင်းအရာတံဆိပ်",
    "setup.label.contentTagValue": "အကြောင်းအရာတံဆိပ်တန်ဖိုး",
    "setup.label.ExecutionType": "လုပ်ဆောင်မှု အမျိုးအစား",
    "setup.label.OperationMode": "စစ်ဆင်ရေးရည်မှန်းချက်",
    "setup.label.AggregationType": "စုစည်းမှု အမျိုးအစား",
    "setup.label.DurationInDays": "ကြာချိန် (နေ့ရက်များ)",
    "setup.label.CreateTicketTeamUser": "လက်မှတ်အသင်းအသုံးပြုသူဖန်တီးပါ",
    "setup.label.termsConditions": "စည်းကမ်းသတ်မှတ်ချက်များ",
    "setup.label.updateTermsConditions":
      "စည်းမျဥ်းစည်းကမ်းများကို အပ်ဒိတ်လုပ်ပါ။",
    "setup.label.updateDigitalContent":
      "ဒစ်ဂျစ်တယ် အကြောင်းအရာကို အပ်ဒိတ်လုပ်ပါ။",
    "setup.label.createDigitalContent": "ဒစ်ဂျစ်တယ်အကြောင်းအရာဖန်တီးပါ။",
    "setup.label.createTermsConditions": "စည်းမျဥ်းစည်းကမ်းများကို ဖန်တီးပါ။",
    "setup.label.digitalContent": "ဒစ်ဂျစ်တယ် အကြောင်းအရာ",
    "setup.label.planContent": "အကြောင်းအရာအစီအစဉ်",
    "setup.label.selectPlanContent": "အစီအစဉ်အကြောင်းအရာကို ရွေးပါ။",
    "setup.label.FilterType": "စစ်ထုတ်ခြင်းအမျိုးအစား",
    "setup.label.FilterValue": "စစ်ထုတ်ခြင်းတန်ဖိုး",
    "setup.label.ContractPeriod": "စာချုပ်ကာလ",
    "setup.label.ExternalPlanId": "ပြင်ပအစီအစဉ်အိုင်ဒီ",
    "setup.label.ExternalProductId": "ပြင်ပထုတ်ကုန်အိုင်ဒီ",
    "setup.label.SelectedPlanDiscounts":
      "အထူးရွေးချယ်ထားသောအစီအစဉ်လျှော့ဈေးများ,",
    "setup.label.ProductDiscount": "ထုတ်ကုန်လျှော့ဈေးများ,",
    "setup.label.AddContract": "စာချုပ်ထည့်ပါ။",
    "setup.label.EditContract": "စာချုပ်ကို တည်းဖြတ်ပါ။",
    "setup.label.ViewContract": "စာချုပ်ကိုကြည့်ပါ။",
    "setup.label.ContractType": "စာချုပ်အမျိုးအစား",
    "setup.label.ContractUnit": "စာချုပ်ယူနစ်",
    "setup.label.updateNetMask": "နက် မက်ခ်ကို အပ်ဒိတ်လုပ်ပါ",
    "setup.label.Update": "အပ်ဒိတ်",
    "setup.label.BillType": "ဘಿಲ್အမျိုးအစား,",
    "setup.label.BillFrequency": "ဘီလ်ထွက် frequency,",
    "setup.label.PlanEndDate": "အစီအစဉ်အဆုံးသတ်နေ့,",
    "setup.label.AddContent": "အကြောင်းအရာထည့်ပါ,",
    "setup.label.CreatePlanContent": "အစီအစဉ်အကြောင်းအရာဖန်တီးပါ,",
    "setup.label.SelectLanguage": "ဘာသာစကားရွေးပါ,",
    "setup.label.UploadDigitalImage": "ဓာတ်ပုံဒစ်ဂျစ်တယ်တင်ပါ,",
    "setup.label.ViewPlanContent": "အစီအစဉ်အကြောင်းအရာကြည့်ပါ,",
    "setup.label.ExternalPlanName": "ပြင်ပအစီအစဉ်အမည်,",
    "setup.label.ExternalProductName": "ပြင်ပထုတ်ကုန်အမည်,",
    "setup.label.ViewPrice": "ဈေးနှုန်းကြည့်ပါ,",
    "setup.label.PlanValidationRules": "စီမံကိန်း အတည်ပြုစည်းမျဥ်းများ",
    "setup.label.CreateValidationRule": "အတည်ပြုစည်းမျဥ်း အသစ် ဖန်တီးရန်",
    "setup.label.EditValidationRule": "အတည်ပြုစည်းမျဥ်း ပြင်ဆင်ရန်",
    "setup.label.InputPlanId": "စီမံကိန်း ID ထည့်ရန်",
    "setup.label.CheckinPlanId": "စီမံကိန်းအတည်ပြု ID",
    "setup.label.RuleAppliesTo": "ယူနစ်",
    "setup.label.Rule": "စည်းမျဥ်း",
    "setup.label.ViewValidationRule": "Peraturan Pengesahan Pandangan",
    "setup.label.ValidationRule": "Peraturan Pengesahan",
    "setup.label.createIpPool": "IP ကူးစက်မှုကို ဖန်တီးပါ",
    "setup.label.editIpPool": "IP ကူးစက်မှုကို တည်းဖြတ်ပါ",
    "setup.label.AddOrEditDiscount": "လျှော့စျေးထည့်/တည်းဖြတ်ပါ။",
    "setup.label.Next": "နောက်တစ်ခု",
    "setup.label.MainCategory": "ပင်မအမျိုးအစား",
    "setup.label.SubCategory": "အမျိုးအစားခွဲ",
    "setup.label.select_date": "ရက်စွဲရွေးပါ",
    "setup.label.AddDiscountTrigger": "လျှော့စျေး စနစ်တက်ရှက်ထည့်ပါ",
    "setup.label.AddPromotionTrigger": "ပရိုမိုးရှင်းအစပျိုးထည့်ပါ။",
    "setup.label.edit_promotion_trigger": "ပရိုမိုးရှင်းအစပျိုးကို တည်းဖြတ်ပါ။",
    "setup.label.DiscountTrigger": "လျှော့စျေး စနစ်တက်ရှက်",
    "setup.label.TriggerName": "စနစ်တက်ရှက် နာမည်",
    "setup.label.When": "အခါ",
    "setup.label.CustomerType": "ဖောက်သည် အမျိုးအစား",
    "setup.label.Criteria": "စံနှုန်းများ",
    "setup.label.Values": "တန်ဖိုးများ",
    "setup.label.ApplicableTo": "သက်ဆိုင်ရာ",
    "setup.label.ApplicableValues": "သက်ဆိုင်ရာတန်ဖိုးများ",
    "setup.label.DiscountRulesAndRates":
      "လျှော့စျေး စည်းမျဉ်းများနှင့်နှုန်းများ",
    "setup.label.RuleName": "စည်းမျဉ်း နာမည်",
    "setup.label.MaxDiscount": "အများဆုံးလျှော့စျေး",
    "setup.label.ResourceId": "အရင်းအမြစ် အိုင်ဒီ",
    "setup.label.DiscountRateType": "လျှော့စျေးနှုန်း အမျိုးအစား",
    "setup.label.Unit": "ယူနစ်",
    "setup.label.DiscountId": "လျှော့စျေး အိုင်ဒီ",
    "setup.label.DiscountName": "လျှော့စျေး အမည်",
    "setup.label.Priority": "ဦးစားပေး",
    "setup.label.Items": "ပစ္စည်းများ",
    "setup.label.ItemCode": "ပစ္စည်းကုဒ်",
    "setup.label.ItemDescription": "ပစ္စည်းဖြေကြားချက်",
    "setup.label.Units": "ယူနစ်",
    "setup.label.Total": "စုစုပေါင်း",
    "setup.label.Warranty": "အရောင်းအဝယ်",
    "setup.label.UsedItems": "သုံးစွဲသောပစ္စည်းများ",
    "setup.label.Balanced": "သောက်ဆေးနိုင်",
    "setup.label.IsProvisioning": "ပေးပြီးလျှင်",
    "setup.label.CreateItem": "ပစ္စည်းဖွင့်ရန်",
    "setup.label.ItemClass": "ပစ္စည်းအမျိုးအစား",
    "setup.label.ReorderLevel": "ပြင်ရန်စျေးနှုန်းအနေဖြင့်ပြန်လည်ရှိပါသည်",
    "setup.label.WarrantyPeriod": "အရောင်းအဝယ်အကြားကိန်း",
    "setup.label.Currency": "ငွေကြေး",
    "setup.label.DefaultPrice": "ပုံမှန်စျေးနှုန်း",
    "setup.label.IsSelector": "ရွေးချယ်သောအောက်ပါအတိုင်း",
    "setup.label.SelectorMenu": "ရွေးချယ်သောအောက်ပါအတိုင်းမီနူး",
    "setup.label.Selector": "ရွေးချယ်သောအောက်ပါအတိုင်း",
    "setup.label.VariablePrice": "စျေးနှုန်းအရှိန်",
    "setup.label.ItemModel": "ပစ္စည်းများမှာအမျိုးအစား",
    "setup.label.Price": "စျေးနှုန်း",
    "setup.label.Action": "လုပ်ဆောင်ချက်",

    "setup.label.Cancel": "ပယ်ဖျက်မည်",
    "setup.label.planPrice": "အစီအစဉ်ဈေးနှုန်း",
    "setup.label.listview": "စာရင်းမြင်ကွင်း",
    "setup.label.Submit": "တင်သွင်းမည်",
    "setup.label.EditItem": "ပစ္စည်းတစ်ခုတည်းဖြတ်ပါ",
    "setup.label.Id": "အမှတ်",
    "setup.label.ItemMasterId": "ပစ္စည်းသင်္ဘောဆိုက်ရန်အမှတ်",
    "setup.label.RegionId": "ဒေတာအမှတ်",
    "setup.label.Edit": "တည်းဖြတ်ပါ",
    "setup.label.ViewItem": "ကြည့်ရှုလုပ်ပါ",
    "setup.label.UnitPrice": "ယူနစ်စျေးနှုန်း",
    "setup.label.ItemModels": "ပစ္စည်းများအမြင့်",
    "setup.label.NetworkElement": "ကွန်ပျူတာအခြေအနေ",
    "setup.label.Model": "မိုးခွင့်",
    "setup.label.Make": "ဖန်တီးပါ",
    "setup.label.CreateItemModel": "ပစ္စည်းမိုးစကြည့်ပါ",
    "setup.label.Reset": "ပြန်စစ်သည်",
    "setup.label.EditItemModel": "ပစ္စည်းမိုးစနစ်ကိုတည်းဖြတ်ပါ",
    "setup.label.ServiceCode": "ဝန်ဆောင်မှုကုတ်",
    "setup.label.ServiceDescription": "ဝန်ဆောင်မှုဖော်ပြချက်",
    "setup.label.ServiceType": "ဝန်ဆောင်မှုအမျိုးအစား",
    "setup.label.Isoptional": "ရွေးချယ်နိုင်သော",
    "setup.label.Isautoprovision": "အလိုအလျောက်ပြုလုပ်မှု",
    "setup.label.CreateService": "ဝန်ဆောင်မှုဖန်တီးပါ",
    "setup.label.Code": "ကုတ်",
    "setup.label.Description": "ဖော်ပြချက်",
    "setup.label.Type": "အမျိုးအစား",
    "setup.label.EditService": "ဝန်ဆောင်မှုတည်းဖြတ်ပါ",
    "setup.label.ServiceParameter": "ဝန်ဆောင်မှုပါရာမီတာ",
    "setup.label.ParamName": "ပါရာမီတာနာမည်",
    "setup.label.ParamType": "ပါရာမီတာအမျိုးအစား",
    "setup.label.ParamCategory": "ပါရာမီတာအမျိုးအစား",
    "setup.label.ParamValue": "ပါရာမီတာတန်ဖိုး",
    "setup.label.BB": "BB",

    "setup.label.Delete": "ဖျက်ပါ",
    "setup.label.ServiceCategory": "ဝန်ဆောင်မှုအမျိုးအစား",
    "setup.label.DeleteServices": "ဝန်ဆောင်မှုများဖျက်ပါ",
    "setup.label.Confirm": "အတည်ပြုပါ",

    "setup.label.Service": "ဝန်ဆောင်မှု",
    "setup.label.Status": "အခြေအနေ",
    "setup.label.Bouquet": "ပန်းစည်း",
    "setup.label.Actions": "လှုပ်ရှားမှုများ",
    "setup.label.CreateProduct": "ထုတ်ကုန်ဖန်တီးပါ",
    "setup.label.ProductParameter": "ထုတ်ကုန်ပါရာမီတာ",
    "setup.label.EditProduct": "ထုတ်ကုန်တည်းဖြတ်ပါ",
    "setup.label.ProductDescription": "ထုတ်ကုန်ဖော်ပြချက်",
    "setup.label.ProductCategory": "ထုတ်ကုန်အမျိုးအစား",
    "setup.label.BroadcasterCode": "ရေဒီယိုအခြေစိုက်ကုဒ်",
    "setup.label.BroadcasterName": "ရေဒီယိုအခြေစိုက်နာမည်",
    "setup.label.GstRegNumber": "GST မှတ်ပုံတင်နံပါတ်",
    "setup.label.ContactPerson": "ဆက်သွယ်ရန်ပုဂ္ဂိုလ်",
    "setup.label.ContactMobile": "ဆက်သွယ်ရန်မိုဘိုင်း",
    "setup.label.Email": "အီးမေးလ်",
    "setup.label.CreateBroadcaster": "ရေဒီယိုအခြေစိုက်တည်ဆောက်ပါ",
    "setup.label.Address": "လိပ်စာ",
    "setup.label.MobileNo": "မိုဘိုင်းနံပါတ်",
    "setup.label.LandlineNo": "မြေပြင်လိုင်းနံပါတ်",
    "setup.label.EditBroadcaster": "ရေဒီယိုအခြေစိုက်တည်းဖြတ်ပါ",

    "setup.label.ChannelName": "ချန်နယ်နာမည်",
    "setup.label.ChannelType": "ချန်နယ်အမျိုးအစား",
    "setup.label.DeleteBroadcaster": "ရေဒီယိုအခြေစိုက်ကိုဖျက်ပါ",

    "setup.label.ChannelCategory": "ချန်နယ်အမျိုးအစား",
    "setup.label.ChannelSequence": "ချန်နယ်အမှတ်စဉ်",

    "setup.label.IsHdChannel": "HD ချန်နယ်ဖြစ်သည်",
    "setup.label.CreateChannel": "ချန်နယ်ဖန်တီးပါ",
    "setup.label.Language": "ဘာသာစကား",
    "setup.label.IsLocalChannel": "တိုင်းရင်းဆိုင်ရာချန်နယ်ဖြစ်သည်",
    "setup.label.Genre": "အမျိုးအစား",

    "setup.label.BroadcasterId": "ရေဒီယိုအခြေစိုက် ID",
    "setup.label.EditChannel": "ချန်နယ်တည်းဖြတ်ပါ",
    "setup.label.DeleteChannel": "ချန်နယ်ကိုဖျက်ပါ",

    "setup.label.ProductMapping": "ကုန်ပစ္စည်းမြေပုံဖွဲ့စည်းမှု",
    "setup.label.CreateProductChannelMapping":
      "ကုန်ပစ္စည်းချန်နယ်မြေပုံဖွဲ့စည်းမှုဖန်တီးပါ",
    "setup.label.ProductId": "ကုန်ပစ္စည်း ID",
    "setup.label.AvailableChannels": "ရရှိနိုင်သောချန်နယ်များ",
    "setup.label.SelectedChannels": "ရွေးချယ်ထားသောချန်နယ်များ",
    "setup.label.EditChannelMapping": "ချန်နယ်မြေပုံဖွဲ့စည်းမှုကိုတည်းဖြတ်ပါ",
    "setup.label.PlanPricing": "အစီအစဉ်နှင့် စျေးနှုန်း",
    "setup.label.CreatePlan": "အစီအစဉ်ဖန်တီးပါ",
    "setup.label.PlanCode": "အစီအစဉ်ကုဒ်",
    "setup.label.PlanDescription": "အစီအစဉ်အကြောင်းအရာ",
    "setup.label.PlanStatus": "အစီအစဉ်အခြေအနေ",
    "setup.label.PlanProvisionSystem": "အစီအစဉ်ရောက်ရှိရေးစနစ်",
    "setup.label.PlanStartDate": "အစီအစဉ်စတင်သည့်နေ့",
    "setup.label.IsPrepaid": "ကြိုတင်ငွေပေးချေထားသည်",
    "setup.label.Duration": "ကြာချိန်",
    "setup.label.PlanType": "အစီအစဉ်အမျိုးအစား",
    "setup.label.BillingRule": "ဘီလ်အတွက် စည်းမျဉ်းများ",
    "setup.label.EndDate": "ပြီးဆုံးသည့်နေ့",

    "setup.label.IsProvision": "ရောက်ရှိရေးလုပ်ဆောင်ခြင်း",

    "setup.label.EditPlan": "အစီအစဉ်တည်းဖြတ်ပါ",
    "setup.label.SelectProduct": "ထုတ်ကုန်ကို ရွေးပါ",
    "setup.label.ViewPlan": "အစီအစဉ်ကြည့်ရှုပါ",

    "setup.label.ProvisioningSystem": "ရောက်ရှိရေးစနစ်",

    "setup.label.DeletePlan": "အစီအစဉ်ကို ဖျက်ပါ",
    "setup.label.Prices": "စျေးနှုန်းများ",

    "setup.label.ChargeOwner": "ငွေပေးချေသူ",
    "setup.label.DiscountCode": "လျှော့စျေးကုဒ်",
    "setup.label.PriceRegion": "စျေးနှုန်းယူနစ်",
    "setup.label.Resource": "ရင်းမြတ်",
    "setup.label.SalesChannel": "အရောင်းချန်နယ်",
    "setup.label.OrderType": "အော်ဒါအမျိုးအစား",
    "setup.label.BusinessType": "လုပ်ငန်းအမျိုးအစား",
    "setup.label.rounding_type": "ကုန်ပစ္စည်းအမျိုးအစား",
    "setup.label.gl_id": "GL Id",
    "setup.label.duration": "ကျင်းပ",
    "setup.label.value": "တန်ဖိုး",
    "setup.label.TemplateDefinition": "တိုင်ကြားပြန်ကြားမှု",
    "setup.label.CreateTemplateDefinition": "တိုင်ကြားပြန်ကြားမှုထည့်သွင်းမှု",
    "setup.label.TemplateName": "ထုတ်ယူသည့်ပုံစံ",
    "setup.label.Delimiter": "ထုတ်ယူသည့်တွဲခြား",
    "setup.label.NumberOfFields": "စာရင်းနံပါတ်",
    "setup.label.HeaderRecorderType": "ခေါင်းစဥ်မှတ်တမ်းအမျိုးအစား",
    "setup.label.EventRecordType": "အဖွဲ့အစည်းစာရင်း",

    "setup.label.ProductCode": "ကုန်ပစ္စည်းကုဒ်",
    "setup.label.IsHeader": "ခေါင်းစဥ်ဖြင့်",
    "setup.label.FieldType": "စာရင်းအမျိုးအစား",
    "setup.label.FieldName": "စာရင်းနာမည်",
    "setup.label.IdentifierType": "စာရင်းတည်ရာများအမျိုးအစား",
    "setup.label.Length": "အရွယ်အစား",
    "setup.label.ExistsTemplateDefinition": "တည်နေရာရှိသောတင်ပြီးမှု",

    "setup.label.UOM(Unit Of measurement)": "UOM (အမျိုးအစားတည်း)",
    "setup.label.CreateUOM": "UOM ဖန်တီးပါ",
    "setup.label.Name": "အမည်",
    "setup.label.EditTemplateDefinition": "ထုတ်ယူသည့်ပုံစံကိုတည်းဖြတ်ပါ",
    "setup.label.EditUOM": "UOM တည်းဖြတ်ပါ",
    "setup.label.Save": "သိမ်းဆည်းပါ",
    "setup.label.DeleteUOM": "UOM ဖျက်ပါ",
    "setup.label.Ok": "အိုကေ",
    "setup.label.ViewUOM": "UOM ကြည့်ပါ",
    "setup.label.RUM(RatableUsageMetric)":
      "RUM (အသုံးစရိတ်အသုံးချုပ်အမျိုးအစား)",
    "setup.label.CreateRUM": "RUM ဖန်တီးပါ",
    "setup.label.ChargeName": "ငွေပေးချေနိုင်သည့်အမည်",
    "setup.label.Template Name": "ထုတ်ယူသည့်ပုံစံအမည်",
    "setup.label.RumName": "Rum အမည်",
    "setup.label.RumExpression": "Rum ထုတ်ယူသည့်ပုံစံ",

    "setup.label.Operators": "လုပ်ဆောင်သည့်လျှိပ်များ",
    "setup.label.EditRUM": "RUM တည်းဖြတ်ပါ",
    "setup.label.ViewRUM": "RUM ကြည့်ပါ",
    "setup.label.TimePeriod": "အချိန်ကာလ",
    "setup.label.CreateTimePeriod": "အချိန်ကာလ ဖန်တီးပါ",
    "setup.label.TimeModelName": "အချိန်မော်ဒယ်အမည်",
    "setup.label.StartYear": "အစတစ်နှစ်",
    "setup.label.EndYear": "အဆုံးတစ်နှစ်",
    "setup.label.StartMonth": "အစတစ်လ",
    "setup.label.EndMonth": "အဆုံးတစ်လ",
    "setup.label.StartDay": "အစတစ်ရက်",
    "setup.label.EndDay": "အဆုံးတစ်ရက်",
    "setup.label.StartTime": "အစအချိန်",
    "setup.label.EndTime": "အဆုံးအချိန်",
    "setup.label.CreateTimeModel": "အချိန်မော်ဒယ် ဖန်တီးပါ",
    "setup.label.ExpandAll / CollapseAll":
      "အားလုံးတိုးချဲ့ပါ / အားလုံးခေါ်ယူပါ",
    "setup.label.AddTimemodel": "အချိန်မော်ဒယ် ထည့်ပါ",
    "setup.label.UsageRatePlan": "အသုံးပြုမှုနှုန်းထားအစီအစဉ်",
    "setup.label.CreateUsageRatePlan": "အသုံးပြုမှုနှုန်းထားအစီအစဉ် ဖန်တီးပါ",
    "setup.label.PlanName": "အစီအစဉ်အမည်",
    "setup.label.ProductName": "ထုတ်ကုန်အမည်",
    "setup.label.TimemodelName": "အချိန်မော်ဒယ်အမည်",
    "setup.label.ViewUsageRatePlan": "အသုံးပြုမှုနှုန်းထားအစီအစဉ် ကြည့်ပါ",
    "setup.label.RUM": "RUM",
    "setup.label.RatingType": "အဆင့်သတ်မှတ်ခြင်းအမျိုးအစား",
    "setup.label.TimeModel": "အချိန်မော်ဒယ်",
    "setup.label.ZoneModel": "ဇုန်မော်ဒယ်",
    "setup.label.ViewQuantityTier": "အရေအတွက်အဆင့်ကြည့်ပါ",
    "setup.label.QuantityTier": "အရေအတွက်အဆင့်",
    "setup.label.TierName": "အဆင့်အမည်",
    "setup.label.CumulativeResource": "စုဆောင်းသောအရင်းအမြစ်",
    "setup.label.TierRange": "အဆင့်အကွာအဝေး",
    "setup.label.StepName": "အဆင့်အမည်",
    "setup.label.StartRange": "စတင်ကာလ",
    "setup.label.EndRange": "ဆုံးမှတ်ကာလ",
    "setup.label.AddQuantityTier": "အရေအတွက်အဆင့်ထည့်ပါ",
    "setup.label.NumberZone": "နံပါတ်ဇုန်",
    "setup.label.CreateNumberZone": "နံပါတ်ဇုန်ဖန်တီးပါ",
    "setup.label.SourceNumberPrefix": "အရင်းအမြစ်နံပါတ်ပရီဖစ်",
    "setup.label.DestinationNumberPrefix": "ဦးတည်ရာနံပါတ်ပရီဖစ်",
    "setup.label.ImpactCategory": "သက်ရောက်မှုအမျိုးအစား",
    "setup.label.Rank": "နံပါတ်",
    "setup.label.APNZone": "APN ဇုန်",
    "setup.label.APN": "APN",
    "setup.label.CreateAPNZone": "APN ဇုန်ဖန်တီးပါ",
    "setup.label.OperatorZone": "အော်ပရေတာဇုန်",
    "setup.label.CreateOperatorZone": "အော်ပရေတာဇုန်ဖန်တီးပါ",
    "setup.label.SourceOperatorCode": "အရင်းအမြစ်အော်ပရေတာကုဒ်",
    "setup.label.DestinationOperatorCode": "ဦးတည်ရာအော်ပရေတာကုဒ်",
    "setup.label.ICZone": "IC ဇုန်",
    "setup.label.IncomingTrunkid": "ဝင်ရောက်လာသော Trunkid",
    "setup.label.OutcomingTrunkid": "ထွက်နေသော Trunkid",
    "setup.label.CreateChargeCode": "အခကြေးငွေကုဒ်ဖန်တီးပါ",
    "setup.label.ChargeDescription": "အခကြေးငွေဖော်ပြချက်",
    "setup.label.ChargeType": "အခကြေးငွေ အမျိုးအစား",
    "setup.label.ChargeDuration": "အခကြေးငွေသတ်မှတ်ချိန်",
    "setup.label.DurationType": "ကြာမြင့်ချိန် အမျိုးအစား",
    "setup.label.TaxInclusive": "အခွန်ပါဝင်သည်",
    "setup.label.BillFrequencyCode": "ဘီလ် အကြိမ်နှုန်းကုဒ်",

    "setup.label.TaxCode": "အခွန်ကုဒ်",
    "setup.label.IsAggregate": "စုစုပေါင်းဖြစ်ပါသလား",
    "setup.label.EditChargeCode": "အခကြေးငွေကုဒ် တည်းဖြတ်ပါ",
    "setup.label.TaxMaster": "အခွန် မာစတာ",
    "setup.label.CreateTaxMaster": "အခွန် မာစတာဖန်တီးပါ",

    "setup.label.GroupType": "အုပ်စု အမျိုးအစား",
    "setup.label.GroupCode": "အုပ်စုကုဒ်",

    "setup.label.StartDate": "စတင်သည့်ရက်စွဲ",

    "setup.label.Rate": "နှုန်း",
    "setup.label.BaseTaxCode": "အခြေခံအခွန်ကုဒ်",
    "setup.label.Jurisdiction": "တရားဝင်ခွင့်",
    "setup.label.RateType": "နှုန်း အမျိုးအစား",
    "setup.label.Location": "တည်နေရာ",
    "setup.label.DeleteTax": "အခွန် ဖျက်ပါ",
    "setup.label.CreateDiscount": "လျှော့စျေးဖန်တီးပါ",

    "setup.label.DiscountDescription": "လျှော့စျေးဖော်ပြချက်",
    "setup.label.DiscountType": "လျှော့စျေးအမျိုးအစား",
    "setup.label.DiscountRate": "လျှော့စျေးနှုန်း",
    "setup.label.DiscountDetails": "လျှော့စျေးအသေးစိတ်",
    "setup.label.ClientCategory": "ဖောက်သည်အမျိုးအစား",
    "setup.label.CustomerCategory": "ဖောက်သည်အမျိုးအစား",

    "setup.label.EditDiscount": "လျှော့စျေးတည်းဖြတ်ပါ",
    "setup.label.DeleteDiscount": "လျှော့စျေးဖျက်ပါ",
    "setup.label.CreatePromotion": "ပရိုမိုးရှင်းဖန်တီးပါ",
    "setup.label.PromotionCode": "ပရိုမိုးရှင်းကုဒ်",
    "setup.label.PromotionName": "ပရိုမိုးရှင်းအမည်",
    "setup.label.PromotionId": "ပရိုမိုးရှင်း ID",
    "setup.label.PromotionDescription": "ပရိုမိုးရှင်းဖော်ပြချက်",

    "setup.label.EditPromotionCode": "ပရိုမိုးရှင်းကုဒ်တည်းဖြတ်ပါ",
    "setup.label.ListOfDiscounts": "လျှော့စျေးစာရင်း",
    "setup.label.ListofTimePeriods": "အချိန်ကာလစာရင်း",

    "setup.label.CreatePriceRegion": "စျေးနှုန်းဒေသဖန်တီးပါ",
    "setup.label.RegionCode": "ဒေသကုဒ်",
    "setup.label.RegionName": "ဒေသအမည်",
    "setup.label.Country": "နိုင်ငံ",
    "setup.label.States": "ပြည်နယ်များ",
    "setup.label.EditPriceRegion": "စျေးနှုန်းဒေသကိုတည်းဖြတ်ပါ",
    "setup.label.DeletePriceRegion": "စျေးနှုန်းဒေသကိုဖျက်ပါ",

    "setup.label.CreateSalesCatalogue": "ရောင်းအားကတ်တလောက်ဖန်တီးပါ",
    "setup.label.SalesCatalogueName": "အရောင်း Catalouge အမည်",
    "setup.label.AssignUsers": "အသုံးပြုသူများကို ချမှတ်ပါ",
    "setup.label.SalesPlanCategory": "ရောင်းအားအစီအစဉ်အမျိုးအစား",
    "setup.label.Plans": "အစီအစဉ်များ",
    "setup.label.EditSalesCatalogue": "ရောင်းအားကတ်တလောက်ကိုတည်းဖြတ်ပါ",
    "setup.label.DeleteSalesCatalogue": "ရောင်းအားကတ်တလောက်ကိုဖျက်ပါ",

    "setup.label.UserId": "အသုံးပြုသူ ID",
    "setup.label.UserName": "အသုံးပြုသူအမည်",
    "setup.label.CreateUsersCatalogue": "အသုံးပြုသူများစာရင်းဖန်တီးပါ",
    "setup.label.Catalogue": "စာရင်း",
    "setup.label.EditUserCatalogue": "အသုံးပြုသူများစာရင်းကိုတည်းဖြတ်ပါ",
    "setup.label.VoucherPins": "ဗောက်ချာ ပင်များ",
    "setup.label.CreateVoucherPins": "ဗောက်ချာ ပင်များ ဖန်တီးပါ",
    "setup.label.Voucher": "ဗောက်ချာ",
    "setup.label.Coupon": "ကူပွန်",
    "setup.label.LCO": "LCO",
    "setup.label.LengthOfPins": "ပင်အရှည်",
    "setup.label.SerialNoLength": "စီးရီးနံပါတ်အရှည်",
    "setup.label.NumberValue ": "နံပါတ်တန်ဖိုး",
    "setup.label.PinValue ": "ပင်တန်ဖိုး",
    "setup.label.BatchName": "ဘတ်ချ်အမည်",
    "setup.label.PinCategory": "ပင်အမျိုးအစား",

    "setup.label.BeginWith": "စတင်ရန်",
    "setup.label.Quantity": "ပမာဏ",
    "setup.label.PinType": "ပင်အမျိုးအစား",
    "setup.label.Value": "တန်ဖိုး",
    "setup.label.SIMNumbers": "SIM နံပါတ်များ",
    "setup.label.CreateSIMNumber": "SIM နံပါတ်ဖန်တီးပါ",
    "setup.label.NumberCategory": "နံပါတ်အမျိုးအစား",
    "setup.label.ExpiryDate": "သက်တမ်းကုန်စက်",
    "setup.label.Partner": "ပါတနာ",
    "setup.label.LengthofNumber": "နံပါတ်၏ အရှည်",
    "setup.label.LengthofSerialNumber": "စီးရီးနံပါတ်၏ အရှည်",
    "setup.label.NumberType": "နံပါတ်အမျိုးအစား",
    "setup.label.Product": "ထုတ်ကုန်",
    "setup.label.Supplier": "ပေးသွင်းသူ",
    "setup.label.CreateSupplier": "ပေးသွင်းသူ ဖန်တီးပါ",
    "setup.label.SupplierCode": "ပေးသွင်းသူ ကုဒ်",
    "setup.label.SupplierDescription": "ပေးသွင်းသူ ဖော်ပြချက်",
    "setup.label.SupplierAddress": "ပေးသွင်းသူလိပ်စာ",
    "setup.label.EditSupplier": "ပေးသွင်းသူ တည်းဖြတ်ပါ",
    "setup.label.AddressMaster": "လိပ်စာမာစတာ",
    "setup.label.CountryName": "နိုင်ငံအမည်",
    "setup.label.StateName": "ပြည်နယ်အမည်",
    "setup.label.DistrictName": "ခရိုင်အမည်",
    "setup.label.CityName": "မြို့အမည်",
    "setup.label.TreeView": "သစ်ပင်ကြည့်မူ",
    "setup.label.AddCountry": "နိုင်ငံ ထည့်ပါ",
    "setup.label.CountryCode": "နိုင်ငံကုဒ်",
    "setup.label.TeamHead": "အဖွဲ့ခေါင်းဆောင်",
    "setup.label.CreateTicketTeam": "လက်မှတ်အဖွဲ့ကို ဖန်တီးပါ",
    "setup.label.TeamCode": "အဖွဲ့ကုဒ်",
    "setup.label.TeamDescription": "အဖွဲ့အကြောင်းအရာ",
    "setup.label.TeamCategory": "အဖွဲ့အမျိုးအစား",
    "setup.label.CreateTicketTeamUsers":
      "လက်မှတ်အဖွဲ့အသုံးပြုသူများကို ဖန်တီးပါ",
    "setup.label.TeamEmail": "အဖွဲ့အီးမေးလ်",
    "setup.label.AvailableUsers": "ရရှိနိုင်သော အသုံးပြုသူများ",
    "setup.label.SelectedUsers": "ရွေးချယ်ထားသော အသုံးပြုသူများ",
    "setup.label.TeamId": "အဖွဲ့ ID",
    "setup.label.ViewTeam": "အဖွဲ့ကို ကြည့်ပါ",
    "setup.label.DeleteTeam": "အဖွဲ့ကို ဖျက်ပါ",
    "setup.label.EditTicketTeam": "လက်မှတ်အဖွဲ့ကို တည်းဖြတ်ပါ",
    "setup.label.TeamUser": "အဖွဲ့အသုံးပြုသူ",
    "setup.label.EditTicketUsers": "လက်မှတ်အသုံးပြုသူများကို တည်းဖြတ်ပါ",
    "setup.label.DeleteTeamUser": "အဖွဲ့အသုံးပြုသူကို ဖျက်ပါ",
    "setup.label.VendorManagement": "လက်ကားရောင်းသူစီမံခန့်ခွဲမှု",
    "setup.label.CreateVendor": "လက်ကားရောင်းသူဖန်တီးပါ",

    "setup.label.ContactName": "ဆက်သွယ်ရန်နာမည်",
    "setup.label.Mobile": "မိုဘိုင်း",
    "setup.label.Landline": "မြေနီ",

    "setup.label.CreateNewVendor": "လက်ကားရောင်းသူအသစ်ဖန်တီးပါ",
    "setup.label.EditVendor": "လက်ကားရောင်းသူတည်းဖြတ်ပါ",
    "setup.label.FeeMaster": "ကြေးဝန်ကြီး",
    "setup.label.CreateFeeMaster": "ကြေးဝန်ကြီး ဖန်တီးပါ",
    "setup.label.FeeMasterCode": "ကြေးဝန်ကြီး ကုဒ်",
    "setup.label.FeeMasterDescription": "ကြေးဝန်ကြီး ဖော်ပြချက်",
    "setup.label.FeeMasterTransactionType": "ကြေးဝန်ကြီး လုပ်ငန်းအမျိုးအစား",
    "setup.label.ChargeCode": "အခကြေးငွေ ကုဒ်",
    "setup.label.VariablePricing": "ပြောင်းလဲနိုင်သော စျေးနှုန်း",
    "setup.label.Regions": "တိုင်းဒေသကြီးများ",
    "setup.label.Amount": "ငွေပမာဏ",

    "setup.label.EditFeeMaster": "ကြေးဝန်ကြီး တည်းဖြတ်ပါ",
    "setup.label.ManageMessage": "မက်ဆေ့ချ်ကိုစီမံပါ",
    "setup.label.AddMessage": "မက်ဆေ့ချ်ထည့်ပါ",
    "setup.label.TemplateDescription": "နမူနာ ဖော်ပြချက်",
    "setup.label.Subject": "ခေါင်းစဉ်",
    "setup.label.MessageType": "မက်ဆေ့ခ််အမျိုးအစား",
    "setup.label.Header": "ခေါင်းစီး",
    "setup.label.Body": "ကိုယ်",
    "setup.label.Footer": "အောက်ခြေ",
    "setup.label.CreateMessageTemplate": "မက်ဆေ့ချ် နမူနာ ဖန်တီးပါ",
    "setup.label.MessageParams": "မက်ဆေ့ချ် ပါရာမီတာများ",
    "setup.label.Parameter": "ပါရာမီတာ",
    "setup.label.Params": "ပါရာမီတာများ",
    "setup.label.DeleteMessage": "မက်ဆေ့ချ်ကိုဖျက်ပါ",
    "setup.label.EditMessage": "မက်ဆေ့စ်တည်းဖြတ်ပါ",
    "setup.label.GroupsDetails": "အုပ်စုအသေးစိတ်",
    "setup.label.GroupName": "အဖွဲ့အမည်",
    "setup.label.GroupAddress": "အဖွဲ့လိပ်စာ",
    "setup.label.CountNo's": "နံပါတ်များကိုရေတွက်ပါ",
    "setup.label.AddGroup": "အဖွဲ့ထည့်ပါ",
    "setup.label.AdditionalInformation": "ထပ်မံသတင်းအချက်အလက်များ",
    "setup.label.GroupCIR": "အဖွဲ့ CIR",
    "setup.label.DIR": "DIR",
    "setup.label.MemberCIR": "အဖွဲ့ဝင် CIR",
    "setup.label.IpPoolManagement": "IP စင်ကူစုစည်းမှု စီမံခန့်ခွဲမှု",
    "setup.label.UpdateNetMask": "Net Mask အပ်ဒိတ်လုပ်ပါ",
    "setup.label.IpAddress": "IP လိပ်စာ",
    "setup.label.NetMark": "Net Mark",
    "setup.label.IpType": "IP အမျိုးအစား",
    "setup.label.CoustomerId": "ဖောက်သည် ID",
    "setup.label.CustomerName": "ဖောက်သည်အမည်",
    "setup.label.Notes": "မှတ်စုများ",
    "setup.label.Subnet": "Subnet",

    "setup.label.DetailsOfMedia": "မီဒီယာအသေးစိတ်",
    "setup.label.Media": "မီဒီယာ",
    "setup.label.AddMedia": "မီဒီယာထည့်ပါ",
    "setup.label.MediaTitle": "မီဒီယာခေါင်းစဉ်",
    "setup.label.MediaCatagory": "မီဒီယာအမျိုးအစား",
    "setup.label.ContentProvider": "အကြောင်းအရာပေးသူ",
    "setup.label.Share": "ဝေစု(%)",
    "setup.label.AddMediaDetails": "မီဒီယာအသေးစိတ်ထည့်ပါ",
    "setup.label.MediaLocation": "မီဒီယာတည်နေရာ",
    "setup.label.SelectMediaCategory": "မီဒီယာအမျိုးအစားရွေးပါ",
    "setup.label.Movies": "ရုပ်ရှင်",

    "setup.label.ViewMedia": "မီဒီယာကြည့်ရှုပါ",
    "setup.label.EditMedia": "မီဒီယာတည်းဖြတ်ပါ",
    "setup.label.MediaAttributes": "မီဒီယာအသေးစိတ်",
    "setup.label.Cast": "သရုပ်ဆောင်များ",
    "setup.label.AttributeType": "အသေးစိတ်အမျိုးအစား",
    "setup.label.CaptionValue": "နာမည်တပ်တန်ဖိုး",
    "setup.label.NickName": "နာမည်လေး",
    "setup.label.Image": "ပုံ",
    "setup.label.AddMediaLocations": "မီဒီယာတည်နေရာထည့်ပါ",
    "setup.label.LanguageData": "ဘာသာစကားအချက်အလက်",
    "setup.label.FormatData": "ဖော်မတ်အချက်အလက်",
    "setup.label.MediaLocations": "မီဒီယာတည်နေရာများ",
    "setup.label.DetailsOfEvent": "ပွဲ၏ အသေးစိတ်",
    "setup.label.EventName": "ပွဲ အမည်",
    "setup.label.EventCode": "ဖြစ်ရပ်ကုဒ်",
    "setup.label.SelectedMediaService": "ရွေးချယ်ထားသောမီဒီယာဝန်ဆောင်မှု",
    "setup.label.AvailableMedia": "ရရှိနိုင်သောမီဒီယာ",
    "setup.label.EventDescription": "ပွဲ အကြောင်းအရာ",
    "setup.label.EventCategory": "ပွဲ အမျိုးအစား",
    "setup.label.CreateEvent": "ပွဲ ဖန်တီးမည်",
    "setup.label.DetailsOfProperty": "ပိုင်ဆိုင်မှု၏ အသေးစိတ်",
    "setup.label.PropertyCode": "ပိုင်ဆိုင်မှု ကုဒ်",
    "setup.label.PropertyType": "ပိုင်ဆိုင်မှု အမျိုးအစား",
    "setup.label.Parcel": "စည်ပင်",
    "setup.label.BuildingCode": "အဆောက်အဦ ကုဒ်",
    "setup.label.Precinct": "အနီးအနား",
    "setup.label.Allocated": "ပေးအပ်ခြင်း",
    "setup.label.UploadPropertyData": "ပိုင်ဆိုင်မှု ဒေတာ တင်မည်",
    "setup.label.Clear": "ရှင်းလင်းသည်",
    "setup.label.CreateProperty": "ပိုင်ဆိုင်မှု ဖန်တီးမည်",
    "setup.label.PropertyDataUpload": "ပိုင်ဆိုင်မှု ဒေတာ တင်မည်",
    "setup.label.Street": "လမ်း",
    "setup.label.PaymentType": "ငွေပေးချေမှု အမျိုးအစား",
    "setup.label.PoBox": "စာတိုက်",
    "setup.label.State": "ပြည်နယ်",
    "setup.label.District": "ခရိုင်",
    "setup.label.Floor": "ထပ်",

    "setup.label.LimitCode": "ကန့်သတ်ကုဒ်",
    "setup.label.PropertyMaster": "ပိုင်ဆိုင်မှု မာစတာ",
    "setup.label.CodeDescription": "ကုဒ် ဖေါ်ပြချက်",
    "setup.label.ReferenceValue": "ရည်ညွှန်း အဘိုး",
    "setup.label.Services": "ဝန်ဆောင်မှုများ",

    "setup.label.IsBouquet": "ပန်းစည်းပါသလား",
    "setup.label.Broadcaster": "ထုတ်လွှင့်သူ",
    "setup.label.Channel": "လွှင့်တင်လိုက်ပါ",

    "setup.label.ContactNumber": "ဆက်သွယ်ရန်နံပါတ်",

    "setup.label.UOM": "ယူအိုအမ်",

    "setup.label.DeleteTemplateDefinition": "အမျိုးအစားညွှန်းကိန်းကို ဖျက်ပါ",

    "setup.label.Discount": "လျှော့စျေး",

    "setup.label.SalseCatalogue": "အရောင်းစာရင်း",
    "setup.label.UserCatalogue": "အသုံးပြုသူစာရင်း",
    "setup.label.Team": "အသင်း",

    "setup.label.MediaDetails": "မီဒီယာအသေးစိတ်",
    "setup.label.Event": "ဖြစ်ရပ်",
    "setup.label.Properties": "အိမ်ခြံမြေ",

    "setup.label.ServicesProducts": "ဝန်ဆောင်မှုများနှင့် ထုတ်ကုန်များ",
    "setup.label.BroadcasterChannelMapping":
      "ထုတ်လွှင့်သူ, လမ်းကြောင်းနှင့် မြေပုံ",

    "setup.label.UsageRating": "အသုံးပြုမှုအဆင့်သတ်မှတ်ချက်",
    "setup.label.ZoneSetup": "ဇုန်ချိန်ညှိမှု",
    "setup.label.Promotion": "ကြိုးပမ်းမှု",
    "setup.label.PromotionTrigger": "ပရိုမိုးရှင်းအစပျိုး",
    "setup.label.PromotionRulesAndRates":
      "ပရိုမိုးရှင်း စည်းကမ်းများနှင့် စျေးနှုန်းများ",
    "setup.label.CatalogeMapping": "စာရင်းပြုစုခြင်း",
    "setup.label.VoucherPin": "ဗောက်ချာ",
    "setup.label.SIMNumber": "SIM နံပါတ်",
    "setup.label.TeamTeamUser": "အသင်းနှင့် အသင်းအသုံးပြုသူ",
    "setup.label.MessageTemplate": "သတင်းစကားပုံ",
    "setup.label.ClosedUserGroup": "ပိတ်ထားသောအသုံးပြုသူအဖွဲ့",
    "setup.label.IpManagement": "IP စီမံခန့်ခွဲမှု",
    "setup.label.PropertyDefinition": "ပိုင်ဆိုင်မှုအဓိပ္ပါယ်",
    "setup.label.PriorityMapping": "ဦးစားပေးမြေပုံဆွဲခြင်း။",
    "setup.label.AddProducts": "ထုတ်ကုန်များ ထည့်မည်",
    "setup.label.AddDiscount": "လျှော့စျေး ထည့်မည်",
    "setup.label.Products": "ထုတ်ကုန်များ",
    "setup.label.ChargeCodeData": "အခကြေးငွေကုဒ်ဒေတာ",
    "setup.label.TaxMapping": "အခွန်မြေပုံ",
    "setup.label.TaxRegion": "အခွန်တိုင်းဒေသကြီး",
    "setup.label.CreateUserCatalogue": "အသုံးပြုသူစာရင်းပြုစုပါ",
    "setup.label.IcZone": "Ic ဧရိယာ",
    "setup.label.ViewIcZone": "Ic ဧရိယာကြည့်ရှုပါ",
    "setup.label.ViewNumberZone": "နံပါတ်ဇုန်ကိုကြည့်ပါ",

    "setup.label.EditNumberZone": "နံပါတ်ဇုန်ကိုတည်းဖြတ်ပါ",
    "setup.label.DeleteNumberZone": "နံပါတ်ဇုန်ကိုဖျက်ပါ",
    "setup.label.AreYouSure": "သေချာပါသလား?",
    "setup.label.ViewAPNZone": "APN ဇုန်ကိုကြည့်ပါ",
    "setup.label.EditAPNZone": "APN ဇုန်ကိုတည်းဖြတ်ပါ",
    "setup.label.DeleteAPNZone": "APN ဇုန်ကိုဖျက်ပါ",
    "setup.label.ViewOperatorZone": "စစ်ဆင်ရေးဇုန်ကိုကြည့်ပါ",
    "setup.label.EditOperatorZone": "စစ်ဆင်ရေးဇုန်ကိုတည်းဖြတ်ပါ",

    "setup.label.CreateICZone": "IC ဇုန်ကိုဖန်တီးပါ",
    "setup.label.EditICZone": "IC ဇုန်ကိုတည်းဖြတ်ပါ",
    "setup.label.DeleteOperatorZone": "စစ်ဆင်ရေးဇုန်ကိုဖျက်ပါ",
    "setup.label.DeleteIcZone": "IC ဇုန်ကိုဖျက်ပါ",
    "setup.label.MobileNumber": "မိုဘိုင်းနံပါတ်",
    "setup.label.LandlineNumber": "လက်ကိုင်ဖုန်းနံပါတ် (ရွေးချယ်နိုင်သည်)",
    "setup.label.RatePlanName": "အမီတာအစီအစဉ်အမည်",
    "setup.label.UsageRateBalance": "အသုံးပြုမှုနှုန်း လက်ကျန်",
    "setup.label.ValidityType": "တရားဝင်မှုအမျိုးအစား",
    "setup.label.ListOfRateTires": "နှုန်းထား တာယာများစာရင်း",
    "setup.label.Validity": "တရားဝင်မှု",
    "setup.label.CreatePlanName": "အစီအစဉ်အမည်ဖန်တီးပါ",
    "setup.label.EditPlanContent": "အစီအစဉ်အကြောင်းအရာကိုတည်းဖြတ်ပါ",
    "setup.label.CreatePlanDescription": "အစီအစဉ်ဖော်ပြချက်ဖန်တီးပါ",
    "setup.label.ContentType": "အကြောင်းအရာအမျိုးအစား",
    "setup.label.CreateFeatureList": "အင်္ဂါရပ်စာရင်းဖန်တီးပါ",
    "setup.label.Area": "ဧရိယာ",
    "setup.label.TaxPercentage": "အခွန်ရာခိုင်နှုန်း",
    "setup.label.Add": "ထည့်ပါ",
    "setup.label.Remove": "ဖယ်ရှားပါ။",
    "setup.label.CreateVoucherPin": "ဗောက်ချာပင်ဖန်တီးပါ",
    "setup.label.EditSubCategory": "အမျိုးအစားခွဲများကို တည်းဖြတ်ပါ။",
    "setup.label.CreateSubCategory": "အမျိုးအစားခွဲများကို ဖန်တီးပါ။",
    "setup.label.ViewSubCategory": "အမျိုးအစားခွဲများကို ကြည့်ရှုပါ။",
    "setup.label.TimeTaken": "အချိန်ယူ",
    "setup.label.TeamMapping": "အဖွဲ့မြေပုံ",
    "setup.label.CreateTeamMapping": "အဖွဲ့မြေပုံဖန်တီးပါ",

    "setup.label.Category": "အမျိုးအစား",
    "setup.label.external_promotional_code": "ပြင်ပ ပရိုမိုးရှင်းကုဒ်",
    "setup.label.Subcategory": "အမျိုးအစားခွဲ",

    "setup.label.DeleteItemMapping": "အချက်အလက်မြေပုံဖျက်ပါ",
    "setup.label.EditTeamMapping": "အဖွဲ့မြေပုံတည်းဖြတ်ပါ",
    "setup.label.ViewTeamMapping": "အဖွဲ့မြေပုံကြည့်ပါ",
    "setup.label.DeletePriorityMapping": "ဦးစားပေးမှုမြေပုံဖျက်ပါ",
    "setup.label.discount_rule": "လျှော့စျေး စည်းမျဉ်း",
    "setup.label.promotion_rule": "ပရိုမိုးရှင်းစည်းမျဉ်း",
    "setup.label.discount_rate": "လျှော့စျေးနှုန်း",
    "setup.label.create_discount_rule": "လျှော့စျေးစည်းမျဉ်းကိုဖန်တီးပါ။",
    "setup.label.edit_promotion_rule": "ပရိုမိုးရှင်းစည်းမျဉ်းကို တည်းဖြတ်ပါ။",
    "setup.label.create_promotion_rule": "မြှင့်တင်ရေးစည်းမျဉ်းကို ဖန်တီးပါ။",
    "setup.label.create_discount_rate": "လျှော့စျေးနှုန်းကိုဖန်တီးပါ။",
    "setup.label.add_discount_rate": "လျှော့စျေးနှုန်း ထည့်ပါ",
    "setup.label.add_promotion_rate": "ပရိုမိုးရှင်းနှုန်းထည့်ပါ။",
    "setup.label.edit_discount": "လျှော့စျေးပြင်ဆင်ရန်",
    "setup.label.edit_promotion": "ပရိုမိုးရှင်းကို တည်းဖြတ်ပါ။",
    "setup.label.edit_discount_trigger": "လျှော့စျေး ဦးတည်ချက် ပြင်ဆင်ရန်",
    "setup.label.edit_discount_rule": "လျှော့စျေး စည်းမျဉ်း ပြင်ဆင်ရန်",
    "setup.label.collection_process": "စုစည်းခြင်း လုပ်ငန်းစဉ်",
    "setup.label.create_collection_profile": "စုစည်းခြင်း ပရိုဖိုင် ဖန်တီးပါ",
    "setup.label.collection_profile": "စုစည်းခြင်း ပရိုဖိုင်",
    "setup.label.collection_profile_id": "စုစည်းခြင်း ပရိုဖိုင် ID",
    "setup.label.region": "ဒေသ",
    "setup.label.collection": "စုစည်းခြင်း",
    "setup.label.collection_trigger": "စုစည်းခြင်း သွင်ပြင် လုပ်ဆောင်ခြင်း",
    "setup.label.collection_scenario": "စုစည်းခြင်း အဖြစ်အပျက်",
    "setup.label.add_collection_trigger":
      "စုစည်းခြင်း သွင်ပြင် လုပ်ဆောင်ခြင်းထည့်ပါ",
    "setup.label.add_collection_scenario": "စုစည်းခြင်း အဖြစ်အပျက် ထည့်ပါ",
    "setup.label.trigger_id": "ဖြစ်စဉ် ID",
    "setup.label.criteria_type": "စာရင်းပေးချက် အမျိုးအစား",
    "setup.label.due_balance": "ကျန်ငွေ",
    "setup.label.ageing_days": "သက်တမ်းရက်",
    "setup.label.scenario_id": "သဘောထား ID",
    "setup.label.action_name": "လုပ်ဆောင်ချက် နာမည်",
    "setup.label.age": "အသက်",
    "setup.label.create_collection_trigger": "စုစည်းခြင်းဖြစ်စဉ် ဖန်တီးပါ",
    "setup.label.create_collection_scenario": "စုစည်းခြင်း သဘောထား ဖန်တီးပါ",
    "setup.label.edit_collection_profile": "စုစည်းခြင်းပရိုဖိုင်ကို တည်းဖြတ်ပါ",
    "setup.label.edit_collection_trigger": "စုစည်းခြင်းဖြစ်စဉ်ကို တည်းဖြတ်ပါ",
    "setup.label.edit_collection_scenario": "စုစည်းခြင်း သဘောထားကို တည်းဖြတ်ပါ",
    "setup.label.SlaInHours": "SLA အတွက် နာရီ",
    "setup.label.contractduration": "စာချုပ်သက်တမ်း",
    "setup.label.chargesperiodicity": "အခကြိမ်နှုန်း",
  },

  vi: {
    "setup.label.Enter_product_Description":"Nhập mô tả sản phẩm",
    "setup.label.FeedbackStatus" : "Trạng thái phản hồi",
    "setup.label.EnterCountryName": "Nhập tên quốc gia",
    "setup.label.location": "Vị trí",
    "setup.label.selectLocation": "Chọn vị trí",
    "setup.label.create_group_ticket": "Tạo vé nhóm",
    "setup.label.default": "Thiết lập",
    "setup.label.customerFeedback": "Phản hồi của khách hàng",
    "setup.label.automation": "Tự động hóa",
    "setup.label.automation_master": "Chủ tự động hóa",
    "setup.label.create_automation": "Tạo tự động hóa",
    "setup.label.edit_automation": "Chỉnh sửa tự động hóa",
    "setup.label.automation_detail": "Chi tiết tự động hóa",
    "setup.label.automation_steps": "Các bước tự động hóa",
    "setup.label.add_automation_step": "Thêm bước tự động hóa",
    "setup.label.AutomationId": "ID tự động hóa",
    "setup.label.EntityName": "Tên thực thể",
    "setup.label.EntityType": "Loại thực thể",
    "setup.label.WorkflowName": "Tên quy trình",
    "setup.label.CreateAutomationScenario": "Tạo kịch bản tự động hóa",
    "setup.label.EditAutomationStep": "Chỉnh sửa bước tự động hóa",
    "setup.label.ActionType": "Loại hành động",
    "setup.label.ActionDetails": "Chi tiết hành động",
    "setup.label.StepOrder": "Thứ tự bước",
    "setup.label.questionAnswerSet": "Bộ câu hỏi và câu trả lời",
    "setup.label.addQuestionSet": "Thêm bộ câu hỏi",
    "setup.label.EditQuestionSet": "Chỉnh sửa bộ câu hỏi",
    "setup.label.CategoryName": "Tên danh mục",
    "setup.label.SubCategoryName": "Tên danh mục con",
    "setup.label.TotalQuestions": "Tổng số câu hỏi",
    "setup.label.QuestionType": "Loại câu hỏi",
    "setup.label.QuestionText": "Văn bản câu hỏi",
    "setup.label.CustomerFeedback": "Phản hồi của khách hàng",
    "setup.label.TicketId": "ID vé",
    "setup.label.LinkedAt": "Liên kết lúc",
    "setup.label.Remarks": "Ghi chú",
    "setup.label.AddFeedback": "Thêm phản hồi",
    "setup.label.PendingForApproval": "Chờ phê duyệt",
    "setup.label.user_availability": "Tình trạng sẵn sàng của người dùng",
    "setup.label.all_users_availability":
      "Tình trạng sẵn sàng của tất cả người dùng",
    "setup.label.create_user_availability":
      "Tạo tình trạng sẵn sàng của người dùng",
    "setup.label.LeaveManagement": "Quản lý nghỉ phép",
    "setup.label.CreateLeave": "Tạo nghỉ phép",
    "setup.label.EditLeave": "Chỉnh sửa nghỉ phép",
    "setup.label.ViewLeave": "Xem nghỉ phép",
    "setup.label.AllUserLeaves": "Tất cả các ngày nghỉ của người dùng",
    "setup.label.MyLeaves": "Ngày nghỉ của tôi",
    "setup.label.ConfigId": "ID cấu hình",
    "setup.label.edit_user_availability":
      "Chỉnh sửa tình trạng sẵn sàng của người dùng",
    "setup.label.view_user_availability":
      "Xem tình trạng sẵn sàng của người dùng",
    "setup.label.unavailability_date": "Ngày không khả dụng",
    "setup.label.start_time": "Thời gian bắt đầu",
    "setup.label.end_time": "Thời gian kết thúc",
    "setup.label.my_availability": "Tình trạng sẵn sàng của tôi",
    "setup.label.user": "Người dùng",
    "setup.label.EditShift": "Chỉnh sửa ca làm việc",
    "setup.label.UserWorkingShift": "Ca làm việc của người dùng",
    "setup.label.CreateUserWorkingShift": "Tạo ca làm việc của người dùng",
    "setup.label.EditUserWorkingShift": "Chỉnh sửa ca làm việc của người dùng",
    "setup.label.ViewUserWorkingShift": "Xem ca làm việc của người dùng",
    "setup.label.TeamName": "Tên nhóm",
    "setup.label.Shift": "Ca làm việc",
    "setup.label.ShiftManagement": "Quản lý ca làm việc",
    "setup.label.CreateShift": "Tạo ca làm việc",
    "setup.label.ShiftName": "Tên ca làm việc",
    "setup.label.Session": "Phiên làm việc",
    "setup.label.SessionType": "Loại phiên làm việc",
    "setup.label.LeaveDetails": "Chi tiết nghỉ phép",
    "setup.label.SessionStartTime": "Thời gian bắt đầu phiên",
    "setup.label.SessionEndTime": "Thời gian kết thúc phiên",
    "setup.label.LeaveType": "Loại nghỉ phép",
    "setup.label.AddAnotherDate": "Thêm ngày khác",
    "setup.label.Apn_Zone": "Khu vực APN",
    "setup.label.FeeMaster": "Quản lý phí",
    "setup.label.Number_Zone": "Vùng số",
    "setup.label.DeleteRUM": "Xóa RUM",
    "setup.label.Edit_TimeModel": "Chỉnh sửa mô hình thời gian",
    "setup.label.Edit_Year": "Chỉnh sửa năm",
    "setup.label.scenario_name": "Tên kịch bản",
    "setup.label.event_name": "Tên sự kiện",
    "setup.label.Edit_Month": "Chỉnh sửa tháng",
    "setup.label.Edit_Day": "Chỉnh sửa ngày",
    "setup.label.Edit_Time": "Chỉnh sửa giờ",
    "setup.label.Delete_TimeModel": "Xóa mô hình thời gian",
    "setup.label.Delete_Year": "Xóa năm",
    "setup.label.Delete_Month": "Xóa tháng",
    "setup.label.Delete_Day": "Xóa ngày",
    "setup.label.Delete_Time": "Xóa giờ",
    "setup.label.Are_you_sure_?": "Bạn có chắc không?",
    "setup.label.Save": "Lưu",
    "setup.label.TemplateDefinition": "Định nghĩa mẫu",
    "setup.label.EditQuantityTier": "Chỉnh sửa cấp số lượng",
    "setup.label.Usage_Rate_Balance": "Số dư tỷ lệ sử dụng",
    "setup.label.Template_Name": "Tên mẫu",
    "setup.label.Delimiter": "Ký tự phân cách",
    "setup.label.Number_Of_Fields": "Số lượng trường",
    "setup.label.Header_Recorder_Type": "Loại ghi âm tiêu đề",
    "setup.label.Event_Record_Type": "Loại ghi âm sự kiện",
    "setup.label.CreateUOM": "Tạo đơn vị đo lường",
    "setup.label.TimePeriod": "Khoảng thời gian",
    "setup.label.Usage_Rate_Plan": "Kế hoạch tỷ lệ sử dụng",
    "setup.label.TemplateDefinition": "Định nghĩa mẫu",
    "setup.label.CreateRUM": "Tạo RUM",
    "setup.label.CreateTimePeriod": "Tạo khoảng thời gian",
    "setup.label.TimemodelName": "Tên mô hình thời gian",
    "setup.label.TimePeriodName": "Tên khoảng thời gian",
    "setup.label.StartYear": "Năm bắt đầu",
    "setup.label.EndYear": "Năm kết thúc",
    "setup.label.UsageRatePlan": "Kế hoạch tỷ lệ sử dụng",
    "setup.label.Create_Usage_Rate_Plan": "Tạo kế hoạch tỷ lệ sử dụng",
    "setup.label.Id": "ID",
    "setup.label.PlanName": "Tên kế hoạch",
    "setup.label.ProductName": "Tên sản phẩm",
    "setup.label.ChargeCode": "Mã phí",
    "setup.label.TimeModelName": "Tên mô hình thời gian",
    "setup.label.RatingType": "Loại đánh giá",
    "setup.label.RumName": "Tên RUM",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "Bạn có chắc chắn muốn xóa không?",
    "setup.label.UOM": "Đơn vị đo lường",
    "setup.label.RUM": "RUM",
    "setup.label.ImpactCategory": "Danh mục ảnh hưởng",
    "setup.label.Resource": "Tài nguyên",
    "setup.label.GLID": "GLID",
    "setup.label.Unit": "Đơn vị",
    "setup.label.Rate": "Tỷ lệ",
    "setup.label.Action": "Hành động",
    "setup.label.options_selected": "tùy chọn đã chọn",
    "setup.label.UsageRateBalance": "Số dư tỷ lệ sử dụng",
    "setup.label.EndYear": "Năm kết thúc",
    "setup.label.StartMonth": "Tháng bắt đầu",
    "setup.label.EndMonth": "Tháng kết thúc",
    "setup.label.StartDay": "Ngày bắt đầu",
    "setup.label.EndDay": "Ngày kết thúc",
    "setup.label.StartTime": "Thời gian bắt đầu",
    "setup.label.Time_Model_Name": "Tên mô hình thời gian",
    "setup.label.model_includes_which_all_Bands_?":
      "Mô hình bao gồm các dải nào?",
    "setup.label.YearRestriction": "Giới hạn năm",
    "setup.label.MonthRestriction": "Giới hạn tháng",
    "setup.label.DayRestriction": "Giới hạn ngày",
    "setup.label.TimeRestriction": "Giới hạn thời gian",
    "setup.label.Code": "Mã",
    "setup.label.Name": "Tên",
    "setup.label.PriorityMapping": "Ánh xạ mức độ ưu tiên",
    "setup.label.AddJurisdiction": "Thêm khu vực pháp lý",
    "setup.label.Are_you_sure_?": "Bạn có chắc không?",
    "setup.label.Country": "Quốc gia",
    "setup.label.State": "Bang/Tỉnh",
    "setup.label.District": "Quận/Huyện",
    "setup.label.RateType": "Loại thuế suất",
    "setup.label.Remove": "Xóa",
    "setup.label.TaxMaster": "Quản lý thuế",
    "setup.label.Team": "Đội",
    "setup.label.Add": "Thêm",
    "setup.label.FeeMaster": "Quản lý phí",
    "setup.label.DeleteChargeCode": "Xóa mã tính phí",
    "setup.label.SelectSearch": "Chọn tìm kiếm",
    "setup.label.Select_Content_Tag_Value": "Chọn giá trị thẻ nội dung",
    "setup.label.Plan_Content": "Nội dung gói",
    "setup.label.Plan": "Gói",
    "setup.label.ProductPrice": "Giá sản phẩm",
    "setup.label.SelectedPromotions": "Khuyến mãi đã chọn",
    "setup.label.AvailablePromotions": "Khuyến mãi khả dụng",
    "setup.label.SelectType": "Chọn loại",
    "setup.label.Type": "Loại",
    "setup.label.No_versions_available": "Không có phiên bản khả dụng",
    "setup.label.Version": "Phiên bản",
    "setup.label.ListPrice": "Giá niêm yết",
    "setup.label.SellingPrice": "Giá bán",
    "setup.label.EnterPlanDescription": "Nhập mô tả gói",
    "setup.label.AddPrice": "Thêm giá",
    "setup.label.Save": "Lưu",
    "setup.label.AddDiscount": "Thêm giảm giá",
    "setup.label.AvailablePlans": "Gói khả dụng",
    "setup.label.SelectedPlans": "Gói đã chọn",
    "setup.label.PlanType": "Loại gói",
    "setup.label.Plan_Start_Date": "Ngày bắt đầu gói",
    "setup.label.Plan_End_Date": "Ngày kết thúc gói",
    "setup.label.Bill_Type": "Loại hóa đơn",
    "setup.label.AttributeTypes": "Loại thuộc tính",
    "setup.label.Add": "Thêm",
    "setup.label.Select_Content_Tag": "Chọn thẻ nội dung",
    "setup.label.PlanName": "Tên gói",
    "setup.label.AvailableDiscounts": "Giảm giá có sẵn",
    "setup.label.Search": "Tìm kiếm...",
    "setup.label.MoveRight": "Di chuyển sang phải",
    "setup.label.MoveLeft": "Di chuyển sang trái",
    "setup.label.SelectedDiscounts": "Giảm giá đã chọn",
    "setup.label.SelectType": "Chọn loại",
    "setup.label.SelectLanguage": "Chọn ngôn ngữ",
    "setup.label.SelectContentTag": "Chọn thẻ nội dung",
    "setup.label.SelectContentTagValue": "Chọn giá trị thẻ",
    "setup.label.DigitalContent": "Nội dung kỹ thuật số",
    "setup.label.Enter_Plan_Description": "Nhập mô tả gói",
    "setup.label.DC_Rule": "Quy tắc DC",
    "setup.label.PlanAttribute": "Thuộc tính gói",
    "setup.label.AdvanceView": "Chế độ xem nâng cao",
    "setup.label.Update": "Cập nhật",
    "setup.label.ProductMapping": "Ánh xạ sản phẩm",
    "setup.label.Service": "Dịch vụ",
    "setup.label.SubProducts": "Sản phẩm phụ",
    "setup.label.Type": "Loại",
    "setup.label.EnterValue": "Nhập giá trị",
    "setup.label.PriceRegion": "Khu vực giá",
    "setup.label.Enter_service_Description": "Nhập mô tả dịch vụ",
    "setup.label.ParamName": "Tên tham số",
    "setup.label.Category": "Danh mục",
    "setup.label.Type": "Loại",
    "setup.label.EnterValue": "Nhập giá trị",
    "setup.label.SalesCatalogue": "Danh mục bán hàng",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "Bạn có chắc chắn muốn xóa không?",
    "setup.label.Channel": "Kênh",
    "setup.label.Broadcaster": "Đài truyền hình",
    "setup.label.AddPrice": "Thêm giá",
    "setup.label.DeleteMediaEvent": "Xoá sự kiện truyền thông",
    "setup.label.AdvMedia": "Truyền thông quảng cáo",
    "setup.label.EditMedia": "Chỉnh sửa truyền thông",
    "setup.label.AddEvent": "Thêm sự kiện",
    "setup.label.AddAttributes": "Thêm thuộc tính",
    "setup.label.AddLocation": "Thêm địa điểm",
    "setup.label.DeleteEvent": "Xoá sự kiện",
    "setup.label.Are_you_sure_?": "Bạn có chắc không?",
    "setup.label.Add": "Thêm",
    "setup.label.ViewEvent": "Xem sự kiện",
    "setup.label.Event": "Sự kiện",
    "setup.label.RUM": "RUM",
    "setup.label.OptType": "Loại tùy chọn",
    "setup.label.Currency": "Tiền tệ",
    "setup.label.Amount": "Số tiền",
    "setup.label.Add": "Thêm",
    "setup.label.Save": "Lưu",
    "setup.label.AddDiscount": "Thêm giảm giá",
    "setup.label.EnterEventCode": "Nhập mã sự kiện",
    "setup.label.EnterEventDescription": "Nhập mô tả sự kiện",
    "setup.label.EventDescription": "Mô tả sự kiện",
    "setup.label.EventCategory": "Danh mục sự kiện",
    "setup.label.ChargeCode": "Mã phí",
    "setup.label.SelectEventValidity": "Chọn hiệu lực sự kiện",
    "setup.label.EditEvent": "Chỉnh sửa sự kiện",
    "setup.label.UnitCode": "Mã đơn vị",
    "setup.label.MediaTitle": "Tiêu đề phương tiện",
    "setup.label.ContentProvider": "Nhà cung cấp nội dung",
    "setup.label.MediaType": "Loại phương tiện",
    "setup.label.Rated": "Đánh giá",
    "setup.label.MediaCategory": "Danh mục phương tiện",
    "setup.label.Rating": "Xếp hạng",
    "setup.label.Poster": "Áp phích",
    "setup.label.Status": "Trạng thái",
    "setup.label.MovieDuration": "Thời gian phim",
    "setup.label.ReleaseDate": "Ngày phát hành",
    "setup.label.Genre": "Thể loại",
    "setup.label.Subject": "Chủ đề",
    "setup.label.Overview": "Tổng quan",
    "setup.label.Share(%)": "Chia sẻ (%)",
    "setup.label.Cast": "Dàn diễn viên",
    "setup.label.AttributeType": "Loại thuộc tính",
    "setup.label.CaptionValue": "Giá trị chú thích",
    "setup.label.NickName": "Biệt danh",
    "setup.label.Image": "Hình ảnh",
    "setup.label.Language": "Ngôn ngữ",
    "setup.label.Format": "Định dạng",
    "setup.label.Location": "Vị trí",
    "setup.label.CustomerType": "Loại khách hàng",
    "setup.label.FormatType": "Loại định dạng",
    "setup.label.DiscountCode": "Mã giảm giá",
    "setup.label.ReProcess": "Xử lý lại",
    "setup.label.Code": "Mã",
    "setup.label.Description": "Mô tả",
    "setup.label.PropertyCodeType": "Loại mã tài sản",
    "setup.label.ReferenceValue": "Giá trị tham chiếu",
    "setup.label.EditProperty": "Chỉnh sửa tài sản",
    "setup.label.EditPropertyMaster": "Chỉnh sửa quản lý tài sản",
    "setup.label.Cancel": "Hủy bỏ",
    "setup.label.View": "Xem",
    "setup.label.Edit": "Chỉnh sửa",
    "setup.label.Browse_file_to_Upload": "Chọn tệp để tải lên",
    "setup.label.CreatePropertyMaster": "Tạo quản lý tài sản",
    "setup.label.Property": "Tài sản",
    "setup.label.PropertyMaster": "Quản lý tài sản",
    "setup.label.ViewProperty": "Xem tài sản",
    "setup.label.ViewPropertyMaster": "Xem quản lý tài sản",
    "setup.label.Are_you_sure_?": "Bạn có chắc chắn không?",
    "setup.label.Edit": "Chỉnh sửa",
    "setup.label.Code": "Mã",
    "setup.label.Name": "Tên",
    "setup.label.AddState": "Thêm bang",
    "setup.label.AddDistrict": "Thêm huyện",
    "setup.label.AddCity": "Thêm thành phố",
    "setup.label.EditCountry": "Chỉnh sửa quốc gia",
    "setup.label.EditState": "Chỉnh sửa bang",
    "setup.label.EditDistrict": "Chỉnh sửa huyện",
    "setup.label.EditCity": "Chỉnh sửa thành phố",
    "setup.label.DeleteCountry": "Xoá quốc gia",
    "setup.label.DeleteState": "Xoá bang",
    "setup.label.DeleteDistrict": "Xoá huyện",
    "setup.label.DeleteCity": "Xoá thành phố",
    "setup.label.ServiceAvailablity": "Tình trạng dịch vụ",
    "setup.label.EnterCountryCode": "Nhập mã quốc gia",
    "setup.label.EnterCode": "Nhập mã",
    "setup.label.EnterName": "Nhập tên",
    "setup.label.Service_Availablity_for_the": "Tình trạng dịch vụ cho",
    "setup.label.SelectServices": "Chọn dịch vụ",
    "setup.label.Select_One_or_More": "Chọn một hoặc nhiều",
    "setup.label.options_selected": "đã chọn",
    "setup.label.PromotionName": "Tên khuyến mãi",
    "setup.label.PromotionCode": "Mã khuyến mãi",
    "setup.label.BussinesType": "Loại hình kinh doanh",
    "setup.label.OrderType": "Loại đơn hàng",
    "setup.label.PaymentType": "Hình thức thanh toán",
    "setup.label.SelectCategory": "Chọn danh mục",
    "setup.label.PromotionTrigger": "Kích hoạt khuyến mãi",
    "setup.label.PromotionRule": "Quy tắc khuyến mãi",
    "setup.label.PromotionTriggerCondition": "Điều kiện kích hoạt khuyến mãi",
    "setup.label.DiscountTriggerCondition": "Điều kiện kích hoạt giảm giá",
    "setup.label.DiscountRule": "Quy tắc giảm giá",
    "setup.label.DiscountTrigger": "Trình kích hoạt giảm giá",
    "setup.label.EditTriggerCondition": "Chỉnh sửa điều kiện kích hoạt",
    "setup.label.Rate": "Tỷ lệ",
    "setup.label.EditRule": "Chỉnh sửa quy tắc",
    "setup.label.AddRate": "Thêm tỷ lệ",
    "setup.label.Download": "Tải xuống",
    "setup.label.Process": "Xử lý",
    "setup.label.ViewVendor": "Xem nhà cung cấp",
    "setup.label.VendorCode": "Mã nhà cung cấp",
    "setup.label.VendorName": "Tên nhà cung cấp",
    "setup.label.select_Currency": "Chọn tiền tệ",
    "setup.label.select_Country": "Chọn quốc gia",
    "setup.label.Filter_List": "Lọc danh sách",
    "setup.label.Are_you_sure_you_want_to_delete_?":
      "Bạn có chắc chắn muốn xóa không?",
    "setup.label.DeleteVoucher": "Xóa phiếu",
    "setup.label.UpdatePin": "Cập nhật mã PIN",
    "setup.label.UpdateVoucher": "Cập nhật phiếu",
    "setup.label.select_from_dropdown": "Chọn từ danh sách thả xuống",
    "setup.label.ItemModel": "Mẫu mặt hàng",
    "setup.label.price": "Giá",
    "setup.label.Edit": "Chỉnh sửa",
    "setup.label.Delete": "Xóa",
    "setup.label.Item": "Mặt hàng",
    "setup.label.EnterSupplierAddress": "Nhập địa chỉ nhà cung cấp",
    "setup.label.Title": "Tiêu đề",
    "setup.label.AddPromotionTriggerCondition":
      "Thêm điều kiện kích hoạt khuyến mãi",
    "setup.label.EditPromotionTriggerCondition":
      "Chỉnh sửa điều kiện kích hoạt khuyến mãi",
    "setup.label.AssignTo": "Gán cho",
    "setup.label.Version": "Phiên bản",
    "setup.label.IsOverride": "Có ghi đè không",
    "setup.label.PlanAttribute": "Thuộc tính kế hoạch",
    "setup.label.ValidationRule": "Quy tắc xác thực",
    "setup.label.SaveAndContinue": "Lưu và tiếp tục",
    "setup.label.PlanManagement": "Quản lý kế hoạch",
    "setup.label.Plan": "Kế hoạch",
    "setup.label.DiscountTriggerCondition": "Điều kiện kích hoạt giảm giá",
    "setup.label.AddDiscountTriggerCondition":
      "Thêm điều kiện kích hoạt giảm giá",
    "setup.label.SalesChannel": "Kênh bán hàng",
    "setup.label.PaymentType": "Loại thanh toán",
    "setup.label.OrderType": "Loại đơn hàng",
    "setup.label.BusinessType": "Loại hình kinh doanh",
    "setup.label.ViewDigitalContent": "Xem nội dung kỹ thuật số",
    "setup.label.EditDigitalContent": "Chỉnh sửa nội dung kỹ thuật số",
    "setup.label.AddDigitalContent": "Thêm nội dung kỹ thuật số",
    "setup.label.PromotionRuleName": "Tên quy tắc khuyến mãi",
    "setup.label.PromotionTriggerCondition": "Điều kiện kích hoạt khuyến mãi",
    "setup.label.AddPromotionTriggerCondition":
      "Thêm điều kiện kích hoạt khuyến mãi",
    "setup.label.BussinesType": "Loại hình kinh doanh",
    "setup.label.requestApproval": "Yêu cầu phê duyệt",
    "setup.label.validity_uom": "Đơn Vị Hiệu Lực",
    "setup.label.validity_value": "Giá Trị Hiệu Lực",
    "setup.label.ViewItemModel": "Xem mô hình mặt hàng",
    "setup.label.ItemType": "Loại mặt hàng",
    "setup.label.ViewSupplier": "Xem Nhà cung cấp",
    "setup.label.SupplierCode": "Mã Nhà cung cấp",
    "setup.label.SupplierDescription": "Mô tả Nhà cung cấp",
    "setup.label.SupplierAddress": "Địa chỉ Nhà cung cấp",
    "setup.label.DeleteSupplier": "Xóa Nhà cung cấp",
    "setup.label.CreateContract": "Tạo hợp đồng",
    "setup.label.RateTierName": "Tên bậc xếp hạng",
    "setup.label.RangeType": "Loại phạm vi",
    "setup.label.CreateDiscountRule": "Tạo quy tắc giảm giá",
    "setup.label.RuleCondition": "Điều kiện quy tắc",
    "setup.label.CreateRuleCondition": "Tạo điều kiện quy tắc",
    "setup.label.CreateRule": "Tạo quy tắc",
    "setup.label.Entity": "thực thể",
    "setup.label.EntityField": "Trường thực thể",
    "setup.label.contentTag": "Thẻ nội dung",
    "setup.label.contentTagValue": "Giá trị thẻ nội dung",
    "setup.label.ExecutionType": "Loại thực thi",
    "setup.label.OperationMode": "Chế độ hoạt động",
    "setup.label.AggregationType": "Loại tổng hợp",
    "setup.label.DurationInDays": "Thời gian trong ngày",
    "setup.label.CreateTicketTeamUser": "Tạo người dùng nhóm vé",
    "setup.label.termsConditions": "Điều khoản & Điều kiện",
    "setup.label.updateTermsConditions": "Cập nhật Điều khoản & Điều kiện",
    "setup.label.updateDigitalContent": "Cập nhật nội dung số",
    "setup.label.createDigitalContent": "Tạo nội dung số",
    "setup.label.createTermsConditions": "Tạo Điều khoản & Điều kiện",
    "setup.label.digitalContent": "Nội dung số",
    "setup.label.planContent": "Nội dung kế hoạch",
    "setup.label.selectPlanContent": "Chọn nội dung kế hoạch",
    "setup.label.FilterType": "Loại bộ lọc",
    "setup.label.FilterValue": "Giá trị bộ lọc",
    "setup.label.ExternalPlanId": "ID kế hoạch bên ngoài",
    "setup.label.ExternalProductId": "ID sản phẩm bên ngoài",
    "setup.label.SelectedPlanDiscounts": "Giảm giá gói đã chọn,",
    "setup.label.ProductDiscount": "Giảm giá sản phẩm,",
    "setup.label.ContractPeriod": "Thời hạn hợp đồng",
    "setup.label.AddContract": "Thêm hợp đồngt",
    "setup.label.EditContract": "Chỉnh sửa hợp đồng",
    "setup.label.ViewContract": "Xem hợp đồng",
    "setup.label.ContractType": "Loại hợp đồng",
    "setup.label.ContractUnit": "Đơn vị hợp đồng",
    "setup.label.updateNetMask": "Cập nhật Net Mask",
    "setup.label.Update": "Cập nhật",
    "setup.label.BillType": "Loại hóa đơn",
    "setup.label.BillFrequency": "Tần suất hóa đơn",
    "setup.label.PlanEndDate": "Ngày kết thúc kế hoạch",
    "setup.label.AddContent": "Thêm nội dung",
    "setup.label.CreatePlanContent": "Tạo nội dung kế hoạch",
    "setup.label.SelectLanguage": "Chọn ngôn ngữ",
    "setup.label.UploadDigitalImage": "Tải lên hình ảnh kỹ thuật số",
    "setup.label.ViewPlanContent": "Xem nội dung kế hoạch",
    "setup.label.ExternalPlanName": "Tên kế hoạch ngoài",
    "setup.label.ExternalProductName": "Tên sản phẩm ngoài",
    "setup.label.ViewPrice": "Xem giá",
    "setup.label.PlanValidationRules": "Quy tắc xác thực kế hoạch",
    "setup.label.CreateValidationRule": "Tạo quy tắc xác thực",
    "setup.label.EditValidationRule": "Chỉnh sửa quy tắc xác thực",
    "setup.label.InputPlanId": "Nhập ID kế hoạch",
    "setup.label.CheckinPlanId": "ID kế hoạch xác thực",
    "setup.label.RuleAppliesTo": "Đơn vị",
    "setup.label.Rule": "Quy tắc",
    "setup.label.ViewValidationRule": "Quy tắc xác thực hiển thị",
    "setup.label.ValidationRule": "Quy tắc xác thực",
    "setup.label.createIpPool": "Tạo bể IP",
    "setup.label.editIpPool": "Chỉnh sửa bể IP",
    "setup.label.AddOrEditDiscount": "Thêm/Chỉnh sửa Giảm giá",
    "setup.label.Next": "Tiếp Theo",
    "setup.label.MainCategory": "danh Mục chính",
    "setup.label.SubCategory": "Danh mục phụ",
    "setup.label.select_date": "Chọn Ngày",
    "setup.label.AddDiscountTrigger": "Thêm Bộ Kích Hoạt Giảm Giá",
    "setup.label.AddPromotionTrigger": "Thêm kích hoạt khuyến mãi",
    "setup.label.edit_promotion_trigger": "Chỉnh sửa kích hoạt khuyến mãi",
    "setup.label.DiscountTrigger": "Bộ Kích Hoạt Giảm Giá",
    "setup.label.TriggerName": "Tên Bộ Kích Hoạt",
    "setup.label.When": "Khi Nào",
    "setup.label.CustomerType": "Loại Khách Hàng",
    "setup.label.Criteria": "Tiêu Chí",
    "setup.label.Values": "Giá Trị",
    "setup.label.ApplicableTo": "Áp Dụng Cho",
    "setup.label.ApplicableValues": "Giá Trị Áp Dụng",
    "setup.label.DiscountRulesAndRates": "Quy Tắc Và Tỷ Lệ Giảm Giá",
    "setup.label.RuleName": "Tên Quy Tắc",
    "setup.label.MaxDiscount": "Giảm Giá Tối Đa",
    "setup.label.ResourceId": "ID Tài Nguyên",
    "setup.label.DiscountRateType": "Loại Tỷ Lệ Giảm Giá",
    "setup.label.Unit": "Đơn Vị",
    "setup.label.DiscountId": "Mã Giảm Giá",
    "setup.label.DiscountName": "Tên Giảm Giá",
    "setup.label.Priority": "Ưu Tiên",
    "setup.label.Items": "Các mặt hàng",
    "setup.label.ItemCode": "Mã hàng",
    "setup.label.ItemDescription": "Mô tả hàng",
    "setup.label.Units": "Đơn vị",
    "setup.label.Total": "Tổng cộng",
    "setup.label.Warranty": "Bảo hành",
    "setup.label.UsedItems": "Các mặt hàng đã sử dụng",
    "setup.label.Balanced": "Cân đối",
    "setup.label.IsProvisioning": "Là cung cấp",
    "setup.label.CreateItem": "Tạo mặt hàng",
    "setup.label.ItemClass": "Lớp mặt hàng",
    "setup.label.ReorderLevel": "Mức đặt lại",
    "setup.label.WarrantyPeriod": "Thời gian bảo hành",
    "setup.label.Currency": "Tiền tệ",
    "setup.label.DefaultPrice": "Giá mặc định",
    "setup.label.IsSelector": "Là lựa chọn",
    "setup.label.SelectorMenu": "Menu lựa chọn",
    "setup.label.Selector": "Lựa chọn",
    "setup.label.VariablePrice": "Giá biến đổi",
    "setup.label.ItemModel": "Mô hình mặt hàng",
    "setup.label.Price": "Giá",
    "setup.label.Action": "Hành động",

    "setup.label.Cancel": "Hủy bỏ",
    "setup.label.planPrice": "Giá Kế Hoạch",
    "setup.label.listview": "Chế Độ Danh Sách",
    "setup.label.Submit": "Gửi",
    "setup.label.EditItem": "Chỉnh sửa mặt hàng",
    "setup.label.Id": "Id",
    "setup.label.ItemMasterId": "Id Mặt hàng chính",
    "setup.label.RegionId": "Id Vùng",
    "setup.label.Edit": "Chỉnh sửa",
    "setup.label.ViewItem": "Xem mặt hàng",
    "setup.label.UnitPrice": "Đơn giá",
    "setup.label.ItemModels": "Mô hình mặt hàng",
    "setup.label.NetworkElement": "Yếu tố mạng",
    "setup.label.Model": "Mô hình",
    "setup.label.Make": "Tạo",
    "setup.label.CreateItemModel": "Tạo mô hình mặt hàng",
    "setup.label.Reset": "Đặt lại",
    "setup.label.EditItemModel": "Chỉnh sửa mô hình mặt hàng",
    "setup.label.ServiceCode": "Mã dịch vụ",
    "setup.label.ServiceDescription": "Mô tả dịch vụ",
    "setup.label.ServiceType": "Loại dịch vụ",
    "setup.label.Isoptional": "Tùy chọn",
    "setup.label.Isautoprovision": "Tự động cung cấp",
    "setup.label.CreateService": "Tạo dịch vụ",
    "setup.label.Code": "Mã",
    "setup.label.Description": "Mô tả",
    "setup.label.Type": "Loại",
    "setup.label.EditService": "Chỉnh sửa dịch vụ",
    "setup.label.ServiceParameter": "Tham số dịch vụ",
    "setup.label.ParamName": "Tên tham số",
    "setup.label.ParamType": "Loại tham số",
    "setup.label.ParamCategory": "Danh mục tham số",
    "setup.label.ParamValue": "Giá trị tham số",
    "setup.label.BB": "BB",

    "setup.label.Delete": "Xóa",
    "setup.label.ServiceCategory": "Danh mục dịch vụ",
    "setup.label.DeleteServices": "Xóa dịch vụ",
    "setup.label.Confirm": "Xác nhận",

    "setup.label.Service": "Dịch vụ",
    "setup.label.Status": "Trạng thái",
    "setup.label.Bouquet": "Bó hoa",
    "setup.label.Actions": "Hành động",
    "setup.label.CreateProduct": "Tạo sản phẩm",
    "setup.label.ProductParameter": "Tham số sản phẩm",
    "setup.label.EditProduct": "Chỉnh sửa sản phẩm",
    "setup.label.ProductCode": "Mã sản phẩm",
    "setup.label.ProductDescription": "Mô tả sản phẩm",
    "setup.label.ProductCategory": "Danh mục sản phẩm",
    "setup.label.BroadcasterCode": "Mã Đài Phát",
    "setup.label.BroadcasterName": "Tên Đài Phát",
    "setup.label.GstRegNumber": "Số Đăng Ký GST",
    "setup.label.ContactPerson": "Người Liên Hệ",
    "setup.label.ContactMobile": "Điện Thoại Di Động Liên Hệ",
    "setup.label.Email": "Email",
    "setup.label.CreateBroadcaster": "Tạo Đài Phát",
    "setup.label.Address": "Địa Chỉ",
    "setup.label.MobileNo": "Số Di Động",
    "setup.label.LandlineNo": "Số Điện Thoại Bàn",
    "setup.label.EditBroadcaster": "Chỉnh Sửa Đài Phát",

    "setup.label.ChannelName": "Tên Kênh",
    "setup.label.ChannelType": "Loại Kênh",
    "setup.label.DeleteBroadcaster": "Xóa Đài Phát",

    "setup.label.ChannelCategory": "Danh Mục Kênh",
    "setup.label.ChannelSequence": "Thứ Tự Kênh",

    "setup.label.IsHdChannel": "Là Kênh HD",
    "setup.label.CreateChannel": "Tạo Kênh",
    "setup.label.Language": "Ngôn Ngữ",
    "setup.label.IsLocalChannel": "Là Kênh Địa Phương",
    "setup.label.Genre": "Thể Loại",

    "setup.label.BroadcasterId": "ID Đài Phát",
    "setup.label.EditChannel": "Chỉnh Sửa Kênh",
    "setup.label.DeleteChannel": "Xóa Kênh",

    "setup.label.ProductMapping": "Lập Bản Đồ Sản Phẩm",
    "setup.label.CreateProductChannelMapping": "Tạo Bản Đồ Kênh Sản Phẩm",
    "setup.label.ProductId": "ID Sản Phẩm",
    "setup.label.AvailableChannels": "Kênh Có Sẵn",
    "setup.label.SelectedChannels": "Kênh Đã Chọn",
    "setup.label.EditChannelMapping": "Chỉnh Sửa Bản Đồ Kênh",
    "setup.label.PlanPricing": "Kế Hoạch & Giá Cả",
    "setup.label.CreatePlan": "Tạo Kế Hoạch",
    "setup.label.PlanCode": "Mã Kế Hoạch",
    "setup.label.PlanDescription": "Mô Tả Kế Hoạch",
    "setup.label.PlanStatus": "Trạng Thái Kế Hoạch",
    "setup.label.PlanProvisionSystem": "Hệ Thống Cung Cấp Kế Hoạch",
    "setup.label.PlanStartDate": "Ngày Bắt Đầu Kế Hoạch",
    "setup.label.IsPrepaid": "Trả Trước",
    "setup.label.Duration": "Thời Gian",
    "setup.label.PlanType": "Loại Kế Hoạch",
    "setup.label.BillingRule": "Quy Tắc Thanh Toán",
    "setup.label.EndDate": "Ngày Kết Thúc",

    "setup.label.IsProvision": "Được Cung Cấp",

    "setup.label.EditPlan": "Chỉnh Sửa Kế Hoạch",
    "setup.label.SelectProduct": "Chọn Sản Phẩm",
    "setup.label.ViewPlan": "Xem Kế Hoạch",

    "setup.label.ProvisioningSystem": "Hệ Thống Cung Cấp",

    "setup.label.DeletePlan": "Xóa Kế Hoạch",
    "setup.label.Prices": "Giá cả",

    "setup.label.ChargeOwner": "Chủ sở hữu phí",
    "setup.label.DiscountCode": "Mã giảm giá",
    "setup.label.PriceRegion": "Khu vực giá",
    "setup.label.Resource": "Nguồn",
    "setup.label.SalesChannel": "Kênh bán hàng",
    "setup.label.OrderType": "Loại lệnh",
    "setup.label.BusinessType": "Loại hình kinh doanh",
    "setup.label.rounding_type": "Loại làm tròn",
    "setup.label.gl_id": "GL Id",
    "setup.label.duration": "Thời gian",
    "setup.label.value": "Giá trị",
    "setup.label.TemplateDefinition": "Định nghĩa Mẫu",
    "setup.label.CreateTemplateDefinition": "Tạo Định nghĩa Mẫu",
    "setup.label.TemplateName": "Tên Mẫu",
    "setup.label.Delimiter": "Dấu phân cách",
    "setup.label.NumberOfFields": "Số Lượng Trường",
    "setup.label.HeaderRecorderType": "Loại Bộ ghi Đầu mục",
    "setup.label.EventRecordType": "Loại Ghi Sự kiện",

    "setup.label.IsHeader": "Là Đầu mục",
    "setup.label.FieldType": "Loại Trường",
    "setup.label.FieldName": "Tên Trường",
    "setup.label.IdentifierType": "Loại Định danh",
    "setup.label.Length": "Chiều Dài",
    "setup.label.ExistsTemplateDefinition": "Định nghĩa Mẫu Đã Tồn tại",

    "setup.label.UOM(Unit Of measurement)": "UOM (Đơn vị đo lường)",
    "setup.label.CreateUOM": "Tạo UOM",
    "setup.label.Name": "Tên",
    "setup.label.EditTemplateDefinition": "Chỉnh sửa Định nghĩa Mẫu",
    "setup.label.EditUOM": "Chỉnh sửa UOM",
    "setup.label.Save": "Lưu",
    "setup.label.DeleteUOM": "Xóa UOM",
    "setup.label.Ok": "Ok",
    "setup.label.ViewUOM": "Xem UOM",
    "setup.label.RUM(RatableUsageMetric)":
      "RUM (Đo lường Sử dụng Có thể Tính Phí)",
    "setup.label.CreateRUM": "Tạo RUM",
    "setup.label.ChargeName": "Tên Cước phí",
    "setup.label.Template Name": "Tên Mẫu",
    "setup.label.RumName": "Tên RUM",
    "setup.label.RumExpression": "Biểu thức RUM",

    "setup.label.Operators": "Toán tử",
    "setup.label.EditRUM": "Chỉnh sửa RUM",
    "setup.label.ViewRUM": "Xem RUM",
    "setup.label.TimePeriod": "Khoảng thời gian",
    "setup.label.CreateTimePeriod": "Tạo khoảng thời gian",
    "setup.label.TimeModelName": "Tên mô hình thời gian",
    "setup.label.StartYear": "Năm bắt đầu",
    "setup.label.EndYear": "Năm kết thúc",
    "setup.label.StartMonth": "Tháng bắt đầu",
    "setup.label.EndMonth": "Tháng kết thúc",
    "setup.label.StartDay": "Ngày bắt đầu",
    "setup.label.EndDay": "Ngày kết thúc",
    "setup.label.StartTime": "Thời gian bắt đầu",
    "setup.label.EndTime": "Thời gian kết thúc",
    "setup.label.CreateTimeModel": "Tạo mô hình thời gian",
    "setup.label.ExpandAll / CollapseAll": "Mở rộng tất cả / Thu gọn tất cả",
    "setup.label.AddTimemodel": "Thêm mô hình thời gian",
    "setup.label.UsageRatePlan": "Kế hoạch tỷ lệ sử dụng",
    "setup.label.CreateUsageRatePlan": "Tạo kế hoạch tỷ lệ sử dụng",
    "setup.label.PlanName": "Tên kế hoạch",
    "setup.label.ProductName": "Tên sản phẩm",
    "setup.label.TimemodelName": "Tên mô hình thời gian",

    "setup.label.ViewUsageRatePlan": "Xem kế hoạch tỷ lệ sử dụng",
    "setup.label.RUM": "RUM",
    "setup.label.RatingType": "Loại xếp hạng",
    "setup.label.TimeModel": "Mô hình thời gian",
    "setup.label.ZoneModel": "Mô hình vùng",
    "setup.label.ViewQuantityTier": "Xem cấp số lượng",
    "setup.label.QuantityTier": "Cấp số lượng",
    "setup.label.TierName": "Tên cấp",
    "setup.label.CumulativeResource": "Tài nguyên tích lũy",
    "setup.label.TierRange": "Phạm vi cấp",
    "setup.label.StepName": "Tên bước",
    "setup.label.StartRange": "Phạm vi bắt đầu",
    "setup.label.EndRange": "Phạm vi kết thúc",
    "setup.label.AddQuantityTier": "Thêm cấp số lượng",
    "setup.label.NumberZone": "Khu vực số",
    "setup.label.CreateNumberZone": "Tạo khu vực số",
    "setup.label.SourceNumberPrefix": "Tiền tố số nguồn",
    "setup.label.DestinationNumberPrefix": "Tiền tố số đích",
    "setup.label.ImpactCategory": "Danh mục ảnh hưởng",
    "setup.label.Rank": "Xếp hạng",
    "setup.label.APNZone": "Khu vực APN",
    "setup.label.APN": "APN",
    "setup.label.CreateAPNZone": "Tạo khu vực APN",
    "setup.label.OperatorZone": "Khu vực nhà điều hành",
    "setup.label.CreateOperatorZone": "Tạo khu vực nhà điều hành",
    "setup.label.SourceOperatorCode": "Mã nhà điều hành nguồn",
    "setup.label.DestinationOperatorCode": "Mã nhà điều hành đích",
    "setup.label.ICZone": "Khu vực IC",
    "setup.label.IncomingTrunkid": "Trunkid đến",
    "setup.label.OutcomingTrunkid": "Trunkid đi",
    "setup.label.CreateChargeCode": "Tạo mã phí",
    "setup.label.ChargeDescription": "Mô tả phí",
    "setup.label.ChargeType": "Loại phí",
    "setup.label.ChargeDuration": "Thời lượng phí",
    "setup.label.DurationType": "Loại thời lượng",
    "setup.label.TaxInclusive": "Bao gồm thuế",
    "setup.label.BillFrequencyCode": "Mã tần suất hóa đơn",

    "setup.label.TaxCode": "Mã thuế",
    "setup.label.IsAggregate": "Là tổng hợp",
    "setup.label.EditChargeCode": "Chỉnh sửa mã phí",
    "setup.label.TaxMaster": "Thạc sĩ thuế",
    "setup.label.CreateTaxMaster": "Tạo thạc sĩ thuế",

    "setup.label.GroupType": "Loại nhóm",
    "setup.label.GroupCode": "Mã nhóm",

    "setup.label.StartDate": "Ngày bắt đầu",

    "setup.label.Rate": "Tỷ lệ",
    "setup.label.BaseTaxCode": "Mã số thuế cơ sở",
    "setup.label.Jurisdiction": "Thẩm quyền",
    "setup.label.RateType": "Loại tỷ lệ",
    "setup.label.Location": "Vị trí",
    "setup.label.DeleteTax": "Xóa thuế",
    "setup.label.CreateDiscount": "Tạo chiết khấu",

    "setup.label.DiscountDescription": "Mô tả chiết khấu",
    "setup.label.DiscountType": "Loại chiết khấu",
    "setup.label.DiscountRate": "Tỷ lệ chiết khấu",
    "setup.label.DiscountDetails": "Chi tiết chiết khấu",
    "setup.label.ClientCategory": "Danh mục khách hàng",
    "setup.label.CustomerCategory": "Danh mục khách hàng",

    "setup.label.EditDiscount": "Chỉnh sửa chiết khấu",
    "setup.label.DeleteDiscount": "Xóa chiết khấu",
    "setup.label.CreatePromotion": "Tạo khuyến mãi",
    "setup.label.PromotionCode": "Mã khuyến mãi",
    "setup.label.PromotionName": "Tên khuyến mãi",
    "setup.label.PromotionId": "Id khuyến mãi",
    "setup.label.PromotionDescription": "Mô tả khuyến mãi",

    "setup.label.EditPromotionCode": "Chỉnh sửa mã khuyến mãi",
    "setup.label.ListOfDiscounts": "Danh sách giảm giá",
    "setup.label.ListofTimePeriods": "Danh sách các khoảng thời gian",

    "setup.label.CreatePriceRegion": "Tạo khu vực giá",
    "setup.label.RegionCode": "Mã khu vực",
    "setup.label.RegionName": "Tên khu vực",
    "setup.label.Country": "Quốc gia",
    "setup.label.States": "Các bang",
    "setup.label.EditPriceRegion": "Chỉnh sửa khu vực giá",
    "setup.label.DeletePriceRegion": "Xóa khu vực giá",

    "setup.label.CreateSalesCatalogue": "Tạo danh mục bán hàng",
    "setup.label.SalesCatalogueName": "Tên danh mục bán hàng",
    "setup.label.AssignUsers": "Gán người dùng",
    "setup.label.SalesPlanCategory": "Danh mục kế hoạch bán hàng",
    "setup.label.Plans": "Kế hoạch",
    "setup.label.EditSalesCatalogue": "Chỉnh sửa danh mục bán hàng",
    "setup.label.DeleteSalesCatalogue": "Xóa danh mục bán hàng",

    "setup.label.UserId": "ID người dùng",
    "setup.label.UserName": "Tên người dùng",
    "setup.label.CreateUsersCatalogue": "Tạo danh mục người dùng",
    "setup.label.Catalogue": "Danh mục",
    "setup.label.EditUserCatalogue": "Chỉnh sửa danh mục người dùng",
    "setup.label.VoucherPins": "Mã phiếu giảm giá",
    "setup.label.CreateVoucherPins": "Tạo mã phiếu giảm giá",
    "setup.label.Voucher": "Phiếu quà tặng",
    "setup.label.Coupon": "Phiếu giảm giá",
    "setup.label.LCO": "LCO",
    "setup.label.LengthOfPins": "Độ dài của mã pin",
    "setup.label.SerialNoLength": "Độ dài số sê-ri",
    "setup.label.NumberValue ": "Giá trị số",
    "setup.label.PinValue ": "Giá trị mã PIN",
    "setup.label.BatchName": "Tên lô",
    "setup.label.PinCategory": "Loại mã",

    "setup.label.BeginWith": "Bắt đầu bằng",
    "setup.label.Quantity": "Số lượng",
    "setup.label.PinType": "Loại mã",
    "setup.label.Value": "Giá trị",
    "setup.label.SIMNumbers": "Số SIM",
    "setup.label.CreateSIMNumber": "Tạo số SIM",
    "setup.label.NumberCategory": "Loại số",
    "setup.label.ExpiryDate": "Ngày hết hạn",
    "setup.label.Partner": "Đối tác",
    "setup.label.LengthofNumber": "Chiều dài số",
    "setup.label.LengthofSerialNumber": "Chiều dài số sê-ri",
    "setup.label.NumberType": "Loại số",
    "setup.label.Product": "Sản phẩm",
    "setup.label.Supplier": "Nhà cung cấp",
    "setup.label.CreateSupplier": "Tạo nhà cung cấp",
    "setup.label.SupplierCode": "Mã nhà cung cấp",
    "setup.label.SupplierDescription": "Mô tả nhà cung cấp",
    "setup.label.SupplierAddress": "Địa chỉ nhà cung cấp",
    "setup.label.EditSupplier": "Chỉnh sửa nhà cung cấp",
    "setup.label.AddressMaster": "Địa chỉ chính",
    "setup.label.CountryName": "Tên quốc gia",
    "setup.label.StateName": "Tên bang",
    "setup.label.DistrictName": "Tên quận",
    "setup.label.CityName": "Tên thành phố",
    "setup.label.TreeView": "Chế độ xem cây",
    "setup.label.AddCountry": "Thêm quốc gia",
    "setup.label.CountryCode": "Mã quốc gia",
    "setup.label.TeamHead": "Trưởng nhóm",
    "setup.label.CreateTicketTeam": "Tạo nhóm vé",
    "setup.label.TeamCode": "Mã nhóm",
    "setup.label.TeamDescription": "Mô tả nhóm",
    "setup.label.TeamCategory": "Danh mục nhóm",
    "setup.label.CreateTicketTeamUsers": "Tạo người dùng nhóm vé",
    "setup.label.TeamEmail": "Email nhóm",
    "setup.label.AvailableUsers": "Người dùng có sẵn",
    "setup.label.SelectedUsers": "Người dùng đã chọn",
    "setup.label.TeamId": "ID nhóm",
    "setup.label.ViewTeam": "Xem nhóm",
    "setup.label.DeleteTeam": "Xóa nhóm",
    "setup.label.EditTicketTeam": "Chỉnh sửa nhóm vé",
    "setup.label.TeamUser": "Người dùng nhóm",
    "setup.label.EditTicketUsers": "Chỉnh sửa người dùng vé",
    "setup.label.DeleteTeamUser": "Xóa người dùng nhóm",
    "setup.label.VendorManagement": "Quản lý nhà cung cấp",
    "setup.label.CreateVendor": "Tạo nhà cung cấp",

    "setup.label.ContactName": "Tên liên hệ",
    "setup.label.Mobile": "Di động",
    "setup.label.Landline": "Điện thoại cố định",

    "setup.label.CreateNewVendor": "Tạo nhà cung cấp mới",
    "setup.label.EditVendor": "Chỉnh sửa nhà cung cấp",
    "setup.label.FeeMaster": "Quản lý phí",
    "setup.label.CreateFeeMaster": "Tạo quản lý phí",
    "setup.label.FeeMasterCode": "Mã quản lý phí",
    "setup.label.FeeMasterDescription": "Mô tả quản lý phí",
    "setup.label.FeeMasterTransactionType": "Loại giao dịch quản lý phí",
    "setup.label.ChargeCode": "Mã phí",
    "setup.label.VariablePricing": "Giá thay đổi",
    "setup.label.Regions": "Khu vực",
    "setup.label.Amount": "Số tiền",

    "setup.label.EditFeeMaster": "Chỉnh sửa quản lý phí",
    "setup.label.ManageMessage": "Quản lý tin nhắn",
    "setup.label.AddMessage": "Thêm tin nhắn",
    "setup.label.TemplateDescription": "Mô tả mẫu",
    "setup.label.Subject": "Chủ đề",
    "setup.label.MessageType": "Loại tin nhắn",
    "setup.label.Header": "Đầu trang",
    "setup.label.Body": "Nội dung",
    "setup.label.Footer": "Chân trang",
    "setup.label.CreateMessageTemplate": "Tạo mẫu tin nhắn",
    "setup.label.MessageParams": "Tham số tin nhắn",
    "setup.label.Parameter": "Tham số",
    "setup.label.Params": "Tham số",
    "setup.label.DeleteMessage": "Xóa tin nhắn",
    "setup.label.EditMessage": "Chỉnh sửa tin nhắn",
    "setup.label.GroupsDetails": "Chi tiết nhóm",
    "setup.label.GroupName": "Tên nhóm",
    "setup.label.GroupAddress": "Địa chỉ nhóm",
    "setup.label.CountNo's": "Đếm số",
    "setup.label.AddGroup": "Thêm nhóm",
    "setup.label.AdditionalInformation": "Thông tin bổ sung",
    "setup.label.GroupCIR": "CIR nhóm",
    "setup.label.DIR": "DIR",
    "setup.label.MemberCIR": "CIR thành viên",
    "setup.label.IpPoolManagement": "Quản lý hồ IP",
    "setup.label.UpdateNetMask": "Cập nhật mặt nạ mạng",
    "setup.label.IpAddress": "Địa chỉ IP",
    "setup.label.NetMark": "Dấu mạng",
    "setup.label.IpType": "Loại IP",
    "setup.label.CoustomerId": "ID khách hàng",
    "setup.label.CustomerName": "Tên khách hàng",
    "setup.label.Notes": "Ghi chú",
    "setup.label.Subnet": "Mạng con",

    "setup.label.DetailsOfMedia": "Chi tiết về phương tiện",
    "setup.label.Media": "Phương tiện",
    "setup.label.AddMedia": "Thêm phương tiện",
    "setup.label.MediaTitle": "Tiêu đề phương tiện",
    "setup.label.MediaCatagory": "Danh mục phương tiện",
    "setup.label.ContentProvider": "Nhà cung cấp nội dung",
    "setup.label.Share": "Chia sẻ(%)",
    "setup.label.AddMediaDetails": "Thêm chi tiết phương tiện",
    "setup.label.MediaLocation": "Vị trí phương tiện",
    "setup.label.SelectMediaCategory": "Chọn danh mục phương tiện",
    "setup.label.Movies": "Phim",

    "setup.label.ViewMedia": "Xem phương tiện",
    "setup.label.EditMedia": "Chỉnh sửa phương tiện",
    "setup.label.MediaAttributes": "Thuộc tính phương tiện",
    "setup.label.Cast": "Diễn viên",
    "setup.label.AttributeType": "Loại thuộc tính",
    "setup.label.CaptionValue": "Giá trị chú thích",
    "setup.label.NickName": "Biệt danh",
    "setup.label.Image": "Hình ảnh",
    "setup.label.AddMediaLocations": "Thêm vị trí phương tiện",
    "setup.label.LanguageData": "Dữ liệu ngôn ngữ",
    "setup.label.FormatData": "Dữ liệu định dạng",
    "setup.label.MediaLocations": "Vị trí phương tiện",
    "setup.label.DetailsOfEvent": "Chi tiết sự kiện",
    "setup.label.EventName": "Tên sự kiện",
    "setup.label.EventCode": "Mã Sự Kiện",
    "setup.label.SelectedMediaService": "Dịch Vụ Truyền Thông Đã Chọn",
    "setup.label.AvailableMedia": "Truyền Thông Có Sẵn",
    "setup.label.EventDescription": "Mô tả sự kiện",
    "setup.label.EventCategory": "Thể loại sự kiện",
    "setup.label.CreateEvent": "Tạo sự kiện",
    "setup.label.DetailsOfProperty": "Chi tiết tài sản",
    "setup.label.PropertyCode": "Mã tài sản",
    "setup.label.PropertyType": "Loại tài sản",
    "setup.label.Parcel": "Gói hàng",
    "setup.label.BuildingCode": "Mã tòa nhà",
    "setup.label.Precinct": "Khu vực",
    "setup.label.Allocated": "Đã phân bổ",
    "setup.label.UploadPropertyData": "Tải lên dữ liệu tài sản",
    "setup.label.Clear": "Xóa",
    "setup.label.CreateProperty": "Tạo tài sản",
    "setup.label.PropertyDataUpload": "Tải lên dữ liệu tài sản",
    "setup.label.Street": "Đường phố",
    "setup.label.PaymentType": "Loại thanh toán",
    "setup.label.PoBox": "Hộp thư",
    "setup.label.State": "Bang",
    "setup.label.District": "Huyện",
    "setup.label.Floor": "Tầng",

    "setup.label.LimitCode": "Mã giới hạn",
    "setup.label.PropertyMaster": "Chủ sở hữu tài sản",
    "setup.label.CodeDescription": "Mô tả mã",
    "setup.label.ReferenceValue": "Giá trị tham chiếu",
    "setup.label.Services": "Dịch vụ",

    "setup.label.IsBouquet": "Là Bouquet",
    "setup.label.Broadcaster": "Nhà phát thanh",
    "setup.label.Channel": "Kênh",

    "setup.label.ContactNumber": "Số liên lạc",

    "setup.label.UOM": "Đơn vị",

    "setup.label.DeleteTemplateDefinition": "Xóa Định nghĩa Mẫu",

    "setup.label.Discount": "Giảm giá",

    "setup.label.SalseCatalogue": "Danh mục Bán hàng",
    "setup.label.UserCatalogue": "Danh mục Người dùng",
    "setup.label.Team": "Đội",

    "setup.label.MediaDetails": "Chi tiết Phương tiện",
    "setup.label.Event": "Sự kiện",
    "setup.label.Properties": "Tài sản",

    "setup.label.ServicesProducts": "Dịch vụ & Sản phẩm",
    "setup.label.BroadcasterChannelMapping": "Đài phát thanh, Kênh & Bản đồ",

    "setup.label.UsageRating": "Đánh giá Sử dụng",
    "setup.label.ZoneSetup": "Thiết lập Khu vực",
    "setup.label.Promotion": "Khuyến mãi",
    "setup.label.PromotionTrigger": "Kích hoạt khuyến mãi",
    "setup.label.PromotionRulesAndRates": "Thể lệ và tỷ lệ khuyến mãi",
    "setup.label.CatalogeMapping": "Bản đồ Danh mục",
    "setup.label.VoucherPin": "Mã Voucher",
    "setup.label.SIMNumber": "Số SIM",
    "setup.label.TeamTeamUser": "Đội & Người dùng Đội",
    "setup.label.MessageTemplate": "Mẫu Tin nhắn",
    "setup.label.ClosedUserGroup": "Nhóm Người dùng Đóng",
    "setup.label.IpManagement": "Quản lý IP",
    "setup.label.PropertyDefinition": "Định nghĩa Tài sản",
    "setup.label.PriorityMapping": "Ánh xạ ưu tiên",
    "setup.label.AddProducts": "Thêm Sản phẩm",
    "setup.label.AddDiscount": "Thêm Giảm giá",
    "setup.label.Products": "Sản phẩm",
    "setup.label.ChargeCodeData": "Dữ Liệu Mã Phí",
    "setup.label.TaxMapping": "Bản Đồ Thuế",
    "setup.label.TaxRegion": "Khu Vực Thuế",
    "setup.label.CreateUserCatalogue": "Tạo Danh Mục Người Dùng",
    "setup.label.IcZone": "Khu Vực Ic",
    "setup.label.ViewIcZone": "Xem Khu Vực Ic",
    "setup.label.ViewNumberZone": "Xem Khu Vực Số",

    "setup.label.EditNumberZone": "Chỉnh Sửa Khu Vực Số",
    "setup.label.DeleteNumberZone": "Xóa Khu Vực Số",
    "setup.label.AreYouSure": "Bạn có chắc không?",
    "setup.label.ViewAPNZone": "Xem Khu Vực APN",
    "setup.label.EditAPNZone": "Chỉnh Sửa Khu Vực APN",
    "setup.label.DeleteAPNZone": "Xóa Khu Vực APN",
    "setup.label.ViewOperatorZone": "Xem Khu Vực Nhà Mạng",
    "setup.label.EditOperatorZone": "Chỉnh Sửa Khu Vực Nhà Mạng",

    "setup.label.CreateICZone": "Tạo Khu Vực IC",
    "setup.label.EditICZone": "Chỉnh Sửa Khu Vực IC",
    "setup.label.DeleteOperatorZone": "Xóa Khu Vực Nhà Mạng",
    "setup.label.DeleteIcZone": "Xóa Khu Vực IC",
    "setup.label.MobileNumber": "Số Di Động",
    "setup.label.LandlineNumber": "Số điện thoại cố định (Tùy chọn)",
    "setup.label.RatePlanName": "Tên Gói Cước",
    "setup.label.UsageRateBalance": "Số dư Tỷ lệ Sử dụng",
    "setup.label.ValidityType": "Loại hiệu lực",
    "setup.label.ListOfRateTires": "Danh Sách Tỷ Lệ Lốp Xe",
    "setup.label.Validity": "Hiệu lực",
    "setup.label.CreatePlanName": "Tạo tên kế hoạch",
    "setup.label.EditPlanContent": "Chỉnh sửa nội dung kế hoạch",
    "setup.label.CreatePlanDescription": "Tạo mô tả kế hoạch",
    "setup.label.ContentType": "Loại nội dung",
    "setup.label.CreateFeatureList": "Tạo danh sách tính năng",
    "setup.label.Area": "Khu vực",
    "setup.label.TaxPercentage": "Phần trăm thuế",
    "setup.label.Add": "Thêm",
    "setup.label.Remove": "Di dời",
    "setup.label.CreateVoucherPin": "Tạo Mã Phiếu",
    "setup.label.EditSubCategory": "Chỉnh sửa danh mục phụ",
    "setup.label.CreateSubCategory": "Tạo danh mục phụ",
    "setup.label.ViewSubCategory": "Xem danh mục phụ",
    "setup.label.TimeTaken": "Thời gian thực hiện",
    "setup.label.TeamMapping": "Ánh xạ Đội",
    "setup.label.CreateTeamMapping": "Tạo ánh xạ Đội",

    "setup.label.Category": "Thể loại",
    "setup.label.external_promotional_code": "Mã khuyến mại bên ngoài",
    "setup.label.Subcategory": "Danh mục con",

    "setup.label.DeleteItemMapping": "Xóa ánh xạ Mục",
    "setup.label.EditTeamMapping": "Chỉnh sửa ánh xạ Đội",
    "setup.label.ViewTeamMapping": "Xem ánh xạ Đội",
    "setup.label.DeletePriorityMapping": "Xóa ánh xạ Ưu tiên",
    "setup.label.discount_rule": "Quy tắc Giảm giá",
    "setup.label.promotion_rule": "Quy tắc khuyến mãi",
    "setup.label.discount_rate": "Tỷ lệ Giảm giá",
    "setup.label.create_discount_rule": "Tạo quy tắc giảm giá",
    "setup.label.edit_promotion_rule": "Chỉnh sửa quy tắc khuyến mãi",
    "setup.label.create_promotion_rule": "Tạo quy tắc khuyến mãi",
    "setup.label.create_discount_rate": "Tạo tỷ lệ chiết khấu",
    "setup.label.add_discount_rate": "Thêm Tỷ lệ Giảm giá",
    "setup.label.add_promotion_rate": "Thêm Tỷ Lệ Khuyến Mãi",
    "setup.label.edit_discount": "Chỉnh sửa Giảm giá",
    "setup.label.edit_promotion": "Chỉnh sửa khuyến mãi",
    "setup.label.edit_discount_trigger": "Chỉnh sửa Kích hoạt Giảm giá",
    "setup.label.edit_discount_rule": "Chỉnh sửa Quy tắc Giảm giá",
    "setup.label.collection_process": "Quy trình Thu thập",
    "setup.label.create_collection_profile": "Tạo Hồ sơ Thu thập",
    "setup.label.collection_profile": "Hồ sơ Thu thập",
    "setup.label.collection_profile_id": "ID Hồ sơ Thu thập",
    "setup.label.region": "Khu vực",
    "setup.label.collection": "Thu thập",
    "setup.label.collection_trigger": "Kích hoạt Thu thập",
    "setup.label.collection_scenario": "Kịch bản Thu thập",
    "setup.label.add_collection_trigger": "Thêm Kích hoạt Thu thập",
    "setup.label.add_collection_scenario": "Thêm Kịch bản Thu thập",
    "setup.label.trigger_id": "ID Kích hoạt",
    "setup.label.criteria_type": "Loại Tiêu chí",
    "setup.label.due_balance": "Số dư Đến hạn",
    "setup.label.ageing_days": "Số ngày Già hóa",
    "setup.label.scenario_id": "ID Kịch bản",
    "setup.label.action_name": "Tên Hành động",
    "setup.label.age": "Tuổi",
    "setup.label.create_collection_trigger": "Tạo Kích hoạt Thu thập",
    "setup.label.create_collection_scenario": "Tạo Kịch bản Thu thập",
    "setup.label.edit_collection_profile": "Chỉnh sửa Hồ sơ Thu thập",
    "setup.label.edit_collection_trigger": "Chỉnh sửa Kích hoạt Thu thập",
    "setup.label.edit_collection_scenario": "Chỉnh sửa Kịch bản Thu thập",
    "setup.label.SlaInHours": "SLA tính bằng giờ",
    "setup.label.contractduration": "Thời hạn hợp đồng",
    "setup.label.chargesperiodicity": "Tần suất tính phí",
  },
};
